'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var uikitResources = require('@cometchat/uikit-resources');
var chatSdkJavascript = require('@cometchat/chat-sdk-javascript');
var lit = require('lit');
var decorators_js = require('lit/decorators.js');
var styleMap_js = require('lit/directives/style-map.js');
var uikitElements = require('@cometchat/uikit-elements');

var _a;
class CometChatSoundManager {
    /**
     * @param  {string} sound
     * @param  {string|null=null} customSound
     */
    static play(sound, customSound = null) {
        if (!this.hasInteracted())
            return;
        const resource = CometChatSoundManager.Sound[sound];
        const handler = CometChatSoundManager.handlers[resource];
        if (!handler) {
            return false;
        }
        return handler(customSound);
    }
    static pause() {
        if (CometChatSoundManager.audio) {
            CometChatSoundManager.audio.pause();
            CometChatSoundManager.audio.currentTime = 0;
            CometChatSoundManager.audio = null;
        }
    }
    /**
     * Checks if the user has interacted with the page.
     * @returns {boolean} True if the user has interacted, false otherwise.
     */
    static hasInteracted() {
        if ('userActivation' in navigator) {
            return window.navigator.userActivation.isActive ||
                window.navigator.userActivation.hasBeenActive;
        }
        else {
            return true;
        }
    }
}
_a = CometChatSoundManager;
CometChatSoundManager.audio = null;
CometChatSoundManager.Sound = Object.freeze({
    incomingCall: "incomingCall",
    incomingMessage: "incomingMessage",
    incomingMessageFromOther: "incomingMessageFromOther",
    outgoingCall: "outgoingCall",
    outgoingMessage: "outgoingMessage",
});
/**
 * @param  {string|null=null} customSound
 */
CometChatSoundManager.onIncomingMessage = (customSound = null) => {
    CometChatSoundManager.audio = new Audio(customSound || 'https://assets.cometchat.io/uikits/static/audio/incomingmessage.wav');
    CometChatSoundManager.audio.currentTime = 0;
    if (_a.hasInteracted())
        CometChatSoundManager.audio.play();
};
/**
 * @param  {string|null=null} customSound
 */
CometChatSoundManager.onIncomingOtherMessage = (customSound = null) => {
    CometChatSoundManager.audio = new Audio(customSound || 'https://assets.cometchat.io/uikits/static/audio/incomingothermessage.wav');
    CometChatSoundManager.audio.currentTime = 0;
    if (_a.hasInteracted())
        CometChatSoundManager.audio.play();
};
/**
 * @param  {string|null=null} customSound
 */
CometChatSoundManager.onOutgoingMessage = (customSound = null) => {
    CometChatSoundManager.audio = new Audio(customSound || 'https://assets.cometchat.io/uikits/static/audio/outgoingmessage.wav');
    CometChatSoundManager.audio.currentTime = 0;
    if (_a.hasInteracted())
        CometChatSoundManager.audio.play();
};
/**
 * @param  {string|null=null} customSound
 */
CometChatSoundManager.onIncomingCall = (customSound = null) => {
    try {
        CometChatSoundManager.audio = new Audio(customSound || 'https://assets.cometchat.io/uikits/static/audio/incomingcall.wav');
        CometChatSoundManager.audio.currentTime = 0;
        if (typeof CometChatSoundManager.audio.loop == "boolean") {
            CometChatSoundManager.audio.loop = true;
        }
        else {
            CometChatSoundManager.audio.addEventListener("ended", function () {
                this.currentTime = 0;
                this.play();
            }, false);
        }
        if (_a.hasInteracted())
            CometChatSoundManager.audio.play();
    }
    catch (error) {
        console.log(error);
    }
};
/**
 * @param  {string|null=null} customSound
 */
CometChatSoundManager.onOutgoingCall = (customSound = null) => {
    try {
        CometChatSoundManager.audio = new Audio(customSound || 'https://assets.cometchat.io/uikits/static/audio/outgoingcall.wav');
        CometChatSoundManager.audio.currentTime = 0;
        if (typeof CometChatSoundManager.audio.loop == "boolean") {
            CometChatSoundManager.audio.loop = true;
        }
        else {
            CometChatSoundManager.audio.addEventListener("ended", function () {
                this.currentTime = 0;
                this.play();
            }, false);
        }
        if (_a.hasInteracted())
            CometChatSoundManager.audio.play();
    }
    catch (error) {
        console.log(error);
    }
};
CometChatSoundManager.handlers = {
    incomingCall: CometChatSoundManager.onIncomingCall,
    outgoingCall: CometChatSoundManager.onOutgoingCall,
    incomingMessage: CometChatSoundManager.onIncomingMessage,
    incomingMessageFromOther: CometChatSoundManager.onIncomingOtherMessage,
    outgoingMessage: CometChatSoundManager.onOutgoingMessage,
};

// change folder structure
class CometChatUIKitUtility {
    /**
     * Creates a deep copy of the value provided
     *
     * @remarks
     * This function cannot copy truly private properties (those that start with a "#" symbol inside a class block).
     * Functions are copied by reference and additional properties on the array objects are ignored
     *
     * @param arg - Any value
     * @returns A deep copy of `arg`
     */
    static clone(arg) {
        /*
          If there are additional properties attached to a function or an array object other than the standard properties,
              those properties will be ignored
          Cannot copy private properties (those that start with a "#" symbol inside a class block)
          Functions are copied by reference
      */
        if (typeof arg !== "object" || !arg) {
            return arg;
        }
        let res;
        if (Array.isArray(arg)) {
            // arg is an array, there's no hatch to fool the Array.isArray method, so lets create an array
            res = [];
            for (const value of arg) {
                res.push(CometChatUIKitUtility.clone(value));
            }
            return res;
        }
        else {
            // arg is an object
            res = {};
            const descriptor = Object.getOwnPropertyDescriptors(arg);
            for (const k of Reflect.ownKeys(descriptor)) {
                const curDescriptor = descriptor[k];
                if (curDescriptor.hasOwnProperty("value")) {
                    // Property is a data property
                    Object.defineProperty(res, k, {
                        ...curDescriptor,
                        value: CometChatUIKitUtility.clone(curDescriptor["value"]),
                    });
                }
                else {
                    // Property is an accessor property
                    Object.defineProperty(res, k, curDescriptor);
                }
            }
            Object.setPrototypeOf(res, Object.getPrototypeOf(arg));
        }
        return res;
    }
    static getExtensionData(messageObject) {
        var _a;
        let messageText;
        //xss extensions data
        const xssData = CometChatUIKitUtility.checkMessageForExtensionsData(messageObject, "xss-filter");
        if (xssData &&
            CometChatUIKitUtility.checkHasOwnProperty(xssData, "sanitized_text") &&
            CometChatUIKitUtility.checkHasOwnProperty(xssData, "hasXSS") &&
            xssData.hasXSS === "yes") {
            messageText = xssData === null || xssData === void 0 ? void 0 : xssData.sanitized_text;
        }
        //datamasking extensions data
        const maskedData = CometChatUIKitUtility.checkMessageForExtensionsData(messageObject, "data-masking");
        if (maskedData &&
            CometChatUIKitUtility.checkHasOwnProperty(maskedData, "data") &&
            CometChatUIKitUtility.checkHasOwnProperty(maskedData.data, "sensitive_data") &&
            CometChatUIKitUtility.checkHasOwnProperty(maskedData.data, "message_masked") &&
            maskedData.data.sensitive_data === "yes") {
            messageText = (_a = maskedData === null || maskedData === void 0 ? void 0 : maskedData.data) === null || _a === void 0 ? void 0 : _a.message_masked;
        }
        //profanity extensions data
        const profaneData = CometChatUIKitUtility.checkMessageForExtensionsData(messageObject, "profanity-filter");
        if (profaneData &&
            CometChatUIKitUtility.checkHasOwnProperty(profaneData, "profanity") &&
            CometChatUIKitUtility.checkHasOwnProperty(profaneData, "message_clean") &&
            profaneData.profanity === "yes") {
            messageText = profaneData === null || profaneData === void 0 ? void 0 : profaneData.message_clean;
        }
        return messageText || messageObject.text;
    }
    static sanitizeHtml(htmlString, whitelistRegExes) {
        if (!htmlString) {
            return "";
        }
        if (!Array.isArray(whitelistRegExes)) {
            return htmlString;
        }
        let returnString = htmlString;
        try {
            returnString = htmlString.replace(/<[^>]+>?/g, function (match) {
                const combinedRegex = new RegExp("(" + whitelistRegExes.map((regex) => regex.source).join("|") + ")");
                return combinedRegex.test(match)
                    ? match
                    : match.replace(/</g, "&lt;").replace(/>/g, "&gt;");
            });
        }
        catch (error) {
            console.log(error);
        }
        return returnString;
    }
}
CometChatUIKitUtility.checkHasOwnProperty = (obj = {}, key) => {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
CometChatUIKitUtility.ID = () => {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return "_" + Math.random().toString(36).substr(2, 9);
};
CometChatUIKitUtility.getUnixTimestamp = () => {
    return Math.round(+new Date() / 1000);
};
CometChatUIKitUtility.checkMessageForExtensionsData = (message, extensionKey) => {
    try {
        let output = [];
        if (message.hasOwnProperty("metadata")) {
            const metadata = message["metadata"];
            const injectedObject = metadata["@injected"];
            if (injectedObject && injectedObject.hasOwnProperty("extensions")) {
                const extensionsObject = injectedObject["extensions"];
                if (extensionsObject &&
                    extensionsObject.hasOwnProperty(extensionKey)) {
                    output = extensionsObject[extensionKey];
                }
            }
        }
        return output;
    }
    catch (error) { }
};

var CometChatUIKitSharedSettings = {};

class InteractiveMessageUtils {
    /**
     * Converts an interactive message to its corresponding object type.
     * @param message The message to convert.
     * @returns The converted message object.
     */
    static convertInteractiveMessage(message) {
        if (message.getCategory() === uikitResources.CometChatUIKitConstants.MessageCategory.interactive && !message.getDeletedAt()) {
            switch (message.getType()) {
                case uikitResources.CometChatUIKitConstants.MessageTypes.form:
                    return uikitResources.FormMessage.fromJSON(message);
                case uikitResources.CometChatUIKitConstants.MessageTypes.card:
                    return uikitResources.CardMessage.fromJSON(message);
                case uikitResources.CometChatUIKitConstants.MessageTypes.scheduler:
                    return uikitResources.SchedulerMessage.fromJSON(message);
                default:
                    return message;
            }
        }
        else {
            return message;
        }
    }
    static async fetcher({ url, method, body, headers, }) {
        try {
            const res = await fetch(url, {
                method,
                body: JSON.stringify(body),
                headers: {
                    "Content-Type": "application/json",
                    ...headers,
                },
            });
            return res;
        }
        catch (error) {
            throw error;
        }
    }
    static async actionHandler(action, data) {
        var _a, _b, _c;
        let returnBool = false;
        switch (action.getActionType() || (action === null || action === void 0 ? void 0 : action.actionType)) {
            case uikitResources.ButtonAction.apiAction:
                const type = data.message.getType();
                const dataKey = this.dataSet[type] || "data";
                let payload = action.getPayload() || {};
                const payloadData = {};
                const metaInfo = this.getMetaData(data.message);
                const appId = CometChatUIKitSharedSettings && (CometChatUIKitSharedSettings === null || CometChatUIKitSharedSettings === void 0 ? void 0 : CometChatUIKitSharedSettings.uikitSettings) ? (_a = CometChatUIKitSharedSettings === null || CometChatUIKitSharedSettings === void 0 ? void 0 : CometChatUIKitSharedSettings.uikitSettings) === null || _a === void 0 ? void 0 : _a.appId : "";
                const region = CometChatUIKitSharedSettings && (CometChatUIKitSharedSettings === null || CometChatUIKitSharedSettings === void 0 ? void 0 : CometChatUIKitSharedSettings.uikitSettings) ? (_b = CometChatUIKitSharedSettings === null || CometChatUIKitSharedSettings === void 0 ? void 0 : CometChatUIKitSharedSettings.uikitSettings) === null || _b === void 0 ? void 0 : _b.region : "";
                if (payload) {
                    payloadData["payload"] = payload;
                }
                payloadData["trigger"] = "ui_message_interacted";
                payloadData["appID"] = appId;
                payloadData["region"] = region;
                payloadData["data"] = metaInfo;
                payloadData["data"]["interactedBy"] = (_c = data === null || data === void 0 ? void 0 : data.loggedInUser) === null || _c === void 0 ? void 0 : _c.getUid();
                payloadData["data"]["interactionTimezoneCode"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
                payloadData["data"]["interactedElementId"] = data.elementId;
                if (data === null || data === void 0 ? void 0 : data.data) {
                    payloadData["data"][dataKey] = data === null || data === void 0 ? void 0 : data.data;
                }
                const response = await InteractiveMessageUtils.fetcher({
                    url: action.getURL(),
                    method: action.getMethod() || uikitResources.HTTPSRequestMethods.POST,
                    body: payloadData,
                    headers: action.getHeaders() || {},
                });
                if (response.status >= 200 && response.status < 300) {
                    returnBool = true;
                }
                break;
            case uikitResources.ButtonAction.urlNavigation:
                window.open(action.getURL(), "_blank");
                returnBool = true;
                break;
            case uikitResources.ButtonAction.custom:
                returnBool = true;
                break;
        }
        return returnBool;
    }
    static getMetaData(messageObj) {
        const conversationId = messageObj.getConversationId();
        const senderUID = messageObj.getSender().getUid();
        const receiverUID = messageObj.getReceiverId();
        const receiverType = messageObj.getReceiverType();
        const messageCategory = messageObj.getCategory();
        const type = messageObj.getType();
        const id = messageObj.getId();
        return {
            conversationId: conversationId,
            sender: senderUID,
            receiver: receiverUID,
            receiverType: receiverType,
            messageCategory: messageCategory,
            messageType: type,
            messageId: id
        };
    }
}
InteractiveMessageUtils.dataSet = {
    "form": "formData",
    "scheduler": "schedulerData"
};

var DeleteIcon = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M17.25%2021H6.75C6.35218%2021%205.97064%2020.842%205.68934%2020.5607C5.40804%2020.2794%205.25%2019.8978%205.25%2019.5V6H18.75V19.5C18.75%2019.8978%2018.592%2020.2794%2018.3107%2020.5607C18.0294%2020.842%2017.6478%2021%2017.25%2021Z%22%20stroke%3D%22%23FF0000%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9.75%2016.5V10.5%22%20stroke%3D%22%23FF0000%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.25%2016.5V10.5%22%20stroke%3D%22%23FF0000%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.25%206H21.75%22%20stroke%3D%22%23FF0000%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.25%203H9.75C9.35218%203%208.97064%203.15804%208.68934%203.43934C8.40804%203.72064%208.25%204.10218%208.25%204.5V6H15.75V4.5C15.75%204.10218%2015.592%203.72064%2015.3107%203.43934C15.0294%203.15804%2014.6478%203%2014.25%203Z%22%20stroke%3D%22%23FF0000%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

class ConversationUtils {
    static getDefaultOptions(theme = new uikitResources.CometChatTheme({})) {
        return [new uikitResources.CometChatOption({
                id: uikitResources.CometChatUIKitConstants.ConversationOptions.delete,
                title: uikitResources.localize("DELETE"),
                //inside style
                iconURL: DeleteIcon,
                onClick: null,
                iconTint: theme.palette.getAccent700(),
                backgroundColor: "transparent",
                titleFont: uikitResources.fontHelper(theme.typography.subtitle1),
                titleColor: theme.palette.getAccent600()
            })]; //change to cometchatoption
    }
    static getLastConversationMessage(conversationObject, loggedInUser, additionalParams) {
        let msgObject = conversationObject === null || conversationObject === void 0 ? void 0 : conversationObject.getLastMessage();
        if (additionalParams) {
            this.additionalParams = additionalParams;
        }
        var message = "";
        if (!msgObject) {
            message = uikitResources.localize("CLICK_TO_START_CONVERSATION");
        }
        else if (msgObject === null || msgObject === void 0 ? void 0 : msgObject.getDeletedAt()) {
            message = uikitResources.localize("MESSAGE_IS_DELETED");
        }
        else if ((msgObject === null || msgObject === void 0 ? void 0 : msgObject.getCategory()) == uikitResources.CometChatUIKitConstants.MessageCategory.message && !(msgObject === null || msgObject === void 0 ? void 0 : msgObject.getDeletedAt())) {
            message = this.getLastMessage(conversationObject);
        }
        else if ((msgObject === null || msgObject === void 0 ? void 0 : msgObject.getCategory()) == uikitResources.CometChatUIKitConstants.MessageCategory.action) {
            message = this.getLastMessageAction(conversationObject);
        }
        else if ((msgObject === null || msgObject === void 0 ? void 0 : msgObject.getCategory()) == uikitResources.CometChatUIKitConstants.MessageCategory.call) {
            message = this.getLastMessageCall(conversationObject);
        }
        else if ((msgObject === null || msgObject === void 0 ? void 0 : msgObject.getCategory()) == uikitResources.CometChatUIKitConstants.MessageCategory.custom) {
            message = this.getLastMessageCustom(conversationObject);
        }
        else if ((msgObject === null || msgObject === void 0 ? void 0 : msgObject.getCategory()) == uikitResources.CometChatUIKitConstants.MessageCategory.interactive) {
            message = this.getLastMessageInteractive(conversationObject);
        }
        if (msgObject && (conversationObject === null || conversationObject === void 0 ? void 0 : conversationObject.getConversationType()) != chatSdkJavascript.CometChat.RECEIVER_TYPE.USER) {
            if ((msgObject === null || msgObject === void 0 ? void 0 : msgObject.getSender().getUid()) == (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.getUid())) {
                message = `${uikitResources.localize("YOU")}: ${message}`;
            }
            else {
                message = `${msgObject === null || msgObject === void 0 ? void 0 : msgObject.getSender().getName()}:  ${message}`;
            }
        }
        return message;
    }
    static getLastMessage(conversation) {
        var _a;
        let message;
        let messageObject = conversation.getLastMessage();
        switch (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getType()) {
            case uikitResources.CometChatUIKitConstants.MessageTypes.text:
                {
                    if (this.additionalParams) {
                        const formatters = ((_a = this.additionalParams) === null || _a === void 0 ? void 0 : _a["textFormatters"]) || [];
                        const regexList = formatters === null || formatters === void 0 ? void 0 : formatters.map((f) => {
                            return f === null || f === void 0 ? void 0 : f.getRegexPatterns();
                        });
                        const lastMessage = (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getText()) || "";
                        message = CometChatUIKitUtility.sanitizeHtml(lastMessage, regexList === null || regexList === void 0 ? void 0 : regexList.flat());
                    }
                    else {
                        message = messageObject.getText() || "";
                    }
                }
                break;
            case uikitResources.CometChatUIKitConstants.MessageTypes.image:
                message = uikitResources.localize("MESSAGE_IMAGE");
                break;
            case uikitResources.CometChatUIKitConstants.MessageTypes.file:
                message = uikitResources.localize("MESSAGE_FILE");
                break;
            case uikitResources.CometChatUIKitConstants.MessageTypes.video:
                message = uikitResources.localize("MESSAGE_VIDEO");
                break;
            case uikitResources.CometChatUIKitConstants.MessageTypes.audio:
                message = uikitResources.localize("MESSAGE_AUDIO");
                break;
            default:
                message = messageObject.getType();
                break;
        }
        return message;
    }
    static getLastMessageCustom(conversation) {
        let msgObject = conversation.getLastMessage();
        return msgObject.getType();
    }
    static getLastMessageAction(conversation) {
        let message = conversation === null || conversation === void 0 ? void 0 : conversation.getLastMessage();
        let actionMessage = '';
        if (message.hasOwnProperty("actionBy") === false || message.hasOwnProperty("actionOn") === false) {
            return actionMessage;
        }
        if (message.getAction() !== uikitResources.CometChatUIKitConstants.groupMemberAction.JOINED && message.getAction() !== uikitResources.CometChatUIKitConstants.groupMemberAction.LEFT && (message.getActionBy().hasOwnProperty("name") === false || message.getActionOn().hasOwnProperty("name") === false)) {
            return actionMessage;
        }
        if (message.getAction() === uikitResources.CometChatUIKitConstants.groupMemberAction.SCOPE_CHANGE) {
            if (message.hasOwnProperty("data") && message.getData().hasOwnProperty("extras")) {
                if (message.getData().extras.hasOwnProperty("scope")) {
                    if (message.getData().extras.scope.hasOwnProperty("new") === false) {
                        return actionMessage;
                    }
                }
                else {
                    return actionMessage;
                }
            }
            else {
                return actionMessage;
            }
        }
        if (message.getAction() === uikitResources.CometChatUIKitConstants.groupMemberAction.SCOPE_CHANGE && message.getData().extras.hasOwnProperty("scope") === false) {
            return actionMessage;
        }
        if (message.getAction() === uikitResources.CometChatUIKitConstants.groupMemberAction.SCOPE_CHANGE && message.getData().extras.scope.hasOwnProperty("new") === false) {
            return actionMessage;
        }
        const byEntity = message.getActionBy();
        const onEntity = message.getActionOn();
        const byString = byEntity.name;
        const forString = message.getAction() !== uikitResources.CometChatUIKitConstants.groupMemberAction.JOINED && message.getAction() !== uikitResources.CometChatUIKitConstants.groupMemberAction.LEFT ? onEntity.name : "";
        switch (message.getAction()) {
            case uikitResources.CometChatUIKitConstants.groupMemberAction.ADDED:
                actionMessage = `${byString} ${uikitResources.localize("ADDED")} ${forString}`;
                break;
            case uikitResources.CometChatUIKitConstants.groupMemberAction.JOINED:
                actionMessage = `${byString} ${uikitResources.localize("JOINED")}`;
                break;
            case uikitResources.CometChatUIKitConstants.groupMemberAction.LEFT:
                actionMessage = `${byString} ${uikitResources.localize("LEFT")}`;
                break;
            case uikitResources.CometChatUIKitConstants.groupMemberAction.KICKED:
                actionMessage = `${byString} ${uikitResources.localize("KICKED")} ${forString}`;
                break;
            case uikitResources.CometChatUIKitConstants.groupMemberAction.BANNED:
                actionMessage = `${byString} ${uikitResources.localize("BANNED")} ${forString}`;
                break;
            case uikitResources.CometChatUIKitConstants.groupMemberAction.UNBANNED:
                actionMessage = `${byString} ${uikitResources.localize("UNBANNED")} ${forString}`;
                break;
            case uikitResources.CometChatUIKitConstants.groupMemberAction.SCOPE_CHANGE: {
                const newScope = message["data"]["extras"]["scope"]["new"];
                actionMessage = `${byString} ${uikitResources.localize("MADE")} ${forString} ${newScope}`;
                break;
            }
        }
        return actionMessage;
    }
    static getLastMessageInteractive(conversation) {
        var _a;
        let messageObject = conversation === null || conversation === void 0 ? void 0 : conversation.getLastMessage();
        messageObject = InteractiveMessageUtils.convertInteractiveMessage(messageObject);
        switch (messageObject === null || messageObject === void 0 ? void 0 : messageObject.type) {
            case uikitResources.CometChatUIKitConstants.MessageTypes.form:
                return "📋 " + messageObject.getTitle();
            case uikitResources.CometChatUIKitConstants.MessageTypes.card:
                return "🪧 " + messageObject.getText();
            case uikitResources.CometChatUIKitConstants.MessageTypes.scheduler:
                return "🗓️ " + (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getTitle()) || ((_a = messageObject === null || messageObject === void 0 ? void 0 : messageObject.interactiveData) === null || _a === void 0 ? void 0 : _a.title);
            default:
                return messageObject === null || messageObject === void 0 ? void 0 : messageObject.getType();
        }
    }
    static getLastMessageCall(conversation) {
        let messageObject = conversation === null || conversation === void 0 ? void 0 : conversation.getLastMessage();
        if ((messageObject === null || messageObject === void 0 ? void 0 : messageObject.getType()) === "audio") {
            return uikitResources.localize("AUDIO_CALL");
        }
        else if ((messageObject === null || messageObject === void 0 ? void 0 : messageObject.getType()) === "video") {
            return uikitResources.localize("VIDEO_CALL");
        }
        else {
            return messageObject === null || messageObject === void 0 ? void 0 : messageObject.getType();
        }
    }
}

class DetailsUtils {
    static getBanOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban,
            title: uikitResources.localize("BAN"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getPrimary()) !== null && _a !== void 0 ? _a : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.subtitle1)
        });
    }
    static getViewMembersOption(theme) {
        var _a, _b;
        return new uikitResources.CometChatDetailsOption({
            id: (_a = uikitResources.CometChatUIKitConstants.GroupOptions) === null || _a === void 0 ? void 0 : _a.viewMembers,
            title: uikitResources.localize("VIEW_MEMBERS"),
            titleColor: (_b = theme === null || theme === void 0 ? void 0 : theme.palette.getPrimary()) !== null && _b !== void 0 ? _b : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2),
        });
    }
    static getBannedMembersOption(theme) {
        var _a, _b;
        return new uikitResources.CometChatDetailsOption({
            id: (_a = uikitResources.CometChatUIKitConstants.GroupOptions) === null || _a === void 0 ? void 0 : _a.bannedMembers,
            title: uikitResources.localize("BANNED_MEMBERS"),
            titleColor: (_b = theme === null || theme === void 0 ? void 0 : theme.palette.getPrimary()) !== null && _b !== void 0 ? _b : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2),
        });
    }
    static getAddMembersOption(theme) {
        var _a, _b;
        return new uikitResources.CometChatDetailsOption({
            id: (_a = uikitResources.CometChatUIKitConstants.GroupOptions) === null || _a === void 0 ? void 0 : _a.addMembers,
            title: uikitResources.localize("ADD_MEMBERS"),
            titleColor: (_b = theme === null || theme === void 0 ? void 0 : theme.palette.getPrimary()) !== null && _b !== void 0 ? _b : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2),
        });
    }
    static getLeaveGroupOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.GroupOptions.leave,
            title: uikitResources.localize("LEAVE"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getError()) !== null && _a !== void 0 ? _a : '#FF0000',
            titleFont: uikitResources.fontHelper(theme.typography.title2)
        });
    }
    static getDeleteGroupOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.GroupOptions.delete,
            title: uikitResources.localize("DELETE_AND_EXIT"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getError()) !== null && _a !== void 0 ? _a : '#FF0000',
            titleFont: uikitResources.fontHelper(theme.typography.title2),
        });
    }
    static getBlockUserOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.UserOptions.block,
            title: uikitResources.localize("BLOCK_USER"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getError()) !== null && _a !== void 0 ? _a : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2)
        });
    }
    static getUnBlockUserOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.UserOptions.unblock,
            title: uikitResources.localize("UNBLOCK_USER"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getError()) !== null && _a !== void 0 ? _a : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2)
        });
    }
    static getViewProfileOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.UserOptions.viewProfile,
            title: uikitResources.localize("VIEW_PROFILE"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getPrimary()) !== null && _a !== void 0 ? _a : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2)
        });
    }
    static getLeaveOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.GroupOptions.leave,
            title: uikitResources.localize("LEAVE"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getPrimary()) !== null && _a !== void 0 ? _a : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2),
        });
    }
    static getDeleteOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.GroupOptions.delete,
            title: uikitResources.localize("DELETE_AND_EXIT"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getError()) !== null && _a !== void 0 ? _a : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2),
        });
    }
}
DetailsUtils.getDefaultGroupMemberOptions = (loggedInUser, group = null, groupMember = null) => {
};
DetailsUtils.getDefaultDetailsTemplate = (loggedInUser, user = null, group = null, theme = new uikitResources.CometChatTheme({})) => {
    return [
        DetailsUtils.getPrimaryDetailsTemplate(loggedInUser, user, group, theme),
        DetailsUtils.getSecondaryDetailsTeamplate(loggedInUser, user, group, theme)
    ];
};
DetailsUtils.getPrimaryDetailsTemplate = (loggedInUser, user = null, group = null, theme = new uikitResources.CometChatTheme({})) => {
    return new uikitResources.CometChatDetailsTemplate({
        id: uikitResources.CometChatUIKitConstants.details.primary,
        itemSeparatorColor: theme.palette.getAccent200(),
        options: (user, group, section) => {
            let options = [];
            if (user != null && user.getLink()) {
                options.push(DetailsUtils.getViewProfileOption(theme));
            }
            else if (group) {
                options.push(...[
                    DetailsUtils.getViewMembersOption(theme),
                    DetailsUtils.getAddMembersOption(theme),
                    DetailsUtils.getBannedMembersOption(theme)
                ].filter((template) => {
                    let scope = (group === null || group === void 0 ? void 0 : group.getScope()) ? group === null || group === void 0 ? void 0 : group.getScope() : uikitResources.CometChatUIKitConstants.groupMemberScope.participant;
                    let key = group.getOwner() == (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.getUid()) ? uikitResources.CometChatUIKitConstants.groupMemberScope.owner : scope;
                    return template && _allowedGroupMemberOptions$1[key][template === null || template === void 0 ? void 0 : template.id];
                }));
            }
            return options;
        }
    });
};
DetailsUtils.getSecondaryDetailsTeamplate = (loggedInUser, user = null, group = null, theme = new uikitResources.CometChatTheme({})) => {
    return new uikitResources.CometChatDetailsTemplate({
        id: uikitResources.CometChatUIKitConstants.details.secondary,
        title: group ? uikitResources.localize("MORE") : "",
        titleColor: theme.palette.getAccent600(),
        titleFont: uikitResources.fontHelper(theme.typography.caption1),
        itemSeparatorColor: theme.palette.getAccent200(),
        options: (user, group, section) => {
            let options = [];
            if (user != null) {
                if (user.getBlockedByMe()) {
                    options.push(DetailsUtils.getUnBlockUserOption(theme));
                }
                else {
                    options.push(DetailsUtils.getBlockUserOption(theme));
                }
            }
            else if (group) {
                options.push(...[
                    DetailsUtils.getLeaveGroupOption(theme),
                    DetailsUtils.getDeleteGroupOption(theme)
                ].filter((template) => {
                    let scope = (group === null || group === void 0 ? void 0 : group.getScope()) ? group === null || group === void 0 ? void 0 : group.getScope() : uikitResources.CometChatUIKitConstants.groupMemberScope.participant;
                    let key = group.getOwner() == (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.getUid()) ? uikitResources.CometChatUIKitConstants.groupMemberScope.owner : scope;
                    return _allowedGroupMemberOptions$1[key][template.id];
                }));
            }
            return options;
        }
    });
};
DetailsUtils.validateDetailOptions = (loggedInUserScope, optionId) => {
    return _allowedGroupMemberOptions$1[loggedInUserScope][optionId];
};
const _allowedGroupMemberOptions$1 = {
    [uikitResources.CometChatUIKitConstants.groupMemberScope.participant]: {
        [uikitResources.CometChatUIKitConstants.GroupOptions.leave]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.bannedMembers]: false,
        [uikitResources.CometChatUIKitConstants.GroupOptions.viewMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.addMembers]: false,
        [uikitResources.CometChatUIKitConstants.GroupOptions.delete]: false,
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.moderator]: {
        [uikitResources.CometChatUIKitConstants.GroupOptions.leave]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.bannedMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.viewMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.addMembers]: false,
        [uikitResources.CometChatUIKitConstants.GroupOptions.delete]: false,
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.admin]: {
        [uikitResources.CometChatUIKitConstants.GroupOptions.leave]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.bannedMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.viewMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.addMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.delete]: false,
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.owner]: {
        [uikitResources.CometChatUIKitConstants.GroupOptions.leave]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.bannedMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.viewMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.addMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.delete]: true,
    },
};

class GroupMemberUtils {
    static getViewMemberOptions(groupMember, group, loggedInUser = "", theme = new uikitResources.CometChatTheme({})) {
        var _a;
        let options = [];
        let optionStyle = {
            titleFont: uikitResources.fontHelper(theme.typography.subtitle1),
            titleColor: theme.palette.getAccent(),
            backgroundColor: "transparent",
        };
        if (group.getOwner() == groupMember.getUid()) {
            options = uikitResources.CometChatUIKitConstants.groupMemberScope.owner;
        }
        else {
            let loggedInUserScope = group.getOwner() == loggedInUser ? uikitResources.CometChatUIKitConstants.groupMemberScope.owner : (_a = group.getScope()) !== null && _a !== void 0 ? _a : uikitResources.CometChatUIKitConstants.groupMemberScope.participant;
            let isKickAllowed = _allowedGroupMemberOptions[loggedInUserScope + groupMember.getScope()][uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick];
            let isBanAllowed = _allowedGroupMemberOptions[loggedInUserScope + groupMember.getScope()][uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick];
            let ischangeScopeAllowed = _allowedGroupMemberOptions[loggedInUserScope + groupMember.getScope()][uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick];
            if (isKickAllowed) {
                options.push(new uikitResources.CometChatOption({
                    id: uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick,
                    title: uikitResources.localize("REMOVE"),
                    ...optionStyle
                }));
            }
            if (isBanAllowed) {
                options.push(new uikitResources.CometChatOption({
                    id: uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban,
                    title: uikitResources.localize("BLOCK"),
                    ...optionStyle
                }));
            }
            if (ischangeScopeAllowed) {
                options.push(new uikitResources.CometChatOption({
                    id: uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope,
                    title: uikitResources.localize("CHANGE_ROLE"),
                    ...optionStyle
                }));
            }
            if (!isKickAllowed && !isBanAllowed && !ischangeScopeAllowed) {
                options = groupMember.getScope();
            }
        }
        return options;
    }
    static getBannedMemberOptions(group, groupMember, theme = new uikitResources.CometChatTheme({})) {
        if (_allowedGroupMemberOptions[group.getScope() + groupMember.getScope()][uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]) {
            return [new uikitResources.CometChatOption({
                    id: uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban,
                    titleFont: uikitResources.fontHelper(theme.typography.subtitle1),
                    titleColor: theme.palette.getAccent(),
                    backgroundColor: theme.palette.getBackground(),
                    iconTint: theme.palette.getPrimary(),
                    iconURL: ""
                })];
        }
    }
    static allowScopeChange(group, groupMember) {
        let scopes = _allowedGroupMemberOptions[group.getScope() + groupMember.getScope()][uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope];
        if ((scopes === null || scopes === void 0 ? void 0 : scopes.length) > 0 && scopes.includes(groupMember.getScope())) {
            let index = scopes.indexOf(groupMember.getScope());
            scopes.splice(index, 1);
            scopes.unshift(groupMember.getScope());
        }
        return scopes;
    }
}
const _allowedGroupMemberOptions = {
    [uikitResources.CometChatUIKitConstants.groupMemberScope.participant + uikitResources.CometChatUIKitConstants.groupMemberScope.participant]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.participant + uikitResources.CometChatUIKitConstants.groupMemberScope.moderator]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.participant + uikitResources.CometChatUIKitConstants.groupMemberScope.admin]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.participant + uikitResources.CometChatUIKitConstants.groupMemberScope.owner]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
        [uikitResources.CometChatUIKitConstants.GroupOptions.addMembers]: false,
        [uikitResources.CometChatUIKitConstants.GroupOptions.delete]: false,
        [uikitResources.CometChatUIKitConstants.GroupOptions.leave]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.bannedMembers]: false,
        [uikitResources.CometChatUIKitConstants.GroupOptions.viewMembers]: true //Details
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.moderator + uikitResources.CometChatUIKitConstants.groupMemberScope.participant]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.moderator + uikitResources.CometChatUIKitConstants.groupMemberScope.moderator]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.moderator + uikitResources.CometChatUIKitConstants.groupMemberScope.admin]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.moderator + uikitResources.CometChatUIKitConstants.groupMemberScope.owner]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.admin + uikitResources.CometChatUIKitConstants.groupMemberScope.participant]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.admin, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.admin + uikitResources.CometChatUIKitConstants.groupMemberScope.moderator]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.admin, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.admin + uikitResources.CometChatUIKitConstants.groupMemberScope.admin]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.admin, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.admin + uikitResources.CometChatUIKitConstants.groupMemberScope.owner]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.owner + uikitResources.CometChatUIKitConstants.groupMemberScope.participant]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.admin, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.owner + uikitResources.CometChatUIKitConstants.groupMemberScope.moderator]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.admin, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.owner + uikitResources.CometChatUIKitConstants.groupMemberScope.admin]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.admin, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
};

class MessageReceiptUtils {
}
MessageReceiptUtils.getReceiptStatus = (messageObject) => {
    var _a;
    let icon = receipts.wait;
    if ((messageObject === null || messageObject === void 0 ? void 0 : messageObject.error) || ((_a = messageObject === null || messageObject === void 0 ? void 0 : messageObject.metadata) === null || _a === void 0 ? void 0 : _a.error)) {
        icon = receipts.error;
    }
    else if ((messageObject === null || messageObject === void 0 ? void 0 : messageObject.getReceiverType()) == uikitResources.CometChatUIKitConstants.MessageReceiverType.group) {
        if ((messageObject === null || messageObject === void 0 ? void 0 : messageObject.getSentAt()) && (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getId())) {
            icon = receipts.sent;
        }
        else if (!messageObject.getSender()) {
            icon = receipts.wait;
        }
    }
    else {
        if (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getReadAt()) {
            icon = receipts.read;
        }
        else if (!(messageObject === null || messageObject === void 0 ? void 0 : messageObject.getReadAt()) && (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getDeliveredAt())) {
            icon = receipts.delivered;
        }
        else if ((messageObject === null || messageObject === void 0 ? void 0 : messageObject.getSentAt()) && (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getId())) {
            icon = receipts.sent;
        }
        else {
            icon = receipts.wait;
        }
    }
    return icon;
};
var receipts;
(function (receipts) {
    receipts[receipts["wait"] = 0] = "wait";
    receipts[receipts["sent"] = 1] = "sent";
    receipts[receipts["delivered"] = 2] = "delivered";
    receipts[receipts["read"] = 3] = "read";
    receipts[receipts["error"] = 4] = "error";
})(receipts || (receipts = {}));

/**
 * BaseStyle
 *
 * @property {string} height - The height of the component.
 * @property {string} width - The width of the component.
 * @property {string} border - The border of the component.
 * @property {string} borderRadius - The border radius of the component.
 * @property {string} background - The background color of the component.
 */
class BaseStyle {
    constructor(props) {
        this.height = "100%";
        this.width = "100%";
        this.border = "0 none";
        this.borderRadius = "inherit";
        this.background = "inherit";
        Object.assign(this, props);
    }
}

/**
 * The ContactsStyle class defines the style properties for adding members to a group.
 *
 * @extends BaseStyle
 *
 * @property {string} titleTextFont - Font style for the title text.
 * @property {string} titleTextColor - Color for the title text.
 * @property {string} errorStateTextFont - Font style for the error state text.
 * @property {string} errorStateTextColor - Color for the error state text.
 * @property {string} boxShadow - Box shadow for the contacts container.
 * @property {string} closeButtonIconTint - Tint color for the close button icon.
 * @property {string} submitButtonBackground - Background color for the contacts button.
 * @property {string} submitButtonTextColor - Text color for the contacts button.
 * @property {string} submitButtonTextFont - Font style for the text in the contacts button.
 * @property {string} tabWidth - Width of the tab
 * @property {string} tabHeight - Height of the tab
 * @property {string} tabBorder - Border of the tab
 * @property {string} tabBorderRadius - Border Radius of the tab
 * @property {string} tabBackground - Background of the tab
 * @property {string} tabTitleTextFont - Font style for the tab title
 * @property {string} tabTitleTextColor - Font style for the tab title
 * @property {string} activeTabTitleTextColor - Font style for the active tab title
 * @property {string} activeTabTitleTextFont - Font style for the active tab title
 * @property {string} activeTabBackground  - Background style for the active tab
 * @property {string} activeTabBorder - Border style for the active tab
 * @property {string} selectionIconTint - Selection icon tint
 */
class ContactsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.closeIconTint = "RGB(51, 153, 255)";
        this.tabWidth = "";
        this.tabHeight = "";
        this.tabBorder = "";
        this.tabBorderRadius = "";
        this.tabBackground = "";
        this.tabTitleTextFont = "";
        this.tabTitleTextColor = "";
        this.activeTabTitleTextColor = "";
        this.activeTabTitleTextFont = "";
        this.activeTabBackground = "";
        this.activeTabBorder = "";
        this.selectionIconTint = "";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.boxShadow = "";
        this.submitButtonBackground = "RGB(51, 153, 255)";
        this.submitButtonTextColor = "white";
        this.submitButtonTextFont = "600 15px Inter, sans-serif";
        this.padding = "0 100px";
        Object.assign(this, props);
    }
}

/**
 * WithDetailsStyle
 *
 * @property {string} iconTint - The icon color of the component.
 * @property {string} activeIconTint - The active icon color of the component.
 * @property {string} titleTextFont - The title font of the component.
 * @property {string} titleTextColor - The title color of the component.
 * @property {string} activeTitleTextFont - The active title font of the component.
 * @property {string} activeTitleTextColor - The active title color  of the component.
 * @property {string} activeBackground - The mactive background color of the component.
 */
class TabItemStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.iconTint = "RGBA(20, 20, 20, 0.33)";
        this.activeIconTint = "RGB(51, 153, 255)";
        this.titleTextFont = "400 13px Inter";
        this.titleTextColor = "black";
        this.activeTitleTextFont = "400 13px Inter";
        this.activeTitleTextColor = "RGB(51, 153, 255)";
        this.activeBackground = "transparent";
        this.activeBorderRadius = "0";
        this.boxShadow = "";
        Object.assign(this, props);
    }
}

/**
 * ListStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} titleTextFont - Font for title text.
 * @property {string} titleTextColor - Color for title text.
 * @property {string} searchPlaceholderTextFont - Font for search placeholder text.
 * @property {string} searchPlaceholderTextColor - Color for search placeholder text.
 * @property {string} searchTextFont - Font for search text.
 * @property {string} searchTextColor - Color for search text.
 * @property {string} emptyStateTextFont - Font for empty state text.
 * @property {string} emptyStateTextColor - Color for empty state text.
 * @property {string} errorStateTextFont - Font for error state text.
 * @property {string} errorStateTextColor - Color for error state text.
 * @property {string} loadingIconTint - Tint color for loading icon.
 * @property {string} searchIconTint - Tint color for search icon.
 * @property {string} searchBorder - Border for the search field.
 * @property {string} searchBorderRadius - Border radius for the search field.
 * @property {string} searchBackground - Background color for the search field.
 * @property {string} onlineStatusColor - Color for online status.
 * @property {string} separatorColor - Color for separator.
 * @property {string} sectionHeaderTextFont - Font for section header text.
 * @property {string} sectionHeaderTextColor - Color for section header text.
 * @property {string} boxShadow - Shadow for the box.
 */
class ListStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.searchIconTint = "#bcbcbc";
        this.searchBorder = "1px solid RGBA(20, 20, 20, 0.04)";
        this.searchBorderRadius = "8px";
        this.searchBackground = "RGBA(20, 20, 20, 0.04)";
        this.searchPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.searchPlaceholderTextColor = "#bcbcbc";
        this.searchTextFont = "400 13px Inter, sans-serif";
        this.searchTextColor = "RGBA(20, 20, 20, 0.58)";
        this.sectionHeaderTextFont = "500 12px Inter";
        this.sectionHeaderTextColor = "RGBA(20, 20, 20, 0.46)";
        Object.assign(this, props);
    }
}

class TransferOwnershipStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.MemberScopeTextColor = "rgba(20, 20, 20, 0.33)";
        this.MemberScopeTextFont = "400 15px sans-serif";
        this.transferButtonTextFont = "600 15px Inter, sans-serif";
        this.transferButtonTextColor = "white";
        this.cancelButtonTextFont = "600 15px Inter, sans-serif";
        this.cancelButtonTextColor = "black";
        Object.assign(this, props);
    }
}

/**
 * WithMessagesStyle
 *
 * @property {string} height - The height of the component.
 * @property {string} width - The width of the component.
 * @property {string} border - The border of the component.
 * @property {string} borderRadius - The border radius of the component.
 * @property {string} background - The background color of the component.
 * @property {string} messageTextColor - The messageText color of the component.
 * @property {string} messageTextFont - The messageText font of the component.
 */
class WithMessagesStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.messageTextColor = "RGBA(20, 20, 20, 0.33)";
        this.messageTextFont = "700 22px Inter";
        Object.assign(this, props);
    }
}

/**
 * ConversationsStyle
 *
 * @extends BaseStyle
 *
 * @property {string} titleTextFont - The font of the title text.
 * @property {string} titleTextColor - The color of the title text.
 * @property {string} searchPlaceholderTextFont - The font of the search placeholder text.
 * @property {string} searchPlaceholderTextColor - The color of the search placeholder text.
 * @property {string} searchTextFont - The font of the search text.
 * @property {string} searchTextColor - The color of the search text.
 * @property {string} emptyStateTextFont - The font of the empty state text.
 * @property {string} emptyStateTextColor - The color of the empty state text.
 * @property {string} errorStateTextFont - The font of the error state text.
 * @property {string} errorStateTextColor - The color of the error state text.
 * @property {string} loadingIconTint - The tint color of the loading icon.
 * @property {string} searchIconTint - The tint color of the search icon.
 * @property {string} searchBorder - The border of the search input.
 * @property {string} searchBorderRadius - The border radius of the search input.
 * @property {string} searchBackground - The background color of the search input.
 * @property {string} onlineStatusColor - The color of the online status indicator.
 * @property {string} separatorColor - The color of the separator.
 * @property {string} boxShadow - The box shadow of the component.
 * @property {string} privateGroupIconBackground - The background color of the private group icon.
 * @property {string} passwordGroupIconBackground - The background color of the password group icon.
 * @property {string} sectionHeaderTextFont - The font of the section header text.
 * @property {string} sectionHeaderTextColor - The color of the section header text.
 * @property {string} lastMessageTextColor - The color of the last message text.
 * @property {string} lastMessageTextFont - The font of the last message text.
 * @property {string} typingIndictorTextColor - The color of the typing indicator text.
 * @property {string} typingIndictorTextFont - The font of the typing indicator text.
 * @property {string} threadIndicatorTextFont - The font of the thread indicator text.
 * @property {string} threadIndicatorTextColor - The color of the thread indicator text.
 */
class ConversationsStyle extends BaseStyle {
    // * @property {string} mentionsIconTint -The color for the mentions @ icon
    // mentionIconTint?: string = "rgb(51, 153, 255)";
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.onlineStatusColor = "RGB(0, 200, 111)";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.privateGroupIconBackground = "RGBA(20, 20, 20, 0.04)";
        this.passwordGroupIconBackground = "RGB(247, 165, 0)";
        this.lastMessageTextColor = "rgba(20, 20, 20, 0.58)";
        this.lastMessageTextFont = "400 13px Inter, sans-serif";
        this.typingIndictorTextColor = "RGB(67, 161, 255)";
        this.typingIndictorTextFont = "400 13px Inter, sans-serif";
        this.threadIndicatorTextFont = "400 13px Inter, sans-serif";
        this.threadIndicatorTextColor = "RGBA(20, 20, 20, 0.6)";
        Object.assign(this, props);
    }
}

/**
 * GroupsStyle Class to define the styles for the Groups component.
 *
 * @property {string} titleTextFont - The font for the title text.
 * @property {string} titleTextColor - The color for the title text.
 * @property {string} searchPlaceholderTextFont - The font for the search placeholder text.
 * @property {string} searchPlaceholderTextColor - The color for the search placeholder text.
 * @property {string} searchTextFont - The font for the search text.
 * @property {string} searchTextColor - The color for the search text.
 * @property {string} emptyStateTextFont - The font for the empty state text.
 * @property {string} emptyStateTextColor - The color for the empty state text.
 * @property {string} errorStateTextFont - The font for the error state text.
 * @property {string} errorStateTextColor - The color for the error state text.
 * @property {string} loadingIconTint - The tint color for the loading icon.
 * @property {string} searchIconTint - The tint color for the search icon.
 * @property {string} searchBorder - The border for the search field.
 * @property {string} searchBorderRadius - The border radius for the search field.
 * @property {string} searchBackground - The background color for the search field.
 * @property {string} onlineStatusColor - The color for the online status indicator.
 * @property {string} separatorColor - The color for the separators between items.
 * @property {string} boxShadow - The box shadow for the group item.
 * @property {string} subTitleTextFont - The font for the subtitle text.
 * @property {string} subTitleTextColor - The color for the subtitle text.
 * @property {string} privateGroupIconBackground - The background color for the private group icon.
 * @property {string} passwordGroupIconBackground - The background color for the password protected group icon.
 *
 * @extends {BaseStyle}
 */
class GroupsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.privateGroupIconBackground = "RGBA(20, 20, 20, 0.04)";
        this.passwordGroupIconBackground = "RGB(247, 165, 0)";
        this.searchIconTint = "#bcbcbc";
        this.searchBorder = "1px solid RGBA(20, 20, 20, 0.04)";
        this.searchBorderRadius = "8px";
        this.searchBackground = "RGBA(20, 20, 20, 0.04)";
        this.searchPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.searchPlaceholderTextColor = "#bcbcbc";
        this.searchTextFont = "400 13px Inter, sans-serif";
        this.searchTextColor = "RGBA(20, 20, 20, 0.58)";
        this.subTitleTextFont = "400 13px Inter, sans-serif";
        this.subTitleTextColor = "RGBA(20, 20, 20, 0.58)";
        Object.assign(this, props);
    }
}

/**
 * MessageComposerStyle class defines the style for a message composer component.
 *
 * @property {string} attachIcontint - The tint color for the attach icon.
 * @property {string} sendIconTint - The tint color for the send icon.
 * @property {string} emojiIconTint - The tint color for the emoji icon.
 * @property {string} inputBackground - The background color for the input field.
 * @property {string} inputBorder - The border color for the input field.
 * @property {string} dividerTint - The tint color for the divider.
 * @property {string} textFont - The font for the text.
 * @property {string} textColor - The color for the text.
 * @property {string} placeHolderTextColor - The color for the placeholder text.
 * @property {string} placeHolderTextFont - The font for the placeholder text.
 * @property {string} ActionSheetSeparatorTint - The tint color for the action sheet separator.
 * @property {string} ActionSheetTitleColor - The color for the action sheet title.
 * @property {string} ActionSheetTitleFont - The font for the action sheet title.
 * @property {string} ActionSheetLayoutModeIconTint - The tint color for the action sheet layout mode icon.
 * @property {string} emojiKeyboardTextFont - The font for the emoji keyboard text.
 * @property {string} emojiKeyboardTextColor - The color for the emoji keyboard text.
 * @property {string} previewTitleFont - The font for the preview title.
 * @property {string} previewTitleColor - The color for the preview title.
 * @property {string} previewSubtitleFont - The font for the preview subtitle.
 * @property {string} previewSubtitleColor - The color for the preview subtitle.
 * @property {string} closePreviewTint - The tint color for the close preview button.
 * @property {string} maxInputHeight - The maximum height of the input field.
 * @extends {BaseStyle}
 */
class MessageComposerStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.attachIcontint = "RGBA(20, 20, 20, 0.46)";
        this.sendIconTint = "RGBA(20, 20, 20, 0.46)";
        this.emojiIconTint = "RGBA(20, 20, 20, 0.46)";
        this.AIIconTint = "RGBA(20, 20, 20, 0.46)";
        this.voiceRecordingIconTint = "RGBA(20, 20, 20, 0.46)";
        this.inputBackground = "RGBA(20, 20, 20, 0.04)";
        this.inputBorder = "1px solid RGBA(20, 20, 20, 0.08)";
        this.inputBorderRadius = "12px";
        this.dividerTint = "RGBA(20, 20, 20, 0.08)";
        this.textFont = "400 13px Inter";
        this.textColor = "black";
        this.placeHolderTextColor = "";
        this.placeHolderTextFont = "";
        this.emojiKeyboardTextFont = "400 13px Inter";
        this.emojiKeyboardTextColor = "RGBA(20, 20, 20, 0.6)";
        this.previewTitleFont = "500 12px Inter, sans-serif";
        this.previewTitleColor = "grey";
        this.previewSubtitleColor = "grey";
        this.previewSubtitleFont = "400 13px Inter, sans-serif";
        this.closePreviewTint = "grey";
        this.maxInputHeight = "100px";
        Object.assign(this, props);
    }
}

/**
 * MessageHeaderStyle class represents the styles for message header.
 *
 * @property {string} backButtonIconTint- Tint color for back button icon.
 * @property {string} onlineStatusColor - Color for online status.
 * @property {string} subtitleTextColor - Text color for subtitle.
 * @property {string} subtitleTextFont - Font for subtitle text.
 * @property {string} typingIndicatorTextColor - Text color for typing indicator.
 * @property {string} typingIndicatorTextFont - Font for typing indicator text.
 *  @extends {BaseStyle}
 */
class MessageHeaderStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.backButtonIconTint = "#3399FF";
        this.onlineStatusColor = "#00f300";
        this.subtitleTextColor = "grey";
        this.subtitleTextFont = "400 14px Inter";
        this.typingIndicatorTextColor = "#3399FF";
        this.typingIndicatorTextFont = "400 13px Inter";
        this.privateGroupIconBackground = "rgb(0, 200, 111)";
        this.passwordGroupIconBackground = "RGB(247, 165, 0)";
        Object.assign(this, props);
    }
}

/**
 * MessageListStyle class represents the styles for message list. It extends BaseStyle.
 *
 * @property {string} nameTextFont - Font for name text.
 * @property {string} nameTextColor - Color for name text.
 * @property {string} threadReplySeparatorColor - Separator color for thread reply.
 * @property {string} threadReplyTextFont - Font for thread reply text.
 * @property {string} threadReplyIconTint - Tint color for thread reply icon.
 * @property {string} threadReplyTextColor - Color for thread reply text.
 * @property {string} textFont - Font for text.
 * @property {string} textColor - Color for text.
 * @property {string} emptyStateTextFont - Font for empty state text.
 * @property {string} emptyStateTextColor - Color for empty state text.
 * @property {string} errorStateTextFont - Font for error state text.
 * @property {string} errorStateTextColor - Color for error state text.
 * @property {string} loadingIconTint - Tint color for loading icon.
 *   @extends {BaseStyle}
 */
class MessageListStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.nameTextFont = "500 12px Inter, sans-serif";
        this.nameTextColor = "RGBA(20, 20, 20, 0.6)";
        this.threadReplyTextFont = "500 15px Inter, sans-serif,";
        this.threadReplyIconTint = "RGBA(20, 20, 20, 0.6)";
        this.threadReplyTextColor = "RGB(51, 153, 255)";
        this.threadReplyUnreadTextColor = "RGB(51, 153, 255)";
        this.threadReplyUnreadTextFont = "500 15px Inter, sans-serif";
        this.threadReplyUnreadBackground = "RGBA(51, 153, 255, 0.1)";
        this.TimestampTextFont = "";
        this.TimestampTextColor = "";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "grey";
        Object.assign(this, props);
    }
}

/**
 * MessagesStyle class represents the styles for messages. It extends BaseStyle.
 *
 * @property {string} messageTextColor - Color for message text.
 * @property {string} messageTextFont - Font for message text.
 *   @extends {BaseStyle}
 */
class MessagesStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.messageTextColor = "rgba(20, 20, 20, 0.33)";
        this.messageTextFont = "700 22px Inter";
        Object.assign(this, props);
    }
}

/**
 * UsersStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} titleTextFont - Font for title text.
 * @property {string} titleTextColor - Color for title text.
 * @property {string} searchPlaceholderTextFont - Font for search placeholder text.
 * @property {string} searchPlaceholderTextColor - Color for search placeholder text.
 * @property {string} searchTextFont - Font for search text.
 * @property {string} searchTextColor - Color for search text.
 * @property {string} emptyStateTextFont - Font for empty state text.
 * @property {string} emptyStateTextColor - Color for empty state text.
 * @property {string} errorStateTextFont - Font for error state text.
 * @property {string} errorStateTextColor - Color for error state text.
 * @property {string} loadingIconTint - Tint color for loading icon.
 * @property {string} searchIconTint - Tint color for search icon.
 * @property {string} searchBorder - Border for the search field.
 * @property {string} searchBorderRadius - Border radius for the search field.
 * @property {string} searchBackground - Background color for the search field.
 * @property {string} onlineStatusColor - Color for online status.
 * @property {string} separatorColor - Color for separator.
 * @property {string} sectionHeaderTextFont - Font for section header text.
 * @property {string} sectionHeaderTextColor - Color for section header text.
 * @property {string} boxShadow - Shadow for the box.
 */
class UsersStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.onlineStatusColor = "RGB(0, 200, 111)";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.searchIconTint = "#bcbcbc";
        this.searchBorder = "1px solid RGBA(20, 20, 20, 0.04)";
        this.searchBorderRadius = "8px";
        this.searchBackground = "RGBA(20, 20, 20, 0.04)";
        this.searchPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.searchPlaceholderTextColor = "#bcbcbc";
        this.searchTextFont = "400 13px Inter, sans-serif";
        this.searchTextColor = "RGBA(20, 20, 20, 0.58)";
        this.sectionHeaderTextFont = "500 12px Inter";
        this.sectionHeaderTextColor = "RGBA(20, 20, 20, 0.46)";
        Object.assign(this, props);
    }
}

/**
 * GroupMembersStyle Class representing the styles for group members
 *
 * @property {string} titleTextFont - The font style for the title text.
 * @property {string} titleTextColor - The text color for the title text.
 * @property {string} searchPlaceholderTextFont - The font style for the search placeholder text.
 * @property {string} searchPlaceholderTextColor - The text color for the search placeholder text.
 * @property {string} searchTextFont - The font style for the search text.
 * @property {string} searchTextColor - The text color for the search text.
 * @property {string} emptyStateTextFont - The font style for the empty state text.
 * @property {string} emptyStateTextColor - The text color for the empty state text.
 * @property {string} errorStateTextFont - The font style for the error state text.
 * @property {string} errorStateTextColor - The text color for the error state text.
 * @property {string} loadingIconTint - The tint color for the loading icon.
 * @property {string} searchIconTint - The tint color for the search icon.
 * @property {string} searchBorder - The border for the search box.
 * @property {string} searchBorderRadius - The border radius for the search box.
 * @property {string} searchBackground - The background color for the search box.
 * @property {string} onlineStatusColor - The color indicating the online status of a member.
 * @property {string} separatorColor - The color of the separator.
 * @property {string} sectionHeaderTextFont - The font style for the section header text.
 * @property {string} sectionHeaderTextColor - The text color for the section header text.
 * @property {string} boxShadow - The box shadow for the members list.
 * @property {string} backButtonIconTint - The tint color for the back button icon.
 * @property {string} closeButtonIconTint - The tint color for the close button icon.
 * @property {string} privateGroupIconBackground - The background color for the private group icon.
 * @property {string} passwordGroupIconBackground - The background color for the password protected group icon.
 *
 * @extends {BaseStyle}
 */
class GroupMembersStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.searchPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.searchPlaceholderTextColor = "#bcbcbc";
        this.searchTextFont = "400 13px Inter, sans-serif";
        this.searchTextColor = "RGBA(20, 20, 20, 0.58)";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.searchIconTint = "#bcbcbc";
        this.searchBorder = "1px solid RGBA(20, 20, 20, 0.04)";
        this.searchBorderRadius = "8px";
        this.searchBackground = "RGBA(20, 20, 20, 0.04)";
        this.onlineStatusColor = "RGB(0, 200, 111)";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.boxShadow = "";
        this.backButtonIconTint = "RGB(51, 153, 255)";
        this.closeButtonIconTint = "RGB(51, 153, 255)";
        this.privateGroupIconBackground = "RGBA(20, 20, 20, 0.04)";
        this.passwordGroupIconBackground = "RGB(247, 165, 0)";
        this.padding = "0 100px";
        Object.assign(this, props);
    }
}

/**
 * The AddMembersStyle class defines the style properties for adding members to a group.
 *
 * @extends BaseStyle
 *
 * @property {string} titleTextFont - Font style for the title text.
 * @property {string} titleTextColor - Color for the title text.
 * @property {string} searchPlaceholderTextFont - Font style for the search placeholder text.
 * @property {string} searchPlaceholderTextColor - Color for the search placeholder text.
 * @property {string} searchTextFont - Font style for the search text.
 * @property {string} searchTextColor - Color for the search text.
 * @property {string} emptyStateTextFont - Font style for the empty state text.
 * @property {string} emptyStateTextColor - Color for the empty state text.
 * @property {string} errorStateTextFont - Font style for the error state text.
 * @property {string} errorStateTextColor - Color for the error state text.
 * @property {string} loadingIconTint - Tint color for the loading icon.
 * @property {string} searchIconTint - Tint color for the search icon.
 * @property {string} searchBorder - Border for the search container.
 * @property {string} searchBorderRadius - Border radius for the search container.
 * @property {string} searchBackground - Background color for the search container.
 * @property {string} onlineStatusColor - Color for the online status indicator.
 * @property {string} separatorColor - Color for the separator.
 * @property {string} sectionHeaderTextFont - Font style for the section header text.
 * @property {string} sectionHeaderTextColor - Color for the section header text.
 * @property {string} boxShadow - Box shadow for the add members container.
 * @property {string} backButtonIconTint - Tint color for the back button icon.
 * @property {string} closeButtonIconTint - Tint color for the close button icon.
 * @property {string} privateGroupIconBackground - Background color for the private group icon.
 * @property {string} passwordGroupIconBackground - Background color for the password protected group icon.
 * @property {string} addMembersButtonBackground - Background color for the add members button.
 * @property {string} addMembersButtonTextColor - Text color for the add members button.
 * @property {string} addMembersButtonTextFont - Font style for the text in the add members button.
 */
class AddMembersStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.searchPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.searchPlaceholderTextColor = "#bcbcbc";
        this.searchTextFont = "400 13px Inter, sans-serif";
        this.searchTextColor = "RGBA(20, 20, 20, 0.58)";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.searchIconTint = "#bcbcbc";
        this.searchBorder = "1px solid RGBA(20, 20, 20, 0.04)";
        this.searchBorderRadius = "8px";
        this.searchBackground = "RGBA(20, 20, 20, 0.04)";
        this.onlineStatusColor = "RGB(0, 200, 111)";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.sectionHeaderTextFont = "500 12px Inter, sans-serif";
        this.sectionHeaderTextColor = "RGBA(20, 20, 20, 0.46)";
        this.boxShadow = "";
        this.backButtonIconTint = "RGB(51, 153, 255)";
        this.closeButtonIconTint = "RGB(51, 153, 255)";
        this.addMembersButtonBackground = "RGB(51, 153, 255)";
        this.addMembersButtonTextColor = "white";
        this.addMembersButtonTextFont = "600 15px Inter, sans-serif";
        this.padding = "0 100px";
        Object.assign(this, props);
    }
}

/**
 * BannedMembersStyle
 *
 * @extends BaseStyle
 *
 * @property {string} titleTextFont - The font of the title text.
 * @property {string} titleTextColor - The color of the title text.
 * @property {string} searchPlaceholderTextFont - The font of the search placeholder text.
 * @property {string} searchPlaceholderTextColor - The color of the search placeholder text.
 * @property {string} searchTextFont - The font of the search text.
 * @property {string} searchTextColor - The color of the search text.
 * @property {string} emptyStateTextFont - The font of the empty state text.
 * @property {string} emptyStateTextColor - The color of the empty state text.
 * @property {string} errorStateTextFont - The font of the error state text.
 * @property {string} errorStateTextColor - The color of the error state text.
 * @property {string} loadingIconTint - The tint of the loading icon.
 * @property {string} searchIconTint - The tint of the search icon.
 * @property {string} searchBorder - The border of the search field.
 * @property {string} searchBorderRadius - The border radius of the search field.
 * @property {string} searchBackground - The background color of the search field.
 * @property {string} onlineStatusColor - The color of the online status.
 * @property {string} separatorColor - The color of the separator.
 * @property {string} sectionHeaderTextFont - The font of the section header text.
 * @property {string} sectionHeaderTextColor - The color of the section header text.
 * @property {string} boxShadow - The box shadow style.
 * @property {string} backButtonIconTint - The tint of the back button icon.
 * @property {string} closeButtonIconTint - The tint of the close button icon.
 * @property {string} privateGroupIconBackground - The background color of the private group icon.
 * @property {string} passwordGroupIconBackground - The background color of the password group icon.
 * @property {string} unbanIconTint - The tint of the unban icon.
 */
class BannedMembersStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.searchPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.searchPlaceholderTextColor = "#bcbcbc";
        this.searchTextFont = "400 13px Inter, sans-serif";
        this.searchTextColor = "RGBA(20, 20, 20, 0.58)";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.searchIconTint = "#bcbcbc";
        this.searchBorder = "1px solid RGBA(20, 20, 20, 0.04)";
        this.searchBorderRadius = "8px";
        this.searchBackground = "RGBA(20, 20, 20, 0.04)";
        this.onlineStatusColor = "RGB(0, 200, 111)";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.boxShadow = "";
        this.backButtonIconTint = "RGB(51, 153, 255)";
        this.closeButtonIconTint = "RGB(51, 153, 255)";
        this.unbanIconTint = "RGB(51, 153, 255)";
        this.padding = "0 100px";
        Object.assign(this, props);
    }
}

/**
 * ThreadedMessagesStyle class represents the styles for ThreadedMessagesStyle. It extends BaseStyle.
 *
 * @property {string} titleColor - Color for title text.
 * @property {string} titleFont - Font for title text.
 * @property {string} closeIconTint - Shadow for the box.
 *   @extends {BaseStyle}
 */
class ThreadedMessagesStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleColor = "rgba(20, 20, 20, 0.33)";
        this.titleFont = "700 22px Inter";
        this.closeIconTint = "rgba(20, 20, 20, 0.1)";
        Object.assign(this, props);
    }
}

/**
 * DetailsStyle
 *
 * @extends BaseStyle
 *
 * @property {string} titleTextFont - The font of the title text.
 * @property {string} titleTextColor - The color of the title text.
 * @property {string} onlineStatusColor - The color of the online status indicator.
 * @property {string} separatorColor - The color of the separator.
 * @property {string} privateGroupIconBackground - The background color of the private group icon.
 * @property {string} passwordGroupIconBackground - The background color of the password group icon.
 * @property {string} subtitleTextColor - The color of the subtitle text.
 * @property {string} subtitleTextFont - The font of the subtitle text.
 * @property {string} closeButtonIconTint - The color of the close button
 *  @property {string} margin - The margin of the DetailsComponent
 */
class DetailsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.onlineStatusColor = "RGB(0, 200, 111)";
        this.privateGroupIconBackground = "RGB(0, 200, 111)";
        this.passwordGroupIconBackground = "RGB(247, 165, 0)";
        this.subtitleTextColor = "rgba(20, 20, 20, 0.58)";
        this.subtitleTextFont = "400 13px Inter, sans-serif";
        this.closeButtonIconTint = "RGB(51, 153, 255)";
        this.padding = "0 100px";
        Object.assign(this, props);
    }
}

class OptionsStyle {
    constructor(props) {
        this.titleFont = "";
        this.titleColor = "";
        this.background = "";
        this.iconTint = "";
        Object.assign(this, props);
    }
}

/**
 * MessageInformationStyle class represents the styles for Message information component. It extends BaseStyle.
 *
 * @property {string} titleTextFont - Font for title text.
 * @property {string} titleTextColor - Color for title text.
 * @property {string} sendIconTint - Send icon tint.
 * @property {string} readIconTint - Read icon tint.
 * @property {string} deliveredIconTint - Delivered icon tint.
 * @property {string} emptyStateTextFont - Font for empty state text.
 * @property {string} emptyStateTextColor - Color for empty state text.
 * @property {string} errorStateTextFont - Font for error state text.
 * @property {string} errorStateTextColor - Color for error state text.
 * @property {string} loadingIconTint - Tint color for loading icon.
 * @property {string} subtitleTextFont - Font for subtitle  text.
 * @property {string} subtitleTextColor - Color for subtitle  text.
 * @property {string} dividerTint - divider icon tint.
 */
class MessageInformationStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.sendIconTint = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.readIconTint = "RGBA(20, 20, 20, 0.04)";
        this.deliveredIconTint = "#bcbcbc";
        this.subtitleTextFont = "500 12px Inter";
        this.subtitleTextColor = "RGBA(20, 20, 20, 0.46)";
        this.dividerTint = "";
        this.captionTextFont = "400 13px Inter, sans-serif";
        this.captionTextColor = "#bcbcbc";
        Object.assign(this, props);
    }
}

var LoadingIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FSpinner%402x%3C%2Ftitle%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpattern%20id%3D%22pattern-1%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20patternUnits%3D%22objectBoundingBox%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23image-2%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%3C%2Fpattern%3E%20%20%20%20%20%20%20%20%3Cimage%20id%3D%22image-2%22%20width%3D%2224%22%20height%3D%2224%22%20xlink%3Ahref%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAACH0lEQVRIDY2SyU0FQQxE57PDlThIAIkDSARARqRAJITACQ5ciYMr%2B1av6TfyDAPCUn27vVS5%2B89qGIaLYK1gvcd4sTGL5%2Bc6Ixe5FY0fQbVVDuBzAUt99kusJ7%2F2l0AdRKxarTWiFCWe%2BP8IcENvgwiEWBWZkKbmk41PVAnadP%2BBBAFFrP2HvIlyg%2FeAg%2BZzQGJNAWt1Yz%2BE6q23G0DCICQ0SZKwGc3kqWNuXwmJWRYvOX4iwCDkFPAKkVeAHGdFIa0wb88owHYmaeIMFCEHkX3EmwWcvRG9cDVQ4IlMSEATeYUSNoKdeGqQbwXbPf7xNMmPAm%2F9EDcKUYSImkskHHYDyPc6EHFzl6x%2BMpzeZjRgtRGxx5YdhoP4%2FQAhyO1L2GI81njYji2r%2Be54wVO9BnfBeXAZHAY%2BYZ1JerRPr18bKikELAD5Q3AfsP1ZP7%2FEXwVHAb3Ojny%2BsyQQAQbBUwfkgFr9D%2FhPTnuO%2FE2PWZzn20CAr0VUIUWeUwec2ZIZyPyK%2BJKIyZ0E1LnRdbDuE3k9PJgLIkyOGn8ecxD6FP7RLnyb2jH1JQHJ8RALl4AMovYE8YokbEtQd5GJAEkhuWLmIXFbBMwrQo0Ze0YBGmimuOTJ0SMRNxAImU%2FYTIEPnsgt9G6tmPlKIoEi%2BLrAt0xusiQgYfV1GHJsLlJ7rC%2FeQGIGiOeDDiPA5vT8doP2uUlY%2FRI5uWr1Bi4x7xm%2BABSc5FGl1EGyAAAAAElFTkSuQmCC%22%3E%3C%2Fimage%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FSpinner%22%20fill%3D%22url%28%23pattern-1%29%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3.86827202%2C3.86827202%20C4.25879631%2C3.47774772%204.89196129%2C3.47774772%205.28248558%2C3.86827202%20L9.17157288%2C7.75735931%20C9.56209717%2C8.1478836%209.56209717%2C8.78104858%209.17157288%2C9.17157288%20C8.78104858%2C9.56209717%208.1478836%2C9.56209717%207.75735931%2C9.17157288%20L3.86827202%2C5.28248558%20C3.47774772%2C4.89196129%203.47774772%2C4.25879631%203.86827202%2C3.86827202%20Z%20M12%2C0.5%20C12.5522847%2C0.5%2013%2C0.94771525%2013%2C1.5%20L13%2C7%20C13%2C7.55228475%2012.5522847%2C8%2012%2C8%20C11.4477153%2C8%2011%2C7.55228475%2011%2C7%20L11%2C1.5%20C11%2C0.94771525%2011.4477153%2C0.5%2012%2C0.5%20Z%20M20.131728%2C3.86827202%20C20.5222523%2C4.25879631%2020.5222523%2C4.89196129%2020.131728%2C5.28248558%20L16.2426407%2C9.17157288%20C15.8521164%2C9.56209717%2015.2189514%2C9.56209717%2014.8284271%2C9.17157288%20C14.4379028%2C8.78104858%2014.4379028%2C8.1478836%2014.8284271%2C7.75735931%20L18.7175144%2C3.86827202%20C19.1080387%2C3.47774772%2019.7412037%2C3.47774772%2020.131728%2C3.86827202%20Z%20M23.5%2C12%20C23.5%2C12.5522847%2023.0522847%2C13%2022.5%2C13%20L17%2C13%20C16.4477153%2C13%2016%2C12.5522847%2016%2C12%20C16%2C11.4477153%2016.4477153%2C11%2017%2C11%20L22.5%2C11%20C23.0522847%2C11%2023.5%2C11.4477153%2023.5%2C12%20Z%20M20.131728%2C20.131728%20C19.7412037%2C20.5222523%2019.1080387%2C20.5222523%2018.7175144%2C20.131728%20L14.8284271%2C16.2426407%20C14.4379028%2C15.8521164%2014.4379028%2C15.2189514%2014.8284271%2C14.8284271%20C15.2189514%2C14.4379028%2015.8521164%2C14.4379028%2016.2426407%2C14.8284271%20L20.131728%2C18.7175144%20C20.5222523%2C19.1080387%2020.5222523%2C19.7412037%2020.131728%2C20.131728%20Z%20M12%2C23.5%20C11.4477153%2C23.5%2011%2C23.0522847%2011%2C22.5%20L11%2C17%20C11%2C16.4477153%2011.4477153%2C16%2012%2C16%20C12.5522847%2C16%2013%2C16.4477153%2013%2C17%20L13%2C22.5%20C13%2C23.0522847%2012.5522847%2C23.5%2012%2C23.5%20Z%20M3.86827202%2C20.131728%20C3.47774772%2C19.7412037%203.47774772%2C19.1080387%203.86827202%2C18.7175144%20L7.75735931%2C14.8284271%20C8.1478836%2C14.4379028%208.78104858%2C14.4379028%209.17157288%2C14.8284271%20C9.56209717%2C15.2189514%209.56209717%2C15.8521164%209.17157288%2C16.2426407%20L5.28248558%2C20.131728%20C4.89196129%2C20.5222523%204.25879631%2C20.5222523%203.86827202%2C20.131728%20Z%20M0.5%2C12%20C0.5%2C11.4477153%200.94771525%2C11%201.5%2C11%20L7%2C11%20C7.55228475%2C11%208%2C11.4477153%208%2C12%20C8%2C12.5522847%207.55228475%2C13%207%2C13%20L1.5%2C13%20C0.94771525%2C13%200.5%2C12.5522847%200.5%2C12%20Z%22%20id%3D%22Rectangle-2%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var closeIcon$1 = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FClose%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FClose%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%285.000000%2C%205.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%2214%22%20y2%3D%2214%22%20id%3D%22Path-9%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%2214%22%20y2%3D%2214%22%20id%3D%22Path-9%22%20transform%3D%22translate%287.000000%2C%207.000000%29%20scale%28-1%2C%201%29%20translate%28-7.000000%2C%20-7.000000%29%20%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var readicon = "data:image/svg+xml,%3Csvg%20width%3D%2214%22%20height%3D%2212%22%20viewBox%3D%220%200%2014%2012%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20opacity%3D%220.8%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M9.15147%203.15262C9.32528%202.93804%209.29224%202.62319%209.07766%202.44938C8.86308%202.27557%208.54822%202.30861%208.37441%202.52319L3.61414%208.39998L1.626%206.42494C1.4301%206.23032%201.11352%206.23137%200.918901%206.42727C0.724285%206.62318%200.725331%206.93976%200.921238%207.13438L3.30197%209.49942C3.40229%209.59908%203.54012%209.6516%203.68131%209.64398C3.82251%209.63635%203.95388%209.5693%204.04289%209.45942L9.15147%203.15262ZM13.0814%203.16663C13.263%202.95855%2013.2415%202.6427%2013.0334%202.46115C12.8253%202.27961%2012.5095%202.30111%2012.3279%202.50919L7.17358%208.41667L6.74794%207.99934C6.55077%207.80601%206.2342%207.80912%206.04087%208.0063C5.84754%208.20348%205.85066%208.52004%206.04783%208.71337L6.85187%209.50172C6.95016%209.59809%207.08383%209.64968%207.22138%209.64433C7.35892%209.63897%207.48818%209.57715%207.57868%209.47343L13.0814%203.16663Z%22%20fill%3D%22%239C9CA3%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var deliveredicon = "data:image/svg+xml,%3Csvg%20width%3D%2214%22%20height%3D%2212%22%20viewBox%3D%220%200%2014%2012%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20opacity%3D%220.8%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M9.15147%203.15262C9.32528%202.93804%209.29224%202.62319%209.07766%202.44938C8.86308%202.27557%208.54822%202.30861%208.37441%202.52319L3.61414%208.39998L1.626%206.42494C1.4301%206.23032%201.11352%206.23137%200.918901%206.42727C0.724285%206.62318%200.725331%206.93976%200.921238%207.13438L3.30197%209.49942C3.40229%209.59908%203.54012%209.6516%203.68131%209.64398C3.82251%209.63635%203.95388%209.5693%204.04289%209.45942L9.15147%203.15262ZM13.0814%203.16663C13.263%202.95855%2013.2415%202.6427%2013.0334%202.46115C12.8253%202.27961%2012.5095%202.30111%2012.3279%202.50919L7.17358%208.41667L6.74794%207.99934C6.55077%207.80601%206.2342%207.80912%206.04087%208.0063C5.84754%208.20348%205.85066%208.52004%206.04783%208.71337L6.85187%209.50172C6.95016%209.59809%207.08383%209.64968%207.22138%209.64433C7.35892%209.63897%207.48818%209.57715%207.57868%209.47343L13.0814%203.16663Z%22%20fill%3D%22%239C9CA3%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

/**
  * @property {any} subtitleView - The view for subtitle.
  * @property {any} listItemView - The view for list item.
  * @property {any} bubbleView - The menu.
  * @property {DatePatterns} receiptDatePattern - Enum for date pattern
  * @property {DatePatterns} readIcon - Read icon url
  * @property {DatePatterns} deliveredIcon - Delivered icon url
  * @property {DatePatterns} closeIconURL - Close icon url
  * @property {any} emptyStateView - The view for empty state.
  * @property {any} errorStateView - The view for error state.
  * @property {string} loadingIconURL - The URL for loading icon.
  * @property {any} loadingStateView - The view for loading state.
  * @property {UsersStyle} messageInformationStyle - The style for users.
  * @property {ListItemStyle} listItemStyle - The style for list item.
  * @property {(()=>void) | null} onClose - The style for list item.
  * @property {((error:CometChat.CometChatException)=>void) | null} onError - The style for list item.
  */
class MessageInformationConfiguration {
    constructor(props) {
        this.readIcon = readicon;
        this.deliveredIcon = deliveredicon;
        this.listItemStyle = {};
        this.loadingIconURL = LoadingIcon;
        this.closeIconURL = closeIcon$1;
        this.messageInformationStyle = {};
        Object.assign(this, props);
    }
}

var searchIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M4.9598%2011.531C5.47958%2012.7541%206.4639%2013.7205%207.69625%2014.2178C8.92859%2014.7151%2010.308%2014.7024%2011.531%2014.1826C12.754%2013.6629%2013.7205%2012.6785%2014.2178%2011.4462C14.715%2010.2139%2014.7024%208.83445%2014.1826%207.61142C13.6629%206.3884%2012.6785%205.42195%2011.4462%204.92467C10.2138%204.4274%208.83444%204.44004%207.61141%204.95981C6.38839%205.47959%205.42194%206.46391%204.92467%207.69626C4.42739%208.9286%204.44003%2010.308%204.9598%2011.531V11.531Z%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.114%2013.1139L17.0001%2017.0005%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

/**
  * @property {any} usersRequestBuilder - The request builder for users.
  * @property {any} searchRequestBuilder - The request builder for search.
  * @property {any} subtitleView - The view for subtitle.
  * @property {boolean} disableUsersPresence - Indicates whether to disable users presence or not.
  * @property {any} listItemView - The view for list item.
  * @property {any} menu - The menu.
  * @property {any} options - The options.
  * @property {boolean} hideSeparator - Indicates whether to hide separator or not.
  * @property {SelectionMode} selectionMode - The selection mode.
  * @property {boolean} hideError - Indicates whether to hide error or not.
  * @property {group:CometChat.User} onSelect - The callback on select.
  * @property {any} emptyStateView - The view for empty state.
  * @property {any} errorStateView - The view for error state.
  * @property {string} loadingIconURL - The URL for loading icon.
  * @property {any} loadingStateView - The view for loading state.
  * @property {TitleAlignment} titleAlignment - The alignment of title.
  * @property {BaseStyle} statusIndicatorStyle - The style for status indicator.
  * @property {AvatarStyle} avatarStyle - The style for avatar.
  * @property {UsersStyle} usersStyle - The style for users.
  * @property {ListItemStyle} listItemStyle - The style for list item.
  */
class UsersConfiguration {
    constructor(props) {
        this.disableUsersPresence = false;
        this.selectionMode = uikitResources.SelectionMode.none;
        this.hideError = false;
        this.showSectionHeader = true;
        this.loadingIconURL = LoadingIcon;
        this.searchIconURL = searchIcon;
        this.hideSearch = false;
        this.titleAlignment = uikitResources.TitleAlignment.left;
        this.statusIndicatorStyle = {
            height: "12px",
            width: "12px",
            borderRadius: "16px"
        };
        this.avatarStyle = {
            borderRadius: "16px",
            width: "28px",
            height: "28px",
            border: "1px solid rgb(238 238 238)",
        };
        this.usersStyle = {};
        this.listItemStyle = {};
        Object.assign(this, props);
    }
}

var privateIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2214px%22%20height%3D%2214px%22%20viewBox%3D%220%200%2014%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EPrivate%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Symbols-v2%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Private%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20fill%3D%22%2300C86F%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2214%22%20height%3D%2214%22%20rx%3D%227%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4%2C5%20C5.33333333%2C4.66666667%206.33333333%2C4%207%2C3%20C7.66666667%2C4%208.66666667%2C4.66666667%2010%2C5%20L10%2C6.14589803%20C10%2C8.20151331%208.83859819%2C10.0807009%207%2C11%20L7%2C11%20L7%2C11%20C5.16140181%2C10.0807009%204%2C8.20151331%204%2C6.14589803%20L4%2C5%20L4%2C5%20Z%22%20id%3D%22Rectangle%22%20fill%3D%22%23FFFFFF%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var lockedIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2214px%22%20height%3D%2214px%22%20viewBox%3D%220%200%2014%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3ELocked%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Symbols-v2%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Locked%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20fill%3D%22%23F7A500%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2214%22%20height%3D%2214%22%20rx%3D%227%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7%2C3%20C8.1045695%2C3%209%2C3.8954305%209%2C5%20L9.00079851%2C6.00841863%20C9.2437935%2C6.025429%209.36573413%2C6.06795171%209.48842285%2C6.13356635%20C9.65138581%2C6.2207199%209.7792801%2C6.34861419%209.86643365%2C6.51157715%20C9.95358719%2C6.67454011%2010%2C6.83618323%2010%2C7.2819426%20L10%2C9.7180574%20C10%2C10.1638168%209.95358719%2C10.3254599%209.86643365%2C10.4884229%20C9.7792801%2C10.6513858%209.65138581%2C10.7792801%209.48842285%2C10.8664336%20C9.32545989%2C10.9535872%209.16381677%2C11%208.7180574%2C11%20L5.2819426%2C11%20C4.83618323%2C11%204.67454011%2C10.9535872%204.51157715%2C10.8664336%20C4.34861419%2C10.7792801%204.2207199%2C10.6513858%204.13356635%2C10.4884229%20C4.04641281%2C10.3254599%204%2C10.1638168%204%2C9.7180574%20L4%2C7.2819426%20C4%2C6.83618323%204.04641281%2C6.67454011%204.13356635%2C6.51157715%20C4.2207199%2C6.34861419%204.34861419%2C6.2207199%204.51157715%2C6.13356635%20C4.63442137%2C6.06786855%204.7565156%2C6.02532125%205.00012601%2C6.00835408%20L5%2C5%20C5%2C3.8954305%205.8954305%2C3%207%2C3%20Z%20M7%2C4%20C6.48716416%2C4%206.06449284%2C4.38604019%206.00672773%2C4.88337887%20L6%2C5%20L6%2C6%20L8%2C6%20L8%2C5%20C8%2C4.44771525%207.55228475%2C4%207%2C4%20Z%22%20id%3D%22Rectangle-3%22%20fill%3D%22%23FFFFFF%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

/**
  * @property {any} groupsRequestBuilder - The request builder for groups.
  * @property {any} searchRequestBuilder - The request builder for search.
  * @property {any} subtitleView - The view for subtitle.
  * @property {any} listItemView - The view for list item.
  * @property {any} menu - The menu.
  * @property {any} options - The options.
  * @property {boolean} hideSeparator - Indicates whether to hide separator or not.
  * @property {SelectionMode} selectionMode - The selection mode.
  * @property {boolean} hideError - Indicates whether to hide error or not.
  * @property {group:CometChat.Group} onSelect - The callback on select.
  * @property {any} emptyStateView - The view for empty state.
  * @property {any} errorStateView - The view for error state.
  * @property {string} loadingIconURL - The URL for loading icon.
  * @property {any} loadingStateView - The view for loading state.
  * @property {TitleAlignment} titleAlignment - The alignment of title.
  * @property {BaseStyle} statusIndicatorStyle - The style for status indicator.
  * @property {AvatarStyle} avatarStyle - The style for avatar.
  * @property {GroupsStyle} groupsStyle - The style for groups.
  * @property {ListItemStyle} listItemStyle - The style for list item.
  */
class GroupsConfiguration {
    constructor(props) {
        this.privateGroupIcon = privateIcon;
        this.protectedGroupIcon = lockedIcon;
        this.selectionMode = uikitResources.SelectionMode.none;
        this.loadingIconURL = LoadingIcon;
        this.searchIconURL = searchIcon;
        this.hideSearch = false;
        this.titleAlignment = uikitResources.TitleAlignment.left;
        this.statusIndicatorStyle = {
            height: "12px",
            width: "12px",
            borderRadius: "16px"
        };
        this.avatarStyle = {};
        this.groupsStyle = {};
        this.listItemStyle = {};
        Object.assign(this, props);
    }
}

/**
 ContactsConfiguration class.
* @property {UsersConfiguration} usersConfiguration
* @property {GroupsConfiguration} groupsConfiguration
* @property {string} closeIconURL
* @property {ContactsStyle} contactsStyle
* @property {SelectionMode} selectionMode
* @property {:()=>void} onClose
* @property {TabsVisibility} tabVisibility
* @property {number} selectionLimit
* @property {CometChatTabItem} tabs
* @property {boolean} hideSubmitButton
*/
class ContactsConfiguration {
    constructor(props) {
        this.usersConfiguration = new UsersConfiguration({});
        this.groupsConfiguration = new GroupsConfiguration({});
        this.closeIconURL = closeIcon$1;
        this.contactsStyle = {};
        this.selectionMode = uikitResources.SelectionMode.none;
        this.tabVisibility = uikitResources.TabsVisibility.usersAndGroups;
        this.selectionLimit = 5;
        this.tabs = [];
        this.hideSubmitButton = true;
        Object.assign(this, props);
    }
}

var loadingIcon = "data:image/svg+xml,%3Csvg%20width%3D%2225%22%20height%3D%2224%22%20viewBox%3D%220%200%2025%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8.01057%208.04728C8.34753%209.99213%209.53177%2011.3242%2011.6239%2012C13.716%2011.3242%2014.9002%209.99213%2015.2372%208.04728C15.2572%207.91731%2015.2488%207.78455%2015.2125%207.65816C15.1762%207.53177%2015.1129%207.41476%2015.027%207.3152C14.9411%207.21564%2014.8346%207.1359%2014.7149%207.08149C14.5952%207.02707%2014.4651%206.99928%2014.3336%207.00001H8.9142C8.7827%206.99928%208.65261%207.02707%208.5329%207.08149C8.41319%207.1359%208.30671%207.21564%208.2208%207.3152C8.1349%207.41476%208.07161%207.53177%208.03532%207.65816C7.99902%207.78455%207.99058%207.91731%208.01057%208.04728Z%22%20fill%3D%22%23808080%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.91423%2017C8.78279%2017.0007%208.65276%2016.9729%208.5331%2016.9185C8.41343%2016.8642%208.30699%2016.7845%208.22109%2016.685C8.1352%2016.5855%208.0719%2016.4686%208.03556%2016.3423C7.99922%2016.2159%207.9907%2016.0832%208.01059%2015.9533C8.34756%2014.0085%209.5318%2012.6764%2011.6239%2012C13.716%2012.6764%2014.9003%2014.0085%2015.2372%2015.9533C15.2571%2016.0832%2015.2486%2016.2159%2015.2123%2016.3423C15.1759%2016.4686%2015.1126%2016.5855%2015.0267%2016.685C14.9408%2016.7845%2014.8344%2016.8642%2014.7147%2016.9185C14.5951%2016.9729%2014.465%2017.0007%2014.3336%2017H8.91423Z%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var senticon = "data:image/svg+xml,%3Csvg%20width%3D%2211%22%20height%3D%2212%22%20viewBox%3D%220%200%2011%2012%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_538_3503%29%22%3E%3Cpath%20d%3D%22M2.29175%206.00065L4.58341%208.29232L9.16675%203.70898%22%20stroke%3D%22%23A6A6A6%22%20stroke-width%3D%220.8%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_538_3503%22%3E%3Crect%20width%3D%2211%22%20height%3D%2211%22%20fill%3D%22white%22%20transform%3D%22translate%280%200.5%29%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var errorIcon = "data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2217%22%20viewBox%3D%220%200%2018%2017%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8.99992%2011C8.96695%2011%208.93473%2011.0098%208.90732%2011.0281C8.87992%2011.0464%208.85855%2011.0724%208.84594%2011.1029C8.83332%2011.1333%208.83002%2011.1669%208.83645%2011.1992C8.84289%2011.2315%208.85876%2011.2612%208.88207%2011.2845C8.90538%2011.3078%208.93507%2011.3237%208.9674%2011.3301C8.99973%2011.3366%209.03324%2011.3333%209.0637%2011.3206C9.09415%2011.308%209.12018%2011.2867%209.1385%2011.2593C9.15681%2011.2319%209.16659%2011.1996%209.16659%2011.1667C9.16659%2011.1225%209.14903%2011.0801%209.11777%2011.0488C9.08651%2011.0176%209.04412%2011%208.99992%2011Z%22%20stroke%3D%22%23ff3b30%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9%209.66667V6%22%20stroke%3D%22%23ff3b30%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4%209C4%2010.3261%204.52678%2011.5979%205.46447%2012.5355C6.40215%2013.4732%207.67392%2014%209%2014C10.3261%2014%2011.5979%2013.4732%2012.5355%2012.5355C13.4732%2011.5979%2014%2010.3261%2014%209C14%207.67392%2013.4732%206.40215%2012.5355%205.46447C11.5979%204.52678%2010.3261%204%209%204C7.67392%204%206.40215%204.52678%205.46447%205.46447C4.52678%206.40215%204%207.67392%204%209V9Z%22%20stroke%3D%22%23ff3b30%22%20stroke-width%3D%221.2%22%2F%3E%3C%2Fsvg%3E";

/**
 * @property {any} subtitleView - Property for subtitle view.
 * @property {any} options - Property for options.
 * @property {boolean} disableUsersPresence - Property to disable user's presence. Default is false.
 * @property {boolean} disableReadReceipt - Property to disable read receipt. Default is false.
 * @property {boolean} disableTyping - Property to disable typing. Default is false.
 * @property {string} deliveredIcon - Property for delivered icon. Default is "assets/message-delivered.svg".
 * @property {string} readIcon - Property for read icon. Default is "assets/message-read.svg".
 * @property {string} waitIcon - Property for wait icon. Default is "assets/wait.svg".
 * @property {string} errorIcon - Property for error icon. Default is "assets/warning-small.svg".
 * @property {DatePatterns} datePattern - Property for date pattern. Default is "DatePatterns.DayDateTime".
 * @property {ReceiptStyle} receiptStyle - Property for receipt style.
 * @property {string} sentIcon - Property for sent icon. Default is "assets/message-sent.svg".
 * @property {string} privateGroupIcon - Property for private group icon. Default is "assets/Private.svg".
 * @property {string} protectedGroupIcon - Property for protected group icon. Default is "assets/Locked.svg".
 * @property {string} customSoundForMessages - Property for custom sound for messages.
 * @property {CometChat.Conversation} activeConversation - Property for selected conversation. Default is null.
 * @property {string} searchIconURL - Property for search icon URL. Default is "assets/search.svg".
 * @property {boolean} hideSearch - Property to hide search. Default is true.
 * @property {CometChat.ConversationsRequestBuilder} conversationsRequestBuilder - Property for conversation request builder. Default is "new CometChat.ConversationsRequestBuilder().setLimit(30)".
 * @property {any} emptyStateView - Property for empty state view.
 * @property {member:CometChat.Conversation} onSelect - Property for on select.
 * @property {string} loadingIconURL - Property for loading icon URL. Default is "assets/Spinner.svg".
 * @property {any} errorStateView - Property for error state view.
 * @property {any} loadingStateView - Property for loading state view.
 * @property {TitleAlignment} titleAlignment - Property for title alignment. Default is "TitleAlignment.left".
 * @property {any} listItemView - Property for list item view.
 * @property {any} menu - Property for menu.
 * @property {boolean} hideSeparator - Property to hide separator. Default is false.
 * @property {boolean} hideError - Property to hide error. Default is false.
 * @property {SelectionMode} selectionMode - Property for selection mode. Default is "SelectionMode.none".
 * @property {boolean} disableSoundForMessages - Property to disable sound
 * @property {ConfirmDialogStyle} deleteConversationDialogStyle - The style of the dialog that appears when user tries to delete a conversation.
 * @property {BadgeStyle} badgeStyle - The style of the badge that appears on the conversation list items.
 * @property {DateStyle} dateStyle - The style of the date that appears in the conversation list items.
 * @property {ConversationsStyle} conversationsStyle - The style of the conversation list.
 * @property {ListItemStyle} listItemStyle - The style of the conversation list item.
 * @property {BaseStyle} statusIndicatorStyle - The style of the status indicator that appears in the conversation list items.
 * @property {AvatarStyle} avatarStyle - The style of the avatar that appears in the conversation list items.
 * @property {boolean} disableMentions - Disable Mentions in message list
 * @property {CometChatTextFormatter[]} textFormatters - List of Text Formatter Instances
 */
class ConversationsConfiguration {
    constructor(props) {
        this.disableUsersPresence = false;
        this.disableReceipt = false;
        this.disableTyping = false;
        this.deliveredIcon = deliveredicon;
        this.readIcon = readicon;
        this.waitIcon = loadingIcon;
        this.errorIcon = errorIcon;
        this.datePattern = uikitResources.DatePatterns.DayDateTime;
        this.receiptStyle = {};
        this.sentIcon = senticon;
        this.privateGroupIcon = privateIcon;
        this.protectedGroupIcon = lockedIcon;
        this.customSoundForMessages = "";
        this.loadingIconURL = LoadingIcon;
        this.titleAlignment = uikitResources.TitleAlignment.left;
        this.hideSeparator = false;
        this.hideError = false;
        this.selectionMode = uikitResources.SelectionMode.none;
        this.disableSoundForMessages = false;
        this.deleteConversationDialogStyle = {};
        this.badgeStyle = {};
        this.dateStyle = {};
        this.conversationsStyle = {};
        this.listItemStyle = {};
        this.statusIndicatorStyle = {};
        this.avatarStyle = {};
        this.backdropStyle = {};
        // @property {string} mentionsIconURL - Mentions Icon URL for Unread Mentions Indicator
        //  mentionsIconURL: string = mentionsIcon;
        this.disableMentions = false;
        this.textFormatters = [];
        Object.assign(this, props);
    }
}

/**

CreateGroupConfiguration class represents the configuration options for creating a new group.
@property {closeButtonIconURL} - A string representing the URL of the icon to be used for the close button. Default value is 'closeIcon'.
@property {hideCloseButton} - A boolean indicating whether or not to hide the close button. Default value is false.
@property {createGroupStyle} - An object representing the style options for the create group form. Default value is an empty object.
@property {onError} - A function to be called when an error occurs during group creation. Can be null.
@property {onClose} - A function to be called when the create group form is closed. Can be null.
*/
class CreateGroupConfiguration {
    constructor(props) {
        this.closeButtonIconURL = closeIcon$1;
        this.hideCloseButton = false;
        this.createGroupStyle = {};
        this.createClick = null;
        Object.assign(this, props);
    }
}

var backIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2Fbackbutton%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FBack%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%283.000000%2C%203.250000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2218.75%22%20y1%3D%228.75%22%20x2%3D%220%22%20y2%3D%228.75%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolyline%20id%3D%22Path%22%20points%3D%228.75%200%200%208.75%208.75%2017.5%22%3E%3C%2Fpolyline%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

/**
 AddMembersConfiguration class.
* @property {any} subtitleView
* @property {any} listItemView
* @property {boolean} disableUsersPresence
* @property {any} menu
* @property {CometChatOption[]} options
* @property {string} backButtonIconURL
* @property {string} closeButtonIconURL
* @property {boolean} showBackButton
* @property {boolean} hideSeparator
* @property {SelectionMode} selectionMode
* @property {boolean} hideError
* @property {string} searchIconURL
* @property {boolean} hideSearch
* @property {((error:CometChat.CometChatException)=>void) | null} onError
* @property {(()=>void) | null} onBack
* @property {(()=>void) | null} onClose
* @property {(user:CometChat.User)=>void} onSelect
* @property {any} emptyStateView
* @property {any} errorStateView
* @property {string} loadingIconURL
* @property {boolean} showSectionHeader
* @property {string} sectionHeaderField
* @property {any} loadingStateView
* @property {((guid:string, members:CometChat.User[])=>void) | null} onAddMembersButtonClick
* @property {TitleAlignment} titleAlignment
* @property {any} statusIndicatorStyle
* @property {AvatarStyle} avatarStyle
* @property {AddMembersStyle} addMembersStyle
* @property {ListItemStyle} listItemStyle
*/
class AddMembersConfiguration {
    constructor(props) {
        this.disableUsersPresence = false;
        this.backButtonIconURL = backIcon;
        this.closeButtonIconURL = closeIcon$1;
        this.showBackButton = true;
        this.hideSeparator = false;
        this.selectionMode = uikitResources.SelectionMode.multiple;
        this.hideError = false;
        this.searchIconURL = searchIcon;
        this.hideSearch = false;
        this.onError = (error) => {
            console.log(error);
        };
        this.loadingIconURL = LoadingIcon;
        this.showSectionHeader = false;
        this.sectionHeaderField = "";
        this.titleAlignment = uikitResources.TitleAlignment.center;
        this.usersConfiguration = new UsersConfiguration({});
        this.statusIndicatorStyle = {
            height: "10px",
            width: "10px",
            borderRadius: "16px"
        };
        this.avatarStyle = {};
        this.listItemStyle = {};
        this.addMembersStyle = {};
        Object.assign(this, props);
    }
}

var downarrowIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20%3F%3E%3C!DOCTYPE%20svg%20%20PUBLIC%20%5Ci-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%5Ci%20%20%5Cihttp%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%5Ci%3E%3Csvg%20enable-background%3D%22new%200%200%2032%2032%22%20%20id%3D%22%D0%A1%D0%BB%D0%BE%D0%B9_1%22%20version%3D%221.1%22%20viewBox%3D%220%200%2032%2032%22%20%20xml%3Aspace%3D%22preserve%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Cpath%20d%3D%22M24.285%2C11.284L16%2C19.571l-8.285-8.288c-0.395-0.395-1.034-0.395-1.429%2C0%20%20c-0.394%2C0.395-0.394%2C1.035%2C0%2C1.43l8.999%2C9.002l0%2C0l0%2C0c0.394%2C0.395%2C1.034%2C0.395%2C1.428%2C0l8.999-9.002%20%20c0.394-0.395%2C0.394-1.036%2C0-1.431C25.319%2C10.889%2C24.679%2C10.889%2C24.285%2C11.284z%22%20fill%3D%22%23121313%22%20id%3D%22Expand_More%22%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3C%2Fsvg%3E";

/**
 BannedMembersConfiguration class.
* @property {any} subtitleView
* @property {any} listItemView
* @property {boolean} disableUsersPresence
* @property {any} menu
* @property {CometChatOption[]} options
* @property {string} backButtonIconURL
* @property {string} closeButtonIconURL
* @property {boolean} showBackButton
* @property {boolean} hideSeparator
* @property {SelectionMode} selectionMode
* @property {boolean} hideError
* @property {string} searchIconURL
* @property {boolean} hideSearch
* @property {((error:CometChat.CometChatException)=>void) | null} onError
* @property {(()=>void) | null} onBack
* @property {(()=>void) | null} onClose
* @property {(member:CometChat.GroupMember)=>void} onSelect
* @property {any} emptyStateView
* @property {any} errorStateView
* @property {string} loadingIconURL
* @property {any} loadingStateView
* @property {((guid:string, members:CometChat.User[])=>void) | null} onAddMembersButtonClick
* @property {TitleAlignment} titleAlignment
* @property {any} statusIndicatorStyle
* @property {AvatarStyle} avatarStyle
* @property {GroupMemberStyle} groupMemberStyle
* @property {ChangeScopeStyle} groupScopeStyle
* @property {string} dropdownIconURL
* @property {ListItemStyle} listItemStyle
*/
class GroupMembersConfiguration {
    constructor(props) {
        this.disableUsersPresence = false;
        this.backButtonIconURL = backIcon;
        this.closeButtonIconURL = closeIcon$1;
        this.showBackButton = true;
        this.hideSeparator = false;
        this.selectionMode = uikitResources.SelectionMode.none;
        this.hideError = false;
        this.searchIconURL = searchIcon;
        this.dropdownIconURL = downarrowIcon;
        this.hideSearch = false;
        this.onError = (error) => {
            console.log(error);
        };
        this.loadingIconURL = LoadingIcon;
        this.titleAlignment = uikitResources.TitleAlignment.center;
        this.statusIndicatorStyle = {
            height: "10px",
            width: "10px",
            borderRadius: "16px"
        };
        this.avatarStyle = {};
        this.groupMembersStyle = {};
        this.groupScopeStyle = {};
        this.listItemStyle = {};
        this.backdropStyle = {};
        Object.assign(this, props);
    }
}

/**
 BannedMembersConfiguration class.
* @property {any} subtitleView
* @property {any} listItemView
* @property {boolean} disableUsersPresence
* @property {any} menu
* @property {CometChatOption[]} options
* @property {string} backButtonIconURL
* @property {string} closeButtonIconURL
* @property {boolean} showBackButton
* @property {boolean} hideSeparator
* @property {SelectionMode} selectionMode
* @property {boolean} hideError
* @property {string} searchIconURL
* @property {boolean} hideSearch
* @property {((error:CometChat.CometChatException)=>void) | null} onError
* @property {(()=>void) | null} onBack
* @property {(()=>void) | null} onClose
* @property {(member:CometChat.GroupMember)=>void} onSelect
* @property {any} emptyStateView
* @property {any} errorStateView
* @property {string} loadingIconURL
* @property {any} loadingStateView
* @property {((guid:string, members:CometChat.User[])=>void) | null} onAddMembersButtonClick
* @property {TitleAlignment} titleAlignment
* @property {any} statusIndicatorStyle
* @property {AvatarStyle} avatarStyle
* @property {BannedMembersStyle} bannedMembersStyle
* @property {ListItemStyle} listItemStyle
*/
class BannedMembersConfiguration {
    constructor(props) {
        this.disableUsersPresence = false;
        this.backButtonIconURL = backIcon;
        this.closeButtonIconURL = closeIcon$1;
        this.showBackButton = true;
        this.hideSeparator = false;
        this.selectionMode = uikitResources.SelectionMode.none;
        this.hideError = false;
        this.searchIconURL = searchIcon;
        this.hideSearch = false;
        this.onError = (error) => {
            console.log(error);
        };
        this.loadingIconURL = LoadingIcon;
        this.titleAlignment = uikitResources.TitleAlignment.center;
        this.statusIndicatorStyle = {
            height: "10px",
            width: "10px",
            borderRadius: "16px"
        };
        this.avatarStyle = {};
        this.listItemStyle = {};
        this.bannedMembersStyle = {};
        Object.assign(this, props);
    }
}

/**

TransferOwnershipConfiguration class represents the configuration options for transferring ownership of a group.
@property {groupMemberRequestBuilder} - An instance of CometChat.GroupMembersRequestBuilder to fetch group members. Required.
@property {searchRequestBuilder} - An instance of CometChat.GroupMembersRequestBuilder to search for group members. Required.
@property {subtitleView} - The view to be displayed as subtitle for the transfer ownership screen. Can be any.
@property {listItemView} - The view to be used to render individual list items. Can be any.
@property {disableUsersPresence} - A boolean indicating whether or not to disable presence of group members. Default value is false.
@property {options} - An array of CometChatOption objects to be displayed on the transfer ownership screen. Required.
@property {closeButtonIconURL} - A string representing the URL of the icon to be used for the close button. '.
@property {hideSeparator} - A boolean indicating whether or not to hide the separator between the header and body. Default value is false.
@property {searchIconURL} - A string representing the URL of the icon to be used for the search button.
@property {hideSearch} - A boolean indicating whether or not to hide the search bar. Default value is true.
@property {onError} - A function to be called when an error occurs during the transfer ownership process. Default value logs the error to console.
@property {onClose} - A function to be called when the transfer ownership screen is closed. Required.
@property {onTransferOwnership} - A function to be called when the ownership of the group is transferred. Required.
@property {emptyStateView} - The view to be displayed when there are no group members to transfer ownership to. Can be any.
@property {errorStateView} - The view to be displayed when there is an error while fetching group members. Can be any.
@property {loadingIconURL} - A string representing the URL of the icon to be used for the loading indicator. Default value is 'assets/Spinner.svg'.
@property {loadingStateView} - The view to be displayed while fetching group members. Can be any.
@property {statusIndicatorStyle} - An object representing the style options for the status indicator. .
@property {transferOwnershipStyle} - An object representing the style options for the transfer ownership screen. .
@property {avatarStyle} - An object representing the style options for the avatar image. .
@property {groupMemberStyle} - An object representing the style options for the group members list. .
@property {listItemStyle} - An object representing the style options for the individual list items. .
@property {titleAlignment} - an enum which represents the allignment of the title
**/
class TransferOwnershipConfiguration {
    constructor(props) {
        this.disableUsersPresence = false;
        this.closeButtonIconURL = closeIcon$1;
        this.hideSeparator = false;
        this.searchIconURL = searchIcon;
        this.hideSearch = true;
        this.onError = (error) => {
            console.log(error);
        };
        this.loadingIconURL = LoadingIcon;
        this.statusIndicatorStyle = {};
        this.transferOwnershipStyle = {};
        this.avatarStyle = {};
        this.groupMemberStyle = {};
        this.listItemStyle = {};
        this.titleAlignment = uikitResources.TitleAlignment.center;
        Object.assign(this, props);
    }
}

/**

* DetailsConfiguration class represents the configuration options for the details view.
* @property  {closeButtonIconURL} - string: The URL of the icon used for the close button.
* @property {hideProfile} - boolean: If true, the profile of the user/group will be hidden.
* @property {subtitleView} - any: The subtitle view to be displayed in the details view.
* @property {customProfileView} - any: The custom profile view to be displayed in the details view.
* @property {data} - CometChatDetailsTemplate[]: The array of CometChatDetailsTemplate objects to be displayed in the details view.
* @property {disableUsersPresence} - boolean: If true, the presence of users will be disabled in the details view.
* @property {privateGroupIcon} - string: The URL of the icon used for the private group.
* @property {protectedGroupIcon} - string: The URL of the icon used for the protected group.
* @property {onError} - (error: any) => void: The callback function that will be called when an error occurs.
* @property {onClose} - () => void: The callback function that will be called when the details view is closed.
* @property {leaveDialogStyle} - ConfirmDialogStyle: The style configuration options for the leave dialog.
* @property {statusIndicatorStyle} - any: The style configuration options for the status indicator.
* @property {avatarStyle} - AvatarStyle: The style configuration options for the avatar.
* @property {detailsStyle} - DetailsStyle: The style configuration options for the details view.
* @property {listItemStyle} - ListItemStyle: The style configuration options for the list items in the details view.
*/
class DetailsConfiguration {
    constructor(props) {
        this.closeButtonIconURL = closeIcon$1;
        this.hideProfile = false;
        this.disableUsersPresence = false;
        this.privateGroupIcon = privateIcon;
        this.protectedGroupIcon = lockedIcon;
        this.addMembersConfiguration = new AddMembersConfiguration({});
        this.groupMembersConfiguration = new GroupMembersConfiguration({});
        this.bannedMembersConfiguration = new BannedMembersConfiguration({});
        this.transferOwnershipConfiguration = new TransferOwnershipConfiguration({});
        this.backdropStyle = {};
        this.onError = (error) => {
            console.log(error);
        };
        this.leaveDialogStyle = {};
        this.statusIndicatorStyle = {
            height: "10px",
            width: "10px",
            borderRadius: "16px",
            border: "",
        };
        this.detailsStyle = {};
        this.avatarStyle = {};
        this.listItemStyle = {};
        Object.assign(this, props);
    }
}

/**
* @class MessageHeaderConfiguration
* @property {any} subtitleView - The view that displays the message header subtitle.
* @property {boolean} disableUsersPresence - Whether the user presence should be disabled or not.
* @property {string} protectedGroupIcon - The URL for the protected group icon.
* @property {string} privateGroupIcon - The URL for the private group icon.
* @property {any} menu - The menu associated with the message header.
* @property {AvatarStyle} avatarStyle - The style for the message header avatar.
* @property {BaseStyle} statusIndicatorStyle - The style for the status indicator in the message header.
* @property {MessageHeaderStyle} messageHeaderStyle - The style for the message header.
* @property {ListItemStyle} listItemStyle - The style for the list item in the message header.
* @property {string} backButtonIconURL - The URL for the back button icon.
* @property {boolean} hideBackIcon - Whether the back icon should be hidden or not.
* @property {any} listItemView - The view for the list item.
* @property {any} onError - The callback function that is triggered in case of an error.
* @property {any} onBack - The callback function that is triggered when the back button is clicked.
*/
class MessageHeaderConfiguration {
    constructor(props) {
        this.subtitleView = null;
        this.disableUsersPresence = false;
        this.protectedGroupIcon = lockedIcon;
        this.privateGroupIcon = privateIcon;
        this.avatarStyle = {};
        this.statusIndicatorStyle = {};
        this.messageHeaderStyle = {};
        this.listItemStyle = {};
        this.backButtonIconURL = backIcon;
        this.hideBackButton = true;
        Object.assign(this, props);
    }
}

/**

JoinGroupConfiguration class represents the configuration options for joining a  group.
@property {joinGroupStyle} - An object representing the style options for the join group form. Default value is an empty object.
@property {onError} - A function to be called when an error occurs during group creation. Can be null.
@property {onClose} - A function to be called when the create group form is closed. Can be null.
*/
class JoinGroupConfiguration {
    constructor(props) {
        this.joinGroupStyle = {};
        this.joinClick = null;
        this.messageHeaderConfiguration = new MessageHeaderConfiguration({});
        Object.assign(this, props);
    }
}

var AIIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%3F%3E%3Csvg%20version%3D%221.0%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100.000000pt%22%20height%3D%22100.000000pt%22%20viewBox%3D%220%200%20100.000000%20100.000000%22%20preserveAspectRatio%3D%22xMidYMid%20meet%22%3E%20%20%3Cg%20transform%3D%22translate%280.000000%2C100.000000%29%20scale%280.100000%2C-0.100000%29%22%20fill%3D%22%23000000%22%20stroke%3D%22none%22%3E%20%20%20%20%3Cpath%20d%3D%22M727%20854%20c-4%20-4%20-7%20-15%20-7%20-24%200%20-21%20-28%20-47%20-55%20-52%20-14%20-2%20-20%20-11%20-20%20-28%200%20-17%206%20-26%2020%20-28%2028%20-6%2053%20-30%2057%20-56%202%20-15%2010%20-21%2028%20-21%2018%200%2026%206%2028%2021%204%2026%2029%2050%2057%2056%2029%205%2028%2052%20-1%2056%20-26%204%20-51%2029%20-56%2057%20-3%2020%20-37%2032%20-51%2019z%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M350%20761%20c-5%20-11%20-10%20-32%20-10%20-48%20-1%20-74%20-86%20-160%20-178%20-178%20-50%20-10%20-57%20-14%20-57%20-36%200%20-20%206%20-25%2042%20-31%20117%20-20%20170%20-76%20198%20-211%2012%20-58%2065%20-38%2065%2025%200%2084%2088%20168%20193%20186%2036%206%2042%2011%2042%2031%200%2022%20-7%2026%20-56%2036%20-91%2018%20-162%2084%20-175%20165%20-12%2076%20-41%20104%20-64%2061z%20m80%20-212%20c14%20-14%2033%20-30%2043%20-35%2015%20-9%2010%20-17%20-40%20-69%20l-58%20-60%20-57%2059%20c-57%2059%20-57%2060%20-35%2075%2030%2020%2087%2082%2088%2095%200%206%208%200%2017%20-14%209%20-14%2028%20-37%2042%20-51z%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M727%20354%20c-4%20-4%20-7%20-15%20-7%20-24%200%20-21%20-28%20-47%20-55%20-52%20-14%20-2%20-20%20-11%20-20%20-28%200%20-17%206%20-26%2020%20-28%2028%20-6%2053%20-30%2057%20-56%204%20-30%2052%20-30%2056%200%204%2026%2029%2050%2057%2056%2029%205%2028%2052%20-1%2056%20-26%204%20-51%2029%20-56%2057%20-3%2020%20-37%2032%20-51%2019z%22%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var SmileysIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%20Extensions%2FStipop%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24-Extensions%2FStipop%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12.5%2C1%20C18.2989899%2C1%2023%2C5.70101013%2023%2C11.5%20C23%2C17.2039245%2018.451858%2C21.8455734%2012.7842951%2C21.9962258%20L12.5%2C22%20L6%2C23%20L6.47908443%2C20.1033393%20C3.77065445%2C18.2043706%202%2C15.0589646%202%2C11.5%20C2%2C5.70101013%206.70101013%2C1%2012.5%2C1%20Z%20M12.5%2C2.5%20C7.52943725%2C2.5%203.5%2C6.52943725%203.5%2C11.5%20C3.5%2C14.3705191%204.85206397%2C17.0112175%207.09635804%2C18.6980916%20L7.34021132%2C18.8751453%20L8.11298335%2C19.416961%20L7.817%2C21.202%20L12.3852902%2C20.5%20L12.5%2C20.5%20C17.4705627%2C20.5%2021.5%2C16.4705627%2021.5%2C11.5%20C21.5%2C6.52943725%2017.4705627%2C2.5%2012.5%2C2.5%20Z%20M13.5%2C12.3%20C13.1666667%2C13.9666667%2012.3333333%2C14.8%2011%2C14.8%20C9.66666667%2C14.8%208.83333333%2C13.9666667%208.5%2C12.3%20L13.5%2C12.3%20Z%20M15.0030662%2C6.67300699%20C15.1656001%2C6.92305919%2015.1180007%2C7.24908483%2014.9043132%2C7.44344192%20L14.826993%2C7.50306617%20L13.632%2C8.279%20L14.8086975%2C8.98550424%20C15.0644308%2C9.13894425%2015.1646368%2C9.45281874%2015.0578342%2C9.72120324%20L15.0144958%2C9.80869745%20C14.8610557%2C10.0644308%2014.5471813%2C10.1646368%2014.2787968%2C10.0578342%20L14.1913025%2C10.0144958%20L12.1913025%2C8.81449576%20C11.8402552%2C8.60386734%2011.8048611%2C8.12100565%2012.0939654%2C7.85785853%20L12.173007%2C7.79693383%20L14.173007%2C6.49693383%20C14.4508428%2C6.31634058%2014.8224729%2C6.39517122%2015.0030662%2C6.67300699%20Z%20M8.1%2C6.7%20C8.92842712%2C6.7%209.6%2C7.37157288%209.6%2C8.2%20C9.6%2C9.02842712%208.92842712%2C9.7%208.1%2C9.7%20C7.27157288%2C9.7%206.6%2C9.02842712%206.6%2C8.2%20C6.6%2C7.37157288%207.27157288%2C6.7%208.1%2C6.7%20Z%22%20id%3D%22Oval%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

class UserMemberWrapperConfiguration {
    constructor(props) {
        this.onItemClick = null;
        this.avatarStyle = {};
        this.statusIndicatorStyle = {
            height: "10px",
            width: "10px",
            borderRadius: "16px"
        };
        this.disableUsersPresence = false;
        this.userPresencePlacement = uikitResources.UserPresencePlacement.bottom;
        this.hideSeparator = false;
        this.loadingIconURL = LoadingIcon;
        Object.assign(this, props);
    }
}

var heartIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAFAAAAAAnxZisAAACpElEQVQ4Ea1VzUsVURQ/5868UrEg/AMy0NTMRQRBJfIQszKxgh5ByzbVIooiiDbZBwUtXAWJtGgRJW0MQsxnxfhRIbgpsqcQtajoA8uITGfu3Hs6Z+zJU3pq+n4wc+fee87vd+bcM2cQ5mB0Z+0WMuERQNiNgO+UgtYAgs7K7uffM01fVlevyc9391iAo5bsOkT1gPdvlvd4Q5l2mJ68bahdG2rTwvMmB9HV1gKP0WWA3oSWzlc86rsj9qm6mkOuwgsKsMQSgeErxpEYS5oQOpSLp0u7vA9iGwmkdsWLlaGuPKXKJw3TyU4GYizEYG+OFglXAt7gOWomzoRY5TsO+Na+8pEaqpJ97/FeIuFUjX++X+C4jb+ZPBsUi3C0Wvb5OSaRZ0MBi0xY01GxvfYApuprtjkE/ZZAZXeZpkrnczF2Ek9oaKtCi2c4ogXJRUKIFyJP2zmolHLUSZeAGjWXQq4RcpHwMTVxIeCwVEuuIWfGSPGIl/9OcqohnA7QVWUCeMg1PyJ1nCsIl7ZmVIcqqSo97xen6aK8UC4SleZB5VwS7ijs8p7e9sDQLflIlos8R4FPdLs9Gb8rXJEAq5K7YurEpLHeckTEd8rYp77G483QHNXmTOJLuwZ/ukof9I0dWIqI+PjWDFqHEps870c6EzMCslCSfPYVQtzvG9MpDos5E7GZJrc9gfX3buju/5Qml3GWgCyUed7YtwmdYJHrLqqom8r6vyDfT0whsG3bqrzV+6oeD36ZazdvkCN1NYe5nq8xSRHndpYvd14Igca5dZxdn+xtm7WZMZlXQOxe18c3ukQtLLJDc0cUSPsOiJ6AMqfKugdeRItZbgsKiN/Q5s2xwqLCYw7hOWl3/FO5oj+OtVYODwdZeJe2LD+mVDxe/D/efwCuAQs2cnkFkQAAAABJRU5ErkJggg==";

var micIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FMic%402x%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FMic%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%284%2C%201%29%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%228%22%20y1%3D%2218.3333333%22%20x2%3D%228%22%20y2%3D%2222%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%223.5%22%20y%3D%220%22%20width%3D%229%22%20height%3D%2214.9111111%22%20rx%3D%223.91111111%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C8.8%20L0%2C11%20C0%2C15.0500882%203.35786438%2C18.3333333%207.5%2C18.3333333%20L8.5%2C18.3333333%20C12.6421356%2C18.3333333%2016%2C15.0500882%2016%2C11%20L16%2C8.8%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var PlusIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FPlus%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FPlus%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%282.000000%2C%202.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2210%22%20y1%3D%226%22%20x2%3D%2210%22%20y2%3D%2214%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%226%22%20y1%3D%2210%22%20x2%3D%2214%22%20y2%3D%2210%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C10%20C0%2C15.5228475%204.4771525%2C20%2010%2C20%20C15.5228475%2C20%2020%2C15.5228475%2020%2C10%20C20%2C4.4771525%2015.5228475%2C0%2010%2C0%20C4.4771525%2C0%200%2C4.4771525%200%2C10%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var sendIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FSend%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FSend%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%283.000000%2C%203.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0.158865921%2C1.85985859%20C-0.108182698%2C1.38202197%20-0.0332622567%2C0.786017075%200.343741637%2C0.389140701%20C0.72074553%2C-0.00773567366%201.31211969%2C-0.113146836%201.80303259%2C0.129025252%20L17.6480326%2C8.17819192%20C17.857662%2C8.28481329%2017.9896898%2C8.50008892%2017.9896898%2C8.73527525%20C17.9896898%2C8.97046158%2017.857662%2C9.18573721%2017.6480326%2C9.29235859%20L1.80303259%2C17.3523586%20C1.31211969%2C17.5945307%200.72074553%2C17.4891195%200.343741637%2C17.0922431%20C-0.0332622567%2C16.6953668%20-0.108182698%2C16.0993619%200.158865921%2C15.6215253%20L4.37386592%2C8.73485859%20L0.158865921%2C1.85985859%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2217.9896993%22%20y1%3D%228.73485859%22%20x2%3D%224.36969925%22%20y2%3D%228.73485859%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var stopIcon = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2220px%22%20height%3D%2220px%22%3E%3Cpath%20d%3D%22M%2012%202%20C%206.477%202%202%206.477%202%2012%20C%202%2017.523%206.477%2022%2012%2022%20C%2017.523%2022%2022%2017.523%2022%2012%20C%2022%206.477%2017.523%202%2012%202%20z%20M%2012%204%20C%2016.411%204%2020%207.589%2020%2012%20C%2020%2016.411%2016.411%2020%2012%2020%20C%207.589%2020%204%2016.411%204%2012%20C%204%207.589%207.589%204%2012%204%20z%20M%208%208%20L%208%2016%20L%2016%2016%20L%2016%208%20L%208%208%20z%22%2F%3E%3C%2Fsvg%3E";

/**
 * Class representing the configuration options for the message composer.
 *
 * @property {string} text - The initial text for the message composer. Default is an empty string.
 * @property {any} headerView - The view for the header of the message composer.
 * @property {any} onTextChange - The callback function for when the text in the message composer changes.
 * @property {string} attachmentIconURL - The URL of the attachment icon. Default is "assets/Plus.svg".
 * @property {CometChatMessageComposerAction[]} attachmentOptions - The attachment options for the message composer.
 * @property {any} secondaryButtonView - The view for the secondary button of the message composer.
 * @property {any} auxilaryButtonView - The view for the auxiliary button of the message composer.
 * @property {AuxiliaryButtonAlignment} auxiliaryButtonsAlignment - The alignment of the auxiliary buttons. Default is AuxiliaryButtonAlignment.right.
 * @property {any} sendButtonView - The view for the send button of the message composer.
 * @property {boolean} hideLiveReaction - Flag to hide live reaction. Default is false.
 * @property {string} LiveReactionIconURL - The URL of the live reaction icon. Default is "assets/heart-reaction.png".
 * @property {object} messageComposerStyle - The style for the message composer.
 * @property {any} onSendButtonClick - The callback function for when the send button is clicked.
 * @property {any} onError - The callback function for when an error occurs.
 * @property {CometChatTextFormatter[]} textFormatters - List of Text Formatter Instances
 * @property {boolean} disableMentions - Disable Mentions in message list
 * @property {string} mentionsWarningText - Warning Text to be showed when mentions limit is reached
 * @property {any} mentionsWarningStyle - Style For Warning Message showed when mentions limit is reached
 */
class MessageComposerConfiguration {
    constructor(props) {
        this.text = "";
        this.attachmentIconURL = PlusIcon;
        this.auxiliaryButtonsAlignment = uikitResources.AuxiliaryButtonAlignment.right;
        this.sendButtonIconURL = sendIcon;
        this.emojiIconURL = SmileysIcon;
        this.AIIconURL = AIIcon;
        this.hideLayoutMode = false;
        this.hideLiveReaction = true;
        this.LiveReactionIconURL = heartIcon;
        this.messageComposerStyle = {};
        this.actionSheetStyle = {};
        this.AIOptionsStyle = {};
        this.backdropStyle = {};
        this.hideVoiceRecording = false;
        this.mediaRecorderStyle = {};
        this.voiceRecordingCloseIconURL = closeIcon$1;
        this.voiceRecordingStartIconURL = micIcon;
        this.voiceRecordingStopIconURL = stopIcon;
        this.voiceRecordingSubmitIconURL = sendIcon;
        this.userMemberWrapperConfiguration = new UserMemberWrapperConfiguration({});
        this.textFormatters = [];
        this.disableMentions = false;
        this.mentionsWarningText = '';
        Object.assign(this, props);
    }
}

var ErrorIcon$1 = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%20height%3D%2224%22%20width%3D%2224%22%3E%3Cpath%20stroke%3D%22%23000000%22%20d%3D%22M12%2019.5c-0.2071%200%20-0.375%20-0.1679%20-0.375%20-0.375s0.1679%20-0.375%200.375%20-0.375%22%20stroke-width%3D%221.5%22%3E%3C%2Fpath%3E%3Cpath%20stroke%3D%22%23000000%22%20d%3D%22M12%2019.5c0.2071%200%200.375%20-0.1679%200.375%20-0.375s-0.1679%20-0.375%20-0.375%20-0.375%22%20stroke-width%3D%221.5%22%3E%3C%2Fpath%3E%3Cpath%20stroke%3D%22%23000000%22%20stroke-linecap%3D%22round%22%20stroke-miterlimit%3D%2210%22%20d%3D%22M12%2015.75v-7.5%22%20stroke-width%3D%221.5%22%3E%3C%2Fpath%3E%3Cpath%20stroke%3D%22%23000000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20d%3D%22M13.621%201.76001c-0.1488%20-0.30299%20-0.3796%20-0.5582%20-0.6661%20-0.73668C12.6684%200.844851%2012.3376%200.750244%2012%200.750244s-0.6684%200.094607%20-0.9549%200.273086c-0.2865%200.17848%20-0.5173%200.43369%20-0.6661%200.73668L0.90601%2021.058c-0.11403%200.232%20-0.167064%200.4892%20-0.154094%200.7473%200.01297%200.2582%200.091516%200.5088%200.228221%200.7281%200.136703%200.2194%200.327063%200.4003%200.553103%200.5257%200.22603%200.1254%200.48029%200.1911%200.73877%200.1909H21.728c0.2585%200.0002%200.5127%20-0.0655%200.7388%20-0.1909%200.226%20-0.1254%200.4164%20-0.3063%200.5531%20-0.5257%200.1367%20-0.2193%200.2152%20-0.4699%200.2282%20-0.7281%200.013%20-0.2581%20-0.0401%20-0.5153%20-0.1541%20-0.7473L13.621%201.76001Z%22%20stroke-width%3D%221.5%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

/**
 * Represents the configuration for reaction information.
 * @class ReactionInfoConfiguration
 * @property {ReactionInfoStyle} reactionInfoStyle - The style for the reaction information.
 * @property {CometChat.ReactionsRequestBuilder} reactionsRequestBuilder - The request builder for reactions.
 * @property {string} loadingIconURL - The URL for the loading icon.
 * @property {string} errorIconURL - The URL for the error icon.
 */
class ReactionInfoConfiguration {
    /**
     * Creates an instance of ReactionInfoConfiguration.
     * @param {Partial<ReactionInfoConfiguration>} props - The properties to initialize the configuration.
     */
    constructor(props) {
        this.loadingIconURL = LoadingIcon;
        this.errorIconURL = ErrorIcon$1;
        Object.assign(this, props);
    }
}

/**
 * Represents the configuration for the reaction list.
 * @class ReactionListConfiguration
 * @property {ReactionListStyle} reactionListStyle - The style for the reaction list.
 * @property {CometChat.ReactionsRequestBuilder} reactionsRequestBuilder - The request builder for reactions.
 * @property {string} loadingIconURL - The URL for the loading icon.
 * @property {string} errorIconURL - The URL for the error icon.
 * @property {AvatarStyle} avatarStyle - The style for the avatar.
 * @property {ListItemStyle} listItemStyle - The style for the list item.
 * @property {(reaction: CometChat.MessageReaction, message: CometChat.BaseMessage) => void} reactionItemClicked - The function to be called when a reaction item is clicked.
 */
class ReactionListConfiguration {
    /**
     * Creates an instance of ReactionListConfiguration.
     * @param {Partial<ReactionListConfiguration>} props - The properties to initialize the configuration.
     */
    constructor(props) {
        this.loadingIconURL = LoadingIcon;
        this.errorIconURL = ErrorIcon$1;
        Object.assign(this, props);
    }
}

/**
 * Represents the configuration for reactions.
 * @class ReactionsConfiguration
 * @property {ReactionListConfiguration} reactionListConfiguration - The configuration for the reaction list.
 * @property {ReactionInfoConfiguration} reactionInfoConfiguration - The configuration for the reaction information.
 * @property {(reaction: CometChat.ReactionCount, message: CometChat.BaseMessage) => void} reactionClick - The function to be called when a reaction is clicked.
 * @property {ReactionsStyle} reactionsStyle - The style for the reactions.
 */
class ReactionsConfiguration {
    /**
     * Creates an instance of ReactionInfoConfiguration.
     * @param {Partial<ReactionsConfiguration>} props - The properties to initialize the configuration.
     */
    constructor(props) {
        this.reactionListConfiguration = new ReactionListConfiguration({});
        this.reactionInfoConfiguration = new ReactionInfoConfiguration({});
        this.reactionsStyle = {};
        Object.assign(this, props);
    }
}

var threadIndicatorIcon = "data:image/svg+xml,%3Csvg%20width%3D%2215%22%20height%3D%2215%22%20viewBox%3D%220%200%2015%2015%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_10800_33104%29%22%3E%3Cpath%20d%3D%22M13.9906%201.69617C13.824%204.12358%2012.7401%206.39667%2010.959%208.05423C9.17776%209.71179%206.83266%2010.6296%204.39955%2010.6215C4.23748%2010.6215%203.84965%2010.6297%203.68799%2010.6215H1.03645%22%20stroke%3D%22%23A1A5AC%22%20stroke-width%3D%221.875%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.2041%207.43042L1.0094%2010.6251L4.2041%2013.8198%22%20stroke%3D%22%23A1A5AC%22%20stroke-width%3D%221.875%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_10800_33104%22%3E%3Crect%20width%3D%2215%22%20height%3D%2215%22%20fill%3D%22white%22%20transform%3D%22matrix%28-1%200%200%201%2015%200%29%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

/**
 * @property {any} emptyStateView - The view to be displayed in case there are no messages.
 * @property {any} errorStateView - The view to be displayed in case of error.
 * @property {any} loadingStateView - The view to be displayed when messages are being fetched.
 * @property {boolean} disableReadReceipt - The flag to enable/disable read receipts.
 * @property {string} readIcon - The icon to be displayed as read receipt.
 * @property {string} deliveredIcon - The icon to be displayed as delivered receipt.
 * @property {string} sentIcon - The icon to be displayed as sent receipt.
 * @property {string} waitIcon - The icon to be displayed as wait receipt.
 * @property {string} errorIcon - The icon to be displayed as error receipt.
 * @property {string} alignment - The alignment of the messages (standard, reverse).
 * @property {boolean} showAvatar - The flag to enable/disable showing avatars.
 * @property {DatePatterns} datePattern - The date pattern for the messages.
 * @property {TimestampAlignment} timestampAlignment - The alignment of the timestamps (top, bottom).
 * @property {DatePatterns} DateSeparatorPattern - The date pattern for the date separators.
 * @property {CometChatMessageTemplate[]} templates - The types of messages to be displayed.
 * @property {any} messagesRequestBuilder - The builder to fetch messages.
 * @property {number} thresholdValue - The threshold value to fetch messages.
 * @property {any} onThreadRepliesClick - The function to be called when thread replies are clicked.
 * @property {any} headerView - The header view to be displayed above the messages.
 * @property {any} footerView - The footer view to be displayed below the messages.
 * @property {BaseStyle} wrapperMessageBubbleStyle - The style for the message bubble.
 * @property {AvatarStyle} avatarStyle - The style for the avatar.
 * @property {DateStyle} dateSeparatorStyle - The style for the date separator.
 * @property {MessageListStyle} messageListStyle - The style for the message list.
 * @property {any} onError - The function to be called in case of error.
 * @property {CometChatTextFormatter[]} textFormatters - List of Text Formatter Instances
 * @property {boolean} disableMentions - Disable Mentions in message list
 */
class MessageListConfiguration {
    constructor(props) {
        this.disableReceipt = false;
        this.readIcon = readicon;
        this.deliveredIcon = deliveredicon;
        this.sentIcon = senticon;
        this.waitIcon = loadingIcon;
        this.errorIcon = errorIcon;
        this.alignment = uikitResources.MessageListAlignment.standard;
        this.showAvatar = true;
        this.datePattern = uikitResources.DatePatterns.time;
        this.timestampAlignment = uikitResources.TimestampAlignment.bottom;
        this.DateSeparatorPattern = uikitResources.DatePatterns.DayDate;
        this.hideDateSeparator = false;
        this.templates = [];
        this.messageInformationConfiguration = new MessageInformationConfiguration({});
        this.thresholdValue = 1000;
        this.scrollToBottomOnNewMessages = false;
        this.loadingIconURL = LoadingIcon;
        this.avatarStyle = {};
        this.dateSeparatorStyle = {};
        this.messageListStyle = {};
        this.backdropStyle = {};
        this.disableMentions = false;
        this.reactionsConfiguration = new ReactionsConfiguration({});
        this.disableReactions = false;
        this.emojiKeyboardStyle = {};
        this.threadIndicatorIcon = threadIndicatorIcon;
        this.textFormatters = [];
        Object.assign(this, props);
    }
}

/**
 * @class MessagesConfiguration
 * @param {boolean} hideMessageComposer
 * @param {string} customIncomingMessageSound
 * @param {string} customOutgoingMessageSound
 * @param {boolean} enableSoundForMessages
 * @param {boolean} enableSoundForCalls
 * @param {boolean} enableTypingIndicator
 * @param {object} messageListConfiguration
 * @param {object} messageHeaderConfiguration
 * @param {object} messageComposerConfiguration
 */
class ThreadedMessagesConfiguration {
    constructor(props) {
        this.closeIconURL = closeIcon$1;
        this.messageListConfiguration = new MessageListConfiguration({});
        this.messageComposerConfiguration = new MessageComposerConfiguration({});
        this.threadedMessagesStyle = {};
        this.hideMessageComposer = false;
        Object.assign(this, props);
    }
}

/**
 * @class MessagesConfiguration
 * @param {boolean} hideMessageComposer
 * @param {array} messageTypes
 * @param {string} customIncomingMessageSound
 * @param {string} customOutgoingMessageSound
 * @param {boolean} enableSoundForMessages
 * @param {boolean} enableSoundForCalls
 * @param {boolean} enableTypingIndicator
 * @param {object} messageListConfiguration
 * @param {object} messageHeaderConfiguration
 * @param {object} messageComposerConfiguration
 */
class MessagesConfiguration {
    constructor(props) {
        this.hideMessageComposer = false;
        this.messageHeaderConfiguration = new MessageHeaderConfiguration({});
        this.messageListConfiguration = new MessageListConfiguration({});
        this.messageComposerConfiguration = new MessageComposerConfiguration({});
        this.threadedMessageConfiguration = new ThreadedMessagesConfiguration({});
        this.detailsConfiguration = new DetailsConfiguration({});
        this.messagesStyle = {};
        this.hideMessageHeader = false;
        this.hideDetails = false;
        Object.assign(this, props);
    }
}

var closeIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2Fmoreicon%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FMore%22%20fill%3D%22%23000000%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.5%2C10%20C5.88071187%2C10%207%2C11.1192881%207%2C12.5%20C7%2C13.8807119%205.88071187%2C15%204.5%2C15%20C3.11928813%2C15%202%2C13.8807119%202%2C12.5%20C2%2C11.1192881%203.11928813%2C10%204.5%2C10%20Z%20M12%2C10%20C13.3807119%2C10%2014.5%2C11.1192881%2014.5%2C12.5%20C14.5%2C13.8807119%2013.3807119%2C15%2012%2C15%20C10.6192881%2C15%209.5%2C13.8807119%209.5%2C12.5%20C9.5%2C11.1192881%2010.6192881%2C10%2012%2C10%20Z%20M19.5%2C10%20C20.8807119%2C10%2022%2C11.1192881%2022%2C12.5%20C22%2C13.8807119%2020.8807119%2C15%2019.5%2C15%20C18.1192881%2C15%2017%2C13.8807119%2017%2C12.5%20C17%2C11.1192881%2018.1192881%2C10%2019.5%2C10%20Z%22%20id%3D%22Rectangle-2%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

/**
 * @class MessageBubbleConfiguration
 * @param {BaseStyle} style
 * @param {CometChatMessageOption} options
 * @param {any} leadingView
 * @param {any} headerView
 * @param {any} replyView
 * @param {any} threadView
 *  * @param {string} moreIconURL
 * @param {any} footerView
 *  * @param {number} topMenuSize
 *
 */
class MessageBubbleConfiguration {
    constructor(props) {
        this.messageBubbleStyle = {
            width: "100%",
            height: "auto",
            background: "",
            borderRadius: "12px",
            border: "none"
        };
        this.options = [];
        this.moreIconURL = closeIcon; //Image URL for more icon
        this.topMenuSize = 3;
        Object.assign(this, props);
    }
}

const ExtensionsId = Object.freeze({
    stickers: "stickers",
    reactions: "reactions",
    thumbnailGeneration: "thumbnail-generation",
    linkPreview: "link-preview",
    imageModeration: "image-moderation",
    messageTranslation: "message-translation",
    smartReply: "smart-reply",
    xssFilter: "xss-filter",
    dataMasking: "data-masking",
    polls: "polls",
    whiteboard: "whiteboard",
    document: "document",
    profanityFilter: "profanity-filter"
});

class ExtensionsDataSource {
    enable() {
        chatSdkJavascript.CometChat.isExtensionEnabled(this.getExtensionId())
            .then((isEnabled) => {
            if (isEnabled) {
                this.addExtension();
            }
        })
            .catch((e) => {
            console.error(e);
        });
    }
}

const PollsConstants = Object.freeze({
    polls: "polls",
    post: "POST",
    v2_create: "v2/create",
    v2_vote: "v2/vote",
    extension_poll: "extension_poll",
    injected: "@injected"
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

exports.SmartReplies = class SmartReplies extends lit.LitElement {
    constructor() {
        /**
           * This properties will come from Parent.
           */
        super(...arguments);
        this.smartReplyStyle = {
            height: "",
            width: "",
            border: "",
            borderRadius: "",
            background: "",
            closeIconTint: "grey",
            replyTextColor: "black",
            replyTextFont: "",
            replyBackground: "white",
            boxShadow: "RGBA(20, 20, 20, 0.04) 0 0 0 2px"
        };
        this.replies = [];
        this.closeIconURL = closeIcon$1;
        this.buttonStyles = {
            height: "100%",
            width: "100%",
            border: "none",
            borderRadius: "8px",
            background: ""
        };
        this.closeReplyPreview = () => {
            this.dispatchEvent(new CustomEvent('cc-close-clicked', {
                bubbles: true,
                composed: true,
            }));
        };
    }
    onReplyClick(reply) {
        this.dispatchEvent(new CustomEvent('cc-reply-clicked', {
            bubbles: true,
            composed: true,
            detail: {
                reply: reply
            }
        }));
    }
    closeIconStyle() {
        var _a;
        return {
            height: "24px",
            width: "24px",
            border: "none",
            borderRadius: "0",
            background: "transparent",
            buttonIconTint: (_a = this.smartReplyStyle) === null || _a === void 0 ? void 0 : _a.closeIconTint
        };
    }
    wrapperStyle() {
        var _a, _b, _c, _d, _e;
        return {
            height: (_a = this.smartReplyStyle) === null || _a === void 0 ? void 0 : _a.height,
            width: (_b = this.smartReplyStyle) === null || _b === void 0 ? void 0 : _b.width,
            border: (_c = this.smartReplyStyle) === null || _c === void 0 ? void 0 : _c.border,
            borderRadius: (_d = this.smartReplyStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
            background: (_e = this.smartReplyStyle) === null || _e === void 0 ? void 0 : _e.background,
        };
    }
    render() {
        var _a, _b, _c, _d;
        this.buttonStyles = {
            height: "100%",
            width: "100%",
            border: "none",
            borderRadius: "16px",
            background: (_a = this.smartReplyStyle) === null || _a === void 0 ? void 0 : _a.replyBackground,
            buttonTextFont: (_b = this.smartReplyStyle) === null || _b === void 0 ? void 0 : _b.replyTextFont,
            buttonTextColor: (_c = this.smartReplyStyle) === null || _c === void 0 ? void 0 : _c.replyTextColor,
            boxShadow: (_d = this.smartReplyStyle) === null || _d === void 0 ? void 0 : _d.boxShadow,
            padding: "8px"
        };
        return lit.html `
      <div class="cc-smart-replies" style=${styleMap_js.styleMap(this.wrapperStyle())}>
        <div class="cc-smart-replies__options">
          ${this.replies.map((reply) => lit.html `
                <div class="cc-smart-replies__option">
                  <cometchat-button
                    .text="${reply}"
                    @cc-button-clicked=${() => this.onReplyClick(reply)}
                    .buttonStyle="${this.buttonStyles}"
                  ></cometchat-button>
                </div>
              `)}
        </div>
        ${this.closeIconURL
            ? lit.html `
              <div class="cc-smart-replies__close">
                <cometchat-button
                  @cc-button-clicked=${this.closeReplyPreview}
                  iconURL=${this.closeIconURL}
                  .buttonStyle=${this.closeIconStyle()}
                >
                </cometchat-button>
              </div>
            `
            : lit.nothing}
      </div>
    `;
    }
};
exports.SmartReplies.styles = [
    lit.css `
* {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }
    .cc-smart-replies {
  padding: 7px;
  font-size: 13px;
  display: flex;
  justify-content: flex-start;
  position: relative;
}
.cc-smart-replies__close {
  width: 24px;
  height: 24px;
  margin: auto 0;
  border-radius: 50%;
  cursor: pointer;
}
.cc-smart-replies__options {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  flex-wrap:wrap;
}
.cc-smart-replies__option {
  padding: 4px 8px;
}
  `
];
__decorate([
    decorators_js.property({ type: Object })
], exports.SmartReplies.prototype, "smartReplyStyle", void 0);
__decorate([
    decorators_js.property({ type: Array })
], exports.SmartReplies.prototype, "replies", void 0);
__decorate([
    decorators_js.property()
], exports.SmartReplies.prototype, "closeIconURL", void 0);
exports.SmartReplies = __decorate([
    decorators_js.customElement('smart-replies')
], exports.SmartReplies);

const SmartRepliesConstants = Object.freeze({
    extensions: "extensions",
    metadata: "metadata",
    injected: "@injected",
    smart_reply: "smart-reply",
    reply_positive: "reply_positive",
    reply_neutral: "reply_neutral",
});

class SmartRepliesConfiguration {
    constructor(props) {
        this.SmartRepliesStyle = {};
        Object.assign(this, props);
    }
}

class SmartRepliesStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.replyTextFont = "400 13px Inter, sans-serif";
        this.replyTextColor = "#bcbcbc";
        this.replyBackground = "white";
        this.boxShadow = "RGBA(20, 20, 20, 0.04) 0 0 0 2px";
        this.closeIconTint = "#bcbcbc";
        Object.assign(this, props);
    }
}

const StickersConstants = Object.freeze({
    sticker: "extension_sticker",
    default_stickers: "defaultStickers",
    custom_stickers: "customStickers",
    stickers: "stickers",
    data: "data",
    custom_data: "customData",
    sticker_url: "sticker_url",
    sticker_name: "sticker_name",
    get: "GET",
    v1_fetch: "v1/fetch"
});

exports.StickersKeyboard = class StickersKeyboard extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.errorStateText = uikitResources.localize("SOMETHING_WRONG");
        this.emptyStateText = uikitResources.localize("NO_STICKERS_FOUND");
        this.loadingIconUrl = LoadingIcon;
        this.stickerStyle = {
            width: "100%",
            height: "auto",
            border: "none",
            borderRadius: "8px",
            background: "rgb(245, 245, 245)",
            categoryBackground: "rgb(255,255,255)",
            emptyTextFont: "700 22px Inter,sans-serif",
            emptyTextColor: "rgba(20,20,20, 0.58)",
            errorTextFont: "700 22px Inter,sans-serif",
            errorTextColor: "rgba(20,20,20, 0.58)",
            loadingIconTint: "grey"
        };
        /**
      * Properties for internal use
      */
        this.state = uikitResources.States.loading;
        this.stickerSet = {};
        this.activeStickerList = [];
        this.categoryStickerUrl = [];
        this.keyboardStyles = () => {
            return {
                height: this.stickerStyle.height,
                width: this.stickerStyle.width,
                background: this.stickerStyle.background,
                border: this.stickerStyle.border,
                borderRadius: this.stickerStyle.borderRadius
            };
        };
        this.sectionStyles = () => {
            return {
                background: this.stickerStyle.categoryBackground || "inherit",
                border: this.stickerStyle.border,
                borderRadius: this.stickerStyle.borderRadius
            };
        };
        this.decorateMessageStyles = () => {
            const { state, stickerStyle } = this;
            switch (state) {
                case uikitResources.States.error:
                    return { textColor: stickerStyle.errorTextColor, textFont: stickerStyle.errorTextFont };
                case uikitResources.States.empty:
                    return { textColor: stickerStyle.emptyTextColor, textFont: stickerStyle.emptyTextFont };
                default:
                    return {};
            }
        };
    }
    /**
  * fetching stickers on init
  * @param
  */
    async getStickers() {
        this.state = uikitResources.States.loading;
        try {
            const stickers = await chatSdkJavascript.CometChat.callExtension(StickersConstants.stickers, StickersConstants.get, StickersConstants.v1_fetch);
            let activeStickerSet = null;
            const customStickers = (stickers === null || stickers === void 0 ? void 0 : stickers.customStickers) ? [stickers.customStickers] : [];
            const defaultStickers = stickers.defaultStickers || [];
            defaultStickers.sort((a, b) => a.stickerSetOrder - b.stickerSetOrder);
            customStickers.sort((a, b) => a.stickerSetOrder - b.stickerSetOrder);
            const stickerList = [...defaultStickers, ...customStickers];
            if (stickerList.length === 0) {
                this.state = uikitResources.States.empty;
                this.requestUpdate("state");
            }
            const stickerSet = stickerList.reduce((r, sticker, index) => {
                const { stickerSetName } = sticker;
                if (index === 0) {
                    activeStickerSet = stickerSetName;
                }
                r[stickerSetName] = [...(r[stickerSetName] || []), { ...sticker }];
                return r;
            }, {});
            let activeStickerList = [];
            if (Object.keys(stickerSet).length) {
                Object.keys(stickerSet).forEach((key) => {
                    stickerSet[key].sort((a, b) => a.stickerOrder - b.stickerOrder);
                });
                if (activeStickerSet !== null) {
                    activeStickerList = stickerSet[activeStickerSet];
                }
            }
            this.stickerSet = stickerSet;
            this.activeStickerList = activeStickerList;
            this.requestUpdate("stickerSet");
            if (stickerList.length !== 0) {
                this.state = uikitResources.States.loaded;
                this.requestUpdate("state");
            }
            Object.keys(this.stickerSet).forEach((sectionItem) => {
                const url = this.stickerSet[sectionItem][0];
                this.categoryStickerUrl.push(url);
            });
        }
        catch (error) {
            console.error(error);
            this.state = uikitResources.States.error;
            this.requestUpdate("state");
        }
    }
    /**
     * Gets The sticker collection when sticker category is changed
     * @param
     */
    stickerSetClicked(sectionItem) {
        try {
            const activeStickerList = this.stickerSet[sectionItem];
            this.activeStickerList = activeStickerList;
            this.requestUpdate("activeStickerList");
        }
        catch (error) {
            console.error(error);
        }
    }
    /**
     * Sends Sticker as Message
     * @param
     */
    sendStickerMessage(stickerItem) {
        this.dispatchEvent(new CustomEvent('cc-sticker-clicked', {
            bubbles: true,
            composed: true,
            detail: {
                stickerURL: stickerItem.stickerUrl, stickerName: stickerItem.stickerSetName
            }
        }));
    }
    connectedCallback() {
        super.connectedCallback();
        this.getStickers();
    }
    getStateView() {
        switch (this.state) {
            case uikitResources.States.loading:
                return lit.html `<cometchat-loader .iconURL=${this.loadingIconUrl} .loaderStyle=${this.loaderStyle()}></cometchat-loader>`;
            case uikitResources.States.empty:
                return lit.html `<cometchat-label .text=${this.emptyStateText} .labelStyle=${this.decorateMessageStyles()}></cometchat-label>`;
            case uikitResources.States.error:
                return lit.html `<cometchat-label .text=${this.errorStateText} .labelStyle=${this.decorateMessageStyles()}></cometchat-label>`;
            default:
                return lit.nothing;
        }
    }
    render() {
        const state = this.state;
        const activeStickerList = this.activeStickerList;
        const categoryStickerUrl = this.categoryStickerUrl;
        return lit.html `
    <div class="cc__stickerskeyboard" style=${styleMap_js.styleMap(this.keyboardStyles())}>
      ${state !== uikitResources.States.loaded ? lit.html `
        <div class="decorator__message">
          ${this.getStateView()}
        </div>
      ` : ''}

      <!-- ActiveStickerList -->
      ${state === uikitResources.States.loaded ? lit.html `
        <div class="cc__stickerskeyboard__list">
          ${activeStickerList.map((sticker) => lit.html `
            <div @click=${() => { this.sendStickerMessage(sticker); }}>
              <img src=${sticker.stickerUrl} alt=${sticker.stickerSetName} class="cc__stickerskeyboard__sticker"  />
            </div>
          `)}
        </div>

        <!-- Section Items -->
        <div class="cc__stickerskeyboard__categories" style=${styleMap_js.styleMap(this.sectionStyles())}>
          ${categoryStickerUrl.map((sticker) => lit.html `
            <div @click=${() => { this.stickerSetClicked(sticker.stickerSetName); }}>
              ${sticker.stickerUrl ? lit.html `
                <img src=${sticker.stickerUrl} class="cc__stickerskeyboard__category"  />
              ` : ''}
            </div>
          `)}
        </div>
      ` : ''}
    </div>
  `;
    }
    loaderStyle() {
        return {
            iconTint: this.stickerStyle.loadingIconTint
        };
    }
};
exports.StickersKeyboard.styles = [
    lit.css `
:host {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }
.cc__stickerskeyboard {
  min-height: 230px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.cc__stickerskeyboard__categories {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 16px;
  background: inherit;
}
.cc__stickerskeyboard__categories::-webkit-scrollbar {
    background: transparent;
    height: 8px;
}
.cc__stickerskeyboard__categories::-webkit-scrollbar-thumb {
    background: rgb(232, 229, 229);
    border-radius: 8px;
}
.cc__stickerskeyboard__list::-webkit-scrollbar {
    background: transparent;
    width: 8px;
}
.cc__stickerskeyboard__list::-webkit-scrollbar-thumb {
    background: rgb(232, 229, 229);
    border-radius: 8px;
}
.cc__stickerskeyboard__category {
  height: 35px;
  width: 35px;
  cursor: pointer;
  flex-shrink: 0;
}
.cc__stickerskeyboard__list {
  max-height: calc(100% - 50px);
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
  flex-wrap: wrap;
  background:inherit;
  margin: 0 8px;
}
.cc__stickerskeyboard__sticker {
  min-width: 50px;
  min-height: 50px;
  max-width: 70px;
  cursor: pointer;
  flex-shrink: 0;
  margin-right: 20px;
  height:fit-content;
  width:fit-content;
}
.decorator__message {
 margin:auto;
}
  `
];
__decorate([
    decorators_js.property()
], exports.StickersKeyboard.prototype, "errorStateText", void 0);
__decorate([
    decorators_js.property()
], exports.StickersKeyboard.prototype, "emptyStateText", void 0);
__decorate([
    decorators_js.property()
], exports.StickersKeyboard.prototype, "loadingIconUrl", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.StickersKeyboard.prototype, "stickerStyle", void 0);
exports.StickersKeyboard = __decorate([
    decorators_js.customElement('stickers-keyboard')
], exports.StickersKeyboard);

class StickersConfiguration {
    constructor(props) {
        this.loadingIconUrl = LoadingIcon;
        this.stickerskeyboardstyle = {};
        Object.assign(this, props);
    }
}

class StickersStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.width = '300px';
        this.height = '400px';
        this.stickerButtonWidth = '24px';
        this.sticketButtonHeight = '24px';
        this.stickerButtonIconTint = 'rgba(20, 20, 20, 0.46)';
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.categoryBackground = "";
        Object.assign(this, props);
    }
}

const MessageTranslationConstants = Object.freeze({
    message_translation: "message-translation",
    v2_translate: "v2/translate",
    translated_message: "translated_message",
    extensions: "extensions",
    metadata: "metadata",
    injected: "@injected",
    post: "POST"
});

class MessageTranslationStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.helpTextFont = "400 11px Inter, sans-serif";
        this.helpTextColor = "RGBA(255, 255, 255, 0.6)";
        this.translatedTextFont = "400 13px Inter, sans-serif";
        this.translatedTextColor = "RGBA(255, 255, 255, 0.8)";
        Object.assign(this, props);
    }
}

exports.MessageTranslationBubble = class MessageTranslationBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.translatedText = "";
        this.messageTranslationStyle = {
            helpTextFont: "400 11px Inter, sans-serif",
            helpTextColor: "RGBA(255, 255, 255, 0.6)",
            translatedTextFont: "400 13px Inter, sans-serif",
            translatedTextColor: "RGBA(255, 255, 255, 0.8)",
        };
        this.alignment = uikitResources.MessageBubbleAlignment.right;
        this.helpText = uikitResources.localize("TRANSLATED_MESSAGE");
        this.textFormatters = [];
        this.translatedMessageStyle = () => {
            return {
                color: this.messageTranslationStyle.helpTextColor,
                font: this.messageTranslationStyle.helpTextFont,
            };
        };
        this.translatedMessageTextStyle = () => {
            return {
                color: this.messageTranslationStyle.translatedTextColor,
                font: this.messageTranslationStyle.translatedTextFont,
            };
        };
        this.translationAlignment = () => {
            return {
                display: "flex",
                justifyContent: "center",
                alignItems: this.alignment == uikitResources.MessageBubbleAlignment.left
                    ? "flex-start"
                    : "flex-end",
            };
        };
    }
    render() {
        var _a;
        return lit.html `
      ${this.translatedText && ((_a = this.translatedText) === null || _a === void 0 ? void 0 : _a.trim().length) > 0
            ? lit.html ` <div
            class="cc__messagetranslation"
            style=${styleMap_js.styleMap(this.translationAlignment())}
          >
            <slot></slot>
            <div
              class="cc__messagetranslation_message"
              style=${styleMap_js.styleMap(this.translatedMessageTextStyle())}
            >
              <p id="textContent"></p>
            </div>
            <div
              class="cc__messagetranslation_text"
              style=${styleMap_js.styleMap(this.translatedMessageStyle())}
            >
              ${this.helpText}
            </div>
          </div>`
            : ""}
    `;
    }
    updated(_changedProperties) {
        var _a;
        if (_changedProperties.has("translatedText") ||
            _changedProperties.has("textFormatters")) {
            const textElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("#textContent");
            let finalText = this.translatedText;
            if (textElement && this.textFormatters && this.textFormatters.length) {
                if (this.textFormatters) {
                    for (let i = 0; i < this.textFormatters.length; i++) {
                        finalText = this.textFormatters[i].getFormattedText(finalText, {
                            mentionsTargetElement: uikitResources.MentionsTargetElement.textbubble,
                        });
                    }
                }
            }
            textElement.textContent = "";
            this.pasteHtml(textElement, finalText);
        }
    }
    pasteHtml(textElement, html) {
        try {
            let el = document.createElement("div");
            el.innerHTML = html;
            let frag = document.createDocumentFragment(), node, lastNode;
            while ((node = el.firstChild)) {
                if (node instanceof HTMLElement) {
                    if (this.textFormatters && this.textFormatters.length) {
                        for (let i = 0; i < this.textFormatters.length; i++) {
                            node = this.textFormatters[i].registerEventListeners(node, node.classList);
                        }
                    }
                    frag.appendChild(node);
                }
                lastNode = frag.appendChild(node);
            }
            textElement.appendChild(frag);
        }
        catch (error) {
            console.log(error);
        }
    }
};
exports.MessageTranslationBubble.styles = [
    lit.css `
      .cc__messagetranslation {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        padding: 0 8px;
        width: auto;
        background: transparent;
        gap: 2px;
        padding-bottom: 8px;
      }
      .cc__messagetranslation_message {
        padding: 0 8px;
      }
      .cc__messagetranslation_text {
        padding: 0 8px;
      }
    `,
];
__decorate([
    decorators_js.property()
], exports.MessageTranslationBubble.prototype, "translatedText", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.MessageTranslationBubble.prototype, "messageTranslationStyle", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.MessageTranslationBubble.prototype, "alignment", void 0);
__decorate([
    decorators_js.property()
], exports.MessageTranslationBubble.prototype, "helpText", void 0);
__decorate([
    decorators_js.property()
], exports.MessageTranslationBubble.prototype, "textFormatters", void 0);
exports.MessageTranslationBubble = __decorate([
    decorators_js.customElement("message-translation-bubble")
], exports.MessageTranslationBubble);

class MessageTranslationConfiguration {
    constructor(props) {
        this.MessageTranslationStyle = {};
        Object.assign(this, props);
    }
}

class CollaborativeDocumentStyle extends uikitElements.DocumentBubbleStyle {
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}

class CollaborativeDocumentConfiguration {
    constructor(props) {
        this.documentBubbleStyle = {};
        this.iconURL = "";
        this.ccClicked = null;
        Object.assign(this, props);
    }
}

const CollaborativeDocumentConstants = Object.freeze({
    v1_create: "v1/create",
    extension_document: "extension_document",
    document: "document",
    extensions: "extensions",
    metadata: "metadata",
    injected: "@injected",
    post: "POST"
});

class CollaborativeWhiteboardStyle extends uikitElements.DocumentBubbleStyle {
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}

class CollaborativeWhiteboardConfiguration {
    constructor(props) {
        this.WhiteBoardBubbleStyle = {};
        this.iconURL = "";
        this.ccClicked = null;
        Object.assign(this, props);
    }
}

const CollaborativeWhiteboardConstants = Object.freeze({
    v1_create: "v1/create",
    extension_whiteboard: "extension_whiteboard",
    whiteboard: "whiteboard",
    extensions: "extensions",
    metadata: "metadata",
    injected: "@injected",
    post: "POST"
});

class CreatePollStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.placeholderTextFont = "400 15px Inter";
        this.placeholderTextColor = "RGBA(20, 20, 20, 0.6)";
        this.deleteIconTint = "grey";
        this.titleFont = "700 22px Inter, sans-serif";
        this.titleColor = "rgb(20, 20, 20)";
        this.closeIconTint = "rgb(51, 153, 255)";
        this.questionInputBackground = "rgba(20, 20, 20, 0.08)";
        this.optionInputBackground = "rgba(20, 20, 20, 0.08)";
        this.answerHelpTextFont = "500 12px Inter, sans-serif";
        this.answerHelpTextColor = "rgba(20, 20, 20, 0.58)";
        this.addAnswerIconTint = "rgb(51, 153, 255)";
        this.createPollButtonTextFont = "600 15px Inter, sans-serif";
        this.createPollButtonTextColor = "rgb(255, 255, 255)";
        this.createPollButtonBackground = "rgb(51, 153, 255)";
        this.addAnswerTextFont = "500 15px Inter, sans-serif";
        this.addAnswerTextColor = "rgb(51, 153, 255)";
        this.errorTextFont = "400 15px Inter, sans-serif";
        this.errorTextColor = "rgb(255, 59, 48)";
        this.optionPlaceholderTextFont = "400 15px Inter";
        this.optionPlaceholderTextColor = "RGBA(20, 20, 20, 0.6)";
        this.questionInputTextFont = "400 13px Inter";
        this.questionInputTextColor = "RGBA(20, 20, 20, 0.6)";
        this.optionInputTextFont = "400 13px Inter";
        this.optionInputTextColor = "RGBA(20, 20, 20, 0.6)";
        Object.assign(this, props);
    }
}

exports.CreatePoll = class CreatePoll extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.title = uikitResources.localize("CREATE_POLL");
        this.ccCloseClicked = null;
        this.defaultAnswers = 3;
        this.questionPlaceholderText = uikitResources.localize("QUESTION");
        this.answerPlaceholderText = uikitResources.localize("ANSWER");
        this.answerHelpText = uikitResources.localize("SET_THE_ANSWERS");
        this.addAnswerText = uikitResources.localize("ADD_ANOTHER_ANSWER");
        this.deleteIconURL = DeleteIcon;
        this.closeIconURL = closeIcon$1;
        this.addAnswerIconURL = PlusIcon;
        this.createPollButtonText = uikitResources.localize("CREATE");
        this.createPollStyle = {
            width: "360px",
            height: "620px",
            border: "",
            borderRadius: "8px",
            background: "white",
            placeholderTextFont: "400 15px Inter",
            placeholderTextColor: "RGBA(20, 20, 20, 0.6)",
            deleteIconTint: "grey",
            titleFont: "700 22px Inter, sans-serif",
            titleColor: "rgb(20, 20, 20)",
            closeIconTint: "rgb(51, 153, 255)",
            questionInputBackground: "rgba(20, 20, 20, 0.04)",
            optionInputBackground: "rgba(20, 20, 20, 0.04)",
            questionInputTextFont: "400 13px Inter",
            questionInputTextColor: "RGBA(20, 20, 20, 0.6)",
            optionInputTextFont: "400 13px Inter",
            optionInputTextColor: "RGBA(20, 20, 20, 0.6)",
            answerHelpTextFont: "500 12px Inter, sans-serif",
            answerHelpTextColor: "rgba(20, 20, 20, 0.58)",
            addAnswerIconTint: "rgb(51, 153, 255)",
            createPollButtonTextFont: "600 15px Inter, sans-serif",
            createPollButtonTextColor: "rgb(255, 255, 255)",
            createPollButtonBackground: "rgb(51, 153, 255)",
            addAnswerTextFont: "500 15px Inter, sans-serif",
            addAnswerTextColor: "rgb(51, 153, 255)",
            errorTextFont: "400 15px Inter, sans-serif",
            errorTextColor: "rgb(255, 59, 48)",
            optionPlaceholderTextFont: "400 15px Inter",
            optionPlaceholderTextColor: "RGBA(20, 20, 20, 0.6)"
        };
        /**
      * Properties for internal use
      */
        this.errorText = uikitResources.localize("SOMETHING_WRONG");
        this.inputQuestion = "";
        this.inputOptionItems = [];
        this.isError = false;
        this.type = "";
        this.isLoading = false;
        //   styling
        this.closeButtonStyle = () => {
            return {
                buttonIconTint: this.createPollStyle.closeIconTint,
                border: "none",
                borderRadius: "8px",
                height: "24px",
                width: "24px",
                background: "transparent"
            };
        };
        this.addIconStyle = () => {
            return {
                buttonIconTint: this.createPollStyle.addAnswerIconTint,
                border: "none",
                borderRadius: "8px",
                height: "24px",
                width: "24px",
                background: "transparent"
            };
        };
        this.removeIconStyle = () => {
            return {
                buttonIconTint: this.createPollStyle.deleteIconTint,
                border: "none",
                borderRadius: "8px",
                height: "24px",
                width: "24px",
                background: "transparent"
            };
        };
        this.titleStyle = () => {
            return {
                textFont: this.createPollStyle.titleFont,
                textColor: this.createPollStyle.titleColor
            };
        };
        this.subtitleStyle = () => {
            return {
                textFont: this.createPollStyle.answerHelpTextFont,
                textColor: this.createPollStyle.answerHelpTextColor
            };
        };
        this.placeHolderStyle = () => {
            return {
                height: "24px",
                width: "100%",
                border: "none",
                textFont: this.createPollStyle.questionInputTextFont,
                textColor: this.createPollStyle.questionInputTextColor,
                placeholderTextFont: this.createPollStyle.placeholderTextFont,
                placeholderTextColor: this.createPollStyle.placeholderTextColor,
                borderRadius: "8px",
                boxShadow: "",
                background: "transparent"
            };
        };
        this.optionPlaceHolderStyle = () => {
            return {
                height: "24px",
                width: "100%",
                border: "none",
                textFont: this.createPollStyle.optionInputTextFont,
                textColor: this.createPollStyle.optionInputTextColor,
                placeholderTextFont: this.createPollStyle.optionPlaceholderTextFont,
                placeholderTextColor: this.createPollStyle.optionPlaceholderTextColor,
                borderRadius: "8px",
                boxShadow: "",
                background: "transparent"
            };
        };
        this.addIconTextStyle = () => {
            return {
                font: this.createPollStyle.addAnswerTextFont,
                color: this.createPollStyle.addAnswerTextColor
            };
        };
        this.buttonTextStyle = () => {
            return {
                buttonTextFont: this.createPollStyle.createPollButtonTextFont,
                buttonTextColor: this.createPollStyle.createPollButtonTextColor,
                background: this.createPollStyle.createPollButtonBackground,
                border: "none",
                borderRadius: "8px",
                height: "36px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            };
        };
        this.createPollWrapperStyle = () => {
            return {
                height: this.createPollStyle.height,
                width: this.createPollStyle.width,
                background: this.createPollStyle.background,
                border: this.createPollStyle.border,
                borderRadius: this.createPollStyle.borderRadius
            };
        };
        this.optionBorderStyle = () => {
            return {
                border: this.createPollStyle.border,
                borderRadius: this.createPollStyle.borderRadius,
                background: this.createPollStyle.optionInputBackground
            };
        };
        this.questionBorderStyle = () => {
            return {
                border: this.createPollStyle.border,
                borderRadius: this.createPollStyle.borderRadius,
                background: this.createPollStyle.questionInputBackground
            };
        };
    }
    closePollView() {
        this.dispatchEvent(new CustomEvent('cc-close-clicked', {
            bubbles: true,
            composed: true,
        }));
    }
    getOptionCount(count) {
        let text = this.answerPlaceholderText + " " + (count + 1);
        return text;
    }
    updated(_changedProperties) {
        if (_changedProperties.has('user') || _changedProperties.has('group')) {
            this.inputOptionItems = [];
            let arr = Array(this.defaultAnswers);
            for (let i = 0; i < arr.length; i++) {
                this.addPollOption();
            }
            this.requestUpdate("inputOptionItems");
            if (this.user) {
                this.type = uikitResources.CometChatUIKitConstants.MessageReceiverType.user;
            }
            else if (this.group) {
                this.type = uikitResources.CometChatUIKitConstants.MessageReceiverType.group;
            }
        }
    }
    connectedCallback() {
        super.connectedCallback();
        let arr = Array(this.defaultAnswers);
        for (let i = 0; i < arr.length; i++) {
            this.addPollOption();
        }
    }
    /**
   * Used to add an extra option
   * @param
   */
    addPollOption() {
        try {
            this.inputOptionItems.push({
                key: '',
                value: ''
            });
            this.requestUpdate("inputOptionItems");
        }
        catch (error) {
            console.log(error);
        }
    }
    /**
     * Used to remove an extra option
     * @param number index
     */
    removePollOption(index) {
        try {
            this.inputOptionItems.splice(index, 1);
            this.requestUpdate("inputOptionItems");
        }
        catch (error) {
            console.log(error);
        }
    }
    /**
   * Creates the poll
   */
    createPoll() {
        var _a, _b;
        try {
            let inputValue = this.inputOptionItems
                .map(item => item.value)
                .filter(value => value !== undefined && value !== '');
            if (this.inputQuestion.trim().length === 0) {
                this.isError = true;
                this.requestUpdate("isError");
                return false;
            }
            this.isError = false;
            this.requestUpdate("isError");
            let receiverId;
            let receiverType = this.type;
            if (this.type === chatSdkJavascript.CometChat.RECEIVER_TYPE.USER) {
                receiverId = this.user instanceof chatSdkJavascript.CometChat.User ? (_a = this.user) === null || _a === void 0 ? void 0 : _a.getUid() : this.user.uid;
            }
            else if (this.type === chatSdkJavascript.CometChat.RECEIVER_TYPE.GROUP) {
                receiverId = this.group instanceof chatSdkJavascript.CometChat.Group ? (_b = this.group) === null || _b === void 0 ? void 0 : _b.getGuid() : this.group.guid;
            }
            let optionList = [
                ...inputValue
            ];
            this.isLoading = true;
            chatSdkJavascript.CometChat.callExtension(PollsConstants.polls, PollsConstants.post, PollsConstants.v2_create, {
                question: this.inputQuestion,
                options: optionList,
                receiver: receiverId,
                receiverType: receiverType,
            })
                .then((response) => {
                this.isError = false;
                this.isLoading = false;
                if (response && response.hasOwnProperty("success") && response["success"] === true) {
                    this.closePollView();
                }
            })
                .catch((error) => {
                this.isLoading = false;
                this.isError = true;
                this.requestUpdate("isError");
            })
                .finally(() => {
            });
        }
        catch (error) {
            console.log(error);
        }
        return true;
    }
    render() {
        return lit.html `
 <div class="cc__createpoll" style=${styleMap_js.styleMap(this.createPollWrapperStyle())}>
    <div class="cc__createpoll__close"  >
   <cometchat-button @cc-button-clicked=${() => this.closePollView()} .buttonStyle=${this.closeButtonStyle()} .iconURL=${this.closeIconURL}></cometchat-button>
</div>
    <div class="cc__createpoll__body">
      <div class="cc__pollcaption" >
        <cometchat-label .text=${this.title} .labelStyle=${this.titleStyle()}></cometchat-label>
      </div>
      <div class="cc__createpoll__content">
        <div class="cc__error__body" ?hidden=${!this.isError}>
          <div class="cc__polldata">
            <cometchat-label .text=${this.errorText} >
            </cometchat-label>
          </div>
        </div>
        <div class="cc__pollrow" style=${styleMap_js.styleMap(this.questionBorderStyle())}>
          <div class="cc__polldata">
            <cometchat-input class="cc__polldata__input" .type=${"text"}
              .placeholderText =${this.questionPlaceholderText} .value=${this.inputQuestion} .inputStyle=${this.placeHolderStyle()}
              @cc-input-changed=${(e) => this.inputQuestion = e.target.value}></cometchat-input>
          </div>
        </div>
        <!--  Answers list  -->
        <div class="cc__pollrow cc__addoption__row">
          <div class="icon__wrapper cc__polldata cc__helpertext__wrapper">
            <cometchat-label class="add__answer__text" .labelStyle=${this.subtitleStyle()} .text=${this.answerHelpText}>  </cometchat-label>
          </div>
        </div>
        ${this.inputOptionItems.map((option, i) => lit.html `
          <div class="cc__pollrow" style=${styleMap_js.styleMap(this.optionBorderStyle())}>
            <div class="cc__polldata">
                <cometchat-input class="cc__polldata__input" .type=${"text"}
              .placeholderText =${this.getOptionCount(i)} .value=${option.value} .inputStyle=${this.optionPlaceHolderStyle()}
              @cc-input-changed=${(e) => {
            this.inputOptionItems[i].value = e.target.value;
        }} ></cometchat-input>
            </div>
            ${i > 1 ? lit.html `
            <div class="icon__remove cc__polldata">
                <cometchat-button class="cc__removeicon" @cc-button-clicked=${() => this.removePollOption(i)} .buttonStyle=${this.removeIconStyle()} .iconURL=${this.deleteIconURL}></cometchat-button>
            </div>
            ` : lit.nothing}
          </div>
        `)}
      </div>
          <!--  POLL OPTION VIEW ABOVE -->
          <div class="cc__pollrow cc__addoption__row">
          <div class="icon__wrapper cc__polldata cc__addicon__wrapper">
            <!-- Add Icon -->
            <cometchat-button class="option__icon add__icon" @cc-button-clicked=${() => this.addPollOption()} .buttonStyle=${this.addIconStyle()} .iconURL=${this.addAnswerIconURL}></cometchat-button>
            <span class="add__answer__text" style=${styleMap_js.styleMap(this.addIconTextStyle())}>${this.addAnswerText} </span>
          </div>
        </div>
    </div>
    <div class="cc__createpoll-button">
        <cometchat-button ?disabled=${this.isLoading}  @cc-button-clicked=${() => this.createPoll()} .buttonStyle=${this.buttonTextStyle()} .text=${this.createPollButtonText}></cometchat-button>
      </div>
  </div>
    `;
    }
};
exports.CreatePoll.styles = [
    lit.css `
   *{
    box-sizing:border-box;
       margin:0;
       padding:0;
   }
   .option__icon {
  background-size: 28px 28px;
  cursor: pointer;
  display: block;
  height: 28px;
  width: 28px;
  z-index: 1000;
  margin-right: 10px;
}
.add__icon {
  background-size: 24px 24px;
  cursor: pointer;
  display: block;
  height: 24px;
  width: 24px;
}
.add__answer__text {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cc__removeicon {
  cursor: pointer;
  display: block;
  height: 24px;
  width: 24px;
}
.icon__wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.icon__remove {
  width: fit-content !important;
  display: flex;
  justify-content: flex-end;
  padding-right:16px !important;
}
.cc__createpoll {
  display: block;
  z-index: 10;
  margin: 0 auto;
  border-radius: 8px;
  display: flex;
    flex-direction: column;
    position:relative;
}
input {
  outline: none;
}
.cc__createpoll__close {
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  top: 8px;
    right: 14px;
  cursor: pointer;
}
.cc__createpoll__body {
  padding: 8px;
  width: 100%;
  height: 100%;
 display:flex;
 flex-direction:column;
 justify-content: flex-start;
  margin: 0;
}
.decorator__message--error {
  text-align: center;
}
.cc__error__body {
  border: none !important;
}
.cc__pollcaption {
  margin-bottom: 15px;
  text-align: center;
}
.cc__createpoll__content{
  display: block;
  overflow-x:auto;
}
.cc__polldata {
  padding: 8px;
  width: 100%;
  background: inherit;
  border-radius:inherit;
}
.cc__polldata__width {
  width: 110px;
}
.cc__addoption__row {
  border: none !important;
  margin: 10px 0;
}
.cc__helpertext__wrapper{
  padding: 6px 0 !important;
}
.cc__addicon__wrapper {
  padding: 16px 0 !important;
}
.cc__pollrow {
  display: flex;
  margin: 8px 0;
  justify-content:space-between;
  position:relative;
}
.cc__polldata__input {
  padding: 6px 0;
  background: transparent;
  width: 100%;
  border: none;
}
.cc__polldata__label:focus {
  outline: none;
}
.cc__polldata__label {
  padding: 6px 12px;
}
.cc__createpoll-button {
  display: block;
  width: 100%;
  padding:16px 8px;
}
    `
];
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "title", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CreatePoll.prototype, "user", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CreatePoll.prototype, "group", void 0);
__decorate([
    decorators_js.property({ attribute: false })
], exports.CreatePoll.prototype, "ccCloseClicked", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CreatePoll.prototype, "defaultAnswers", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "questionPlaceholderText", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "answerPlaceholderText", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "answerHelpText", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "addAnswerText", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "deleteIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "closeIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "addAnswerIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "createPollButtonText", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CreatePoll.prototype, "createPollStyle", void 0);
exports.CreatePoll = __decorate([
    decorators_js.customElement('create-poll')
], exports.CreatePoll);

var optionBackgroundIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FCheckmark%20Empty%402x%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FCheckmark-Empty%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%283.000000%2C%203.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C9%20C0%2C13.9705627%204.02943725%2C18%209%2C18%20C13.9705627%2C18%2018%2C13.9705627%2018%2C9%20C18%2C4.02943725%2013.9705627%2C0%209%2C0%20C4.02943725%2C0%200%2C4.02943725%200%2C9%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

exports.PollsBubble = class PollsBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
        this.pollQuestion = "";
        this.pollId = "";
        this.senderUid = "";
        this.pollStyle = {
            width: "100%",
            height: "auto",
            border: "0 none",
            borderRadius: "12px",
            background: "#ededed",
            votePercentTextFont: "",
            votePercentTextColor: "",
            pollQuestionTextFont: "500 12px Inter, sans-serif",
            pollQuestionTextColor: "#39f",
            pollOptionTextFont: "400 15px Inter,sans-serif",
            pollOptionTextColor: "#39f",
            pollOptionBackground: "#fff",
            pollOptionBorder: "",
            pollOptionBorderRadius: "",
            optionsIconTint: "rgba(20, 20, 20, 0.58)",
            totalVoteCountTextFont: "400 13px Inter,sans-serif",
            totalVoteCountTextColor: "#fff",
            selectedPollOptionBackground: "grey",
            userSelectedOptionBackground: "lightblue"
        };
        this.pollOptions = [];
        this.totalVotes = 0;
        this.pollExtensionData = {};
        this.messageContainer = () => {
            return {
                background: "transparent",
                height: this.pollStyle.height,
                width: this.pollStyle.width,
            };
        };
        this.setvotePercentageStyle = () => {
            return {
                font: this.pollStyle.votePercentTextFont,
                color: this.pollStyle.votePercentTextColor,
            };
        };
        this.setPollOptionStyle = () => {
            return {
                font: this.pollStyle.pollOptionTextFont,
                color: this.pollStyle.pollOptionTextColor,
            };
        };
        this.pollResultStyle = () => {
            return {
                textFont: this.pollStyle.totalVoteCountTextFont,
                textColor: this.pollStyle.totalVoteCountTextColor,
            };
        };
        this.pollOptionStyle = (option) => {
            var _a, _b, _c, _d, _e, _f;
            if (option.selectedByLoggedInUser) {
                return {
                    background: `linear-gradient(to right, ${this.pollStyle.userSelectedOptionBackground} ${option.percent}, white 0%)`,
                    border: (_a = this.pollStyle) === null || _a === void 0 ? void 0 : _a.pollOptionBorder,
                    borderRadius: ((_b = this.pollStyle) === null || _b === void 0 ? void 0 : _b.pollOptionBorderRadius) || "8px"
                };
            }
            else if ((option === null || option === void 0 ? void 0 : option.percent) != "0%") {
                return {
                    background: `linear-gradient(to right, ${this.pollStyle.selectedPollOptionBackground} ${option.percent}, white 0%)`,
                    border: (_c = this.pollStyle) === null || _c === void 0 ? void 0 : _c.pollOptionBorder,
                    borderRadius: ((_d = this.pollStyle) === null || _d === void 0 ? void 0 : _d.pollOptionBorderRadius) || "8px"
                };
            }
            else {
                return {
                    background: this.pollStyle.pollOptionBackground,
                    border: (_e = this.pollStyle) === null || _e === void 0 ? void 0 : _e.pollOptionBorder,
                    borderRadius: ((_f = this.pollStyle) === null || _f === void 0 ? void 0 : _f.pollOptionBorderRadius) || "8px"
                };
            }
        };
        this.checkIconStyle = (option) => {
            var _a;
            return option.percent === '0%' ? {
                width: "24px",
                height: "24px",
                iconTint: (_a = this.pollStyle) === null || _a === void 0 ? void 0 : _a.optionsIconTint,
            } : {};
        };
        this.pollStyles = () => {
            var _a, _b, _c, _d, _e;
            return {
                width: (_a = this.pollStyle) === null || _a === void 0 ? void 0 : _a.width,
                height: (_b = this.pollStyle) === null || _b === void 0 ? void 0 : _b.height,
                border: (_c = this.pollStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.pollStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.pollStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
        this.pollTitleStyle = () => {
            var _a, _b;
            return {
                textFont: (_a = this.pollStyle) === null || _a === void 0 ? void 0 : _a.pollQuestionTextFont,
                textColor: (_b = this.pollStyle) === null || _b === void 0 ? void 0 : _b.pollQuestionTextColor,
            };
        };
    }
    /**
     * Displays the poll component , only if it is enabled
     */
    /**
     * Sets Poll Data
     * @param
     */
    setPollExtensionData() {
        var _a, _b, _c, _d, _e, _f;
        try {
            let pollsData = this.metadata[PollsConstants.injected] ? (_b = (_a = this.metadata[PollsConstants.injected]) === null || _a === void 0 ? void 0 : _a.extensions) === null || _b === void 0 ? void 0 : _b.polls : {};
            this.pollExtensionData = pollsData;
            this.pollId = this.pollId;
            this.totalVotes = (_d = (_c = this.pollExtensionData) === null || _c === void 0 ? void 0 : _c.results) === null || _d === void 0 ? void 0 : _d.total;
            let optionKeys = Object.keys((_e = this.pollExtensionData) === null || _e === void 0 ? void 0 : _e.options);
            let optionList = [];
            optionKeys.forEach((currentItem) => {
                var _a, _b, _c, _d, _e;
                const optionData = (_b = (_a = this.pollExtensionData) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.options[currentItem];
                const vote = optionData["count"];
                let calculatedPercent = 0;
                if (this.totalVotes > 0) {
                    calculatedPercent = Math.round((vote / this.totalVotes) * 100);
                }
                let selectedByLoggedInUser = false;
                if (optionData === null || optionData === void 0 ? void 0 : optionData.hasOwnProperty("voters")) {
                    if ((_c = optionData === null || optionData === void 0 ? void 0 : optionData.voters) === null || _c === void 0 ? void 0 : _c.hasOwnProperty((_d = this.loggedInUser) === null || _d === void 0 ? void 0 : _d.uid)) {
                        selectedByLoggedInUser = true;
                    }
                }
                optionList.push({
                    id: currentItem,
                    percent: calculatedPercent + "%",
                    text: (_e = this.pollExtensionData) === null || _e === void 0 ? void 0 : _e.options[currentItem],
                    selectedByLoggedInUser,
                });
            });
            this.pollOptions = ((_f = this.options) === null || _f === void 0 ? void 0 : _f.length) > 0 ? this.options : [...optionList];
            this.requestUpdate("pollOptions");
        }
        catch (error) {
            console.warn(error);
        }
    }
    updated(_changedProperties) {
        if (_changedProperties.has('metadata')) {
            this.setPollExtensionData();
        }
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return lit.html `
<div class="cc__pollsbubble__wrapper" style=${styleMap_js.styleMap(this.pollStyles())}>
        <div class="cc__pollsbubble">
          <cometchat-label .text=${this.pollQuestion} class="cc__pollsbubble__question" .labelStyle=${this.pollTitleStyle()}></cometchat-label>
          <ul class="cc__pollsbubble__options">
            <!-- Options -->
            ${this.pollOptions.map((option) => lit.html `
                <li
                  @click=${() => this.answerPollQuestion(option)}
                  class="cc__pollsbubble__option ${(option === null || option === void 0 ? void 0 : option.selectedByLoggedInUser) ? 'cc__pollsbubble__checked' : 'cc__pollsbubble__unchecked'}"
                  style=${styleMap_js.styleMap(this.pollOptionStyle(option))}
                >
                    <div class="cc__pollsbubble__option-data">
                     ${option.percent == '0%' ? lit.html ` <cometchat-icon class="cc__pollsbubble__option-icon" .iconStyle=${this.checkIconStyle(option)} .URL=${optionBackgroundIcon}></cometchat-icon>` : lit.nothing}
                      <span style=${styleMap_js.styleMap(this.setPollOptionStyle())}>${option === null || option === void 0 ? void 0 : option.text}</span>
                      </div>
                    ${this.totalVotes ? lit.html `<span style=${styleMap_js.styleMap(this.setvotePercentageStyle())}>${option === null || option === void 0 ? void 0 : option.percent}</span>` : lit.nothing}
                </li>
              `)}
            <!-- Options -->
          </ul>
          ${((_b = (_a = this.pollExtensionData) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.total) && ((_d = (_c = this.pollExtensionData) === null || _c === void 0 ? void 0 : _c.results) === null || _d === void 0 ? void 0 : _d.total) === 1 ? lit.html `<cometchat-label class="cc__pollsbubble__total-count" .labelStyle=${this.pollResultStyle()} .text=${((_f = (_e = this.pollExtensionData) === null || _e === void 0 ? void 0 : _e.results) === null || _f === void 0 ? void 0 : _f.total) + " " + uikitResources.localize("VOTE")}></cometchat-label>` : ''}
          ${((_h = (_g = this.pollExtensionData) === null || _g === void 0 ? void 0 : _g.results) === null || _h === void 0 ? void 0 : _h.total) && ((_k = (_j = this.pollExtensionData) === null || _j === void 0 ? void 0 : _j.results) === null || _k === void 0 ? void 0 : _k.total) !== 1 ? lit.html `<cometchat-label class="cc__pollsbubble__total-count" .labelStyle=${this.pollResultStyle()} .text=${((_m = (_l = this.pollExtensionData) === null || _l === void 0 ? void 0 : _l.results) === null || _m === void 0 ? void 0 : _m.total) + " " + uikitResources.localize("VOTES")}></cometchat-label>` : ''}
        </div>
      </div>
      `;
    }
    /**
     * sends the  answer selected by the user for the  the poll question
     * @param Any selectedOption
     */
    answerPollQuestion(selectedOption) {
        var _a;
        try {
            if (((_a = this.loggedInUser) === null || _a === void 0 ? void 0 : _a.uid) != this.senderUid) {
                this.selectedOption = selectedOption;
                this.requestUpdate("selectedOption");
                chatSdkJavascript.CometChat.callExtension(PollsConstants.polls, PollsConstants.post, PollsConstants.v2_vote, {
                    vote: selectedOption.id,
                    id: this.pollId,
                });
            }
            else {
                return;
            }
        }
        catch (error) {
            console.error(error);
        }
    }
};
exports.PollsBubble.styles = [
    lit.css `
    *{
      box-sizing:border-box;
      margin:0;
      padding:0;
    }
.cc__pollsbubble__wrapper {
  width: 100%;
  min-width:100px;
  flex: 1 1;
  align-self: flex-start;
  display: flex;
}
.cc__pollsbubble {
  display: inline-block;
  background: transparent;
  padding: 8px;
  align-self: flex-start;
    width: 100%;
}
.cc__pollsbubble__question {
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: left;
  width: 100%;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
}
.cc__pollsbubble__option-data {
  display: flex;
  align-items: center;
}
.cc__pollsbubble__option-icon {
  display: block;
  margin-right:8px;
}
.cc__pollsbubble__options {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.cc__pollsbubble__options>li {
  margin: 10px 0;
  display: flex;
  width: 100%;
  cursor: pointer;
  position: relative;
}
.cc__pollsbubble__total-count {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content:flex-start;
}
.poll__percent__style {
  max-width: 100%;
  width: 100%;
  min-height: 35px;
  height: 100%;
  position: absolute;
  z-index: 1;
}
.cc__pollsbubble__option{
  width: 100%;
  justify-content: space-between;
  padding:0 4px;
}
.cc__pollsbubble__unchecked {
  display: flex;
  align-items: center;
  min-height: 35px;
  padding:0 4px;
  height: 100%;
  span {
    width: max-content;
    padding: 6px;
    display: inline-block;
  }
}
.cc__pollsbubble__checked {
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 35px;
  height: 100%;
  /* z-index: 2; */
  padding:0 4px;
  span {
    width: max-content;
    padding: 6px;
    display: inline-block;
  }
}
    `
];
__decorate([
    decorators_js.property({ type: Array })
], exports.PollsBubble.prototype, "options", void 0);
__decorate([
    decorators_js.property()
], exports.PollsBubble.prototype, "pollQuestion", void 0);
__decorate([
    decorators_js.property()
], exports.PollsBubble.prototype, "pollId", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.PollsBubble.prototype, "loggedInUser", void 0);
__decorate([
    decorators_js.property()
], exports.PollsBubble.prototype, "senderUid", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.PollsBubble.prototype, "metadata", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.PollsBubble.prototype, "pollStyle", void 0);
exports.PollsBubble = __decorate([
    decorators_js.customElement('polls-bubble')
], exports.PollsBubble);

class PollsBubbleStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.votePercentTextFont = "";
        this.votePercentTextColor = "";
        this.pollQuestionTextFont = "500 12px Inter, sans-serif";
        this.pollQuestionTextColor = "#39f";
        this.pollOptionTextFont = "400 15px Inter,sans-serif";
        this.pollOptionTextColor = "#39f";
        this.pollOptionBackground = "#fff";
        this.optionsIconTint = "rgba(20, 20, 20, 0.58)";
        this.totalVoteCountTextFont = "400 13px Inter,sans-serif";
        this.totalVoteCountTextColor = "#fff";
        this.selectedPollOptionBackground = "#39f";
        this.userSelectedOptionBackground = "";
        this.pollOptionBorderRadius = "";
        this.pollOptionBorder = "";
        Object.assign(this, props);
    }
}

exports.LinkPreview = class LinkPreview extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.linkPreviewStyle = {
            height: "100%",
            width: "100%",
            border: "",
            borderRadius: "8px",
            background: "RGB(248, 248, 248)",
            titleFont: "600 15px Inter",
            titleColor: "RGB(20, 20, 20)",
            descriptionFont: "400 13px Inter",
            descriptionColor: "RGBA(20, 20, 20, 0.6)",
        };
        this.URL = "";
        this.description = "";
        this.title = "";
        this.image = "";
        this.favIconURL = "";
        this.showFavIcon = false;
        this.linkClicked = () => {
            this.dispatchEvent(new CustomEvent("cc-link-clicked", {
                bubbles: true,
                composed: true,
                detail: { url: this.URL },
            }));
            // window.open(this.URL, '_blank');
        };
        // styles
        this.linkPreviewTitleStyle = () => {
            return {
                font: this.linkPreviewStyle.titleFont,
                color: this.linkPreviewStyle.titleColor,
            };
        };
        this.detailsStyle = () => {
            return {
                justifyContent: this.title ? "flex-end" : "center",
            };
        };
        this.linkPreviewContentStyle = () => {
            return {
                height: this.image && this.image != "" ? "50%" : "100%",
                alignItems: this.title ? "initial" : "center",
            };
        };
        this.linkPreviewDescriptionStyle = () => {
            return {
                font: this.linkPreviewStyle.descriptionFont,
                color: this.linkPreviewStyle.descriptionColor,
            };
        };
        this.linkPreviewContainer = () => {
            var _a, _b, _c, _d, _e;
            return {
                width: (_a = this.linkPreviewStyle) === null || _a === void 0 ? void 0 : _a.width,
                height: (_b = this.linkPreviewStyle) === null || _b === void 0 ? void 0 : _b.height,
                border: (_c = this.linkPreviewStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.linkPreviewStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.linkPreviewStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
    }
    firstUpdated(_changedProperties) {
        try {
            const img = new Image();
            img.src = this.favIconURL;
            img.onload = () => {
                this.showFavIcon = true;
                this.requestUpdate("showFavIcon");
            };
            img.onerror = () => {
                this.showFavIcon = false;
            };
        }
        catch (error) { }
    }
    render() {
        return lit.html `
      <div
        class="cc__linkpreview"
        style=${styleMap_js.styleMap(this.linkPreviewContainer())}
      >
        ${this.image
            ? lit.html `
              <img
                class="cc__linkpreview-image cc__link-preview-clickable"
                src="${this.image}"
                alt="${this.title}"
                @click=${this.linkClicked}
              />
            `
            : lit.nothing}
        <div
          class="cc__linkpreview-content"
          style=${styleMap_js.styleMap(this.linkPreviewContentStyle())}
        >
          <div
            class="cc__linkpreview-details"
            style=${styleMap_js.styleMap(this.detailsStyle())}
          >
            <div class="cc__link-preview-clickable" @click=${this.linkClicked}>
              <div
                class="cc__linkpreview-title"
                style=${styleMap_js.styleMap(this.linkPreviewTitleStyle())}
              >
                ${this.title}
              </div>
              <div
                class="cc__linkpreview-description"
                style=${styleMap_js.styleMap(this.linkPreviewDescriptionStyle())}
              >
                ${this.description}
              </div>
            </div>
            <div class="cc__linkpreview-childview">
              <slot></slot>
            </div>
          </div>
          ${this.favIconURL && this.showFavIcon && !this.image
            ? lit.html `
                <div class="cc__linkpreview-favicon cc__link-preview-clickable">
                  <img
                    class="cc__favicon"
                    src="${this.favIconURL}"
                    alt="icon"
                    @click=${this.linkClicked}
                  />
                </div>
              `
            : lit.nothing}
        </div>
      </div>
    `;
    }
};
exports.LinkPreview.styles = [
    lit.css `
      .cc__linkpreview {
        display: flex;
        flex-direction: column;
        min-width: 210px;
        min-height: 60px;
        align-items: center;
        max-width: 280px
      }
      .cc__linkpreview-image {
        width: 100%;
        height: 50%;
        object-fit: cover;
        overflow: hidden;
        padding: 4px;
        box-sizing: border-box
      }
      .cc__linkpreview-content {
        padding: 8px;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        height: 50%;
        text-align: left;
      }
      .cc__linkpreview-title {
        margin-bottom: 2px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        max-height: 22px;
      }
      .cc__linkpreview-description {
        /* height: 65px; */
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
      }
      .cc__linkpreview-text {
        margin-top: auto;
      }
      .cc__linkpreview-favicon {
        margin-left: auto;
        width: 38px;
        height: 38px;
        object-fit: contain;
      }
      .cc__linkpreview-childview {
        margin: 0 -8px;
      }
      .cc__favicon {
        height: 100%;
        width: 100%;
        cursor: pointer;
      }
      .cc__link-preview-clickable {
        cursor: pointer;
      }
      .cc__linkpreview-details {
        text-align: left;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-start;
      }
    `,
];
__decorate([
    decorators_js.property({ type: Object })
], exports.LinkPreview.prototype, "linkPreviewStyle", void 0);
__decorate([
    decorators_js.property()
], exports.LinkPreview.prototype, "URL", void 0);
__decorate([
    decorators_js.property()
], exports.LinkPreview.prototype, "description", void 0);
__decorate([
    decorators_js.property()
], exports.LinkPreview.prototype, "title", void 0);
__decorate([
    decorators_js.property()
], exports.LinkPreview.prototype, "image", void 0);
__decorate([
    decorators_js.property()
], exports.LinkPreview.prototype, "favIconURL", void 0);
exports.LinkPreview = __decorate([
    decorators_js.customElement("link-preview")
], exports.LinkPreview);

/**
 * LinkPreviewStyle class represents the styles for popover. It extends BaseStyle.
 *
 * @property {string} boxShadow - boxshadow for popover.
 *  @extends {BaseStyle}
 */
class LinkPreviewStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleFont = "600 15px Inter, sans-serif";
        this.titleColor = "rgb(20, 20, 20)";
        this.descriptionFont = "400 13px Inter, sans-serif";
        this.descriptionColor = "rgba(20, 20, 20, 0.58)";
        Object.assign(this, props);
    }
}

const ImageModerationConstants = Object.freeze({
    metadata: "metadata",
    injected: "@injected",
    image_moderation: "image-moderation"
});

var UnsafeIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2238px%22%20height%3D%2248px%22%20viewBox%3D%220%200%2038%2048%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EGroup%3C%2Ftitle%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cfilter%20id%3D%22filter-1%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3CfeColorMatrix%20in%3D%22SourceGraphic%22%20type%3D%22matrix%22%20values%3D%220%200%200%200%201.000000%200%200%200%200%201.000000%200%200%200%200%201.000000%200%200%200%200.710000%200%22%3E%3C%2FfeColorMatrix%3E%20%20%20%20%20%20%20%20%3C%2Ffilter%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Symbols-v2%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Chat-View%2FMessage-Received-%26amp%3B-Sent%2FImage-Unsafe%22%20transform%3D%22translate%28-94.000000%2C%20-67.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Container%22%20transform%3D%22translate%280.000000%2C%2022.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%2865.500000%2C%2047.000000%29%22%20id%3D%22Group%22%20filter%3D%22url%28%23filter-1%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%2830.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M28.8088262%2C9.42577596%20C28.8506963%2C7.71756102%2030.2287536%2C6.35502688%2031.9140264%2C6.35555433%20L31.9140264%2C6.35555433%20C32.7358141%2C6.35553806%2033.5236653%2C6.6878709%2034.102944%2C7.27888759%20C34.6822226%2C7.86990427%2035.0050758%2C8.67078232%2035%2C9.50399817%20L35%2C33.2639936%20C35.0072404%2C36.1086013%2033.896766%2C38.8390036%2031.9140264%2C40.8515477%20L31.9140264%2C40.8515477%20C29.9286819%2C42.8636021%2027.2377305%2C43.9957583%2024.4306868%2C44%20L18.393869%2C44%20C14.2477742%2C44.0048704%2010.374426%2C41.9054223%208.07534666%2C38.4071037%20L0.534146186%2C26.9279948%20C-0.178048729%2C25.8443886%20-0.178048729%2C24.432935%200.534146186%2C23.3493288%20L0.534146186%2C23.3493288%20C1.0299224%2C22.6000068%201.81249566%2C22.0953997%202.69202609%2C21.9579171%20C3.57155651%2C21.8204345%204.46768176%2C22.0626382%205.16301604%2C22.6257734%20L10.216199%2C26.7128837%20L10.216199%2C6.35555433%20C10.216199%2C4.62751705%2011.5978094%2C3.22666604%2013.3021122%2C3.22666604%20L13.3021122%2C3.22666604%20C15.009563%2C3.22663265%2016.3967071%2C4.62435858%2016.4073124%2C6.35555433%20L16.4073124%2C3.14844384%20C16.4067922%2C1.43970153%2017.750612%2C0.0424531456%2019.4353648%2C0%20L19.4353648%2C0%20C21.1503195%2C0%2022.540565%2C1.40960632%2022.540565%2C3.14844384%20L22.540565%2C6.35555433%20C22.540565%2C4.62751705%2023.9221754%2C3.22666604%2025.6264782%2C3.22666604%20L25.6264782%2C3.22666604%20C26.4599777%2C3.20564838%2027.2667977%2C3.525368%2027.8653523%2C4.11386759%20C28.4639069%2C4.70236719%2028.8039053%2C5.51020079%2028.8088262%2C6.35555433%20L28.8088262%2C9.42577596%20Z%22%20id%3D%22Path%22%20stroke%3D%22%23000000%22%20stroke-width%3D%223%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2216.4073124%22%20y1%3D%226.27733212%22%20x2%3D%2216.4073124%22%20y2%3D%2218.8515519%22%20id%3D%22Path%22%20stroke%3D%22%23000000%22%20stroke-width%3D%223%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2222.6177128%22%20y1%3D%226.27733212%22%20x2%3D%2222.6177128%22%20y2%3D%2218.8515519%22%20id%3D%22Path%22%20stroke%3D%22%23000000%22%20stroke-width%3D%223%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2228.8088262%22%20y1%3D%2218.8515519%22%20x2%3D%2228.8088262%22%20y2%3D%229.42577596%22%20id%3D%22Path%22%20stroke%3D%22%23000000%22%20stroke-width%3D%223%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

exports.ImageModeration = class ImageModeration extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.imageModerationStyle = {
            height: "100%",
            width: "100%",
            border: "",
            borderRadius: "",
            background: "",
            warningTextFont: "",
            warningTextColor: "",
            filterColor: ""
        };
        this.warningText = "Unsafe Content";
        this.unsafeIconURL = UnsafeIcon;
        this.isUnsafe = false;
        this.removeWarning = () => {
            this.isUnsafe = false;
            this.requestUpdate("isUnsafe");
        };
        this.imageBubbleStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                height: (_a = this.imageModerationStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.imageModerationStyle) === null || _b === void 0 ? void 0 : _b.width,
                border: (_c = this.imageModerationStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.imageModerationStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.imageModerationStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
    }
    updated(changedProperties) {
        if (changedProperties.has('message')) {
            this.isUnsafeContent();
        }
    }
    setFilterStyle() {
        var _a, _b, _c;
        const imageModerationEl = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".cc__imagemoderation");
        if (imageModerationEl instanceof Element) {
            const beforeElement = window.getComputedStyle(imageModerationEl, '::before');
            beforeElement === null || beforeElement === void 0 ? void 0 : beforeElement.setProperty('background-color', (_c = (_b = this.imageModerationStyle) === null || _b === void 0 ? void 0 : _b.filterColor) !== null && _c !== void 0 ? _c : "RGBA(20, 20, 20, 0.68)");
            // use the computed style of the ::before pseudo-element here
        }
    }
    isUnsafeContent() {
        var _a, _b, _c, _d;
        var data = (_a = this.message) === null || _a === void 0 ? void 0 : _a.getData();
        if (((_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.metadata) === null || _b === void 0 ? void 0 : _b[ImageModerationConstants.injected]) === null || _c === void 0 ? void 0 : _c.extensions) === null || _d === void 0 ? void 0 : _d[ImageModerationConstants.image_moderation]) &&
            data.metadata[ImageModerationConstants.injected].extensions[ImageModerationConstants.image_moderation].unsafe == 'yes' &&
            Number(data.metadata[ImageModerationConstants.injected].extensions[ImageModerationConstants.image_moderation].confidence) > 50) {
            this.isUnsafe = true;
            this.requestUpdate("isUnsafe");
            this.setFilterStyle();
        }
        else {
            this.isUnsafe = false;
            this.requestUpdate("isUnsafe");
        }
    }
    _handleWarningClick() {
        this.dispatchEvent(new CustomEvent('cc-show-dialog', {
            bubbles: true,
            composed: true,
            detail: {
                message: this.message,
                onConfirm: this.removeWarning
            }
        }));
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        if (this.isUnsafe) {
            this.setFilterStyle();
        }
    }
    render() {
        if (this.isUnsafe) {
            return lit.html `
        <div class="cc__imagemoderation" style=${styleMap_js.styleMap(this.imageBubbleStyle())}>
          <slot></slot>
          <div class="cc__imagemoderation__warning" @click="${this._handleWarningClick}">
          <img src=${this.unsafeIconURL} style=${styleMap_js.styleMap(this.warningTextStyle())} />
           <div style=${styleMap_js.styleMap(this.warningTextStyle())}>${this.warningText}</div>
        </div>
        </div>
      `;
        }
        else {
            return lit.html `<slot></slot>`;
        }
    }
    warningTextStyle() {
        var _a, _b;
        return {
            font: (_a = this.imageModerationStyle) === null || _a === void 0 ? void 0 : _a.warningTextFont,
            color: (_b = this.imageModerationStyle) === null || _b === void 0 ? void 0 : _b.warningTextColor
        };
    }
};
exports.ImageModeration.styles = [
    lit.css `
.childview{
    height: 100%;
        width: 100%;
}
.cc__imagemoderation {
        position: relative;
        overflow: hidden;
        height: 100%;
        width: 100%;
      }
      .cc__imagemoderation::before {
        content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      backdrop-filter: blur(30px);
      background-color: RGBA(20, 20, 20, 0.75);
      }
      .cc__imagemoderation__warning {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 24px;
        font-weight: bold;
        color: white;
        z-index: 1;
        cursor: pointer;
        display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
      }
    `
];
__decorate([
    decorators_js.property({ type: Object })
], exports.ImageModeration.prototype, "message", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.ImageModeration.prototype, "imageModerationStyle", void 0);
__decorate([
    decorators_js.property()
], exports.ImageModeration.prototype, "warningText", void 0);
__decorate([
    decorators_js.property()
], exports.ImageModeration.prototype, "unsafeIconURL", void 0);
exports.ImageModeration = __decorate([
    decorators_js.customElement('image-moderation')
], exports.ImageModeration);

class ImageModerationConfiguration {
    constructor(props) {
        this.imageModerationStyle = {};
        this.unsafeIconURL = UnsafeIcon;
        Object.assign(this, props);
    }
}

class ImageModerationStyle extends BaseStyle {
    constructor() {
        super(...arguments);
        this.warningTextFont = "500 15px Inter";
        this.warningTextColor = "white";
        this.filterColor = "";
    }
}

const ThumbnailGenerationConstants = Object.freeze({
    metadata: "metadata",
    injected: "@injected",
    extensions: "extensions",
    thumbnail_generation: "thumbnail-generation"
});

const LinkPreviewConstants = Object.freeze({
    metadata: "metadata",
    injected: "@injected",
    extensions: "extensions",
    link_preview: "link-preview",
    links: "links"
});

class ReactionInfoStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.reactionFontSize = "";
        this.namesFont = "";
        this.namesColor = "";
        this.loadingIconTint = "";
        this.errorIconTint = "";
        this.reactedTextFont = "";
        this.reactedTextColor = "";
        this.width = "";
        this.height = "";
        Object.assign(this, props);
    }
}

const containerStyle = (reactionStyle) => {
    return {
        height: reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.height,
        width: reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.width,
        borderRadius: reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.borderRadius,
        background: reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.background,
        padding: reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.barPadding,
        display: "flex",
        alignItems: "center",
        gap: "4px",
    };
};
const getReactionStyle = (reactionStyle, active = false, addPadding = false, useBaseBackground = false) => {
    const background = useBaseBackground ? ((reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.baseReactionBackground) || "white") : (active
        ? (reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.activeReactionBackground) || "#1d8bf7"
        : (reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.reactionBackground) || "#ffffff");
    const border = useBaseBackground ? "none" : (active
        ? (reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.activeReactionBorder) || "2px solid #1d8bf7"
        : (reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.reactionBorder) || "1px solid #e0e0e0");
    let returnValue = {
        borderRadius: (reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.reactionBorderRadius) || "12px",
        background: background,
        border: border,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        gap: "3px",
    };
    if (addPadding) {
        returnValue = {
            ...returnValue,
            padding: active ? "1px 6px" : "2px 6px",
        };
    }
    return returnValue;
};
const getPopoverStyle = (reactionListConfiguration = {}) => {
    var _a, _b, _c, _d, _e;
    return new uikitElements.PopoverStyle({
        width: ((_a = reactionListConfiguration === null || reactionListConfiguration === void 0 ? void 0 : reactionListConfiguration.reactionListStyle) === null || _a === void 0 ? void 0 : _a.width) || "320px",
        height: ((_b = reactionListConfiguration === null || reactionListConfiguration === void 0 ? void 0 : reactionListConfiguration.reactionListStyle) === null || _b === void 0 ? void 0 : _b.height) || "300px",
        border: ((_c = reactionListConfiguration === null || reactionListConfiguration === void 0 ? void 0 : reactionListConfiguration.reactionListStyle) === null || _c === void 0 ? void 0 : _c.border) ||
            `1px solid #e0e0e0`,
        borderRadius: ((_d = reactionListConfiguration === null || reactionListConfiguration === void 0 ? void 0 : reactionListConfiguration.reactionListStyle) === null || _d === void 0 ? void 0 : _d.borderRadius) || "8px",
        background: ((_e = reactionListConfiguration === null || reactionListConfiguration === void 0 ? void 0 : reactionListConfiguration.reactionListStyle) === null || _e === void 0 ? void 0 : _e.background) || "#fff",
    });
};
const getEmojiStyle = (reactionStyle, active = false) => {
    return {
        font: reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.reactionEmojiFont,
        color: active
            ? reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.activeReactionCountTextColor
            : reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.reactionCountTextColor,
    };
};
const getReactionCountStyle = (reactionStyle, active = false) => {
    return {
        font: active
            ? reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.activeReactionCountTextFont
            : reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.reactionCountTextFont,
        color: active
            ? reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.activeReactionCountTextColor
            : reactionStyle === null || reactionStyle === void 0 ? void 0 : reactionStyle.reactionCountTextColor,
    };
};
const getReactionPopupStyle = (reactionDetailsStyle) => {
    return new ReactionInfoStyle({
        height: "200px",
        width: "400px",
        background: (reactionDetailsStyle === null || reactionDetailsStyle === void 0 ? void 0 : reactionDetailsStyle.background) || "#000",
        borderRadius: (reactionDetailsStyle === null || reactionDetailsStyle === void 0 ? void 0 : reactionDetailsStyle.borderRadius) || "8px",
        border: (reactionDetailsStyle === null || reactionDetailsStyle === void 0 ? void 0 : reactionDetailsStyle.border) || "none",
        namesFont: (reactionDetailsStyle === null || reactionDetailsStyle === void 0 ? void 0 : reactionDetailsStyle.namesFont) || "400 14px Inter, sans-serif",
        errorIconTint: (reactionDetailsStyle === null || reactionDetailsStyle === void 0 ? void 0 : reactionDetailsStyle.errorIconTint) || "grey",
        loadingIconTint: (reactionDetailsStyle === null || reactionDetailsStyle === void 0 ? void 0 : reactionDetailsStyle.loadingIconTint) || "grey",
        reactedTextColor: (reactionDetailsStyle === null || reactionDetailsStyle === void 0 ? void 0 : reactionDetailsStyle.reactedTextColor) || "grey",
        namesColor: (reactionDetailsStyle === null || reactionDetailsStyle === void 0 ? void 0 : reactionDetailsStyle.namesColor) || "white",
        reactedTextFont: (reactionDetailsStyle === null || reactionDetailsStyle === void 0 ? void 0 : reactionDetailsStyle.reactedTextFont) || "400 14px Inter, sans-serif",
        reactionFontSize: (reactionDetailsStyle === null || reactionDetailsStyle === void 0 ? void 0 : reactionDetailsStyle.reactionFontSize) || "37px",
    });
};
const getPopoverDynamicStyle = (count) => {
    if (count <= 2) {
        return {
            width: `200px`,
            height: '110px',
        };
    }
    else if (count > 2 && count <= 5) {
        return {
            width: `380px`,
            height: '124px',
        };
    }
    else {
        return {
            width: `380px`,
            height: '160px',
        };
    }
};
const getDynamicPopoverStyle = (ratio, style) => {
    return new uikitElements.PopoverStyle({
        height: ratio === null || ratio === void 0 ? void 0 : ratio.height,
        width: ratio === null || ratio === void 0 ? void 0 : ratio.width,
        border: "none",
        borderRadius: "8px",
        boxShadow: "0px 0px 32px rgba(20, 20, 20, 0.2)",
        background: (style === null || style === void 0 ? void 0 : style.background) || "rgba(255, 255, 255, 1)",
    });
};

exports.CometChatReactions = class CometChatReactions extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.reactionsStyle = {
            height: "fit-content",
            width: "fit-content",
            borderRadius: "",
            border: "",
            background: "transparent",
            reactionBoxShadow: "none",
            barPadding: "4px",
            reactionBorderRadius: "11px",
            reactionBorder: "1px solid rgba(20, 20, 20, 0.08)",
            reactionBackground: "transparent",
            activeReactionBorder: "1px solid rgb(255, 255, 255)",
            activeReactionBackground: "rgb(255, 255, 255)",
            reactionEmojiFont: "500 15px Inter, sans-serif",
            reactionCountTextFont: "500 15px Inter, sans-serif",
            reactionCountTextColor: "rgba(20, 20, 20, 0.69)",
            activeReactionCountTextFont: "500 15px Inter, sans-serif",
            activeReactionCountTextColor: "rgb(51, 153, 255)",
            baseReactionBackground: "white",
        };
        this.alignment = uikitResources.MessageBubbleAlignment.left;
        this.hoverDebounceTime = 500;
        this.messageReactions = [];
        this.maxVisibleEmojis = 0;
        this.maxLimit = 100;
        this.popoverVisibiltiy = {};
        this.popoverTimeout = {};
        this.previousWidth = 0;
        this.moreListALignment = uikitResources.Placement.right;
    }
    /**
     * Checks the reactions for the message object and updates the messageReactions property.
     */
    checkReaction() {
        var _a;
        try {
            this.messageReactions = ((_a = this.messageObject) === null || _a === void 0 ? void 0 : _a.getReactions()) || [];
        }
        catch (error) {
            console.log(error);
        }
    }
    /**
     * Renders the HTML template for the CometChatReactions component.
     * @returns {TemplateResult} The rendered HTML template.
     */
    render() {
        this.checkReaction();
        return lit.html `
      <div
        style=${styleMap_js.styleMap(containerStyle(this.reactionsStyle))}
        class="cc-reactions__container"
      >
     <div class="cc-reactions" id="cc-reactions">
           ${this.showReactions()}
              </div>
              ${this.showMoreUi(this.moreCount())}
      </div>
    `;
    }
    /**
     * Called when the custom element is connected to the DOM.
     * Overrides the connectedCallback method of the base class.
     */
    connectedCallback() {
        super.connectedCallback();
        if ((this === null || this === void 0 ? void 0 : this.parentElement) && !this.resizeObserver) {
            this.attachObserver();
        }
    }
    /**
     * Called when the component's properties have been updated.
     * @param _changedProperties - The map of changed properties.
     */
    updated(_changedProperties) {
        var _a, _b;
        if (_changedProperties.has("messageObject")) {
            if (((_a = this === null || this === void 0 ? void 0 : this.parentElement) === null || _a === void 0 ? void 0 : _a.clientWidth) && (!this.previousWidth || this.previousWidth <= 0)) {
                this.previousWidth = (_b = this.parentElement) === null || _b === void 0 ? void 0 : _b.clientWidth;
            }
            this.checkReaction();
            this.updateMaxVisibleEmojis(this.previousWidth);
        }
    }
    /**
     * This method is called when the custom element is disconnected from the document's DOM.
     * It performs necessary cleanup tasks, such as disconnecting the resize observer if it exists.
     */
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
    /**
     * Attaches a resize observer to the parent element to monitor changes in width.
     * When the width changes, it updates the maximum number of visible emojis.
     */
    attachObserver() {
        this.resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const newWidth = entry.contentRect.width;
                if (this.previousWidth !== newWidth) {
                    if (this.resizeTimeout) {
                        clearTimeout(this.resizeTimeout);
                    }
                    this.resizeTimeout = setTimeout(() => {
                        this.previousWidth = newWidth;
                        this.updateMaxVisibleEmojis(newWidth);
                    }, 200);
                }
            }
        });
        this.resizeObserver.observe(this.parentElement);
    }
    /**
     * Updates the maximum number of visible emojis based on the available width.
     *
     * @param availableWidth The available width to calculate the maximum number of visible emojis. Default value is 0.
     */
    updateMaxVisibleEmojis(availableWidth = 0) {
        this.maxVisibleEmojis = this.getMaxVisibleEmojis(availableWidth);
        if (!isNaN(this.maxVisibleEmojis)) {
            this.requestUpdate("maxVisibleEmojis");
        }
    }
    /**
     * Displays the reactions for the message.
     *
     * @returns An array of React elements representing the reactions.
     */
    showReactions() {
        var _a;
        const reactions = (_a = this.messageReactions) === null || _a === void 0 ? void 0 : _a.slice(0, this.maxVisibleEmojis);
        return reactions === null || reactions === void 0 ? void 0 : reactions.map((reaction) => {
            var _a;
            const dynamicStyle = getPopoverDynamicStyle(reaction === null || reaction === void 0 ? void 0 : reaction.getCount());
            const style = ((_a = this.reactionInfoConfiguration) === null || _a === void 0 ? void 0 : _a.reactionInfoStyle) || {};
            return lit.html `
        <cometchat-popover
          .popoverStyle=${getDynamicPopoverStyle(dynamicStyle, style)}
          .showOnHover=${true}
          .debounceOnHover=${this.hoverDebounceTime}
          .hasToolTip=${true}
          .placement=${uikitResources.Placement.top}
        >
          <div
            slot="children"
            @mouseover=${() => {
                if (!this.popoverTimeout[reaction === null || reaction === void 0 ? void 0 : reaction.getReaction()]) {
                    this.popoverTimeout[reaction === null || reaction === void 0 ? void 0 : reaction.getReaction()] = setTimeout(() => {
                        this.popoverVisibiltiy[reaction === null || reaction === void 0 ? void 0 : reaction.getReaction()] = true;
                        this.requestUpdate("popoverVisibiltiy");
                    }, this.hoverDebounceTime);
                }
            }}
            @mouseout=${() => {
                if (this.popoverTimeout[reaction === null || reaction === void 0 ? void 0 : reaction.getReaction()]) {
                    clearTimeout(this.popoverTimeout[reaction === null || reaction === void 0 ? void 0 : reaction.getReaction()]);
                    this.popoverTimeout[reaction === null || reaction === void 0 ? void 0 : reaction.getReaction()] = null;
                }
            }}
          >
            ${this.reactionChildUi(reaction)}
          </div>
          <div class="" slot="content">${this.reactionPopupUi(reaction)}</div>
        </cometchat-popover>
      `;
        });
    }
    /**
     * Renders the reaction popup UI.
     *
     * @param reaction The reaction count object.
     * @returns The HTML template for the reaction popup UI.
     */
    reactionPopupUi(reaction) {
        var _a, _b, _c, _d;
        let style = getReactionPopupStyle(((_a = this.reactionInfoConfiguration) === null || _a === void 0 ? void 0 : _a.reactionInfoStyle) || {});
        const popoverDynamicStyle = getPopoverDynamicStyle(reaction === null || reaction === void 0 ? void 0 : reaction.getCount());
        style = { ...style, ...popoverDynamicStyle };
        return lit.html `
      <cometchat-reaction-info
        .messageObject=${this.messageObject}
        .reaction=${reaction === null || reaction === void 0 ? void 0 : reaction.getReaction()}
        .reactionInfoStyle=${style}
        .reactionsRequestBuilder=${(_b = this.reactionInfoConfiguration) === null || _b === void 0 ? void 0 : _b.reactionsRequestBuilder}
        .loadingIconURL=${(_c = this.reactionInfoConfiguration) === null || _c === void 0 ? void 0 : _c.loadingIconURL}
        .errorIconURL=${(_d = this.reactionInfoConfiguration) === null || _d === void 0 ? void 0 : _d.errorIconURL}
        style=${styleMap_js.styleMap({
            display: this.popoverVisibiltiy[reaction === null || reaction === void 0 ? void 0 : reaction.getReaction()]
                ? "block"
                : "none",
        })}
      ></cometchat-reaction-info>
    `;
    }
    /**
     * Renders the UI for a single reaction button.
     *
     * @param reaction - The reaction count object.
     * @returns The HTML template for the reaction button UI.
     */
    reactionChildUi(reaction) {
        return lit.html `
      <div
        style=${styleMap_js.styleMap(getReactionStyle(this.reactionsStyle, reaction === null || reaction === void 0 ? void 0 : reaction.getReactedByMe(), false, true))}
      >
        <button
          class="cc-reactions__button"
          style=${styleMap_js.styleMap(getReactionStyle(this.reactionsStyle, reaction === null || reaction === void 0 ? void 0 : reaction.getReactedByMe(), true))}
          @click=${() => {
            if (this.reactionClick) {
                this.reactionClick(reaction, this.messageObject);
            }
        }}
        >
          <span
            class="cc-reactions__name"
            style=${styleMap_js.styleMap(getEmojiStyle(this.reactionsStyle, reaction === null || reaction === void 0 ? void 0 : reaction.getReactedByMe()))}
          >
            ${reaction.getReaction()}
          </span>
          <span
            class="cc-reactions__count"
            style=${styleMap_js.styleMap(getReactionCountStyle(this.reactionsStyle, reaction === null || reaction === void 0 ? void 0 : reaction.getReactedByMe()))}
          >
            ${reaction.getCount()}
          </span>
        </button>
      </div>
    `;
    }
    /**
     * Displays a UI for showing more reactions.
     *
     * @param number The number of reactions to display.
     * @returns The HTML template for the UI.
     */
    showMoreUi(number) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const startPoint = ((_a = this.messageReactions) === null || _a === void 0 ? void 0 : _a.length) - number;
        const newReactionList = (_b = this.messageReactions) === null || _b === void 0 ? void 0 : _b.slice(startPoint, (_c = this.messageReactions) === null || _c === void 0 ? void 0 : _c.length);
        const myReaction = newReactionList === null || newReactionList === void 0 ? void 0 : newReactionList.filter((reaction) => {
            return reaction.getReactedByMe();
        });
        const showActive = (myReaction === null || myReaction === void 0 ? void 0 : myReaction.length) > 0 ? true : false;
        return lit.html `
      <cometchat-popover
        .popoverStyle=${getPopoverStyle(this.reactionListConfiguration)}
        .placement=${this.moreListALignment}
        .childClickHandler=${(openContent, e) => {
            this.getPlacementAlignment(() => {
                openContent(e);
            });
        }}
      >
        <div slot="children">
          <div
          class="cc-reactions__button__more"
            style=${styleMap_js.styleMap({
            ...getReactionStyle(this.reactionsStyle, showActive, false, true),
            display: number === 0 ? 'none' : 'flex'
        })}
          >
            <button
              class="cc-reactions__button"
              style=${styleMap_js.styleMap(getReactionStyle(this.reactionsStyle, showActive, true))}
            >
              <span
                class="cc-reactions__count"
                style=${styleMap_js.styleMap(getReactionCountStyle(this.reactionsStyle, false))}
                >+${number}</span
              >
            </button>
          </div>
        </div>
        <div class="cc-reactions__popover" slot="content">
          <cometchat-reaction-list
            .messageObject=${this.messageObject}
            .reactionListStyle=${(_d = this.reactionListConfiguration) === null || _d === void 0 ? void 0 : _d.reactionListStyle}
            .reactionsRequestBuilder=${(_e = this.reactionListConfiguration) === null || _e === void 0 ? void 0 : _e.reactionsRequestBuilder}
            .loadingIconURL=${(_f = this.reactionListConfiguration) === null || _f === void 0 ? void 0 : _f.loadingIconURL}
            .errorIconURL=${(_g = this.reactionListConfiguration) === null || _g === void 0 ? void 0 : _g.errorIconURL}
            .avatarStyle=${(_h = this.reactionListConfiguration) === null || _h === void 0 ? void 0 : _h.avatarStyle}
            .listItemStyle=${(_j = this.reactionListConfiguration) === null || _j === void 0 ? void 0 : _j.listItemStyle}
            .reactionItemClicked=${(_k = this.reactionListConfiguration) === null || _k === void 0 ? void 0 : _k.reactionItemClicked}
          ></cometchat-reaction-list>
        </div>
      </cometchat-popover>
    `;
    }
    /**
     * Calculates the count of additional reactions beyond the maximum visible emojis.
     * @returns The count of additional reactions.
     */
    moreCount() {
        var _a, _b;
        return ((_a = this.messageReactions) === null || _a === void 0 ? void 0 : _a.length) > this.maxVisibleEmojis
            ? ((_b = this.messageReactions) === null || _b === void 0 ? void 0 : _b.length) - this.maxVisibleEmojis
            : 0;
    }
    /**
     * Calculates the maximum number of visible emojis based on the available width.
     *
     * @param availableWidth - The available width for displaying emojis.
     * @returns The maximum number of visible emojis.
     */
    getMaxVisibleEmojis(availableWidth) {
        var _a, _b, _c;
        const emojiContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".cc-reactions");
        const testEmoji = document.createElement("span");
        testEmoji.textContent = "😀 10";
        testEmoji === null || testEmoji === void 0 ? void 0 : testEmoji.classList.add("cc-reactions__button");
        emojiContainer === null || emojiContainer === void 0 ? void 0 : emojiContainer.appendChild(testEmoji);
        const emojiWidth = testEmoji.offsetWidth +
            parseFloat(getComputedStyle(testEmoji).marginRight) +
            5;
        emojiContainer === null || emojiContainer === void 0 ? void 0 : emojiContainer.removeChild(testEmoji);
        const maxFitEmojis = Math.floor(availableWidth / emojiWidth);
        const adjustedMaxEmojis = Math.max(0, maxFitEmojis - 1);
        const num = Math.min(this.maxLimit, adjustedMaxEmojis);
        let returnValue = num;
        if (num == 0) {
            returnValue = 1;
        }
        else {
            returnValue = num;
        }
        const additionalCount = ((_b = this.messageReactions) === null || _b === void 0 ? void 0 : _b.length) > returnValue
            ? ((_c = this.messageReactions) === null || _c === void 0 ? void 0 : _c.length) - returnValue
            : 0;
        if (additionalCount === 1) {
            returnValue = returnValue + 1;
        }
        return returnValue;
    }
    getPlacementAlignment(callBack) {
        if (this.isMobile()) {
            this.moreListALignment = this.checkBubblePosition();
        }
        else {
            this.moreListALignment = this.alignment === uikitResources.MessageBubbleAlignment.left ? uikitResources.Placement.right : uikitResources.Placement.left;
        }
        this.requestUpdate("moreListALignment");
        callBack();
    }
    isMobile() {
        return window.innerWidth <= 768;
    }
    checkBubblePosition() {
        const bubble = this.bubbleRef;
        if (bubble) {
            const rect = bubble.getBoundingClientRect();
            const isAtTop = rect.top < innerHeight / 2;
            const isAtBottom = rect.bottom > window.innerHeight / 2;
            if (isAtTop) {
                return uikitResources.Placement.bottom;
            }
            else if (isAtBottom) {
                return uikitResources.Placement.top;
            }
            else {
                return uikitResources.Placement.bottom;
            }
        }
        else {
            return uikitResources.Placement.bottom;
        }
    }
};
exports.CometChatReactions.styles = lit.css `
    * {
      box-sizing: border-box;
    }

    .cc-reactions__button {
      background: none;
      border: none;
      outline: none;
      cursor: pointer;
      min-height: 24px;
    }

    .cc-reactions {
      display: flex;
      gap: 2px;
    }

    .cc-reactions__button span{
      line-height: 24px !important;
    }
  `;
__decorate([
    decorators_js.query('.cc-reactions__button__more')
], exports.CometChatReactions.prototype, "bubbleRef", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatReactions.prototype, "messageObject", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatReactions.prototype, "reactionsStyle", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatReactions.prototype, "alignment", void 0);
__decorate([
    decorators_js.property({ type: ReactionListConfiguration })
], exports.CometChatReactions.prototype, "reactionListConfiguration", void 0);
__decorate([
    decorators_js.property({ type: ReactionInfoConfiguration })
], exports.CometChatReactions.prototype, "reactionInfoConfiguration", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatReactions.prototype, "hoverDebounceTime", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatReactions.prototype, "reactionClick", void 0);
exports.CometChatReactions = __decorate([
    decorators_js.customElement("cometchat-reactions")
], exports.CometChatReactions);

class ReactionsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.barPadding = "";
        this.reactionBoxShadow = "";
        this.reactionBorderRadius = "";
        this.reactionBorder = "";
        this.reactionBackground = "";
        this.activeReactionBorder = "";
        this.activeReactionBackground = "";
        this.reactionEmojiFont = "";
        this.reactionCountTextFont = "";
        this.reactionCountTextColor = "";
        this.activeReactionCountTextFont = "";
        this.activeReactionCountTextColor = "";
        this.baseReactionBackground = "";
        this.width = "";
        this.height = "";
        Object.assign(this, props);
    }
}

class CometChatUIKitHelper {
    //---------- Message Events ----------
    ///[onMessageSent] is used to inform the listeners
    ///when the logged-in user is sending a message
    static onMessageSent(message, status) {
        uikitResources.CometChatMessageEvents.ccMessageSent.next({ message, status });
    }
    ///[onMessageEdited] is used to inform the listeners
    ///when the logged-in user is editing a message
    static onMessageEdited(message, status) {
        uikitResources.CometChatMessageEvents.ccMessageEdited.next({ message, status });
    }
    ///[onMessageDeleted] is used to inform the listeners
    ///when the logged-in user has deleted a message
    static onMessageDeleted(message) {
        uikitResources.CometChatMessageEvents.ccMessageDeleted.next(message);
    }
    ///[onMessageRead] is used to inform the listeners
    ///when the logged-in user has read a message
    static onMessageRead(message) {
        uikitResources.CometChatMessageEvents.ccMessageRead.next(message);
    }
    ///[onLiveReaction] is used to inform the listeners
    ///when the logged-in user sends a transient message (live reaction)
    static onLiveReaction(reaction) {
        uikitResources.CometChatMessageEvents.ccLiveReaction.next(reaction);
    }
    //---------- User Events ----------
    ///[onUserBlocked] is used to inform the listeners
    ///when the logged-in user blocks another user
    static onUserBlocked(user) {
        uikitResources.CometChatUserEvents.ccUserBlocked.next(user);
    }
    ///[onUserUnblocked] is used to inform the listeners
    ///when the logged-in user unblocks a blocked user
    static onUserUnblocked(user) {
        uikitResources.CometChatUserEvents.ccUserUnblocked.next(user);
    }
    //---------- Group Events ----------
    ///[onGroupCreated] is used to inform the listeners
    ///when the logged-in user creates a Group
    static onGroupCreated(group) {
        uikitResources.CometChatGroupEvents.ccGroupCreated.next(group);
    }
    ///[onGroupDeleted] is used to inform the listeners
    ///when the logged-in user deletes a Group
    static onGroupDeleted(group) {
        uikitResources.CometChatGroupEvents.ccGroupDeleted.next(group);
    }
    ///[onGroupLeft] is used to inform the listeners
    ///when the logged-in user leaves a Group
    static onGroupLeft(message, leftUser, leftGroup) {
        uikitResources.CometChatGroupEvents.ccGroupLeft.next({
            message: message,
            userLeft: leftUser,
            leftGroup: leftGroup
        });
    }
    ///[onGroupMemberScopeChanged] is used to inform the listeners
    ///when the logged-in user changes the scope of a group member
    ///in a group
    static onGroupMemberScopeChanged(message, updatedUser, scopeChangedTo, scopeChangedFrom, group) {
        uikitResources.CometChatGroupEvents.ccGroupMemberScopeChanged.next({
            message,
            updatedUser,
            scopeChangedTo,
            scopeChangedFrom,
            group
        });
    }
    /**
    * [onGroupMemberBanned] is used to inform the listeners
    * when the logged-in user bans a group member
    */
    static onGroupMemberBanned(message, bannedUser, bannedBy, bannedFrom) {
        uikitResources.CometChatGroupEvents.ccGroupMemberBanned.next({
            message,
            kickedUser: bannedUser,
            kickedBy: bannedBy,
            kickedFrom: bannedFrom,
        });
    }
    /**
     * [onGroupMemberKicked] is used to inform the listeners
     * when the logged-in user kicks a group member from a group
     */
    static onGroupMemberKicked(message, kickedUser, kickedBy, kickedFrom) {
        uikitResources.CometChatGroupEvents.ccGroupMemberKicked.next({
            message,
            kickedUser: kickedUser,
            kickedBy: kickedBy,
            kickedFrom: kickedFrom,
        });
    }
    /**
     * [onGroupMemberUnbanned] is used to inform the listeners
     * when the logged-in user unbans a banned user of a group
     */
    static onGroupMemberUnbanned(message, unbannedUser, unbannedBy, unbannedFrom) {
        uikitResources.CometChatGroupEvents.ccGroupMemberUnbanned.next({
            message,
            unbannedBy: unbannedBy,
            unbannedFrom: unbannedFrom,
            unbannedUser: unbannedUser
        });
    }
    /**
     * [onGroupMemberJoined] is used to inform the listeners
     * when the logged-in user joins a group
     */
    static onGroupMemberJoined(joinedUser, joinedGroup) {
        uikitResources.CometChatGroupEvents.ccGroupMemberJoined.next({
            joinedUser, joinedGroup
        });
    }
    /**
     * [onGroupMemberAdded] is used to inform the listeners
     * when the logged-in user adds users to a group
     */
    static onGroupMemberAdded(messages, usersAdded, groupAddedIn, addedBy) {
        uikitResources.CometChatGroupEvents.ccGroupMemberAdded.next({
            messages: messages,
            userAddedBy: addedBy,
            usersAdded: usersAdded,
            userAddedIn: groupAddedIn
        });
    }
    /**
     * [onOwnershipChanged] is used to inform the listeners
     * when the logged-in user transfers their ownership to some other group member
     */
    static onOwnershipChanged(group, newOwner) {
        uikitResources.CometChatGroupEvents.ccOwnershipChanged.next({
            newOwner: newOwner,
            group: group,
        });
    }
    /**
     * [onConversationDeleted] is used to inform the listeners
     * when the logged-in user deletes a conversation
     */
    static onConversationDeleted(conversation) {
        uikitResources.CometChatConversationEvents.ccConversationDeleted.next(conversation);
    }
    //---------- CometChat UI Events ----------
    /**
     * [showPanel] used to reveal a panel above message composer
     */
    static showPanel(child) {
        uikitResources.CometChatUIEvents.ccShowPanel.next({
            child: child
        });
    }
    /**
     * [hidePanel] used to hide the panel above message composer
     */
    static hidePanel() {
        uikitResources.CometChatUIEvents.ccHidePanel.next();
    }
    static onActiveChatChanged(user, group, message) {
        uikitResources.CometChatUIEvents.ccActiveChatChanged.next({ user, group, message });
    }
}

class UIKitSettings {
    constructor(builder) {
        var _a;
        this.appId = builder.appId;
        this.region = builder.region;
        this.subscriptionType = builder.subscriptionType;
        this.autoEstablishSocketConnection = (_a = builder.autoEstablishSocketConnection) !== null && _a !== void 0 ? _a : true;
        this.authKey = builder.authKey;
        this.deviceToken = builder.deviceToken;
        this.googleApiKey = builder.googleApiKey;
        this.disableCalling = builder.disableCalling;
        this.adminHost = builder.adminHost;
        this.clientHost = builder.clientHost;
        this.extensions = builder.extensions;
        this.aiFeatures = builder.aiFeatures;
    }
    static fromBuilder(builder) {
        return new UIKitSettings(builder);
    }
    getAppId() {
        return this.appId;
    }
    getRegion() {
        return this.region;
    }
    getRoles() {
        return this.roles;
    }
    getSubscriptionType() {
        return this.subscriptionType;
    }
    getAuthKey() {
        return this.authKey;
    }
    isAutoEstablishSocketConnection() {
        return this.autoEstablishSocketConnection;
    }
    getAdminHost() {
        return this.adminHost;
    }
    getClientHost() {
        return this.clientHost;
    }
    getExtensions() {
        return this.extensions;
    }
    getAiFeatures() {
        return this.aiFeatures;
    }
}
class UIKitSettingsBuilder {
    constructor() {
        this.disableCalling = false;
    }
    build() {
        return UIKitSettings.fromBuilder(this);
    }
    setAppId(appId) {
        this.appId = appId;
        return this;
    }
    setRegion(region) {
        this.region = region;
        return this;
    }
    subscribePresenceForAllUsers() {
        this.subscriptionType = 'ALL_USERS';
        return this;
    }
    subscribePresenceForRoles(roles) {
        this.subscriptionType = 'ROLES';
        this.roles = roles;
        return this;
    }
    subscribePresenceForFriends() {
        this.subscriptionType = 'FRIENDS';
        return this;
    }
    setRoles(roles) {
        this.roles = roles;
        return this;
    }
    setAutoEstablishSocketConnection(autoEstablishSocketConnection) {
        this.autoEstablishSocketConnection = autoEstablishSocketConnection;
        return this;
    }
    setAuthKey(authKey) {
        this.authKey = authKey;
        return this;
    }
    setAdminHost(adminHost) {
        this.adminHost = adminHost;
        return this;
    }
    setClientHost(clientHost) {
        this.clientHost = clientHost;
        return this;
    }
    setExtensions(extensions) {
        this.extensions = extensions;
        return this;
    }
    setAiFeatures(aiFeatures) {
        this.aiFeatures = aiFeatures;
        return this;
    }
}

class StorageUtils {
}
StorageUtils.attachChangeDetection = (callback) => {
    window.addEventListener("storage", callback);
};
StorageUtils.detachChangeDetection = (callback) => {
    window.removeEventListener("storage", callback);
};
StorageUtils.setItem = (storageKey, storageValue) => {
    localStorage.setItem(storageKey, JSON.stringify(storageValue));
};
StorageUtils.getItem = (storageKey) => {
    return JSON.parse(localStorage.getItem(storageKey));
};
StorageUtils.removeItem = (storageKey) => {
    localStorage.removeItem(storageKey);
};

class CallingDetailsUtils {
    static isSentByMe(call, loggedInUser) {
        var _a;
        const senderUid = (_a = call.getSender()) === null || _a === void 0 ? void 0 : _a.getUid();
        return !senderUid || senderUid === (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.getUid());
    }
    static isMissedCall(call, loggedInUser) {
        var _a;
        const senderUid = (_a = call.getCallInitiator()) === null || _a === void 0 ? void 0 : _a.getUid();
        const callStatus = call.getStatus();
        if (!senderUid || senderUid === (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.getUid())) {
            return false;
        }
        else {
            return [uikitResources.CometChatUIKitConstants.calls.busy, uikitResources.CometChatUIKitConstants.calls.unanswered, uikitResources.CometChatUIKitConstants.calls.cancelled].includes(callStatus);
        }
    }
    static getCallStatus(call, loggedInUser) {
        const callStatus = call.getStatus();
        const isSentByMe = CallingDetailsUtils.isSentByMe(call, loggedInUser);
        if (isSentByMe) {
            switch (callStatus) {
                case uikitResources.CometChatUIKitConstants.calls.initiated:
                    return uikitResources.localize("OUTGOING_CALL");
                case uikitResources.CometChatUIKitConstants.calls.cancelled:
                    return uikitResources.localize("CALL_CANCELLED");
                case uikitResources.CometChatUIKitConstants.calls.rejected:
                    return uikitResources.localize("CALL_REJECTED");
                case uikitResources.CometChatUIKitConstants.calls.busy:
                    return uikitResources.localize("MISSED_CALL");
                case uikitResources.CometChatUIKitConstants.calls.ended:
                    return uikitResources.localize("CALL_ENDED");
                case uikitResources.CometChatUIKitConstants.calls.ongoing:
                    return uikitResources.localize("CALL_ACCEPTED");
                case uikitResources.CometChatUIKitConstants.calls.unanswered:
                    return uikitResources.localize("CALL_UNANSWERED");
                default:
                    return uikitResources.localize("OUTGOING_CALL");
            }
        }
        else {
            switch (callStatus) {
                case uikitResources.CometChatUIKitConstants.calls.initiated:
                    return uikitResources.localize("INCOMING_CALL");
                case uikitResources.CometChatUIKitConstants.calls.ongoing:
                    return uikitResources.localize("CALL_ACCEPTED");
                case uikitResources.CometChatUIKitConstants.calls.ended:
                    return uikitResources.localize("CALL_ENDED");
                case uikitResources.CometChatUIKitConstants.calls.unanswered:
                case uikitResources.CometChatUIKitConstants.calls.cancelled:
                    return uikitResources.localize("MISSED_CALL");
                case uikitResources.CometChatUIKitConstants.calls.busy:
                    return uikitResources.localize("CALL_BUSY");
                case uikitResources.CometChatUIKitConstants.calls.rejected:
                    return uikitResources.localize("CALL_REJECTED");
                default:
                    return uikitResources.localize("OUTGOING_CALL");
            }
        }
    }
}
CallingDetailsUtils.getDefaultMessageTypes = () => {
    return [uikitResources.CometChatUIKitConstants.MessageTypes.audio, uikitResources.CometChatUIKitConstants.MessageTypes.video, uikitResources.CometChatUIKitConstants.calls.meeting];
};
CallingDetailsUtils.getDefaultCategories = () => {
    return [uikitResources.CometChatUIKitConstants.MessageCategory.call, uikitResources.CometChatUIKitConstants.MessageCategory.custom];
};

/**
 * OutgoingCallStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} subtitleTextFont - Font for subTitle text.
 * @property {string} subtitleTextColor - Color for subTitle text.
 * @property {string} titleTextFont - Font for title text.
 * @property {string} titleTextColor - Color for title text.
 */
class OutgoingCallStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.subtitleTextFont = "400 13px Inter, sans-serif";
        this.subtitleTextColor = "RGBA(20, 20, 20, 0.58)";
        this.declineButtonTextFont = "400 12px Inter";
        this.declineButtonTextColor = "RGBA(20, 20, 20, 0.58)";
        this.declineButtonIconTint = "RGBA";
        this.declineButtonIconBackground = "red";
        Object.assign(this, props);
    }
}

/**
  * @property {string} declineButtonIconURL - close icon to cancel call.
  * @property {(error:CometChat.CometChatException)=>void} onError - callback for error.
  * @property {(()=>void) | null} onCloseClicked - The callback on select.
  * @property {any} customView - The view for outgoingCall.
  * @property {AvatarStyle} avatarStyle - The style for avatar.
  * @property {OutgoingCallStyle} outgoingCallStyle - The style for outgoingCall.
  */
class OutgoingCallConfiguration {
    constructor(props) {
        this.declineButtonIconURL = closeIcon$1;
        this.avatarStyle = {};
        this.disableSoundForCalls = false;
        this.customSoundForCalls = "";
        this.outgoingCallStyle = {};
        this.onDeclineButtonClicked = null;
        Object.assign(this, props);
    }
}

/**
 * CallButtonsStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} subtitleTextFont - Font for subTitle text.
 * @property {string} subtitleTextColor - Color for subTitle text.
 * @property {string} titleTextFont - Font for title text.
 * @property {string} titleTextColor - Color for title text.
 */
class CallButtonsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.voiceCallIconTint = "RGB(51, 153, 255)";
        this.videoCallIconTint = "RGB(51, 153, 255)";
        this.voiceCallIconTextFont = "400 12px Inter";
        this.videoCallIconTextFont = "400 12px Inter";
        this.voiceCallIconTextColor = "RGB(51, 153, 255)";
        this.videoCallIconTextColor = "RGB(51, 153, 255)";
        this.buttonBackground = "";
        this.buttonBorder = "";
        this.buttonBorderRadius = "";
        this.buttonPadding = "";
        Object.assign(this, props);
    }
}

var AudioCallIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FCall%402x%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FCall%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22streamline-icon-phone-actions-voice-mail%4024x24%22%20transform%3D%22translate%283.000000%2C%203.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0.0679824131%2C6.18726899%20L1.15322891%2C7.27252708%20C1.71745406%2C7.8368527%202.48276427%2C8.15389548%203.28076591%2C8.15389548%20C4.07876755%2C8.15389548%204.84407776%2C7.8368527%205.40830291%2C7.27252708%20L7.00415829%2C5.67746515%20C7.28631808%2C5.39534955%207.44483777%2C5.01269036%207.44483777%2C4.61368527%20C7.44483777%2C4.21468018%207.28631808%2C3.83202099%207.00415829%2C3.5499054%20L3.90079098%2C0.446504908%20C3.59388219%2C0.136593264%203.16773676%2C-0.025114152%202.73249452%2C0.00317689658%20C2.29725227%2C0.0314679452%201.89562592%2C0.246981102%201.63141818%2C0.594015717%20C-1.61783738%2C5.00961401%200.349222543%2C9.660257%204.34493966%2C13.6552063%20C8.34065677%2C17.6501557%2012.9904395%2C19.6180471%2017.4059906%2C16.3687568%20C17.7530215%2C16.1045463%2017.9685324%2C15.7029156%2017.9968231%2C15.2676687%20C18.0251139%2C14.8324218%2017.8634082%2C14.4062718%2017.5534999%2C14.0993598%20L14.450943%2C10.9959593%20C14.1688305%2C10.7137965%2013.7861754%2C10.5552751%2013.3871745%2C10.5552751%20C12.9881737%2C10.5552751%2012.6055186%2C10.7137965%2012.323406%2C10.9959593%20L10.7275507%2C12.5918317%20C10.1632311%2C13.1560629%209.8461917%2C13.9213813%209.8461917%2C14.7193915%20C9.8461917%2C15.5174016%2010.1632311%2C16.28272%2010.7275507%2C16.8469512%20L11.8249545%2C17.9443668%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var VideoCallIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FVideo%402x%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FVideo%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%282.000000%2C%206.500000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1.79471961%2C-7.25088203e-17%20L11.9552804%2C7.25088203e-17%20C12.5793435%2C-4.21297127e-17%2012.8056439%2C0.0649779267%2013.033792%2C0.186992889%20C13.2619401%2C0.309007852%2013.4409921%2C0.488059851%2013.5630071%2C0.716207995%20C13.6850221%2C0.94435614%2013.75%2C1.1706565%2013.75%2C1.79471961%20L13.75%2C9.20528039%20C13.75%2C9.8293435%2013.6850221%2C10.0556439%2013.5630071%2C10.283792%20C13.4409921%2C10.5119401%2013.2619401%2C10.6909921%2013.033792%2C10.8130071%20C12.8056439%2C10.9350221%2012.5793435%2C11%2011.9552804%2C11%20L1.79471961%2C11%20C1.1706565%2C11%200.94435614%2C10.9350221%200.716207995%2C10.8130071%20C0.488059851%2C10.6909921%200.309007852%2C10.5119401%200.186992889%2C10.283792%20C0.0649779267%2C10.0556439%209.39485689e-17%2C9.8293435%20-1.61693481e-16%2C9.20528039%20L4.83392135e-17%2C1.79471961%20C-2.80864751e-17%2C1.1706565%200.0649779267%2C0.94435614%200.186992889%2C0.716207995%20C0.309007852%2C0.488059851%200.488059851%2C0.309007852%200.716207995%2C0.186992889%20C0.94435614%2C0.0649779267%201.1706565%2C4.21297127e-17%201.79471961%2C-7.25088203e-17%20Z%22%20id%3D%22Rectangle%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M17.2599167%2C8.63041667%20L19.6304167%2C9.81475%20C19.8435282%2C9.92114296%2020.096526%2C9.90964554%2020.299109%2C9.78436146%20C20.5016921%2C9.65907738%2020.625%2C9.43785985%2020.625%2C9.19966667%20L20.625%2C1.80033333%20C20.625%2C1.56214015%2020.5016921%2C1.34092262%2020.299109%2C1.21563854%20C20.096526%2C1.09035446%2019.8435282%2C1.07885704%2019.6304167%2C1.18525%20L17.2599167%2C2.36958333%20C16.7940465%2C2.60259636%2016.4998441%2C3.07885646%2016.4999999%2C3.59975%20L16.4999999%2C7.40025%20C16.4998441%2C7.92114354%2016.7940465%2C8.39740364%2017.2599167%2C8.63041667%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

/**
  * @property {string} voiceCallIconURL - audio call icon.
    * @property {string} videoCallIconURL - video call icon.
  * @property {(error:CometChat.CometChatException)=>void} onError - callback for error.
  * @property {((user:CometChat.User,group:CometChat.Group)=>void) | null} onVoiceCallClick - The callback to initiate voice call.
   * @property {((user:CometChat.User,group:CometChat.Group)=>void) | null} onVideoCallClick - The callback to initiate video call.
  * @property {CallButtonsStyle} callButtonsStyle - The style for outgoingCall.
  */
class CallButtonsConfiguration {
    constructor(props) {
        this.voiceCallIconURL = AudioCallIcon;
        this.videoCallIconURL = VideoCallIcon;
        this.callButtonsStyle = {};
        Object.assign(this, props);
    }
}

var IncreaseSizeIcon = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M10.2%2013.8L3%2021%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M21%208.4V3H15.6%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M3%2015.6V21H8.4%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M21%203L13.8%2010.2%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var ReduceSizeIcon = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M21%203L13.8%2010.2%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.2%2019.2V13.8H4.80005%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.8%204.8V10.2H19.2%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.2%2013.8L3%2021%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

/**
  * @property {string} minimizeIconURL - reduce size icon.
    * @property {string} maximizeIconURL - increase size icon.
  * @property {CometChat.CallSettingsBuilder} callSettingsBuilder - request builder for calls.
  * @property {CallscreenStyle} ongoingCallStyle - The style for outgoingCall.
  */
class CallScreenConfiguration {
    constructor(props) {
        this.minimizeIconURL = ReduceSizeIcon;
        this.maximizeIconURL = IncreaseSizeIcon;
        this.ongoingCallStyle = {};
        Object.assign(this, props);
    }
}

/**
 * IncomingCallStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} subtitleTextFont - Font for subTitle text.
 * @property {string} subtitleTextColor - Color for subTitle text.
 * @property {string} titleTextFont - Font for title text.
 * @property {string} titleTextColor - Color for title text.
  * @property {string} acceptButtonTextFont - Font for button text.
 * @property {string} acceptButtonTextColor - Color for button text.
 * @property {string} acceptButtonBackground - Background for button text.
 * @property {string} acceptButtonBorderRadius - BorderRadius for button text.
  * @property {string} acceptButtonBorder - Border for button text.
    * @property {string} declineButtonTextFont - Font for button text.
 * @property {string} declineButtonTextColor - Color for button text.
 * @property {string} declineButtonBackground - Background for button text.
 * @property {string} declineButtonBorderRadius - BorderRadius for button text.
  * @property {string} declineButtonBorder - Border for button text.
 */
class IncomingCallStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "600 15px Inter";
        this.titleTextColor = "black";
        this.subtitleTextFont = "400 13px Inter";
        this.subtitleTextColor = "lightgrey";
        this.acceptButtonTextFont = "500 15px Inter";
        this.acceptButtonTextColor = "white";
        this.acceptButtonBackground = "rgba(51, 153, 255)";
        this.acceptButtonBorderRadius = "8px";
        this.acceptButtonBorder = "none";
        this.declineButtonTextFont = "500 15px Inter";
        this.declineButtonTextColor = "white";
        this.declineButtonBackground = "red";
        this.declineButtonBorderRadius = "8px";
        this.declineButtonBorder = "none";
        Object.assign(this, props);
    }
}

/**
 * CallLogHistoryStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} headingFont - Font of the heading.
 * @property {string} headingColor - Color of the heading.
 * @property {string} emptyStateTextColor - Color of the empty state text.
 * @property {string} emptyStateTextFont - Font of the empty state text.
 * @property {string} errorStateTextColor - Color of the error state text.
 * @property {string} errorStateTextFont - Font of the error state text.
 * @property {string} loadingIconTint - Tint of the loading icon.
 * @property {string} backIconTint - Tint of the back icon.
 * @property {string} dateTextFont - Font of the date text.
 * @property {string} dateTextColor - Color of the date text.
 * @property {string} dateSeparatorTextFont - Font of the date separator text.
 * @property {string} dateSeparatorTextColor - Color of the date separator text.
 * @property {string} callDurationTextFont - Font of the call duration text.
 * @property {string} callDurationTextColor - Color of the call duration text.
 * @property {string} callStatusTextFont - Font of the call status text.
 * @property {string} callStatusTextColor - Color of the call status text.
 * @property {string} dividerColor - Color of the divider.
 */
class CallLogHistoryStyle extends BaseStyle {
    constructor(style) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.emptyStateTextColor = "";
        this.emptyStateTextFont = "";
        this.errorStateTextColor = "";
        this.errorStateTextFont = "";
        this.loadingIconTint = "";
        this.backIconTint = "";
        this.dateTextFont = "";
        this.dateTextColor = "";
        this.dateSeparatorTextFont = "";
        this.dateSeparatorTextColor = "";
        this.callDurationTextFont = "";
        this.callDurationTextColor = "";
        this.callStatusTextFont = "";
        this.callStatusTextColor = "";
        this.dividerColor = "";
        Object.assign(this, style);
    }
}

/**
 * CallLogParticipantsStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} headingFont - Font of the heading.
 * @property {string} headingColor - Color of the heading.
 * @property {string} backIconTint - Tint of the back icon.
 * @property {string} callStatusFont - Font of the call status text.
 * @property {string} callStatusColor - Color of the call status text.
 * @property {string} dateTextFont - Font of the date text.
 * @property {string} dateTextColor - Color of the date text.
 */
class CallLogParticipantsStyle extends BaseStyle {
    constructor(style) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.backIconTint = "";
        this.callStatusFont = "";
        this.callStatusColor = "";
        this.dateTextFont = "";
        this.dateTextColor = "";
        Object.assign(this, style);
    }
}

/**
 * CallLogRecordingsStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} headingFont - Font of the heading.
 * @property {string} headingColor - Color of the heading.
 * @property {string} closeIconTint - Tint of the close icon.
 * @property {string} recordingDurationFont - Font of the recording duration text.
 * @property {string} recordingDurationColor - Color of the recording duration text.
 * @property {string} dateTextFont - Font of the date text.
 * @property {string} dateTextColor - Color of the date text.
 */
class CallLogRecordingsStyle extends BaseStyle {
    constructor(style) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.backIconTint = "";
        this.downloadIconTint = "";
        this.recordingDurationFont = "";
        this.recordingDurationColor = "";
        this.dateTextFont = "";
        this.dateTextColor = "";
        Object.assign(this, style);
    }
}

/**
 * CallLogStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} headingFont - Font of the heading.
 * @property {string} headingColor - Color of the heading.
 * @property {string} emptyStateTextColor - Color of the empty state text.
 * @property {string} emptyStateTextFont - Font of the empty state text.
 * @property {string} errorStateTextColor - Color of the error state text.
 * @property {string} errorStateTextFont - Font of the error state text.
 * @property {string} loadingIconTint - Tint of the loading icon.
 * @property {string} closeIconTint - Tint of the close icon.
 * @property {string} infoIconTint - Tint of the info icon.
 * @property {string} missedCallIconTint - Tint of the missed call icon.
 * @property {string} outgoingCallIconTint - Tint of the outgoing call icon.
 * @property {string} incomingCallIconTint - Tint of the incoming call icon.
 * @property {string} callStatusTextFont - Font of the call status text.
 * @property {string} callStatusTextColor - Color of the call status text.
 * @property {string} dateTextFont - Font of the date text.
 * @property {string} dateTextColor - Color of the date text.
 * @property {string} dateSeparatorTextFont - Font of the date separator text.
 * @property {string} dateSeparatorTextColor - Color of the date separator text.
 */
class CallLogsStyle extends BaseStyle {
    constructor(style) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.emptyStateTextColor = "";
        this.emptyStateTextFont = "";
        this.errorStateTextColor = "";
        this.errorStateTextFont = "";
        this.loadingIconTint = "";
        this.infoIconTint = "";
        this.missedCallIconTint = "";
        this.outgoingCallIconTint = "";
        this.incomingCallIconTint = "";
        this.callStatusTextFont = "";
        this.callStatusTextColor = "";
        this.dateTextFont = "";
        this.dateTextColor = "";
        this.dateSeparatorTextFont = "";
        this.dateSeparatorTextColor = "";
        Object.assign(this, style);
    }
}

/**
 * CallLogDetailStyle class represents the styles for users. It extends BaseStyle.
 *
 */
class CallLogDetailsStyle extends BaseStyle {
    constructor(style) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.nameTextFont = "";
        this.nameTextColor = "";
        this.backIconTint = "";
        Object.assign(this, style);
    }
}

/**
 * WithDetailsStyle
 *
 * @property {string} height - The height of the component.
 * @property {string} width - The width of the component.
 * @property {string} border - The border of the component.
 * @property {string} borderRadius - The border radius of the component.
 * @property {string} background - The background color of the component.
 * @property {string} messageTextColor - The messageText color of the component.
 * @property {string} messageTextFont - The messageText font of the component.
 */
class WithDetailsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.messageTextColor = "";
        this.messageTextFont = "";
        Object.assign(this, props);
    }
}

var IncomingAudioCallIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.78531%209.33083L4.34856%209.89458C4.64141%2010.1873%205.03856%2010.3518%205.45265%2010.3518C5.86675%2010.3518%206.2639%2010.1873%206.55675%209.89458L7.38496%209.06639C7.45752%208.99388%207.51508%208.90778%207.55435%208.81301C7.59362%208.71825%207.61383%208.61667%207.61383%208.51409C7.61383%208.41151%207.59362%208.30993%207.55435%208.21517C7.51508%208.1204%207.45752%208.0343%207.38496%207.96179L5.77488%206.35123C5.69603%206.27169%205.601%206.21005%205.49623%206.17048C5.39146%206.13091%205.27941%206.11434%205.16767%206.1219C5.05593%206.12945%204.94713%206.16095%204.84864%206.21426C4.75015%206.26757%204.66428%206.34145%204.59686%206.43087C2.90974%208.72127%203.93211%2011.1335%206.00548%2013.2073C8.07886%2015.2812%2010.4927%2016.3025%2012.7847%2014.6154C12.8739%2014.5477%2012.9475%2014.4617%2013.0005%2014.3631C13.0536%2014.2645%2013.0848%2014.1556%2013.092%2014.0439C13.0993%2013.9322%2013.0824%2013.8202%2013.0426%2013.7155C13.0028%2013.6109%2012.9409%2013.516%2012.8612%2013.4374L11.2506%2011.8268C11.1781%2011.7543%2011.092%2011.6967%2010.9972%2011.6574C10.9025%2011.6182%2010.8009%2011.598%2010.6983%2011.598C10.5957%2011.598%2010.4941%2011.6182%2010.3994%2011.6574C10.3046%2011.6967%2010.2185%2011.7543%2010.146%2011.8268L9.31778%2012.655C9.17274%2012.8%209.05768%2012.9722%208.97918%2013.1617C8.90068%2013.3512%208.86028%2013.5543%208.86028%2013.7594C8.86028%2013.9645%208.90068%2014.1676%208.97918%2014.357C9.05768%2014.5465%209.17274%2014.7187%209.31778%2014.8637L9.89039%2015.4332%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.3872%208.82531L15.4626%203.75%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.5105%208.82517H10.3872V5.7019%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var IncomingVideoCallIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.43018%2015.8583C2.56723%2015.8583%201.86768%2015.1588%201.86768%2014.2958V5.70435C1.86768%204.8414%202.56723%204.14185%203.43018%204.14185H12.1884C13.0513%204.14185%2013.7509%204.8414%2013.7509%205.70435V14.2958C13.7509%2015.1588%2013.0513%2015.8583%2012.1884%2015.8583H3.43018Z%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.1571%2011.9541C13.9068%2011.817%2013.7512%2011.5543%2013.7512%2011.2689V8.73246C13.7512%208.44707%2013.9068%208.18437%2014.1571%208.04726L16.9754%206.50343C17.4961%206.21822%2018.132%206.59497%2018.132%207.18861V12.8128C18.132%2013.4064%2017.4961%2013.7832%2016.9754%2013.4979L14.1571%2011.9541Z%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.41384%2012.5186H5.1875V9.29224%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.3776%207.31396L5.28149%2012.41%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var InfoIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FInfo%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FInfo%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22streamline-icon-information-circle%4024x24%22%20transform%3D%22translate%282.000000%2C%202.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12%2C14%20L11.3333333%2C14%20C10.5969537%2C14%2010%2C13.4030463%2010%2C12.6666667%20L10%2C9.33333333%20C10%2C8.9651435%209.70152317%2C8.66666667%209.33333333%2C8.66666667%20L8.66666667%2C8.66666667%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9.66666667%2C5.33333333%20C9.48257175%2C5.33333333%209.33333333%2C5.48257175%209.33333333%2C5.66666667%20C9.33333333%2C5.85076158%209.48257175%2C6%209.66666667%2C6%20C9.85076158%2C6%2010%2C5.85076158%2010%2C5.66666667%20C10%2C5.48257175%209.85076158%2C5.33333333%209.66666667%2C5.33333333%20L9.66666667%2C5.33333333%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C10%20C0%2C15.5228475%204.4771525%2C20%2010%2C20%20C15.5228475%2C20%2020%2C15.5228475%2020%2C10%20C20%2C4.4771525%2015.5228475%2C0%2010%2C0%20C4.4771525%2C0%200%2C4.4771525%200%2C10%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var MissedAudioCallIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.78531%209.33083L4.34854%209.89458C4.64139%2010.1873%205.03853%2010.3518%205.45262%2010.3518C5.86671%2010.3518%206.26385%2010.1873%206.5567%209.89458L7.38488%209.06639C7.45744%208.99388%207.515%208.90778%207.55427%208.81301C7.59354%208.71825%207.61376%208.61667%207.61376%208.51409C7.61376%208.41151%207.59354%208.30993%207.55427%208.21517C7.515%208.1204%207.45744%208.0343%207.38488%207.96179L5.77484%206.35123C5.69599%206.27169%205.60096%206.21005%205.4962%206.17048C5.39143%206.13091%205.27938%206.11434%205.16764%206.1219C5.05591%206.12945%204.9471%206.16095%204.84862%206.21426C4.75013%206.26757%204.66426%206.34145%204.59684%206.43087C2.90976%208.72127%203.93211%2011.1335%206.00544%2013.2073C8.07877%2015.2812%2010.4925%2016.3025%2012.7845%2014.6154C12.8737%2014.5477%2012.9473%2014.4617%2013.0003%2014.3631C13.0534%2014.2645%2013.0846%2014.1556%2013.0918%2014.0439C13.0991%2013.9322%2013.0822%2013.8202%2013.0424%2013.7155C13.0026%2013.6109%2012.9407%2013.516%2012.861%2013.4374L11.2504%2011.8268C11.1779%2011.7543%2011.0918%2011.6967%2010.9971%2011.6574C10.9023%2011.6182%2010.8007%2011.598%2010.6982%2011.598C10.5956%2011.598%2010.494%2011.6182%2010.3992%2011.6574C10.3045%2011.6967%2010.2184%2011.7543%2010.1459%2011.8268L9.31767%2012.655C9.17263%2012.8%209.05757%2012.9722%208.97908%2013.1617C8.90058%2013.3512%208.86018%2013.5543%208.86018%2013.7594C8.86018%2013.9645%208.90058%2014.1676%208.97908%2014.357C9.05757%2014.5465%209.17263%2014.7187%209.31767%2014.8637L9.89027%2015.4332%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M15.4622%204.53082L12.3389%207.65409L8.43481%203.75%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.43481%206.09245V3.75H10.7773%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var MissedVideoCallIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M14.1573%2011.9539C13.907%2011.8167%2013.7515%2011.5541%2013.7515%2011.2687V8.73221C13.7515%208.44682%2013.907%208.18413%2014.1573%208.04701L16.9757%206.50318C17.4963%206.21798%2018.1322%206.59473%2018.1322%207.18836V12.8125C18.1322%2013.4061%2017.4963%2013.7829%2016.9757%2013.4977L14.1573%2011.9539Z%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.3834%209.1351L8.17601%2012.3425L4.16675%208.33325%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.16675%2010.7388V8.33325H6.5723%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M3.22925%2015.883C2.3663%2015.883%201.66675%2015.1834%201.66675%2014.3205V5.729C1.66675%204.86606%202.3663%204.1665%203.22925%204.1665H11.9874C12.8503%204.1665%2013.5499%204.86606%2013.5499%205.729V14.3205C13.5499%2015.1834%2012.8503%2015.883%2011.9874%2015.883H3.22925Z%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var OutgoingAudioCallIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.78531%209.33083L4.34854%209.89458C4.64139%2010.1873%205.03853%2010.3518%205.45262%2010.3518C5.86671%2010.3518%206.26385%2010.1873%206.5567%209.89458L7.38488%209.06639C7.45744%208.99388%207.515%208.90778%207.55427%208.81301C7.59354%208.71825%207.61376%208.61667%207.61376%208.51409C7.61376%208.41151%207.59354%208.30993%207.55427%208.21517C7.515%208.1204%207.45744%208.0343%207.38488%207.96179L5.77484%206.35123C5.69599%206.27169%205.60096%206.21005%205.4962%206.17048C5.39143%206.13091%205.27938%206.11434%205.16764%206.1219C5.05591%206.12945%204.9471%206.16095%204.84862%206.21426C4.75013%206.26757%204.66426%206.34145%204.59684%206.43087C2.90976%208.72127%203.93211%2011.1335%206.00544%2013.2073C8.07877%2015.2812%2010.4925%2016.3025%2012.7845%2014.6154C12.8737%2014.5477%2012.9473%2014.4617%2013.0003%2014.3631C13.0534%2014.2645%2013.0846%2014.1556%2013.0918%2014.0439C13.0991%2013.9322%2013.0822%2013.8202%2013.0424%2013.7155C13.0026%2013.6109%2012.9407%2013.516%2012.861%2013.4374L11.2504%2011.8268C11.1779%2011.7543%2011.0918%2011.6967%2010.9971%2011.6574C10.9023%2011.6182%2010.8007%2011.598%2010.6982%2011.598C10.5956%2011.598%2010.494%2011.6182%2010.3992%2011.6574C10.3045%2011.6967%2010.2184%2011.7543%2010.1459%2011.8268L9.31767%2012.655C9.17263%2012.8%209.05757%2012.9722%208.97908%2013.1617C8.90058%2013.3512%208.86018%2013.5543%208.86018%2013.7594C8.86018%2013.9645%208.90058%2014.1676%208.97908%2014.357C9.05757%2014.5465%209.17263%2014.7187%209.31767%2014.8637L9.89027%2015.4332%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M15.4623%203.75L10.387%208.82531%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12.3391%203.75H15.4624V6.87327%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var OutgoingVideoCallIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.43018%2015.8583C2.56723%2015.8583%201.86768%2015.1588%201.86768%2014.2958V5.70435C1.86768%204.8414%202.56723%204.14185%203.43018%204.14185H12.1884C13.0513%204.14185%2013.7509%204.8414%2013.7509%205.70435V14.2958C13.7509%2015.1588%2013.0513%2015.8583%2012.1884%2015.8583H3.43018Z%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.1571%2011.9541C13.9068%2011.817%2013.7512%2011.5543%2013.7512%2011.2689V8.73246C13.7512%208.44707%2013.9068%208.18437%2014.1571%208.04726L16.9754%206.50343C17.4961%206.21822%2018.132%206.59497%2018.132%207.18861V12.8128C18.132%2013.4064%2017.4961%2013.7832%2016.9754%2013.4979L14.1571%2011.9541Z%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.15111%207.31395H10.3774V10.5403%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M5.18738%2012.5186L10.2834%207.42248%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

class CallLogsConfiguration {
    constructor(config) {
        this.titleAlignment = uikitResources.TitleAlignment.left;
        this.listItemView = null;
        this.subtitleView = null;
        this.tailView = null;
        this.loadingIconURL = LoadingIcon;
        this.onItemClick = null;
        this.onError = null;
        this.listItemStyle = {};
        this.infoIconUrl = InfoIcon;
        this.onInfoClick = null;
        this.datePattern = uikitResources.DatePatterns.time;
        this.dateSeparatorPattern = uikitResources.DatePatterns.DayDate;
        this.incomingAudioCallIconUrl = IncomingAudioCallIcon;
        this.incomingVideoCallIconUrl = IncomingVideoCallIcon;
        this.outgoingAudioCallIconUrl = OutgoingAudioCallIcon;
        this.outgoingVideoCallIconUrl = OutgoingVideoCallIcon;
        this.missedAudioCallIconUrl = MissedAudioCallIcon;
        this.missedVideoCallIconUrl = MissedVideoCallIcon;
        this.callLogsStyle = {};
        this.avatarStyle = {};
        this.hideSeparator = false;
        this.outgoingCallConfiguration = new OutgoingCallConfiguration({});
        Object.assign(this, config);
    }
}

class CallLogHistoryConfiguration {
    constructor(config) {
        this.loadingIconURL = LoadingIcon;
        this.subtitleView = null;
        this.tailView = null;
        this.onItemClick = null;
        this.backIconUrl = backIcon;
        this.onBackClick = null;
        this.listItemStyle = {};
        this.datePattern = uikitResources.DatePatterns.time;
        this.dateSeparatorPattern = uikitResources.DatePatterns.DayDate;
        this.callLogHistoryStyle = {};
        this.onError = null;
        Object.assign(this, config);
    }
}

class CallLogParticipantsConfiguration {
    constructor(config) {
        this.backIconUrl = backIcon;
        this.onBackClick = null;
        this.avatarStyle = {};
        this.onItemClick = null;
        this.datePattern = uikitResources.DatePatterns.time;
        this.listItemStyle = {};
        this.callLogParticipantsStyle = {};
        this.listItemView = null;
        this.subtitleView = null;
        this.tailView = null;
        Object.assign(this, config);
    }
}

var DownloadIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FDownload%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FDownload%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolyline%20id%3D%22Path%22%20points%3D%227.33333333%2013.2%2011%2016.8666667%2014.6666667%2013.2%22%3E%3C%2Fpolyline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2211%22%20y1%3D%225.86666667%22%20x2%3D%2211%22%20y2%3D%2216.8666667%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C11%20C0%2C17.0751322%204.92486775%2C22%2011%2C22%20C17.0751322%2C22%2022%2C17.0751322%2022%2C11%20C22%2C4.92486775%2017.0751322%2C0%2011%2C0%20C4.92486775%2C0%200%2C4.92486775%200%2C11%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

class CallLogRecordingsConfiguration {
    constructor(config) {
        this.backIconUrl = backIcon;
        this.onBackClick = null;
        this.onItemClick = null;
        this.datePattern = uikitResources.DatePatterns.time;
        this.listItemStyle = {};
        this.callLogRecordingsStyle = {};
        this.downloadIconUrl = DownloadIcon;
        this.hideDownloadButton = false;
        this.onDownloadClick = null;
        this.listItemView = null;
        this.subtitleView = null;
        this.tailView = null;
        Object.assign(this, config);
    }
}

class CallLogDetailsConfiguration {
    constructor(config) {
        this.backIconUrl = backIcon;
        this.avatarStyle = {};
        this.onBackClick = null;
        this.data = null;
        this.callLogHistoryConfiguration = new CallLogHistoryConfiguration({});
        this.callLogParticipantsConfiguration = new CallLogParticipantsConfiguration({});
        this.callLogRecordingsConfiguration = new CallLogRecordingsConfiguration({});
        this.callLogDetailsStyle = {};
        Object.assign(this, config);
    }
}

var CometChatUIKitCalls = (function () { try { const callsSdk = require('@cometchat/calls-sdk-javascript'); if (callsSdk) { return callsSdk.CometChatCalls } } catch (e) { return null } })();

class FormBubbleStyle extends uikitElements.BaseStyle {
    constructor(props) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.wrapperBackground = "";
        this.wrapperBorderRadius = "";
        this.wrapperPadding = "";
        this.goalCompletionTextFont = "";
        this.goalCompletionTextColor = "";
        this.datePickerBorder = "";
        this.datePickerBorderRadius = "";
        this.datePickerFont = "";
        this.datePickerFontColor = "";
        Object.assign(this, props);
    }
}

const textStyle = new uikitElements.InputStyle({
    width: "100%",
    height: "30px",
    border: "1px solid #ccc",
    borderRadius: "3px",
    padding: "0px 0px 0px 5px",
    placeholderTextColor: "#bcbcbc",
    placeholderTextFont: "500 13px sans-serif, Inter",
    textFont: "400 14px sans-serif, Inter",
});
const labelStyle = new uikitElements.LabelStyle({
    textFont: "400 16px sans-serif, Inter",
    textColor: "black",
});
const radioButtonStyle = new uikitElements.RadioButtonStyle({
    height: "16px",
    width: "16px",
    border: "none",
    labelTextFont: "400 14px sans-serif, Inter",
    labelTextColor: "grey",
    borderRadius: "4px",
    background: "",
});
const checkboxStyle = new uikitElements.CheckboxStyle({
    height: "16px",
    width: "16px",
    border: "none",
    borderRadius: "4px",
    background: "",
    labelTextColor: "grey",
    labelTextFont: "400 14px sans-serif, Inter",
});
const dropdownStyle = new uikitElements.DropdownStyle({
    height: "35px",
    width: "100%",
    background: "white",
    border: "1px solid #e2e2e2",
    borderRadius: "12px",
    activeTextFont: "400 15px sans-serif, Inter",
    activeTextColor: "#141414",
    arrowIconTint: "grey",
    textFont: "400 15px sans-serif, Inter",
    textColor: "#141414",
    optionBackground: "white",
    optionBorder: "1px solid #e2e2e2",
    optionHoverBorder: "1px solid #e2e2e2",
    hoverTextFont: "400 15px sans-serif, Inter",
    hoverTextColor: "#141414",
    hoverTextBackground: "#efefef",
});
const buttonStyle$1 = {
    height: "40px",
    width: "100%",
    background: "#3399FF",
    border: "1px solid #e2e2e2",
    borderRadius: "12px",
    buttonTextFont: "400 15px sans-serif, Inter",
    buttonTextColor: "white",
    justifyContent: "center",
};
const quickViewStyle = new uikitElements.QuickViewStyle({
    background: "RGBA(20, 20, 20, 0.04)",
    height: "fit-content",
    width: "100%",
    titleFont: "600 13px sans-serif, Inter",
    titleColor: "#3399FF",
    subtitleFont: "400 13px sans-serif, Inter",
    subtitleColor: "grey",
    leadingBarTint: "#3399FF",
    leadingBarWidth: "4px",
    borderRadius: "8px",
});
const singleSelectStyle = new uikitElements.SingleSelectStyle({
    height: "100%",
    width: "100%",
    background: "#efefef",
    border: "none",
    borderRadius: "12px",
    activeTextFont: "400 15px sans-serif, Inter",
    activeTextColor: "#141414",
    textFont: "400 15px sans-serif, Inter",
    textColor: "grey",
    optionBackground: "white",
    optionBorder: "1px solid #e2e2e2",
    optionBorderRadius: "2px",
    hoverTextFont: "400 15px sans-serif, Inter",
    hoverTextColor: "#141414",
    hoverTextBackground: "#efefef",
});
exports.CometChatFormBubble = class CometChatFormBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.hasCustomCallback = false;
        this.formBubbleStyle = new FormBubbleStyle({
            width: "fit-content",
            height: "fit-content",
            border: "none",
            background: "RGBA(20, 20, 20, 0.04)",
            wrapperBackground: "#fff",
            wrapperPadding: "2px",
            borderRadius: "12px",
            wrapperBorderRadius: "12px",
            titleColor: "#141414",
            titleFont: "400 22px sans-serif, Inter",
            goalCompletionTextFont: "400 15px sans-serif, Inter",
            goalCompletionTextColor: "grey",
            datePickerBorder: "1px solid #e2e2e2",
            datePickerBorderRadius: "3px",
            datePickerFont: "sans-serif, Inter",
            datePickerFontColor: "gray",
        });
        this.data = {};
        this.goalCompletionText = uikitResources.localize("FORM_COMPLETION_MESSAGE");
        this.hasInteractionCompleted = false;
        this.showRequired = [];
        this.isLoading = false;
        this.loadingElement = "";
        this.emitEvent = (elementId) => {
            let response = [];
            if (this.data && Object.keys(this.data).length > 0) {
                response = Object.keys(this.data).map((key) => {
                    var _a, _b;
                    const elementType = (_b = (_a = this.formData) === null || _a === void 0 ? void 0 : _a.getFormFields().find((field) => {
                        return field.getElementId() === key;
                    })) === null || _b === void 0 ? void 0 : _b.getElementType();
                    const element = new uikitResources.BaseInputElement(key, elementType || "");
                    element.setResponse(this.data[key]);
                    return element;
                });
            }
            this.dispatchEvent(new CustomEvent("cc-submit-clicked", {
                bubbles: true,
                composed: true,
                detail: {
                    value: {
                        elementId,
                        data: response,
                    },
                },
            }));
        };
        this.markAsInteracted = (elementId) => {
            var _a;
            chatSdkJavascript.CometChat.markAsInteracted((_a = this.message) === null || _a === void 0 ? void 0 : _a.getId(), elementId).then(() => {
                var _a;
                const interaction = new chatSdkJavascript.CometChat.Interaction(elementId, new Date().getTime());
                (_a = this.interactedElements) === null || _a === void 0 ? void 0 : _a.push(interaction);
                this.hasInteractionCompleted = this.checkHasInteractionCompleted();
                this.setLoading(false, elementId);
                this.requestUpdate("hasInteractionCompleted");
            });
        };
        this.removeElementIdFromRequired = (elementId) => {
            if (this.showRequired.includes(elementId)) {
                this.showRequired.splice(this.showRequired.indexOf(elementId), 1);
                this.requestUpdate("showRequired");
            }
        };
        this.interactedBanner = () => {
            var _a, _b, _c;
            const containerStyle = {
                boxSizing: "border-box",
                margin: "5px",
            };
            const paragraphStyle = {
                font: this.formBubbleStyle.goalCompletionTextFont,
                color: this.formBubbleStyle.goalCompletionTextColor,
            };
            return lit.html `
      <div style=${styleMap_js.styleMap(containerStyle)}>
        <cometchat-quick-view
          title=${(_b = (_a = this.message) === null || _a === void 0 ? void 0 : _a.getSender()) === null || _b === void 0 ? void 0 : _b.getName()}
          subtitle=${(_c = this.formData) === null || _c === void 0 ? void 0 : _c.getTitle()}
          quickViewStyle=${JSON.stringify(this.formBubbleStyle.quickViewStyle)}
        ></cometchat-quick-view>
        <span style=${styleMap_js.styleMap(paragraphStyle)}
          >${this.goalCompletionText}</span
        >
      </div>
    `;
        };
        this.isRequired = (field) => {
            return (field === null || field === void 0 ? void 0 : field.optional) ? "" : "*";
        };
        this.filledRequiredFields = () => {
            var _a;
            let filled = true;
            (_a = this.formData) === null || _a === void 0 ? void 0 : _a.getFormFields().forEach((field) => {
                if (field.getElementType() !== uikitResources.ElementType.button &&
                    field.getElementType() !== uikitResources.ElementType.label) {
                    if (field.getOptional()) {
                        return;
                    }
                    if (!this.data[field.getElementId()]) {
                        filled = false;
                        if (!this.showRequired.includes(field.getElementId()))
                            this.showRequired.push(field.getElementId());
                    }
                }
            });
            return filled;
        };
        this.checkHasInteractionCompleted = () => {
            var _a, _b;
            let completed = false;
            let neededInteractionElement = ((_a = this.interactionGoal) === null || _a === void 0 ? void 0 : _a.getElementIds()) || [];
            let neededInteractionElementCondition = ((_b = this.interactionGoal) === null || _b === void 0 ? void 0 : _b.getType()) || "";
            let interactedElements = this.interactedElements || [];
            switch (neededInteractionElementCondition) {
                case uikitResources.CometChatUIKitConstants.goalType.anyOf:
                    completed = interactedElements.find((element) => neededInteractionElement.includes(element.getElementId()))
                        ? true
                        : false;
                    break;
                case uikitResources.CometChatUIKitConstants.goalType.anyAction:
                    completed = interactedElements.length > 0 ? true : false;
                    break;
                case uikitResources.CometChatUIKitConstants.goalType.allOf:
                    completed = neededInteractionElement.every((element) => interactedElements.find((interaction) => interaction.getElementId() === element))
                        ? true
                        : false;
                    break;
                case uikitResources.CometChatUIKitConstants.goalType.none:
                    completed = false;
                    break;
                default:
                    completed = false;
                    break;
            }
            return completed;
        };
        this.bubbleStyle = () => {
            var _a, _b, _c, _d, _e, _f;
            return {
                width: ((_a = this.formBubbleStyle) === null || _a === void 0 ? void 0 : _a.width) || "fit-content",
                height: ((_b = this.formBubbleStyle) === null || _b === void 0 ? void 0 : _b.height) || "fit-content",
                border: ((_c = this.formBubbleStyle) === null || _c === void 0 ? void 0 : _c.border) || "none",
                background: ((_d = this.formBubbleStyle) === null || _d === void 0 ? void 0 : _d.background) || "RGBA(20, 20, 20, 0.04)",
                borderRadius: ((_e = this.formBubbleStyle) === null || _e === void 0 ? void 0 : _e.borderRadius) || "12px",
                padding: ((_f = this.formBubbleStyle) === null || _f === void 0 ? void 0 : _f.wrapperPadding) || "2px",
            };
        };
        this.titleStyle = () => {
            var _a, _b;
            return {
                color: ((_a = this.formBubbleStyle) === null || _a === void 0 ? void 0 : _a.titleColor) || "#141414",
                font: ((_b = this.formBubbleStyle) === null || _b === void 0 ? void 0 : _b.titleFont) || "400 18px sans-serif, Inter",
                margin: "0px",
                padding: "16px",
            };
        };
        this.wrapperBubbleStyle = () => {
            var _a, _b;
            return {
                background: ((_a = this.formBubbleStyle) === null || _a === void 0 ? void 0 : _a.wrapperBackground) || "#fff",
                borderRadius: ((_b = this.formBubbleStyle) === null || _b === void 0 ? void 0 : _b.wrapperBorderRadius) || "8px",
            };
        };
    }
    render() {
        var _a, _b, _c, _d, _e;
        if (!this.loggedInUser) {
            chatSdkJavascript.CometChat.getLoggedinUser()
                .then((user) => {
                if (user)
                    this.loggedInUser = user;
            })
                .catch((error) => {
                console.log(error);
            });
        }
        if (!this.formBubbleStyle.textInputStyle) {
            this.formBubbleStyle.textInputStyle = textStyle;
        }
        if (!this.formBubbleStyle.labelStyle) {
            this.formBubbleStyle.labelStyle = labelStyle;
        }
        if (!this.formBubbleStyle.radioButtonStyle) {
            this.formBubbleStyle.radioButtonStyle = radioButtonStyle;
        }
        if (!this.formBubbleStyle.checkboxStyle) {
            this.formBubbleStyle.checkboxStyle = checkboxStyle;
        }
        if (!this.formBubbleStyle.dropdownStyle) {
            this.formBubbleStyle.dropdownStyle = dropdownStyle;
        }
        if (!this.formBubbleStyle.buttonStyle) {
            this.formBubbleStyle.buttonStyle = buttonStyle$1;
        }
        if (!this.formBubbleStyle.quickViewStyle) {
            this.formBubbleStyle.quickViewStyle = quickViewStyle;
        }
        if (!this.formBubbleStyle.singleSelectStyle) {
            this.formBubbleStyle.singleSelectStyle = singleSelectStyle;
        }
        if (!this.formData) {
            this.formData = this.message;
            this.goalCompletionText =
                ((_a = this === null || this === void 0 ? void 0 : this.formData) === null || _a === void 0 ? void 0 : _a.getGoalCompletionText()) || this.goalCompletionText;
            this.interactedElements = ((_b = this.message) === null || _b === void 0 ? void 0 : _b.getInteractions()) || [];
            this.interactionGoal = ((_c = this.message) === null || _c === void 0 ? void 0 : _c.getInteractionGoal()) || undefined;
            this.hasInteractionCompleted = this.checkHasInteractionCompleted();
        }
        return this.message
            ? lit.html `
          <div style=${styleMap_js.styleMap(this.bubbleStyle())} class="cc__form_bubble">
            ${this.hasInteractionCompleted
                ? this.interactedBanner()
                : lit.html `<div
                  class="cc__form_bubble__wrapper"
                  style=${styleMap_js.styleMap(this.wrapperBubbleStyle())}
                >
                  <h3 style=${styleMap_js.styleMap(this.titleStyle())}>
                    ${(_d = this.formData) === null || _d === void 0 ? void 0 : _d.getTitle()}
                  </h3>

                  <cometchat-divider></cometchat-divider>
                  <div
                    style=${styleMap_js.styleMap({
                    padding: "16px",
                })}
                  >
                    ${(_e = this.formData) === null || _e === void 0 ? void 0 : _e.getFormFields().map((field) => lit.html `
                            <div class="cc_form-field_wrapper">
                              ${this._renderFormField(field)}
                            </div>
                          `)}
                    <div class="cc_flex__column cc_dynamic-form_button-group">
                      ${this._renderSubmitElement(this.formData.getSubmitElement())}
                    </div>
                  </div>
                </div>`}
          </div>
        `
            : lit.nothing;
    }
    _renderFormField(field) {
        switch (field.getElementType()) {
            case uikitResources.ElementType.label:
                return this._renderLabelField(field);
            case uikitResources.ElementType.text:
                return this._renderTextField(field);
            case uikitResources.ElementType.button:
                return this._renderButtonField(field);
            case uikitResources.ElementType.checkbox:
                return this._renderCheckboxField(field);
            case uikitResources.ElementType.dropdown:
                return this._renderDropdownField(field);
            case uikitResources.ElementType.radio:
                return this._renderRadioField(field);
            case uikitResources.ElementType.dateTime:
                return this._renderDatepickerField(field);
            case uikitResources.ElementType.singleSelect:
                return this._renderSingleSelectField(field);
            default:
                return lit.nothing;
        }
    }
    _renderLabelField(field) {
        const labelStyle = this.formBubbleStyle.labelStyle;
        return lit.html `
      <cometchat-label
        labelStyle=${JSON.stringify(labelStyle)}
        text=${field.getText()}
      ></cometchat-label>
    `;
    }
    _renderTextField(field) {
        const isRequired = this.showRequired.includes(field.getElementId());
        const inputStyle = CometChatUIKitUtility.clone(this.formBubbleStyle.textInputStyle);
        const labelStyle = this.formBubbleStyle.labelStyle;
        const messageInputStyle = new uikitElements.TextInputStyle({
            ...inputStyle,
            height: "fit-content",
            dividerColor: "transparent",
            inputBackground: inputStyle === null || inputStyle === void 0 ? void 0 : inputStyle.background,
            inputPadding: "7px 5px",
            maxHeight: `${14 * ((field.getMaxLines() || 1) + 1)}px`,
            width: "100%",
        });
        const defaultValue = field.getDefaultValue() || "";
        if (defaultValue) {
            this.data[field.getElementId()] = defaultValue;
        }
        if (isRequired) {
            inputStyle.border = "1px solid red";
            messageInputStyle.border = "1px solid red";
        }
        return lit.html `
      <div class="cc_flex__column cc_flex_align">
        <cometchat-label
          labelStyle=${JSON.stringify(labelStyle)}
          text=${field.getLabel() + this.isRequired(field)}
        ></cometchat-label>
        ${(field.getMaxLines() || 1) > 1
            ? lit.html `
              <cometchat-text-input
                textInputStyle=${JSON.stringify(messageInputStyle)}
                placeholderText=${field.getPlaceholder()}
                text=${defaultValue}
                @cc-text-input-changed=${(event) => {
                var _a, _b;
                if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) {
                    this.removeElementIdFromRequired(field.getElementId());
                    this.data[field.getElementId()] = (_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.value;
                }
                else
                    delete this.data[field.getElementId()];
            }}
              >
              </cometchat-text-input>
            `
            : lit.html `
              <cometchat-input
                inputStyle=${JSON.stringify(inputStyle)}
                placeholderText=${field.getPlaceholder()}
                value=${defaultValue}
                @cc-input-changed=${(event) => {
                var _a, _b;
                if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) {
                    this.removeElementIdFromRequired(field.getElementId());
                    this.data[field.getElementId()] = (_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.value;
                }
                else
                    delete this.data[field.getElementId()];
            }}
              ></cometchat-input>
            `}
      </div>
    `;
    }
    validateDefaultValueString(value, mode) {
        if (!value) {
            return false;
        }
        switch (mode) {
            case uikitResources.DateTimePickerMode.date:
                const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
                return dateRegex.test(value);
            case uikitResources.DateTimePickerMode.time:
                const timeRegex = /^\d{2}:\d{2}$/;
                return timeRegex.test(value);
            case uikitResources.DateTimePickerMode.dateTime:
                const dateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
                return dateTimeRegex.test(value);
            default:
                return false;
        }
    }
    convertDateTimeStringToLocalValue(value, timezone, mode) {
        let date, year, month, day, hours, minutes;
        const regex = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2})?$/;
        if (regex.test(value)) {
            date = this.getDateTimeObject(value, timezone);
            year = date.getFullYear();
            month = String(date.getMonth() + 1).padStart(2, "0");
            day = String(date.getDate()).padStart(2, "0");
            hours = String(date.getHours()).padStart(2, "0");
            minutes = String(date.getMinutes()).padStart(2, "0");
        }
        switch (mode) {
            case uikitResources.DateTimePickerMode.date:
                return `${year}-${month}-${day}`;
            case uikitResources.DateTimePickerMode.dateTime:
                return `${year}-${month}-${day}T${hours}:${minutes}`;
            default:
                return value;
        }
    }
    convertDateTimeStringToUTCValue(value, mode) {
        // assume date is in local timezone
        let date, year, month, day, hours, minutes;
        const regex = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2})?$/;
        if (regex.test(value)) {
            date = new Date(value);
            year = date.getUTCFullYear();
            month = String(date.getUTCMonth() + 1).padStart(2, "0");
            day = String(date.getUTCDate()).padStart(2, "0");
            hours = String(date.getUTCHours()).padStart(2, "0");
            minutes = String(date.getUTCMinutes()).padStart(2, "0");
        }
        switch (mode) {
            case uikitResources.DateTimePickerMode.date:
                return `${year}-${month}-${day}`;
            case uikitResources.DateTimePickerMode.dateTime:
                return `${year}-${month}-${day}T${hours}:${minutes}`;
            default:
                return value;
        }
    }
    _renderDatepickerField(field) {
        const isRequired = this.showRequired.includes(field.getElementId());
        const dateTimeField = field;
        const labelStyle = this.formBubbleStyle.labelStyle;
        let defaultValueString = field.getDefaultValue();
        const mode = field.getMode();
        const timezone = field.getTimezoneCode();
        let fromDateTime = field.getFrom();
        let toDateTime = field.getTo();
        const isDefaultValueValid = this.validateDefaultValueString(defaultValueString || "", mode);
        const datePickerStyle = {
            border: this.formBubbleStyle.datePickerBorder,
            borderRadius: this.formBubbleStyle.datePickerBorderRadius,
            color: this.formBubbleStyle.datePickerFontColor,
            font: this.formBubbleStyle.datePickerFont,
            padding: "6px",
            width: "100%",
        };
        if (isRequired) {
            datePickerStyle.border = "1px solid red";
        }
        if (fromDateTime && timezone) {
            fromDateTime = this.convertDateTimeStringToLocalValue(fromDateTime, timezone, mode);
        }
        if (toDateTime && timezone) {
            toDateTime = this.convertDateTimeStringToLocalValue(toDateTime, timezone, mode);
        }
        if (defaultValueString && timezone) {
            defaultValueString = this.convertDateTimeStringToLocalValue(defaultValueString, timezone, mode);
        }
        if (isDefaultValueValid && defaultValueString) {
            if (!this.data[field.getElementId()]) {
                this.data[field.getElementId()] =
                    this.convertDateTimeStringToLocalValue(defaultValueString || "", timezone, mode);
            }
        }
        let inputType = "datetime-local";
        switch (mode) {
            case uikitResources.DateTimePickerMode.date:
                inputType = "date";
                break;
            case uikitResources.DateTimePickerMode.time:
                inputType = "time";
                break;
            case uikitResources.DateTimePickerMode.dateTime:
            default:
                inputType = "datetime-local";
                break;
        }
        return lit.html `
      <div class="cc_flex__column cc_flex_align">
        <cometchat-label
          labelStyle=${JSON.stringify(labelStyle)}
          text=${dateTimeField.getLabel() + this.isRequired(field)}
        ></cometchat-label>
        <div style="display: flex;">
          <input
            type="${inputType}"
            id="${dateTimeField.getElementId()}"
            name="${dateTimeField.getElementId()}"
            style="${styleMap_js.styleMap(datePickerStyle)}"
            value="${isDefaultValueValid ? defaultValueString : ""}"
            min="${fromDateTime}"
            max="${toDateTime}"
            @change=${(event) => {
            const inputElement = event.target;
            const selectedDateString = inputElement.value;
            if (selectedDateString) {
                if (!this.validateSelectedTime(selectedDateString, fromDateTime || "", toDateTime || "", mode)) {
                    this.showRequired.push(dateTimeField.getElementId());
                    inputElement.value = "";
                    this.requestUpdate("showRequired");
                    return;
                }
                this.data[field.getElementId()] = selectedDateString;
                this.removeElementIdFromRequired(dateTimeField.getElementId());
                this.requestUpdate("showRequired");
            }
            else {
                delete this.data[field.getElementId()];
            }
        }}
          />
        </div>
      </div>
    `;
    }
    validateSelectedTime(selectedTime, fromTime, toTime, mode) {
        let selectedDateTime, fromDateTime, toDateTime;
        switch (mode) {
            case uikitResources.DateTimePickerMode.date:
            case uikitResources.DateTimePickerMode.dateTime:
                selectedDateTime = new Date(selectedTime);
                fromDateTime = new Date(fromTime);
                toDateTime = new Date(toTime);
                break;
            case uikitResources.DateTimePickerMode.time:
                selectedDateTime = new Date(`1970-01-01T${selectedTime}`);
                fromDateTime = new Date(`1970-01-01T${fromTime}`);
                toDateTime = new Date(`1970-01-01T${toTime}`);
                break;
            default:
                return false;
        }
        return selectedDateTime >= fromDateTime && selectedDateTime <= toDateTime;
    }
    _renderSubmitElement(field) {
        return this._renderButtonField(field, true);
    }
    _renderButtonField(field, isSubmitElement = false) {
        var _a, _b, _c, _d, _e;
        let disabled;
        const isLoading = this.isLoading && this.loadingElement === field.getElementId();
        const text = isLoading ? "" : field.getButtonText();
        const buttonStyle = this.formBubbleStyle.buttonStyle;
        const backdropStyle = new uikitElements.BackdropStyle({
            background: buttonStyle.background,
            borderRadius: buttonStyle.borderRadius,
        });
        const loaderStyle = new uikitElements.LoaderStyle({
            height: "24px",
            width: "24px",
            border: "",
            borderRadius: "",
            background: "",
            iconTint: buttonStyle.buttonTextColor,
        });
        if (field.getDisableAfterInteracted()) {
            disabled = (_a = this.interactedElements) === null || _a === void 0 ? void 0 : _a.some((element) => element.getElementId() === field.getElementId());
        }
        if (!((_b = this.message) === null || _b === void 0 ? void 0 : _b.getIsSenderInteractionAllowed(false))) {
            let messageUID = (_d = (_c = this.message) === null || _c === void 0 ? void 0 : _c.getSender()) === null || _d === void 0 ? void 0 : _d.getUid();
            let loggedInUserUID = "";
            if (this.loggedInUser) {
                loggedInUserUID = this.loggedInUser.getUid();
                if (!messageUID) {
                    messageUID = (_e = this.loggedInUser) === null || _e === void 0 ? void 0 : _e.getUid();
                }
                if (loggedInUserUID === messageUID) {
                    disabled = true;
                }
            }
            else {
                chatSdkJavascript.CometChat.getLoggedinUser()
                    .then((user) => {
                    if (user) {
                        loggedInUserUID = user.getUid();
                        if (loggedInUserUID === messageUID) {
                            disabled = true;
                            this.requestUpdate();
                        }
                    }
                })
                    .catch((error) => {
                    console.log(error);
                });
            }
        }
        if (isLoading) {
            disabled = true;
        }
        return lit.html `
      <div style="position:relative">
        ${isLoading
            ? lit.html `
              <cometchat-backdrop
                backdropStyle=${JSON.stringify(backdropStyle)}
              >
                <cometchat-loader
                  loaderStyle=${JSON.stringify(loaderStyle)}
                ></cometchat-loader>
              </cometchat-backdrop>
            `
            : lit.nothing}
        <cometchat-button
          buttonStyle=${JSON.stringify(buttonStyle)}
          text=${text}
          ?disabled=${disabled}
          @cc-button-clicked=${() => {
            if (isSubmitElement) {
                if (this.filledRequiredFields()) {
                    if (this.hasCustomCallback) {
                        this.emitEvent(field.getElementId());
                    }
                    else {
                        this._handleButtonClick(field.getAction(), field.getElementId());
                    }
                }
                else {
                    this.requestUpdate("showRequired");
                }
            }
            else {
                this._handleButtonClick(field.getAction(), field.getElementId());
            }
        }}
        ></cometchat-button>
      </div>
    `;
    }
    _renderCheckboxField(field) {
        const labelStyle = this.formBubbleStyle.labelStyle;
        const checkboxStyle = CometChatUIKitUtility.clone(this.formBubbleStyle.checkboxStyle);
        const isRequired = this.showRequired.includes(field.getElementId());
        if (field.getDefaultValue() &&
            Array.isArray(field.getDefaultValue()) &&
            (field.getDefaultValue() || []).length > 0) {
            const key = field.getElementId();
            this.data[key] = field.getDefaultValue();
        }
        if (isRequired) {
            checkboxStyle.border = "1px solid red";
        }
        return lit.html `
      <div class="cc_flex__column cc_flex_align">
        <cometchat-label
          labelStyle=${JSON.stringify(labelStyle)}
          text=${field.getLabel() + this.isRequired(field)}
        ></cometchat-label>
        <div class="cc_form_group">
          ${field.getOptions().map((option) => {
            var _a;
            return lit.html `
              <div class="cc_flex cc_flex_align">
                <cometchat-checkbox
                  name=${field.getElementId()}
                  labelText=${option.getLabel()}
                  labelAlignment=${uikitResources.LabelAlignment.right}
                  dir="rtl"
                  checkboxStyle=${JSON.stringify(checkboxStyle)}
                  ?checked=${(_a = field
                .getDefaultValue()) === null || _a === void 0 ? void 0 : _a.includes(option.getValue())}
                  @cc-checkbox-changed="${(event) => {
                var _a;
                if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.checked) {
                    this.removeElementIdFromRequired(field.getElementId());
                    if (this.data[field.getElementId()] &&
                        Array.isArray(this.data[field.getElementId()])) {
                        this.data[field.getElementId()].push(option.getValue());
                    }
                    else {
                        this.data[field.getElementId()] = [option.getValue()];
                    }
                }
                else {
                    if (this.data[field.getElementId()] &&
                        Array.isArray(this.data[field.getElementId()])) {
                        this.data[field.getElementId()].splice(this.data[field.getElementId()].indexOf(option.getValue()), 1);
                        if (this.data[field.getElementId()].length === 0) {
                            delete this.data[field.getElementId()];
                        }
                    }
                }
            }}"
                />
              </div>
            `;
        })}
        </div>
      </div>
    `;
    }
    _renderDropdownField(field) {
        const labelStyle = this.formBubbleStyle.labelStyle;
        const dropdownStyle = CometChatUIKitUtility.clone(this.formBubbleStyle.dropdownStyle);
        const isRequired = this.showRequired.includes(field.getElementId());
        let selectedOption = "None";
        const options = field.getOptions().map((option) => {
            return option.getLabel();
        });
        if (field.getDefaultValue()) {
            field.getOptions().forEach((option) => {
                if (option.getValue() === field.getDefaultValue()) {
                    this.data[field.getElementId()] = option.getValue();
                    selectedOption = option.getLabel();
                }
            });
        }
        if (isRequired) {
            dropdownStyle.border = "1px solid red";
        }
        return lit.html `
      <div class="cc_flex__column cc_flex_align">
        <cometchat-label
          labelStyle=${JSON.stringify(labelStyle)}
          text=${field.getLabel() + this.isRequired(field)}
        ></cometchat-label>
        <cometchat-dropdown
          dropdownStyle=${JSON.stringify(dropdownStyle)}
          @cc-dropdown-changed=${(event) => {
            var _a;
            if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) {
                this.removeElementIdFromRequired(field.getElementId());
                const option = field.getOptions().find((option) => {
                    var _a;
                    return option.getLabel() === ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value);
                });
                this.data[field.getElementId()] = option === null || option === void 0 ? void 0 : option.getValue();
            }
            else
                delete this.data[field.getElementId()];
        }}
          options=${JSON.stringify(options)}
          selectedOption=${selectedOption}
        ></cometchat-dropdown>
      </div>
    `;
    }
    _renderRadioField(field) {
        const labelStyle = this.formBubbleStyle.labelStyle;
        const radioButtonStyle = this.formBubbleStyle.radioButtonStyle;
        if (field.getDefaultValue()) {
            if (field.getOptions() && field.getOptions().length > 0) {
                field.getOptions().forEach((option) => {
                    if (option.getValue() === field.getDefaultValue()) {
                        this.data[field.getElementId()] = option.getValue();
                    }
                });
            }
        }
        return lit.html `
    <div class="cc_flex__column cc_flex_align">
    <cometchat-label labelStyle=${JSON.stringify(labelStyle)} text=${field.getLabel() + this.isRequired(field)}></cometchat-label>
    <div class="cc_form_group">
    ${field.getOptions().map((o) => {
            return lit.html `
        <cometchat-radio-button
          radioButtonStyle=${JSON.stringify(radioButtonStyle)}
          name=${field.getElementId()}
          labelText=${o.getLabel()}
          labelAlignment=${uikitResources.LabelAlignment.right}
          ?checked=${o.getValue() === field.getDefaultValue()}
          @cc-radio-button-changed=${(event) => {
                var _a;
                this.removeElementIdFromRequired(field.getElementId());
                if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.checked)
                    this.data[field.getElementId()] = o.getValue();
                else
                    delete this.data[field.getElementId()];
            }}
        />
      `;
        })}
    </div>
    </div
    `;
    }
    _renderSingleSelectField(field) {
        const labelStyle = this.formBubbleStyle.labelStyle;
        const singleSelectStyle = CometChatUIKitUtility.clone(this.formBubbleStyle.singleSelectStyle);
        const isRequired = this.showRequired.includes(field.getElementId());
        let selectedOption = "";
        if (field.getDefaultValue()) {
            if (field.getOptions() && field.getOptions().length > 0) {
                field.getOptions().forEach((option) => {
                    if (option.getValue() === field.getDefaultValue()) {
                        this.data[field.getElementId()] = option.getValue();
                        selectedOption = option.getLabel();
                    }
                });
            }
        }
        const options = field.getOptions().map((option) => {
            return option.getLabel();
        });
        if (isRequired) {
            singleSelectStyle.optionBorder = "1px solid red";
        }
        return lit.html `
    <div class="cc_flex__column cc_flex_align">
    <cometchat-label labelStyle=${JSON.stringify(labelStyle)} text=${field.getLabel() + this.isRequired(field)}></cometchat-label>
    <div class="cc_form_group" style="width:100%">
    <cometchat-single-select
    selectStyle=${JSON.stringify(singleSelectStyle)}
      options=${JSON.stringify(options)}
      selectedOption=${selectedOption}
      @cc-single-select-changed=${(event) => {
            var _a;
            this.removeElementIdFromRequired(field.getElementId());
            if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) {
                const option = field.getOptions().find((option) => {
                    var _a;
                    return option.getLabel() === ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value);
                });
                this.data[field.getElementId()] = option === null || option === void 0 ? void 0 : option.getValue();
            }
            else
                delete this.data[field.getElementId()];
        }}
    ></cometchat-single-select>
    </div>
    </div
    `;
    }
    _handleButtonClick(action, elementId) {
        this.setLoading(true, elementId);
        InteractiveMessageUtils.actionHandler(action, {
            elementId: elementId,
            data: this.data,
            loggedInUser: this.loggedInUser,
            message: this.message,
        })
            .then((response) => {
            if (response) {
                this.markAsInteracted(elementId);
            }
            else {
                this.setLoading(false, elementId);
            }
        })
            .catch(() => {
            this.setLoading(false, elementId);
        });
    }
    setLoading(isLoading, elementId) {
        this.isLoading = isLoading;
        if (isLoading) {
            this.loadingElement = elementId;
        }
        else {
            this.loadingElement = "";
        }
        this.requestUpdate("isLoading");
    }
    updated(_changedProperties) {
        var _a, _b, _c;
        if (_changedProperties.has("message")) {
            this.formData = this.message;
            this.goalCompletionText =
                ((_a = this === null || this === void 0 ? void 0 : this.formData) === null || _a === void 0 ? void 0 : _a.getGoalCompletionText()) || this.goalCompletionText;
            this.interactedElements = ((_b = this.message) === null || _b === void 0 ? void 0 : _b.getInteractions()) || [];
            this.interactionGoal = ((_c = this.message) === null || _c === void 0 ? void 0 : _c.getInteractionGoal()) || undefined;
            this.hasInteractionCompleted = this.checkHasInteractionCompleted();
            this.requestUpdate("formData");
        }
    }
    getDateTimeObject(timestampStr, timezoneStr) {
        if (!timestampStr || !timezoneStr) {
            throw new Error("Both timestampStr and timezoneStr are required.");
        }
        const date = new Date(timestampStr);
        const offsetInMinutes = this.getOffsetInMinutes(timezoneStr, date);
        const adjustedDate = new Date(date.getTime() + offsetInMinutes * 60000);
        adjustedDate.setSeconds(0);
        return adjustedDate;
    }
    getOffsetInMinutes(timezoneStr, date) {
        const localTime = date.toLocaleString("en-US", { timeZone: timezoneStr });
        const localDate = new Date(localTime);
        const utcOffset = (date.getTime() - localDate.getTime()) / 60000;
        return utcOffset;
    }
};
exports.CometChatFormBubble.styles = [
    lit.css `
      .cc_flex {
        display: flex;
      }

      .cc_flex__column {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .cc_flex_align {
        text-align: start;
      }

      .cc__form_bubble {
        position: relative;
        padding: 10px;
        max-width: 100%;
        min-width: 210px;
        min-height: 100px;
        box-sizing: border-box;
        overflow: hidden;
      }

      .cc__form_bubble__wrapper {
        display: flex;
        flex-direction: column;
        text-align: start;
        max-width: 100%;
        background-color: #fff;
        border-radius: 8px;
      }

      .cc_form-field_wrapper {
        margin-bottom: 20px;
      }

      .cc_form_group {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: space-evenly;
        width: max-content;
      }

      .cc_dynamic-form_button-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    `,
];
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatFormBubble.prototype, "message", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatFormBubble.prototype, "hasCustomCallback", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatFormBubble.prototype, "formBubbleStyle", void 0);
exports.CometChatFormBubble = __decorate([
    decorators_js.customElement("cometchat-form-bubble")
], exports.CometChatFormBubble);

class CardBubbleStyle extends uikitElements.BaseStyle {
    constructor(props) {
        super({});
        this.wrapperBackground = "";
        this.wrapperBorderRadius = "";
        this.wrapperPadding = "";
        this.imageHeight = "";
        this.imageWidth = "";
        this.imageRadius = "";
        this.imageBackgroundColor = "";
        this.descriptionFontColor = "";
        this.descriptionFont = "";
        this.dividerTintColor = "";
        this.disabledButtonColor = "";
        Object.assign(this, props);
    }
}

const buttonStyle = {
    height: "40px",
    width: "100%",
    background: "transparent",
    border: "none",
    borderRadius: "0px",
    buttonTextFont: "400 15px Inter, sans-serif",
    buttonTextColor: "#3399FF",
    justifyContent: "center",
};
exports.CometChatCardBubble = class CometChatCardBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.cardBubbleStyle = new CardBubbleStyle({
            background: "#f1f5f8",
            wrapperBackground: "white",
            wrapperPadding: "2px",
            borderRadius: "8px",
            wrapperBorderRadius: "8px",
            height: "fit-content",
            width: "300px",
            imageHeight: "auto",
            imageWidth: "100%",
            imageRadius: "8px",
            dividerTintColor: "#f1f5f8",
            imageBackgroundColor: "transparent",
            descriptionFontColor: "#000000",
            descriptionFont: "400 15px 'Inter', sans-serif",
            buttonStyle: buttonStyle,
            disabledButtonColor: "#000000",
        });
        this.showFullScreen = false;
        this.isLoading = false;
        this.loadingElement = "";
        this.markAsInteracted = (elementId) => {
            var _a;
            chatSdkJavascript.CometChat.markAsInteracted((_a = this.message) === null || _a === void 0 ? void 0 : _a.getId(), elementId)
                .then(() => {
                var _a;
                const interaction = new chatSdkJavascript.CometChat.Interaction(elementId, new Date().getTime());
                (_a = this.interactedElements) === null || _a === void 0 ? void 0 : _a.push(interaction);
                this.setLoading(false, elementId);
                this.requestUpdate("interactedElements");
            })
                .catch((error) => {
                console.log(error);
            });
        };
        this.wrapperBubbleStyle = () => {
            var _a, _b;
            return {
                background: ((_a = this.cardBubbleStyle) === null || _a === void 0 ? void 0 : _a.wrapperBackground) || "#fff",
                borderRadius: ((_b = this.cardBubbleStyle) === null || _b === void 0 ? void 0 : _b.wrapperBorderRadius) || "8px",
            };
        };
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        if (!this.message) {
            return lit.nothing;
        }
        if (!this.loggedInUser) {
            chatSdkJavascript.CometChat.getLoggedinUser()
                .then((user) => {
                if (user) {
                    this.loggedInUser = user;
                    this.requestUpdate();
                }
            })
                .catch((error) => {
                console.log(error);
            });
        }
        if (!this.cardData) {
            this.cardData = this.message;
        }
        if (!this.interactedElements) {
            this.interactedElements = this.message.getInteractions() || [new chatSdkJavascript.CometChat.Interaction("submitButton1", new Date().getTime())];
        }
        return lit.html `
        <div
          class="cc__card_bubble"
          style=${styleMap_js.styleMap(this.getContainerStyle())}
        >
        <div
        class="cc__card_bubble__wrapper"
        style=${styleMap_js.styleMap(this.wrapperBubbleStyle())}
      >
          <div class="cc__card_bubble__details">
            ${((_a = this.cardData) === null || _a === void 0 ? void 0 : _a.getImageUrl())
            ? lit.html ` <div class="cc__card_bubble__image">
                  ${this.showFullScreen
                ? lit.html ` <cometchat-full-screen-viewer
                        @cc-close-clicked=${() => {
                    this.showFullScreen = false;
                    this.requestUpdate("showFullScreen");
                }}
                        URL=${(_b = this.cardData) === null || _b === void 0 ? void 0 : _b.getImageUrl()}
                        fullScreenViewerStyle=${JSON.stringify(this.fullScreenViewStyle())}
                        closeIconUrl=${closeIcon$1}
                      ></cometchat-full-screen-viewer>`
                : lit.nothing}
                  <cometchat-image-bubble
                    imageStyle=${JSON.stringify(this.getImageStyle())}
                    src=${(_c = this.cardData) === null || _c === void 0 ? void 0 : _c.getImageUrl()}
                    @cc-image-clicked=${() => {
                this.showFullScreen = true;
                this.requestUpdate("showFullScreen");
            }}
                  ></cometchat-image-bubble>
                </div>`
            : lit.nothing}
            <div
              class="cc__card_bubble__description"
              style=${styleMap_js.styleMap(this.getDescriptionStyle())}
            >
              <p>${(_d = this.cardData) === null || _d === void 0 ? void 0 : _d.getText()}</p>
            </div>
          </div>
          <div class="cc__card_bubble__buttons">
            ${(_f = (_e = this.cardData) === null || _e === void 0 ? void 0 : _e.getCardActions()) === null || _f === void 0 ? void 0 : _f.map((button) => {
            return this._renderButtonField(button);
        })}
          </div>
        </div>
        </div>
      </div>
    `;
    }
    _renderButtonField(field) {
        var _a, _b, _c, _d, _e, _f, _g;
        const isLoading = this.isLoading && (this.loadingElement === field.getElementId());
        const text = isLoading ? "" : field.getButtonText();
        const buttonStyle = this.cardBubbleStyle.buttonStyle;
        const backdropStyle = new uikitElements.BackdropStyle({
            background: buttonStyle.background,
            borderRadius: buttonStyle.borderRadius
        });
        const loaderStyle = new uikitElements.LoaderStyle({
            height: "24px",
            width: "24px",
            border: "",
            borderRadius: "",
            background: "",
            iconTint: buttonStyle.buttonTextColor
        });
        const dividerStyle = {
            height: "2px",
            width: "100%",
            background: (_a = this.cardBubbleStyle) === null || _a === void 0 ? void 0 : _a.dividerTintColor,
        };
        let disabled;
        if (field.getDisableAfterInteracted()) {
            disabled = (_b = this.interactedElements) === null || _b === void 0 ? void 0 : _b.some((element) => element.getElementId() === field.getElementId());
        }
        if (!((_c = this.message) === null || _c === void 0 ? void 0 : _c.getIsSenderInteractionAllowed(false))) {
            let messageUID = (_e = (_d = this.message) === null || _d === void 0 ? void 0 : _d.getSender()) === null || _e === void 0 ? void 0 : _e.getUid();
            let loggedInUserUID = "";
            if (this.loggedInUser) {
                loggedInUserUID = this.loggedInUser.getUid();
                if (!messageUID) {
                    messageUID = (_f = this.loggedInUser) === null || _f === void 0 ? void 0 : _f.getUid();
                }
                if (loggedInUserUID === messageUID) {
                    disabled = true;
                }
            }
            else {
                chatSdkJavascript.CometChat.getLoggedinUser()
                    .then((user) => {
                    if (user) {
                        loggedInUserUID = user.getUid();
                        if (loggedInUserUID === messageUID) {
                            disabled = true;
                            this.requestUpdate();
                        }
                    }
                })
                    .catch((error) => {
                    console.log(error);
                });
            }
        }
        if (isLoading) {
            disabled = true;
        }
        return lit.html `
      <cometchat-divider
        dividerStyle=${JSON.stringify(dividerStyle)}
      ></cometchat-divider>
      <div style='position:relative'>
      ${isLoading ? lit.html `
        <cometchat-backdrop
        backdropStyle=${JSON.stringify(backdropStyle)}
        >
      <cometchat-loader
      loaderStyle=${JSON.stringify(loaderStyle)}
      ></cometchat-loader>
      </cometchat-backdrop>
        ` : lit.nothing}
      <cometchat-button
        buttonStyle=${JSON.stringify({ ...buttonStyle, buttonTextColor: disabled ? (_g = this.cardBubbleStyle) === null || _g === void 0 ? void 0 : _g.disabledButtonColor : buttonStyle.buttonTextColor })}
        text=${text}
        ?disabled=${disabled}
        @cc-button-clicked=${() => {
            this._handleButtonClick(field.getAction(), field.getElementId());
        }}
      ></cometchat-button>
      </div>
    `;
    }
    _handleButtonClick(action, elementId) {
        this.setLoading(true, elementId);
        InteractiveMessageUtils.actionHandler(action, {
            elementId: elementId,
            loggedInUser: this.loggedInUser,
            message: this.message
        }).then((response) => {
            if (response) {
                this.markAsInteracted(elementId);
            }
            else {
                this.setLoading(false, elementId);
            }
        })
            .catch(() => {
            this.setLoading(false, elementId);
        });
    }
    setLoading(isLoading, elementId) {
        this.isLoading = isLoading;
        if (isLoading) {
            this.loadingElement = elementId;
        }
        else {
            this.loadingElement = "";
        }
        this.requestUpdate("isLoading");
    }
    getContainerStyle() {
        const { height, width, background, borderRadius, border, wrapperPadding } = this.cardBubbleStyle;
        return {
            height: height,
            width: width,
            background: background,
            borderRadius: borderRadius,
            border: border,
            padding: wrapperPadding || "8px",
        };
    }
    getImageStyle() {
        var _a, _b, _c;
        return new uikitElements.ImageBubbleStyle({
            height: (_a = this.cardBubbleStyle) === null || _a === void 0 ? void 0 : _a.imageHeight,
            width: (_b = this.cardBubbleStyle) === null || _b === void 0 ? void 0 : _b.imageWidth,
            borderRadius: (_c = this.cardBubbleStyle) === null || _c === void 0 ? void 0 : _c.imageRadius,
            background: "transparent",
        });
    }
    getDescriptionStyle() {
        const { descriptionFontColor, descriptionFont } = this
            .cardBubbleStyle;
        return {
            color: descriptionFontColor,
            font: descriptionFont,
        };
    }
    fullScreenViewStyle() {
        let fullScreenViewerStyle = {
            closeIconTint: "white",
        };
        return fullScreenViewerStyle;
    }
};
exports.CometChatCardBubble.styles = [
    lit.css `
      .cc_flex {
        display: flex;
      }

      .cc_flex__column {
        display: flex;
        flex-direction: column;
        gap: 5px;
      }

      .cc_flex_align {
        text-align: start;
      }

      .cc__card_bubble__wrapper {
        display: flex;
        flex-direction: column;
        text-align: start;
        max-width: 100%;
        background-color: #fff;
        border-radius: 8px;
      }

      .cc__card_bubble {
        display: flex;
        flex-direction: column;
        text-align: start;
        max-width: 100%;
        border-radius: 8px;
        min-width: 210px;
        box-sizing: border-box;
      }

      .cc__card_bubble__details {
        display: flex;
        flex-direction: column;
        gap: 0px;
        padding: 8px;
      }

      .cc__card_bubble__buttons {
        display: flex;
        flex-direction: column;
        gap: 0px;
      }

      .cc__card_bubble__description{
        white-space: pre-line;
        word-break: break-word;
      }
    `,
];
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatCardBubble.prototype, "message", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatCardBubble.prototype, "cardBubbleStyle", void 0);
exports.CometChatCardBubble = __decorate([
    decorators_js.customElement("cometchat-card-bubble")
], exports.CometChatCardBubble);

class SchedulerBubbleStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.width = "";
        this.height = "";
        this.border = "";
        this.background = "";
        this.avatarStyle = {};
        this.suggestedTimeTextFont = "";
        this.suggestedTimeTextColor = "";
        this.suggestedTimeBackground = "";
        this.suggestedTimeBorder = "";
        this.suggestedTimeBorderRadius = "";
        this.suggestedTimeDisabledTextFont = "";
        this.suggestedTimeDisabledTextColor = "";
        this.suggestedTimeDisabledBackground = "";
        this.suggestedTimeDisabledBorder = "";
        this.suggestedTimeDisabledBorderRadius = "";
        this.dateSelectorStyle = {};
        this.timeSlotSelectorStyle = {};
        this.scheduleButtonStyle = {};
        this.titleTextFont = "";
        this.titleTextColor = "";
        this.subtitleTextFont = "";
        this.subtitleTextColor = "";
        this.listItemStyle = {};
        this.summaryTextFont = "";
        this.summaryTextColor = "";
        this.goalCompletionTextFont = "";
        this.goalCompletionTextColor = "";
        this.timezoneTextFont = "";
        this.timezoneTextColor = "";
        this.moreButtonTextFont = "";
        this.moreButtonTextColor = "";
        this.moreButtonTextBorder = "";
        this.moreButtonTextBorderRadius = "";
        this.moreButtonTextBackground = "";
        this.moreButtonDisabledTextFont = "";
        this.moreButtonDisabledTextColor = "";
        this.moreButtonDisabledTextBorder = "";
        this.moreButtonDisabledTextBorderRadius = "";
        this.moreButtonDisabledTextBackground = "";
        this.loadingIconTint = "grey";
        this.backButtonIconTint = "grey";
        this.clockIconTint = "black";
        this.calendarIconTint = "black";
        this.timezoneIconTint = "black";
        this.errorTextFont = "";
        this.errorTextColor = "";
        this.seperatorTint = "";
        Object.assign(this, props);
    }
}

// these aren't really private, but nor are they really useful to document

/**
 * @private
 */
class LuxonError extends Error {}

/**
 * @private
 */
class InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class ConflictingSpecificationError extends LuxonError {}

/**
 * @private
 */
class InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}

/**
 * @private
 */
class InvalidArgumentError extends LuxonError {}

/**
 * @private
 */
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}

/**
 * @private
 */

const n = "numeric",
  s = "short",
  l = "long";

const DATE_SHORT = {
  year: n,
  month: n,
  day: n,
};

const DATE_MED = {
  year: n,
  month: s,
  day: n,
};

const DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
};

const DATE_FULL = {
  year: n,
  month: l,
  day: n,
};

const DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
};

const TIME_SIMPLE = {
  hour: n,
  minute: n,
};

const TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
};

const TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s,
};

const TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l,
};

const TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23",
};

const TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
};

const TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s,
};

const TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l,
};

const DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
};

const DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n,
};

const DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
};

const DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n,
};

const DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n,
};

const DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s,
};

const DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s,
};

const DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l,
};

const DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l,
};

/**
 * @interface
 */
class Zone {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }

  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }

  get ianaName() {
    return this.name;
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}

let singleton$1 = null;

/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */
class SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton$1 === null) {
      singleton$1 = new SystemZone();
    }
    return singleton$1;
  }

  /** @override **/
  get type() {
    return "system";
  }

  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }

  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }

  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }

  /** @override **/
  get isValid() {
    return true;
  }
}

let dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short",
    });
  }
  return dtfCache[zone];
}

const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6,
};

function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""),
    parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted),
    [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}

function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];

    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}

let ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */
class IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }
    return ianaZoneCache[name];
  }

  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }

  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */
  static isValidSpecifier(s) {
    return this.isValidZone(s);
  }

  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e) {
      return false;
    }
  }

  constructor(name) {
    super();
    /** @private **/
    this.zoneName = name;
    /** @private **/
    this.valid = IANAZone.isValidZone(name);
  }

  /** @override **/
  get type() {
    return "iana";
  }

  /** @override **/
  get name() {
    return this.zoneName;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }

  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /** @override **/
  offset(ts) {
    const date = new Date(ts);

    if (isNaN(date)) return NaN;

    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts
      ? partsOffset(dtf, date)
      : hackyOffset(dtf, date);

    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }

    // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
    const adjustedHour = hour === 24 ? 0 : hour;

    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0,
    });

    let asTS = +date;
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / (60 * 1000);
  }

  /** @override **/
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }

  /** @override **/
  get isValid() {
    return this.valid;
  }
}

// todo - remap caching

let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}

let intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}

let intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}

let intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts; // exclude `base` from the options
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}

let sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}

let weekInfoCache = {};
function getCachedWeekInfo(locString) {
  let data = weekInfoCache[locString];
  if (!data) {
    const locale = new Intl.Locale(locString);
    // browsers currently implement this as a property, but spec says it should be a getter function
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    weekInfoCache[locString] = data;
  }
  return data;
}

function parseLocaleString(localeStr) {
  // I really want to avoid writing a BCP 47 parser
  // see, e.g. https://github.com/wooorm/bcp-47
  // Instead, we'll do this:

  // a) if the string has no -u extensions, just leave it alone
  // b) if it does, use Intl to resolve everything
  // c) if Intl fails, try again without the -u

  // private subtags and unicode subtags have ordering requirements,
  // and we're not properly parsing this, so just strip out the
  // private ones if they exist.
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }

  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }

    const { numberingSystem, calendar } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}

function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }

    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }

    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}

function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}

function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}

function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();

  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}

function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return (
      loc.numberingSystem === "latn" ||
      !loc.locale ||
      loc.locale.startsWith("en") ||
      new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn"
    );
  }
}

/**
 * @private
 */

class PolyNumberFormatter {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;

    const { padTo, floor, ...otherOpts } = opts;

    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }

  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      // to match the browser's numberformatter defaults
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}

/**
 * @private
 */

class PolyDateFormatter {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = undefined;

    let z = undefined;
    if (this.opts.timeZone) {
      // Don't apply any workarounds if a timeZone is explicitly provided in opts
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
      // That is why fixed-offset TZ is set to that unless it is:
      // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
      // 2. Unsupported by the browser:
      //    - some do not support Etc/
      //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
        // we manually apply the offset and substitute the zone as needed.
        z = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({ minutes: dt.offset });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z = dt.zone.name;
    } else {
      // Custom zones can have any offset / offsetName so we just manually
      // apply the offset and substitute the zone as needed.
      z = "UTC";
      this.dt = dt.setZone("UTC").plus({ minutes: dt.offset });
      this.originalZone = dt.zone;
    }

    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }

  format() {
    if (this.originalZone) {
      // If we have to substitute in the actual zone name, we have to use
      // formatToParts so that the timezone can be replaced.
      return this.formatToParts()
        .map(({ value }) => value)
        .join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }

  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName,
          });
          return {
            ...part,
            value: offsetName,
          };
        } else {
          return part;
        }
      });
    }
    return parts;
  }

  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}

/**
 * @private
 */
class PolyRelFormatter {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }

  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }

  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}

const fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7],
};

/**
 * @private
 */

class Locale {
  static fromOpts(opts) {
    return Locale.create(
      opts.locale,
      opts.numberingSystem,
      opts.outputCalendar,
      opts.weekSettings,
      opts.defaultToEN
    );
  }

  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }

  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }

  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }

  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);

    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);

    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};

    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }

  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }

    return this.fastNumbersCached;
  }

  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness =
      (this.numberingSystem === null || this.numberingSystem === "latn") &&
      (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }

  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        validateWeekSettings(alts.weekSettings) || this.weekSettings,
        alts.defaultToEN || false
      );
    }
  }

  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }

  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }

  months(length, format = false) {
    return listStuff(this, length, months, () => {
      const intl = format ? { month: length, day: "numeric" } : { month: length },
        formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        this.monthsCache[formatStr][length] = mapMonths((dt) => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length];
    });
  }

  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      const intl = format
          ? { weekday: length, year: "numeric", month: "long", day: "numeric" }
          : { weekday: length },
        formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays((dt) =>
          this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length];
    });
  }

  meridiems() {
    return listStuff(
      this,
      undefined,
      () => meridiems,
      () => {
        // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
        // for AM and PM. This is probably wrong, but it's makes parsing way easier.
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }

        return this.meridiemCache;
      }
    );
  }

  eras(length) {
    return listStuff(this, length, eras, () => {
      const intl = { era: length };

      // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
      // to definitely enumerate them.
      if (!this.eraCache[length]) {
        this.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map((dt) =>
          this.extract(dt, intl, "era")
        );
      }

      return this.eraCache[length];
    });
  }

  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts),
      results = df.formatToParts(),
      matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }

  numberFormatter(opts = {}) {
    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
    // (in contrast, the rest of the condition is used heavily)
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }

  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }

  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }

  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }

  isEnglish() {
    return (
      this.locale === "en" ||
      this.locale.toLowerCase() === "en-us" ||
      new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us")
    );
  }

  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }

  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }

  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }

  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }

  equals(other) {
    return (
      this.locale === other.locale &&
      this.numberingSystem === other.numberingSystem &&
      this.outputCalendar === other.outputCalendar
    );
  }
}

let singleton = null;

/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */
class FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton === null) {
      singleton = new FixedOffsetZone(0);
    }
    return singleton;
  }

  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  }

  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s) {
    if (s) {
      const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  }

  constructor(offset) {
    super();
    /** @private **/
    this.fixed = offset;
  }

  /** @override **/
  get type() {
    return "fixed";
  }

  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }

  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }

  /** @override **/
  offsetName() {
    return this.name;
  }

  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }

  /** @override **/
  get isUniversal() {
    return true;
  }

  /** @override **/
  offset() {
    return this.fixed;
  }

  /** @override **/
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }

  /** @override **/
  get isValid() {
    return true;
  }
}

/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */
class InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    /**  @private */
    this.zoneName = zoneName;
  }

  /** @override **/
  get type() {
    return "invalid";
  }

  /** @override **/
  get name() {
    return this.zoneName;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName() {
    return null;
  }

  /** @override **/
  formatOffset() {
    return "";
  }

  /** @override **/
  offset() {
    return NaN;
  }

  /** @override **/
  equals() {
    return false;
  }

  /** @override **/
  get isValid() {
    return false;
  }
}

/**
 * @private
 */

function normalizeZone(input, defaultZone) {
  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone;
    else if (lowered === "local" || lowered === "system") return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return new InvalidZone(input);
  }
}

let now = () => Date.now(),
  defaultZone = "system",
  defaultLocale = null,
  defaultNumberingSystem = null,
  defaultOutputCalendar = null,
  twoDigitCutoffYear = 60,
  throwOnInvalid,
  defaultWeekSettings = null;

/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */
class Settings {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now;
  }

  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    now = n;
  }

  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }

  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }

  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }

  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }

  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }

  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }

  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }

  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }

  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */

  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }

  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }

  /**
   * Get the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }

  /**
   * Set the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // cut-off year is 0, so all 'yy' are interpreted as current century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 1949; '50' -> 2050
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }

  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }

  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }

  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
  }
}

class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }

  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
}

const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
  leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];

function unitOutOfRange(unit, value) {
  return new Invalid(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}

function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));

  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }

  const js = d.getUTCDay();

  return js === 0 ? 7 : js;
}

function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}

function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder,
    month0 = table.findIndex((i) => i < ordinal),
    day = ordinal - table[month0];
  return { month: month0 + 1, day };
}

function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return ((isoWeekday - startOfWeek + 7) % 7) + 1;
}

/**
 * @private
 */

function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj,
    ordinal = computeOrdinal(year, month, day),
    weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);

  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7),
    weekYear;

  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }

  return { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}

function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData,
    weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek),
    yearInDays = daysInYear(weekYear);

  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek,
    year;

  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }

  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(weekData) };
}

function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...timeObject(gregData) };
}

function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(ordinalData) };
}

/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData =
    !isUndefined(obj.localWeekday) ||
    !isUndefined(obj.localWeekNumber) ||
    !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData =
      !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);

    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek(),
    };
  } else {
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
  }
}

function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear),
    validWeek = integerBetween(
      obj.weekNumber,
      1,
      weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)
    ),
    validWeekday = integerBetween(obj.weekday, 1, 7);

  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}

function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year),
    validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}

function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year),
    validMonth = integerBetween(obj.month, 1, 12),
    validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}

function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour =
      integerBetween(hour, 0, 23) ||
      (hour === 24 && minute === 0 && second === 0 && millisecond === 0),
    validMinute = integerBetween(minute, 0, 59),
    validSecond = integerBetween(second, 0, 59),
    validMillisecond = integerBetween(millisecond, 0, 999);

  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}

/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/

/**
 * @private
 */

// TYPES

function isUndefined(o) {
  return typeof o === "undefined";
}

function isNumber(o) {
  return typeof o === "number";
}

function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}

function isString(o) {
  return typeof o === "string";
}

function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}

// CAPABILITIES

function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}

function hasLocaleWeekInfo() {
  try {
    return (
      typeof Intl !== "undefined" &&
      !!Intl.Locale &&
      ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype)
    );
  } catch (e) {
    return false;
  }
}

// OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}

function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }
  return arr.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}

function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (
      !integerBetween(settings.firstDay, 1, 7) ||
      !integerBetween(settings.minimalDays, 1, 7) ||
      !Array.isArray(settings.weekend) ||
      settings.weekend.some((v) => !integerBetween(v, 1, 7))
    ) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend),
    };
  }
}

// NUMBERS AND STRINGS

function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}

// x % n but takes the sign of n instead of x
function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}

function padStart(input, n = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n, "0");
  } else {
    padded = ("" + input).padStart(n, "0");
  }
  return padded;
}

function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}

function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseFloat(string);
  }
}

function parseMillis(fraction) {
  // Return undefined (instead of 0) in these cases, where fraction is not set
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    const f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}

function roundTo(number, digits, towardZero = false) {
  const factor = 10 ** digits,
    rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
}

// DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}

function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}

function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1,
    modYear = year + (month - modMonth) / 12;

  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}

// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
  let d = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );

  // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
    // so if obj.year is in 99, but obj.day makes it roll over into year 100,
    // the calculations done by Date.UTC are using year 2000 - which is incorrect
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}

// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}

function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}

function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}

// PARSING

function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts),
    intlOpts = {
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    };

  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }

  const modified = { timeZoneName: offsetFormat, ...intlOpts };

  const parsed = new Intl.DateTimeFormat(locale, modified)
    .formatToParts(date)
    .find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}

// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);

  // don't || this because we want to preserve -0
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }

  const offMin = parseInt(offMinuteStr, 10) || 0,
    offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}

// COERCION

function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue))
    throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}

function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}

function formatOffset(offset, format) {
  const hours = Math.trunc(Math.abs(offset / 60)),
    minutes = Math.trunc(Math.abs(offset % 60)),
    sign = offset >= 0 ? "+" : "-";

  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}

function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}

/**
 * @private
 */

const monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];

function months(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}

const weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];

function weekdays(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}

const meridiems = ["AM", "PM"];

const erasLong = ["Before Christ", "Anno Domini"];

const erasShort = ["BC", "AD"];

const erasNarrow = ["B", "A"];

function eras(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}

function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}

function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}

function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}

function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}

function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."],
  };

  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;

  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }

  const isInPast = Object.is(count, -0) || count < 0,
    fmtValue = Math.abs(count),
    singular = fmtValue === 1,
    lilUnits = units[unit],
    fmtUnit = narrow
      ? singular
        ? lilUnits[1]
        : lilUnits[2] || lilUnits[1]
      : singular
      ? units[unit][0]
      : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}

function stringifyTokens(splits, tokenToString) {
  let s = "";
  for (const token of splits) {
    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }
  return s;
}

const macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS,
};

/**
 * @private
 */

class Formatter {
  static create(locale, opts = {}) {
    return new Formatter(locale, opts);
  }

  static parseFormat(fmt) {
    // white-space is always considered a literal in user-provided formats
    // the " " token has a special meaning (see unitForToken)

    let current = null,
      currentFull = "",
      bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull });
        }
        currentFull = c;
        current = c;
      }
    }

    if (currentFull.length > 0) {
      splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
    }

    return splits;
  }

  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }

  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }

  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }

  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, { ...this.opts, ...opts });
  }

  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }

  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }

  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }

  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }

  num(n, p = 0) {
    // we get some perf out of doing this here, annoyingly
    if (this.opts.forceSimple) {
      return padStart(n, p);
    }

    const opts = { ...this.opts };

    if (p > 0) {
      opts.padTo = p;
    }

    return this.loc.numberFormatter(opts).format(n);
  }

  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en",
      useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory",
      string = (opts, extract) => this.loc.extract(dt, opts, extract),
      formatOffset = (opts) => {
        if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
          return "Z";
        }

        return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
      },
      meridiem = () =>
        knownEnglish
          ? meridiemForDateTime(dt)
          : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"),
      month = (length, standalone) =>
        knownEnglish
          ? monthForDateTime(dt, length)
          : string(standalone ? { month: length } : { month: length, day: "numeric" }, "month"),
      weekday = (length, standalone) =>
        knownEnglish
          ? weekdayForDateTime(dt, length)
          : string(
              standalone ? { weekday: length } : { weekday: length, month: "long", day: "numeric" },
              "weekday"
            ),
      maybeMacro = (token) => {
        const formatOpts = Formatter.macroTokenToFormatOpts(token);
        if (formatOpts) {
          return this.formatWithSystemDefault(dt, formatOpts);
        } else {
          return token;
        }
      },
      era = (length) =>
        knownEnglish ? eraForDateTime(dt, length) : string({ era: length }, "era"),
      tokenToString = (token) => {
        // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
        switch (token) {
          // ms
          case "S":
            return this.num(dt.millisecond);
          case "u":
          // falls through
          case "SSS":
            return this.num(dt.millisecond, 3);
          // seconds
          case "s":
            return this.num(dt.second);
          case "ss":
            return this.num(dt.second, 2);
          // fractional seconds
          case "uu":
            return this.num(Math.floor(dt.millisecond / 10), 2);
          case "uuu":
            return this.num(Math.floor(dt.millisecond / 100));
          // minutes
          case "m":
            return this.num(dt.minute);
          case "mm":
            return this.num(dt.minute, 2);
          // hours
          case "h":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
          case "hh":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
          case "H":
            return this.num(dt.hour);
          case "HH":
            return this.num(dt.hour, 2);
          // offset
          case "Z":
            // like +6
            return formatOffset({ format: "narrow", allowZ: this.opts.allowZ });
          case "ZZ":
            // like +06:00
            return formatOffset({ format: "short", allowZ: this.opts.allowZ });
          case "ZZZ":
            // like +0600
            return formatOffset({ format: "techie", allowZ: this.opts.allowZ });
          case "ZZZZ":
            // like EST
            return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
          case "ZZZZZ":
            // like Eastern Standard Time
            return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
          // zone
          case "z":
            // like America/New_York
            return dt.zoneName;
          // meridiems
          case "a":
            return meridiem();
          // dates
          case "d":
            return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
          case "dd":
            return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
          // weekdays - standalone
          case "c":
            // like 1
            return this.num(dt.weekday);
          case "ccc":
            // like 'Tues'
            return weekday("short", true);
          case "cccc":
            // like 'Tuesday'
            return weekday("long", true);
          case "ccccc":
            // like 'T'
            return weekday("narrow", true);
          // weekdays - format
          case "E":
            // like 1
            return this.num(dt.weekday);
          case "EEE":
            // like 'Tues'
            return weekday("short", false);
          case "EEEE":
            // like 'Tuesday'
            return weekday("long", false);
          case "EEEEE":
            // like 'T'
            return weekday("narrow", false);
          // months - standalone
          case "L":
            // like 1
            return useDateTimeFormatter
              ? string({ month: "numeric", day: "numeric" }, "month")
              : this.num(dt.month);
          case "LL":
            // like 01, doesn't seem to work
            return useDateTimeFormatter
              ? string({ month: "2-digit", day: "numeric" }, "month")
              : this.num(dt.month, 2);
          case "LLL":
            // like Jan
            return month("short", true);
          case "LLLL":
            // like January
            return month("long", true);
          case "LLLLL":
            // like J
            return month("narrow", true);
          // months - format
          case "M":
            // like 1
            return useDateTimeFormatter
              ? string({ month: "numeric" }, "month")
              : this.num(dt.month);
          case "MM":
            // like 01
            return useDateTimeFormatter
              ? string({ month: "2-digit" }, "month")
              : this.num(dt.month, 2);
          case "MMM":
            // like Jan
            return month("short", false);
          case "MMMM":
            // like January
            return month("long", false);
          case "MMMMM":
            // like J
            return month("narrow", false);
          // years
          case "y":
            // like 2014
            return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
          case "yy":
            // like 14
            return useDateTimeFormatter
              ? string({ year: "2-digit" }, "year")
              : this.num(dt.year.toString().slice(-2), 2);
          case "yyyy":
            // like 0012
            return useDateTimeFormatter
              ? string({ year: "numeric" }, "year")
              : this.num(dt.year, 4);
          case "yyyyyy":
            // like 000012
            return useDateTimeFormatter
              ? string({ year: "numeric" }, "year")
              : this.num(dt.year, 6);
          // eras
          case "G":
            // like AD
            return era("short");
          case "GG":
            // like Anno Domini
            return era("long");
          case "GGGGG":
            return era("narrow");
          case "kk":
            return this.num(dt.weekYear.toString().slice(-2), 2);
          case "kkkk":
            return this.num(dt.weekYear, 4);
          case "W":
            return this.num(dt.weekNumber);
          case "WW":
            return this.num(dt.weekNumber, 2);
          case "n":
            return this.num(dt.localWeekNumber);
          case "nn":
            return this.num(dt.localWeekNumber, 2);
          case "ii":
            return this.num(dt.localWeekYear.toString().slice(-2), 2);
          case "iiii":
            return this.num(dt.localWeekYear, 4);
          case "o":
            return this.num(dt.ordinal);
          case "ooo":
            return this.num(dt.ordinal, 3);
          case "q":
            // like 1
            return this.num(dt.quarter);
          case "qq":
            // like 01
            return this.num(dt.quarter, 2);
          case "X":
            return this.num(Math.floor(dt.ts / 1000));
          case "x":
            return this.num(dt.ts);
          default:
            return maybeMacro(token);
        }
      };

    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  }

  formatDurationFromString(dur, fmt) {
    const tokenToField = (token) => {
        switch (token[0]) {
          case "S":
            return "millisecond";
          case "s":
            return "second";
          case "m":
            return "minute";
          case "h":
            return "hour";
          case "d":
            return "day";
          case "w":
            return "week";
          case "M":
            return "month";
          case "y":
            return "year";
          default:
            return null;
        }
      },
      tokenToString = (lildur) => (token) => {
        const mapped = tokenToField(token);
        if (mapped) {
          return this.num(lildur.get(mapped), token.length);
        } else {
          return token;
        }
      },
      tokens = Formatter.parseFormat(fmt),
      realTokens = tokens.reduce(
        (found, { literal, val }) => (literal ? found : found.concat(val)),
        []
      ),
      collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t));
    return stringifyTokens(tokens, tokenToString(collapsed));
  }
}

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;

function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}

function combineExtractors(...extractors) {
  return (m) =>
    extractors
      .reduce(
        ([mergedVals, mergedZone, cursor], ex) => {
          const [val, zone, next] = ex(m, cursor);
          return [{ ...mergedVals, ...val }, zone || mergedZone, next];
        },
        [{}, null, 1]
      )
      .slice(0, 2);
}

function parse(s, ...patterns) {
  if (s == null) {
    return [null, null];
  }

  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}

function simpleParse(...keys) {
  return (match, cursor) => {
    const ret = {};
    let i;

    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}

// ISO and SQL parsing
const offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
const sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);

function int(match, pos, fallback) {
  const m = match[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}

function extractISOYmd(match, cursor) {
  const item = {
    year: int(match, cursor),
    month: int(match, cursor + 1, 1),
    day: int(match, cursor + 2, 1),
  };

  return [item, null, cursor + 3];
}

function extractISOTime(match, cursor) {
  const item = {
    hours: int(match, cursor, 0),
    minutes: int(match, cursor + 1, 0),
    seconds: int(match, cursor + 2, 0),
    milliseconds: parseMillis(match[cursor + 3]),
  };

  return [item, null, cursor + 4];
}

function extractISOOffset(match, cursor) {
  const local = !match[cursor] && !match[cursor + 1],
    fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
    zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}

function extractIANAZone(match, cursor) {
  const zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
}

// ISO time parsing

const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);

// ISO duration parsing

const isoDuration =
  /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;

function extractISODuration(match) {
  const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] =
    match;

  const hasNegativePrefix = s[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";

  const maybeNegate = (num, force = false) =>
    num !== undefined && (force || (num && hasNegativePrefix)) ? -num : num;

  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds),
    },
  ];
}

// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60,
};

function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr),
  };

  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday =
      weekdayStr.length > 3
        ? weekdaysLong.indexOf(weekdayStr) + 1
        : weekdaysShort.indexOf(weekdayStr) + 1;
  }

  return result;
}

// RFC 2822/5322
const rfc2822 =
  /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;

function extractRFC2822(match) {
  const [
      ,
      weekdayStr,
      dayStr,
      monthStr,
      yearStr,
      hourStr,
      minuteStr,
      secondStr,
      obsOffset,
      milOffset,
      offHourStr,
      offMinuteStr,
    ] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);

  let offset;
  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }

  return [result, new FixedOffsetZone(offset)];
}

function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s
    .replace(/\([^()]*\)|[\n\t]/g, " ")
    .replace(/(\s\s+)/g, " ")
    .trim();
}

// http date

const rfc1123 =
    /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
  rfc850 =
    /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
  ascii =
    /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;

function extractRFC1123Or850(match) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

function extractASCII(match) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);

const extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);

/*
 * @private
 */

function parseISODate(s) {
  return parse(
    s,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}

function parseRFC2822Date(s) {
  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}

function parseHTTPDate(s) {
  return parse(
    s,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}

function parseISODuration(s) {
  return parse(s, [isoDuration, extractISODuration]);
}

const extractISOTimeOnly = combineExtractors(extractISOTime);

function parseISOTimeOnly(s) {
  return parse(s, [isoTimeOnly, extractISOTimeOnly]);
}

const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);

const extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);

function parseSQL(s) {
  return parse(
    s,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}

const INVALID$2 = "Invalid Duration";

// unit conversion constants
const lowOrderMatrix = {
    weeks: {
      days: 7,
      hours: 7 * 24,
      minutes: 7 * 24 * 60,
      seconds: 7 * 24 * 60 * 60,
      milliseconds: 7 * 24 * 60 * 60 * 1000,
    },
    days: {
      hours: 24,
      minutes: 24 * 60,
      seconds: 24 * 60 * 60,
      milliseconds: 24 * 60 * 60 * 1000,
    },
    hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1000 },
    minutes: { seconds: 60, milliseconds: 60 * 1000 },
    seconds: { milliseconds: 1000 },
  },
  casualMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: 52,
      days: 365,
      hours: 365 * 24,
      minutes: 365 * 24 * 60,
      seconds: 365 * 24 * 60 * 60,
      milliseconds: 365 * 24 * 60 * 60 * 1000,
    },
    quarters: {
      months: 3,
      weeks: 13,
      days: 91,
      hours: 91 * 24,
      minutes: 91 * 24 * 60,
      seconds: 91 * 24 * 60 * 60,
      milliseconds: 91 * 24 * 60 * 60 * 1000,
    },
    months: {
      weeks: 4,
      days: 30,
      hours: 30 * 24,
      minutes: 30 * 24 * 60,
      seconds: 30 * 24 * 60 * 60,
      milliseconds: 30 * 24 * 60 * 60 * 1000,
    },

    ...lowOrderMatrix,
  },
  daysInYearAccurate = 146097.0 / 400,
  daysInMonthAccurate = 146097.0 / 4800,
  accurateMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: daysInYearAccurate / 7,
      days: daysInYearAccurate,
      hours: daysInYearAccurate * 24,
      minutes: daysInYearAccurate * 24 * 60,
      seconds: daysInYearAccurate * 24 * 60 * 60,
      milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000,
    },
    quarters: {
      months: 3,
      weeks: daysInYearAccurate / 28,
      days: daysInYearAccurate / 4,
      hours: (daysInYearAccurate * 24) / 4,
      minutes: (daysInYearAccurate * 24 * 60) / 4,
      seconds: (daysInYearAccurate * 24 * 60 * 60) / 4,
      milliseconds: (daysInYearAccurate * 24 * 60 * 60 * 1000) / 4,
    },
    months: {
      weeks: daysInMonthAccurate / 7,
      days: daysInMonthAccurate,
      hours: daysInMonthAccurate * 24,
      minutes: daysInMonthAccurate * 24 * 60,
      seconds: daysInMonthAccurate * 24 * 60 * 60,
      milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000,
    },
    ...lowOrderMatrix,
  };

// units ordered by size
const orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds",
];

const reverseUnits = orderedUnits$1.slice(0).reverse();

// clone really means "create another instance just like this one, but with these changes"
function clone$1(dur, alts, clear = false) {
  // deep merge for vals
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...(alts.values || {}) },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix,
  };
  return new Duration(conf);
}

function durationToMillis(matrix, vals) {
  let sum = vals.milliseconds ?? 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}

// NB: mutates parameters
function normalizeValues(matrix, vals) {
  // the logic below assumes the overall value of the duration is positive
  // if this is not the case, factor is used to make it so
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;

  orderedUnits$1.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];

        // if (previousVal < 0):
        // lower order unit is negative (e.g. { years: 2, days: -2 })
        // normalize this by reducing the higher order unit by the appropriate amount
        // and increasing the lower order unit
        // this can never make the higher order unit negative, because this function only operates
        // on positive durations, so the amount of time represented by the lower order unit cannot
        // be larger than the higher order unit
        // else:
        // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
        // in this case we attempt to convert as much as possible from the lower order unit into
        // the higher order one
        //
        // Math.floor takes care of both of these cases, rounding away from 0
        // if previousVal < 0 it makes the absolute value larger
        // if previousVal >= it makes the absolute value smaller
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);

  // try to convert any decimals into smaller units if possible
  // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
  orderedUnits$1.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}

// Remove all properties with a value of 0 from an object
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}

/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */
class Duration {
  /**
   * @private
   */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;

    if (config.matrix) {
      matrix = config.matrix;
    }

    /**
     * @access private
     */
    this.values = config.values;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.matrix = matrix;
    /**
     * @access private
     */
    this.isLuxonDuration = true;
  }

  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return Duration.fromObject({ milliseconds: count }, opts);
  }

  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${
          obj === null ? "null" : typeof obj
        }`
      );
    }

    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix,
    });
  }

  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }

  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }

  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }

  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }

    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({ invalid });
    }
  }

  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds",
    }[unit ? unit.toLowerCase() : unit];

    if (!normalized) throw new InvalidUnitError(unit);

    return normalized;
  }

  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o) {
    return (o && o.isLuxonDuration) || false;
  }

  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }

  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }

  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false,
    };
    return this.isValid
      ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt)
      : INVALID$2;
  }

  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID$2;

    const l = orderedUnits$1
      .map((unit) => {
        const val = this.values[unit];
        if (isUndefined(val)) {
          return null;
        }
        return this.loc
          .numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) })
          .format(val);
      })
      .filter((n) => n);

    return this.loc
      .listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts })
      .format(l);
  }

  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid) return {};
    return { ...this.values };
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    // we could use the formatter, but this is an easier way to get the minimum string
    if (!this.isValid) return null;

    let s = "P";
    if (this.years !== 0) s += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s += this.weeks + "W";
    if (this.days !== 0) s += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s += "T";
    if (this.hours !== 0) s += this.hours + "H";
    if (this.minutes !== 0) s += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      // this will handle "floating point madness" by removing extra decimal places
      // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
      s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
    if (s === "P") s += "T0S";
    return s;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;

    const millis = this.toMillis();
    if (millis < 0 || millis >= 86400000) return null;

    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
      includeOffset: false,
    };

    const dateTime = DateTime.fromMillis(millis, { zone: "UTC" });
    return dateTime.toISOTime(opts);
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }

  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    if (!this.isValid) return NaN;

    return durationToMillis(this.matrix, this.values);
  }

  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }

  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid) return this;

    const dur = Duration.fromDurationLike(duration),
      result = {};

    for (const k of orderedUnits$1) {
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }

    return clone$1(this, { values: result }, true);
  }

  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid) return this;

    const dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }

  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone$1(this, { values: result }, true);
  }

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }

  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values) {
    if (!this.isValid) return this;

    const mixed = { ...this.values, ...normalizeObject(values, Duration.normalizeUnit) };
    return clone$1(this, { values: mixed });
  }

  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone$1(this, opts);
  }

  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }

  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, { values: vals }, true);
  }

  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, { values: vals }, true);
  }

  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid) return this;

    if (units.length === 0) {
      return this;
    }

    units = units.map((u) => Duration.normalizeUnit(u));

    const built = {},
      accumulated = {},
      vals = this.toObject();
    let lastUnit;

    for (const k of orderedUnits$1) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;

        let own = 0;

        // anything we haven't boiled down yet should get boiled to this unit
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }

        // plus anything that's already in this unit
        if (isNumber(vals[k])) {
          own += vals[k];
        }

        // only keep the integer part for now in the hopes of putting any decimal part
        // into a smaller unit later
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1000 - i * 1000) / 1000;

        // otherwise, keep it in the wings to boil it later
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }

    // anything leftover becomes the decimal for the last unit
    // lastUnit must be defined since units is not empty
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] +=
          key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }

    normalizeValues(this.matrix, built);
    return clone$1(this, { values: built }, true);
  }

  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }

  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone$1(this, { values: negated }, true);
  }

  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }

  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }

  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }

  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }

  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }

  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }

  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }

  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }

  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }

  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }

  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    if (!this.loc.equals(other.loc)) {
      return false;
    }

    function eq(v1, v2) {
      // Consider 0 and undefined as equal
      if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
      return v1 === v2;
    }

    for (const u of orderedUnits$1) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
}

const INVALID$1 = "Invalid Interval";

// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}

/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */
class Interval {
  /**
   * @private
   */
  constructor(config) {
    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */
    this.e = config.end;
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.isLuxonInterval = true;
  }

  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }

    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({ invalid });
    }
  }

  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start),
      builtEnd = friendlyDateTime(end);

    const validateError = validateStartEnd(builtStart, builtEnd);

    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd,
      });
    } else {
      return validateError;
    }
  }

  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }

  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }

  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s, e] = (text || "").split("/", 2);
    if (s && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s, opts);
        startIsValid = start.isValid;
      } catch (e) {
        startIsValid = false;
      }

      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e) {
        endIsValid = false;
      }

      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }

      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s, opts);
        if (dur.isValid) {
          return Interval.before(end, dur);
        }
      }
    }
    return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }

  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o) {
    return (o && o.isLuxonInterval) || false;
  }

  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }

  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }

  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }

  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }

  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts?.useLocaleWeeks) {
      end = this.end.reconfigure({ locale: start.locale });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }

  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }

  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }

  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }

  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }

  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }

  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }

  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes
        .map(friendlyDateTime)
        .filter((d) => this.contains(d))
        .sort((a, b) => a.toMillis() - b.toMillis()),
      results = [];
    let { s } = this,
      i = 0;

    while (s < this.e) {
      const added = sorted[i] || this.e,
        next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }

    return results;
  }

  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);

    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }

    let { s } = this,
      idx = 1,
      next;

    const results = [];
    while (s < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      idx += 1;
    }

    return results;
  }

  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }

  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }

  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }

  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }

  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }

  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    return this.s.equals(other.s) && this.e.equals(other.e);
  }

  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid) return this;
    const s = this.s > other.s ? this.s : other.s,
      e = this.e < other.e ? this.e : other.e;

    if (s >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  }

  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid) return this;
    const s = this.s < other.s ? this.s : other.s,
      e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  }

  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals
      .sort((a, b) => a.s - b.s)
      .reduce(
        ([sofar, current], item) => {
          if (!current) {
            return [sofar, item];
          } else if (current.overlaps(item) || current.abutsStart(item)) {
            return [sofar, current.union(item)];
          } else {
            return [sofar.concat([current]), item];
          }
        },
        [[], null]
      );
    if (final) {
      found.push(final);
    }
    return found;
  }

  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null,
      currentCount = 0;
    const results = [],
      ends = intervals.map((i) => [
        { time: i.s, type: "s" },
        { time: i.e, type: "e" },
      ]),
      flattened = Array.prototype.concat(...ends),
      arr = flattened.sort((a, b) => a.time - b.time);

    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;

      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }

        start = null;
      }
    }

    return Interval.merge(results);
  }

  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return Interval.xor([this].concat(intervals))
      .map((i) => this.intersection(i))
      .filter((i) => i && !i.isEmpty());
  }

  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid) return INVALID$1;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }

  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid
      ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this)
      : INVALID$1;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }

  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, { separator = " – " } = {}) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }

  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }

  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}

/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */
class Info {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({ month: 12 });

    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }

  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }

  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }

  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }

  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }

  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    // copy the array, because we cache it internally
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }

  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }

  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }

  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }

  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }

  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }

  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }

  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative(), localeWeek: hasLocaleWeekInfo() };
  }
}

function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(),
    ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}

function highOrderDiffs(cursor, later, units) {
  const differs = [
    ["years", (a, b) => b.year - a.year],
    ["quarters", (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4],
    ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - (days % 7)) / 7;
      },
    ],
    ["days", dayDiff],
  ];

  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;

  /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;

      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);

      if (highWater > later) {
        // we overshot the end point, backtrack cursor by 1
        results[unit]--;
        cursor = earlier.plus(results);

        // if we are still overshooting now, we need to backtrack again
        // this happens in certain situations when diffing times in different zones,
        // because this calculation ignores time zones
        if (cursor > later) {
          // keep the "overshot by 1" around as highWater
          highWater = cursor;
          // backtrack cursor by 1
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }

  return [cursor, results, highWater, lowestOrder];
}

function diff (earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);

  const remainingMillis = later - cursor;

  const lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );

  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({ [lowestOrder]: 1 });
    }

    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }

  const duration = Duration.fromObject(results, opts);

  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts)
      .shiftTo(...lowerOrderUnits)
      .plus(duration);
  } else {
    return duration;
  }
}

const numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d",
};

const numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881],
};

const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");

function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);

      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}

function digitRegex({ numberingSystem }, append = "") {
  return new RegExp(`${numberingSystems[numberingSystem || "latn"]}${append}`);
}

const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";

function intUnit(regex, post = (i) => i) {
  return { regex, deser: ([s]) => post(parseDigits(s)) };
}

const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");

function fixListRegex(s) {
  // make dots optional and also make them literal
  // make space and non breakable space characters interchangeable
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}

function stripInsensitivities(s) {
  return s
    .replace(/\./g, "") // ignore dots that were made optional
    .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}

function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s]) =>
        strings.findIndex((i) => stripInsensitivities(s) === stripInsensitivities(i)) + startIndex,
    };
  }
}

function offset(regex, groups) {
  return { regex, deser: ([, h, m]) => signedOffset(h, m), groups };
}

function simple(regex) {
  return { regex, deser: ([s]) => s };
}

function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

/**
 * @param token
 * @param {Locale} loc
 */
function unitForToken(token, loc) {
  const one = digitRegex(loc),
    two = digitRegex(loc, "{2}"),
    three = digitRegex(loc, "{3}"),
    four = digitRegex(loc, "{4}"),
    six = digitRegex(loc, "{6}"),
    oneOrTwo = digitRegex(loc, "{1,2}"),
    oneToThree = digitRegex(loc, "{1,3}"),
    oneToSix = digitRegex(loc, "{1,6}"),
    oneToNine = digitRegex(loc, "{1,9}"),
    twoToFour = digitRegex(loc, "{2,4}"),
    fourToSix = digitRegex(loc, "{4,6}"),
    literal = (t) => ({ regex: RegExp(escapeToken(t.val)), deser: ([s]) => s, literal: true }),
    unitate = (t) => {
      if (token.literal) {
        return literal(t);
      }
      switch (t.val) {
        // era
        case "G":
          return oneOf(loc.eras("short"), 0);
        case "GG":
          return oneOf(loc.eras("long"), 0);
        // years
        case "y":
          return intUnit(oneToSix);
        case "yy":
          return intUnit(twoToFour, untruncateYear);
        case "yyyy":
          return intUnit(four);
        case "yyyyy":
          return intUnit(fourToSix);
        case "yyyyyy":
          return intUnit(six);
        // months
        case "M":
          return intUnit(oneOrTwo);
        case "MM":
          return intUnit(two);
        case "MMM":
          return oneOf(loc.months("short", true), 1);
        case "MMMM":
          return oneOf(loc.months("long", true), 1);
        case "L":
          return intUnit(oneOrTwo);
        case "LL":
          return intUnit(two);
        case "LLL":
          return oneOf(loc.months("short", false), 1);
        case "LLLL":
          return oneOf(loc.months("long", false), 1);
        // dates
        case "d":
          return intUnit(oneOrTwo);
        case "dd":
          return intUnit(two);
        // ordinals
        case "o":
          return intUnit(oneToThree);
        case "ooo":
          return intUnit(three);
        // time
        case "HH":
          return intUnit(two);
        case "H":
          return intUnit(oneOrTwo);
        case "hh":
          return intUnit(two);
        case "h":
          return intUnit(oneOrTwo);
        case "mm":
          return intUnit(two);
        case "m":
          return intUnit(oneOrTwo);
        case "q":
          return intUnit(oneOrTwo);
        case "qq":
          return intUnit(two);
        case "s":
          return intUnit(oneOrTwo);
        case "ss":
          return intUnit(two);
        case "S":
          return intUnit(oneToThree);
        case "SSS":
          return intUnit(three);
        case "u":
          return simple(oneToNine);
        case "uu":
          return simple(oneOrTwo);
        case "uuu":
          return intUnit(one);
        // meridiem
        case "a":
          return oneOf(loc.meridiems(), 0);
        // weekYear (k)
        case "kkkk":
          return intUnit(four);
        case "kk":
          return intUnit(twoToFour, untruncateYear);
        // weekNumber (W)
        case "W":
          return intUnit(oneOrTwo);
        case "WW":
          return intUnit(two);
        // weekdays
        case "E":
        case "c":
          return intUnit(one);
        case "EEE":
          return oneOf(loc.weekdays("short", false), 1);
        case "EEEE":
          return oneOf(loc.weekdays("long", false), 1);
        case "ccc":
          return oneOf(loc.weekdays("short", true), 1);
        case "cccc":
          return oneOf(loc.weekdays("long", true), 1);
        // offset/zone
        case "Z":
        case "ZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
        case "ZZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
        // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
        // because we don't have any way to figure out what they are
        case "z":
          return simple(/[a-z_+-/]{1,256}?/i);
        // this special-case "token" represents a place where a macro-token expanded into a white-space literal
        // in this case we accept any non-newline white-space
        case " ":
          return simple(/[^\S\n\r]/);
        default:
          return literal(t);
      }
    };

  const unit = unitate(token) || {
    invalidReason: MISSING_FTP,
  };

  unit.token = token;

  return unit;
}

const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy",
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM",
  },
  day: {
    numeric: "d",
    "2-digit": "dd",
  },
  weekday: {
    short: "EEE",
    long: "EEEE",
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh",
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH",
  },
  minute: {
    numeric: "m",
    "2-digit": "mm",
  },
  second: {
    numeric: "s",
    "2-digit": "ss",
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ",
  },
};

function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;

  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value,
    };
  }

  const style = formatOpts[type];

  // The user might have explicitly specified hour12 or hourCycle
  // if so, respect their decision
  // if not, refer back to the resolvedOpts, which are based on the locale
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      // tokens only differentiate between 24 hours or not,
      // so we do not need to check hourCycle here, which is less supported anyways
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }

  if (val) {
    return {
      literal: false,
      val,
    };
  }

  return undefined;
}

function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [`^${re}$`, units];
}

function match(input, regex, handlers) {
  const matches = input.match(regex);

  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h = handlers[i],
          groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}

function dateTimeFromMatches(matches) {
  const toField = (token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };

  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }

  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }

  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }

  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }

  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }

  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }

  const vals = Object.keys(matches).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches[k];
    }

    return r;
  }, {});

  return [vals, zone, specificOffset];
}

let dummyDateTimeCache = null;

function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }

  return dummyDateTimeCache;
}

function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }

  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);

  if (tokens == null || tokens.includes(undefined)) {
    return token;
  }

  return tokens;
}

function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}

/**
 * @private
 */

function explainFromTokens(locale, input, format) {
  const tokens = expandMacroTokens(Formatter.parseFormat(format), locale),
    units = tokens.map((t) => unitForToken(t, locale)),
    disqualifyingUnit = units.find((t) => t.invalidReason);

  if (disqualifyingUnit) {
    return { input, tokens, invalidReason: disqualifyingUnit.invalidReason };
  } else {
    const [regexString, handlers] = buildRegex(units),
      regex = RegExp(regexString, "i"),
      [rawMatches, matches] = match(input, regex, handlers),
      [result, zone, specificOffset] = matches
        ? dateTimeFromMatches(matches)
        : [null, null, undefined];
    if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
      throw new ConflictingSpecificationError(
        "Can't include meridiem when specifying 24-hour format"
      );
    }
    return { input, tokens, regex, rawMatches, matches, result, zone, specificOffset };
  }
}

function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}

function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }

  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}

const INVALID = "Invalid DateTime";
const MAX_DATE = 8.64e15;

function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}

// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}

/**
 * @param {DateTime} dt
 */
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(
      dt.c,
      dt.loc.getMinDaysInFirstWeek(),
      dt.loc.getStartOfWeek()
    );
  }
  return dt.localWeekData;
}

// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function clone(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid,
  };
  return new DateTime({ ...current, ...alts, old: current });
}

// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  let utcGuess = localTS - o * 60 * 1000;

  // Test whether the zone matches the offset for this ts
  const o2 = tz.offset(utcGuess);

  // If so, offset didn't change and we're done
  if (o === o2) {
    return [utcGuess, o];
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= (o2 - o) * 60 * 1000;

  // If that gives us the local time we want, we're done
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }

  // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
}

// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;

  const d = new Date(ts);

  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds(),
  };
}

// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
}

// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
  const oPre = inst.o,
    year = inst.c.year + Math.trunc(dur.years),
    month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
    c = {
      ...inst.c,
      year,
      month,
      day:
        Math.min(inst.c.day, daysInMonth(year, month)) +
        Math.trunc(dur.days) +
        Math.trunc(dur.weeks) * 7,
    },
    millisToAdd = Duration.fromObject({
      years: dur.years - Math.trunc(dur.years),
      quarters: dur.quarters - Math.trunc(dur.quarters),
      months: dur.months - Math.trunc(dur.months),
      weeks: dur.weeks - Math.trunc(dur.weeks),
      days: dur.days - Math.trunc(dur.days),
      hours: dur.hours,
      minutes: dur.minutes,
      seconds: dur.seconds,
      milliseconds: dur.milliseconds,
    }).as("milliseconds"),
    localTS = objToLocalTS(c);

  let [ts, o] = fixOffset(localTS, oPre, inst.zone);

  if (millisToAdd !== 0) {
    ts += millisToAdd;
    // that could have changed the offset by going over a DST, but we want to keep the ts the same
    o = inst.zone.offset(ts);
  }

  return { ts, o };
}

// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if ((parsed && Object.keys(parsed).length !== 0) || parsedZone) {
    const interpretationZone = parsedZone || zone,
      inst = DateTime.fromObject(parsed, {
        ...opts,
        zone: interpretationZone,
        specificOffset,
      });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}

// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid
    ? Formatter.create(Locale.create("en-US"), {
        allowZ,
        forceSimple: true,
      }).formatDateTimeFromString(dt, format)
    : null;
}

function toISODate(o, extended) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);

  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    c += "-";
    c += padStart(o.c.day);
  } else {
    c += padStart(o.c.month);
    c += padStart(o.c.day);
  }
  return c;
}

function toISOTime(
  o,
  extended,
  suppressSeconds,
  suppressMilliseconds,
  includeOffset,
  extendedZone
) {
  let c = padStart(o.c.hour);
  if (extended) {
    c += ":";
    c += padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
      c += ":";
    }
  } else {
    c += padStart(o.c.minute);
  }

  if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
    c += padStart(o.c.second);

    if (o.c.millisecond !== 0 || !suppressMilliseconds) {
      c += ".";
      c += padStart(o.c.millisecond, 3);
    }
  }

  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }

  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}

// defaults for unspecified units in the supported calendars
const defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  };

// Units in the supported calendars, sorted by bigness
const orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
  orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond",
  ],
  orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];

// standardize case and plurality in units
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal",
  }[unit.toLowerCase()];

  if (!normalized) throw new InvalidUnitError(unit);

  return normalized;
}

function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}

// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone),
    loc = Locale.fromObject(opts),
    tsNow = Settings.now();

  let ts, o;

  // assume we have the higher-order units
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }

    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }

    const offsetProvis = zone.offset(tsNow);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = tsNow;
  }

  return new DateTime({ ts, zone, loc, o });
}

function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round,
    format = (c, unit) => {
      c = roundTo(c, round || opts.calendary ? 0 : 2, true);
      const formatter = end.loc.clone(opts).relFormatter(opts);
      return formatter.format(c, unit);
    },
    differ = (unit) => {
      if (opts.calendary) {
        if (!end.hasSame(start, unit)) {
          return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
        } else return 0;
      } else {
        return end.diff(start, unit).get(unit);
      }
    };

  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }

  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}

function lastOpts(argList) {
  let opts = {},
    args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}

/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */
class DateTime {
  /**
   * @access private
   */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;

    let invalid =
      config.invalid ||
      (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) ||
      (!zone.isValid ? unsupportedZone(zone) : null);
    /**
     * @access private
     */
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;

    let c = null,
      o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);

      if (unchanged) {
        [c, o] = [config.old.c, config.old.o];
      } else {
        const ot = zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }

    /**
     * @access private
     */
    this._zone = zone;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.invalid = invalid;
    /**
     * @access private
     */
    this.weekData = null;
    /**
     * @access private
     */
    this.localWeekData = null;
    /**
     * @access private
     */
    this.c = c;
    /**
     * @access private
     */
    this.o = o;
    /**
     * @access private
     */
    this.isLuxonDateTime = true;
  }

  // CONSTRUCT

  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime({});
  }

  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }

  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;

    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }

  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options = {}) {
    const ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }

    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    return new DateTime({
      ts: ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options),
    });
  }

  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options),
      });
    }
  }

  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1000,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options),
      });
    }
  }

  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);

    const tsNow = Settings.now(),
      offsetProvis = !isUndefined(opts.specificOffset)
        ? opts.specificOffset
        : zoneToUse.offset(tsNow),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    // cases:
    // just a weekday -> this week's instance of that weekday, no worries
    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
    // (gregorian month or day) + ordinal -> error
    // otherwise just use weeks or ordinals or gregorian, depending on what's specified

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    const useWeekData = definiteWeekDef || (normalized.weekday && !containsGregor);

    // configure ourselves to deal with gregorian dates or week stuff
    let units,
      defaultValues,
      objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }

    // set default values for missing stuff
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }

    // make sure the values we have are in range
    const higherOrderInvalid = useWeekData
        ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek)
        : containsOrdinal
        ? hasInvalidOrdinalData(normalized)
        : hasInvalidGregorianData(normalized),
      invalid = higherOrderInvalid || hasInvalidTimeData(normalized);

    if (invalid) {
      return DateTime.invalid(invalid);
    }

    // compute the actual time
    const gregorian = useWeekData
        ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek)
        : containsOrdinal
        ? ordinalToGregorian(normalized)
        : normalized,
      [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse),
      inst = new DateTime({
        ts: tsFinal,
        zone: zoneToUse,
        o: offsetFinal,
        loc,
      });

    // gregorian data + weekday serves only to validate
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }

    return inst;
  }

  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }

  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }

  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }

  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }

    const { locale = null, numberingSystem = null } = opts,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      }),
      [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }

  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return DateTime.fromFormat(text, fmt, opts);
  }

  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }

  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }

    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({ invalid });
    }
  }

  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o) {
    return (o && o.isLuxonDateTime) || false;
  }

  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => (t ? t.val : null)).join("");
  }

  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }

  // INFO

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }

  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }

  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }

  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }

  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }

  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }

  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }

  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }

  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }

  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }

  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }

  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }

  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }

  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }

  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }

  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }

  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }

  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }

  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }

  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }

  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }

  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }

  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }

  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }

  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }

  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }

  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }

  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }

  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale,
      });
    } else {
      return null;
    }
  }

  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale,
      });
    } else {
      return null;
    }
  }

  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }

  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return (
        this.offset > this.set({ month: 1, day: 1 }).offset ||
        this.offset > this.set({ month: 5 }).offset
      );
    }
  }

  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    const dayMs = 86400000;
    const minuteMs = 60000;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);

    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (
      c1.hour === c2.hour &&
      c1.minute === c2.minute &&
      c1.second === c2.second &&
      c1.millisecond === c2.millisecond
    ) {
      return [clone(this, { ts: ts1 }), clone(this, { ts: ts2 })];
    }
    return [this];
  }

  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }

  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }

  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }

  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }

  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid
      ? weeksInWeekYear(
          this.localWeekYear,
          this.loc.getMinDaysInFirstWeek(),
          this.loc.getStartOfWeek()
        )
      : NaN;
  }

  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }

  // TRANSFORM

  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset), opts);
  }

  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }

  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone(this, { ts: newTS, zone });
    }
  }

  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone(this, { loc });
  }

  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }

  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values) {
    if (!this.isValid) return this;

    const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);

    const settingWeekStuff =
        !isUndefined(normalized.weekYear) ||
        !isUndefined(normalized.weekNumber) ||
        !isUndefined(normalized.weekday),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(
        { ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), ...normalized },
        minDaysInFirstWeek,
        startOfWeek
      );
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };

      // if we didn't set the day but we ended up on an overflow date,
      // use the last day of the right month
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }

    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone(this, { ts, o });
  }

  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return clone(this, adjustTime(this, dur));
  }

  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone(this, adjustTime(this, dur));
  }

  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;

    const o = {},
      normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
      // no default, invalid units throw in normalizeUnit()
    }

    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }

    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }

    return this.set(o);
  }

  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit, opts) {
    return this.isValid
      ? this.plus({ [unit]: 1 })
          .startOf(unit, opts)
          .minus(1)
      : this;
  }

  // OUTPUT

  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt)
      : INVALID;
  }

  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this)
      : INVALID;
  }

  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this)
      : [];
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false,
  } = {}) {
    if (!this.isValid) {
      return null;
    }

    const ext = format === "extended";

    let c = toISODate(this, ext);
    c += "T";
    c += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }

    return toISODate(this, format === "extended");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended",
  } = {}) {
    if (!this.isValid) {
      return null;
    }

    let c = includePrefix ? "T" : "";
    return (
      c +
      toISOTime(
        this,
        format === "extended",
        suppressSeconds,
        suppressMilliseconds,
        includeOffset,
        extendedZone
      )
    );
  }

  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";

    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }

    return toTechFormat(this, fmt, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }

    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }

  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }

  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }

  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }

  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1000 : NaN;
  }

  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1000) : NaN;
  }

  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }

  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }

  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid) return {};

    const base = { ...this.c };

    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }

  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }

  // COMPARE

  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }

    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };

    const units = maybeArray(unit).map(Duration.normalizeUnit),
      otherIsLater = otherDateTime.valueOf() > this.valueOf(),
      earlier = otherIsLater ? this : otherDateTime,
      later = otherIsLater ? otherDateTime : this,
      diffed = diff(earlier, later, units, durOpts);

    return otherIsLater ? diffed.negate() : diffed;
  }

  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime.now(), unit, opts);
  }

  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }

  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;

    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return (
      adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts)
    );
  }

  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return (
      this.isValid &&
      other.isValid &&
      this.valueOf() === other.valueOf() &&
      this.zone.equals(other.zone) &&
      this.loc.equals(other.loc)
    );
  }

  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || DateTime.fromObject({}, { zone: this.zone }),
      padding = options.padding ? (this < base ? -options.padding : options.padding) : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = undefined;
    }
    return diffRelative(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit,
    });
  }

  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;

    return diffRelative(options.base || DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true,
    });
  }

  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }

  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }

  // MISC

  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      });
    return explainFromTokens(localeToUse, text, fmt);
  }

  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime.fromFormatExplain(text, fmt, options);
  }

  // FORMAT PRESETS

  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }

  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
}

/**
 * @private
 */
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}

const NEW_LINE = /\r\n|\n|\r/;
const EVENT = 'VEVENT';
const EVENT_START = 'BEGIN';
const EVENT_END = 'END';
const START_DATE = 'DTSTART';
const END_DATE = 'DTEND';
const DESCRIPTION = 'DESCRIPTION';
const SUMMARY = 'SUMMARY';
const LOCATION = 'LOCATION';
const ALARM = 'VALARM';
const TZID = 'TZID';
const TZOFFSETFROM = 'TZOFFSETFROM';
const TZOFFSETTO = 'TZOFFSETTO';
const keyMap = {
    [START_DATE]: 'startDate',
    [END_DATE]: 'endDate',
    [DESCRIPTION]: 'description',
    [SUMMARY]: 'summary',
    [LOCATION]: 'location',
    [TZID]: 'tzid',
    [TZOFFSETFROM]: 'tzOffsetFrom',
    [TZOFFSETTO]: 'tzOffsetTo',
};
const clean = (string) => unescape(string).trim();
const icsToJson = (icsData) => {
    var _a;
    const array = [];
    let currentObj = {};
    let timeZoneObj = {};
    let lastKey = '';
    const lines = icsData.split(NEW_LINE);
    let isAlarm = false;
    for (let i = 0, iLen = lines.length; i < iLen; ++i) {
        const line = lines[i];
        const lineData = line.split(':');
        let key = lineData[0];
        const value = lineData[1];
        let kyParts = [];
        if (key.indexOf(';') !== -1) {
            const keyParts = key.split(';');
            key = keyParts[0];
            kyParts = keyParts;
            // Maybe do something with that second part later
        }
        if (lineData.length < 2) {
            if (key.startsWith(' ') && lastKey !== undefined && lastKey.length) {
                currentObj[lastKey] += clean(line.substr(1));
            }
            continue;
        }
        else {
            lastKey = keyMap[key];
        }
        switch (key) {
            case EVENT_START:
                if (value === EVENT) {
                    currentObj = { ...timeZoneObj };
                }
                else if (value === ALARM) {
                    isAlarm = true;
                }
                break;
            case EVENT_END:
                isAlarm = false;
                if (value === EVENT) {
                    timeZoneObj = {};
                    array.push(currentObj);
                }
                break;
            case START_DATE:
                if (kyParts.length > 1) {
                    let tzid = (_a = kyParts[1]) === null || _a === void 0 ? void 0 : _a.split('=');
                    if (tzid.length > 1)
                        currentObj[keyMap[TZID]] = tzid[1];
                }
                currentObj[keyMap[START_DATE]] = value;
                break;
            case END_DATE:
                currentObj[keyMap[END_DATE]] = value;
                break;
            case DESCRIPTION:
                if (!isAlarm)
                    currentObj[keyMap[DESCRIPTION]] = clean(value);
                break;
            case SUMMARY:
                currentObj[keyMap[SUMMARY]] = clean(value);
                break;
            case LOCATION:
                currentObj[keyMap[LOCATION]] = clean(value);
                break;
            case TZID:
                timeZoneObj[keyMap[TZID]] = value;
                break;
            case TZOFFSETFROM:
                timeZoneObj[keyMap[TZOFFSETFROM]] = value;
                break;
            case TZOFFSETTO:
                timeZoneObj[keyMap[TZOFFSETTO]] = value;
                break;
            default:
                continue;
        }
    }
    return array;
};

class SchedulerMessageUtils {
    constructor() {
        this.dateFormats = {
            date: "yyyy-MM-dd",
            time: "HHmm",
        };
        this.tempQuickSelectAvailablityObsj = {};
        this.availabilityObject = {};
        this.tempQuickSelectAvailablityObj = {};
        this.quickSelectAvailablityObj = {};
        this.getDaysInRange = ({ startDate, endDate }) => {
            startDate = new Date(startDate);
            endDate = new Date(endDate);
            let currentDate = new Date(startDate);
            let dayArray = [];
            const days = [
                "sunday",
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
            ];
            while (currentDate <= endDate) {
                dayArray.push({
                    day: days[currentDate.getDay()],
                    date: this.getFormatedDateString({
                        date: currentDate,
                        format: this.dateFormats.date,
                    }),
                });
                currentDate.setDate(currentDate.getDate() + 1);
            }
            return dayArray;
        };
        this.addMinutes = (time, minutes) => {
            // create a new date object
            const date = new Date();
            // split the time string into hours and minutes
            const parts = time.split(":");
            // set the time on the date object
            date.setHours(+parts[0]);
            date.setMinutes(+parts[1]);
            // add the minutes
            date.setMinutes(date.getMinutes() + minutes);
            // format and return the new time
            return `${date
                .getHours()
                .toString()
                .padStart(2, "0")}${date.getMinutes().toString().padStart(2, "0")}`;
        };
        this.convertToATimeZone = (time, timeZone, formats, usingFunc, fromFormat) => {
            if (usingFunc === "fromMillis" && typeof time === "number") {
                let timeZoneTime = DateTime.fromMillis(time, { zone: timeZone });
                let localTime = timeZoneTime.setZone();
                return localTime.toFormat(formats);
            }
            if (usingFunc === "fromFormat" && typeof time === "string") {
                let timeZoneTime = DateTime.fromFormat(time, fromFormat || "", {
                    zone: timeZone,
                });
                let localTime = timeZoneTime.setZone();
                return localTime.toFormat(formats);
            }
            return "";
        };
        this.getDayFomDate = (date) => {
            let day = DateTime.fromFormat(date, "yyyy-MM-dd").toFormat("EEEE");
            return day;
        };
        this.getConvertedAvailablityObjectForDate = (date, day, availabilityObj, newObj, timeZone = "Asia/Kolkata") => {
            var _a;
            let newAvailabilityObj = availabilityObj;
            if (!newAvailabilityObj || !newAvailabilityObj)
                return;
            (_a = newAvailabilityObj[day.toLowerCase()]) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
                let from = this.convertToATimeZone(`${date} ${item.from}`, timeZone, "yyyy-MM-dd HHmm", "fromFormat", "yyyy-MM-dd HHmm").split(" ");
                let startDate = from[0];
                let startTime = from[1];
                let to = this.convertToATimeZone(`${date} ${item.to}`, timeZone, "yyyy-MM-dd HHmm", "fromFormat", "yyyy-MM-dd HHmm").split(" ");
                let endDate = to[0];
                let endTime = to[1];
                if (endTime !== "2359" && (endTime === null || endTime === void 0 ? void 0 : endTime.slice(-1)) === "9") {
                    endTime = this.addMinutes(`${endTime.slice(0, 2)}:${endTime.slice(2)}`, 1);
                }
                if (startDate === endDate) {
                    if (newObj[startDate]) {
                        newObj[startDate] = {
                            day: this.getDayFomDate(startDate),
                            date: startDate,
                            availability: [
                                ...newObj[startDate]["availability"],
                                { from: startTime, to: endTime },
                            ],
                        };
                    }
                    else {
                        newObj[startDate] = {
                            day: this.getDayFomDate(startDate),
                            date: startDate,
                            availability: [{ from: startTime, to: endTime }],
                        };
                    }
                }
                else {
                    if (newObj[startDate]) {
                        newObj[startDate] = {
                            day: this.getDayFomDate(startDate),
                            date: startDate,
                            availability: [
                                ...newObj[startDate]["availability"],
                                { from: startTime, to: "2359" },
                            ],
                        };
                    }
                    else {
                        newObj[startDate] = {
                            day: this.getDayFomDate(startDate),
                            date: startDate,
                            availability: [{ from: startTime, to: "2359" }],
                        };
                    }
                    if (newObj[endDate]) {
                        newObj[endDate] = {
                            day: this.getDayFomDate(endDate),
                            date: endDate,
                            availability: [
                                ...newObj[endDate]["availability"],
                                { from: "0000", to: endTime },
                            ],
                        };
                    }
                    else {
                        newObj[endDate] = {
                            day: this.getDayFomDate(endDate),
                            date: endDate,
                            availability: [{ from: "0000", to: endTime }],
                        };
                    }
                }
            });
        };
        this.getInitialAvailableDays = async ({ date, availability, timeZoneCode, blockedTime, bufferTime, duration, quickSlotDate }) => {
            // Convert the date to a Date object and calculate the previous and next dates
            let targetDate = new Date(date);
            let prevDate = new Date(targetDate);
            prevDate.setDate(targetDate.getDate() - 1);
            let nextDate = new Date(targetDate);
            nextDate.setDate(targetDate.getDate() + 1);
            // get dates and days which are in range
            // Format the dates back to 'yyyy-mm-dd' format
            let startDate = this.formatDate(prevDate);
            let rangeEndDate = new Date(targetDate);
            rangeEndDate.setDate(targetDate.getDate() + 10);
            // assign the meeting availablity range as per weekday
            let alldays = this.getDaysInRange({ startDate, endDate: this.formatDate(rangeEndDate) });
            let availabilityObj = {};
            alldays.forEach((item) => {
                let finalObj = {
                    ...item,
                    availability: availability[item.day],
                    date: item.date,
                    timeZoneCode,
                };
                if (availability[item.day]) {
                    availabilityObj[item.date] = finalObj;
                }
            });
            let newAvailabilityObj = { ...availabilityObj };
            let newObj = {};
            Object.entries(newAvailabilityObj).forEach(([key, value]) => {
                value.availability.forEach((item, i) => {
                    let from = this.convertToATimeZone(`${value.date} ${item.from}`, value.timeZoneCode, "yyyy-MM-dd HHmm", "fromFormat", "yyyy-MM-dd HHmm").split(" ");
                    let startDate = from[0];
                    let startTime = from[1];
                    let to = this.convertToATimeZone(`${value.date} ${item.to}`, value.timeZoneCode, "yyyy-MM-dd HHmm", "fromFormat", "yyyy-MM-dd HHmm").split(" ");
                    let endDate = to[0];
                    let endTime = to[1];
                    if (startDate === endDate) {
                        if (newObj[startDate]) {
                            newObj[startDate] = {
                                day: this.getDayFomDate(startDate),
                                date: startDate,
                                availability: [
                                    ...newObj[startDate]["availability"],
                                    { from: startTime, to: endTime },
                                ],
                            };
                        }
                        else {
                            newObj[startDate] = {
                                day: this.getDayFomDate(startDate),
                                date: startDate,
                                availability: [{ from: startTime, to: endTime }],
                            };
                        }
                    }
                    else {
                        if (newObj[startDate]) {
                            newObj[startDate] = {
                                day: this.getDayFomDate(startDate),
                                date: startDate,
                                availability: [
                                    ...newObj[startDate]["availability"],
                                    { from: startTime, to: "2359" },
                                ],
                            };
                        }
                        else {
                            newObj[startDate] = {
                                day: this.getDayFomDate(startDate),
                                date: startDate,
                                availability: [{ from: startTime, to: "2359" }],
                            };
                        }
                        if (newObj[endDate]) {
                            newObj[endDate] = {
                                day: this.getDayFomDate(endDate),
                                date: endDate,
                                availability: [
                                    ...newObj[endDate]["availability"],
                                    { from: "0000", to: endTime },
                                ],
                            };
                        }
                        else {
                            newObj[endDate] = {
                                day: this.getDayFomDate(endDate),
                                date: endDate,
                                availability: [{ from: "0000", to: endTime }],
                            };
                        }
                    }
                });
            });
            let sortedAvailableDates = Object.keys(newObj).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
            this.availabilityObject = newObj;
            let slotDate = sortedAvailableDates[0] || date;
            if (quickSlotDate && sortedAvailableDates.includes(quickSlotDate)) {
                slotDate = quickSlotDate;
            }
            let quickSlots = await this.getQuickSelectSlots(slotDate, blockedTime, newObj, bufferTime, duration);
            return {
                availableSlots: this.availabilityObject,
                quickSlots: quickSlots
            };
        };
        this.combineAvailability = (availability) => {
            if (availability && availability.length) {
                // Sort availability array
                availability.sort((a, b) => a.from.localeCompare(b.from));
                let combinedAvailability = [availability[0]];
                for (let i = 1; i < availability.length; i++) {
                    let prev = combinedAvailability[combinedAvailability.length - 1];
                    let curr = availability[i];
                    if (prev.to === curr.from) {
                        // If the previous 'to' matches with current 'from', combine them
                        prev.to = curr.to;
                    }
                    else {
                        // If not, add the current block to the result
                        combinedAvailability.push(curr);
                    }
                }
                return combinedAvailability;
            }
            return [];
        };
        this.getMeetingSlots = ({ date, availabilityObject, blockedTime, timeFormat, duration, bufferTime }) => {
            return new Promise((resolve, reject) => {
                // const previousDate = new Date(date);
                // previousDate.setDate(previousDate.getDate() - 1);
                // const previousDateStr = previousDate.toISOString().substr(0, 10);
                var _a;
                // // Check if there are any overrunning meetings from the previous day
                // const previousOverruns = blockedTime[previousDateStr]?.filter((item: any) => item.endTime >= "0000") || [];
                // // Check for overrunning meetings for the next day
                // const nextDate = new Date(date);
                // nextDate.setDate(nextDate.getDate() + 1);
                // const nextDateStr = nextDate.toISOString().substr(0, 10);
                // const nextOverruns = blockedTime[nextDateStr]?.filter((item: any) => item.startTime <= "0000") || [];
                // Continue with your existing code...
                let range = [];
                let selectedDateSlots = this.combineAvailability((_a = availabilityObject[date]) === null || _a === void 0 ? void 0 : _a.availability);
                if (selectedDateSlots && (selectedDateSlots === null || selectedDateSlots === void 0 ? void 0 : selectedDateSlots.length) > 0) {
                    selectedDateSlots === null || selectedDateSlots === void 0 ? void 0 : selectedDateSlots.forEach((item) => {
                        var _a;
                        let icsSelectedSlots = (_a = blockedTime[date]) !== null && _a !== void 0 ? _a : [];
                        // let icsSelectedSlots = [...(blockedTime[date] ?? []), ...previousOverruns, ...nextOverruns];
                        let selectedSlots = [];
                        icsSelectedSlots === null || icsSelectedSlots === void 0 ? void 0 : icsSelectedSlots.forEach((item) => {
                            if (item.startDate === item.endDate) {
                                selectedSlots.push({
                                    startTime: item.startTime,
                                    endTime: item.endTime,
                                });
                            }
                            else {
                                // managed if there is a meeting which ends next day
                                selectedSlots.push({
                                    startTime: item.startTime,
                                    endTime: "2359",
                                });
                                if (item.endTime == "0000")
                                    return;
                                if (blockedTime[item.endDate])
                                    blockedTime[item.endDate] = [
                                        ...blockedTime[item.endDate],
                                        {
                                            startDate: item.startDate,
                                            endDate: item.startDate,
                                            startTime: "0000",
                                            endTime: item.endTime,
                                        },
                                    ];
                                else
                                    blockedTime[item.endDate] = [
                                        {
                                            startDate: item.endDate,
                                            endDate: item.endDate,
                                            startTime: "0000",
                                            endTime: item.endTime,
                                        },
                                    ];
                            }
                        });
                        // get slots for a particular range
                        range = [
                            ...range,
                            ...this.getMinSlotsFromRange({
                                startTime: item.from,
                                endTime: item.to,
                                selectedSlots,
                                slotDuration: duration !== null && duration !== void 0 ? duration : 30,
                                bufferDuration: bufferTime !== null && bufferTime !== void 0 ? bufferTime : 0,
                                timeFormat: timeFormat
                            }),
                        ];
                    });
                }
                else {
                    resolve([]);
                }
                resolve(range);
            });
        };
        this.getFormatedDateString = ({ date, format, }) => {
            if (typeof date === "number") {
                return DateTime.fromMillis(date * 1000).toFormat(format);
            }
            if (typeof date === "object") {
                return DateTime.fromISO(date.toISOString()).toFormat(format);
            }
            return "";
        };
        this.convertDate = (dateStr) => {
            const year = dateStr.slice(0, 4);
            const month = dateStr.slice(4, 6);
            const day = dateStr.slice(6, 8);
            const time = dateStr.slice(9);
            return `${year}-${month}-${day}T${time.slice(0, 2)}:${time.slice(2, 4)}:${time.slice(4)}`;
        };
        this.convertToLocalTimeZone = (time, timeZone, formats) => {
            const isoTime = DateTime.fromISO(time, {
                zone: timeZone,
            });
            const utcTime = isoTime.toUTC();
            const timeZoneOffsetInMins = new Date().getTimezoneOffset();
            const localTime = utcTime
                .minus({ minutes: timeZoneOffsetInMins })
                .toFormat(formats);
            return localTime;
        };
        this.getNextFormatedDate = (date, previous = false) => {
            // Convert the date string to a Date object
            let dateObj = new Date(date);
            // Adjust the date
            dateObj.setDate(dateObj.getDate() + (previous ? -1 : 1));
            // Format the date object back to a string and return it
            return dateObj.toISOString().split('T')[0];
        };
        this.getSlotsForADate = async (blockedTime, date, bufferTime, duration, timeFormat = "12Hr", datesAvailability, timezoneCode) => {
            let newObj = {}; // Declare newObj here
            let previousDate = this.getNextFormatedDate(date, true);
            let previousDay = DateTime.fromFormat(previousDate, this.dateFormats.date).toFormat("EEEE");
            this.getConvertedAvailablityObjectForDate(previousDate, previousDay, datesAvailability, newObj, timezoneCode);
            let day = DateTime.fromFormat(date, this.dateFormats.date).toFormat("EEEE");
            this.getConvertedAvailablityObjectForDate(date, day, datesAvailability, newObj, timezoneCode);
            let nextDate = this.getNextFormatedDate(date);
            let nextDay = DateTime.fromFormat(nextDate, this.dateFormats.date).toFormat("EEEE");
            this.getConvertedAvailablityObjectForDate(nextDate, nextDay, datesAvailability, newObj, timezoneCode);
            if (newObj[date]) {
                let availabilityObjWithTimeSlots = { ...newObj };
                let range = await this.getMeetingSlots({
                    date,
                    availabilityObject: availabilityObjWithTimeSlots,
                    blockedTime: blockedTime,
                    bufferTime: bufferTime,
                    duration: duration,
                    timeFormat: timeFormat
                });
                if (range.length) {
                    let lastSlot = range[range.length - 1];
                    let lastSlotMinutes = Number(lastSlot.slice(0, 2)) * 60 + Number(lastSlot.slice(3));
                    if (lastSlotMinutes < 1439 &&
                        lastSlotMinutes + duration * 2 > 1440) {
                        let nextDate = this.getNextFormatedDate(date);
                        let nextRange = await this.getMeetingSlots({
                            date: nextDate,
                            availabilityObject: availabilityObjWithTimeSlots,
                            blockedTime: blockedTime,
                            bufferTime: bufferTime,
                            duration: duration,
                            timeFormat: timeFormat
                        });
                        if (nextRange[0] === "00:00") {
                            let nextSlotInMinutes = lastSlotMinutes + duration + 1;
                            let hours = Math.floor(nextSlotInMinutes / 60);
                            let minutes = (nextSlotInMinutes - 1) % 60;
                            if (hours <= 23)
                                range.push(`${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`);
                        }
                    }
                    availabilityObjWithTimeSlots[date] = {
                        ...availabilityObjWithTimeSlots[date],
                        availability: range,
                    };
                    return availabilityObjWithTimeSlots[date];
                }
                else {
                    return [];
                    //   no slots available
                }
            }
            else {
                return [];
                //   no slots available
            }
        };
        this.getNextQuickSlots = async (date, currentRange, bufferTime, duration, blockedTime) => {
            if (this.tempQuickSelectAvailablityObj[date]) {
                let nextDate = this.getNextFormatedDate(date);
                let nextRange = await this.getMeetingSlots({
                    date: nextDate,
                    availabilityObject: this.tempQuickSelectAvailablityObj,
                    bufferTime,
                    duration,
                    blockedTime
                });
                // Ensure nextRange is an Array
                if (!Array.isArray(nextRange)) {
                    nextRange = [];
                }
                if (!this.tempQuickSelectAvailablityObj[nextDate])
                    return;
                this.tempQuickSelectAvailablityObj[nextDate].availability = nextRange;
                this.quickSelectAvailablityObj[nextDate] = {
                    ...this.quickSelectAvailablityObj[nextDate],
                    ...this.tempQuickSelectAvailablityObj[nextDate],
                };
                const combinedLength = [
                    ...(Array.isArray(currentRange) ? currentRange : []),
                    ...nextRange,
                ].length;
                if (combinedLength < 2) {
                    return await this.getNextQuickSlots(nextDate, nextRange, bufferTime, duration, blockedTime);
                }
                return nextRange;
            }
        };
        this.getQuickSelectSlots = async (date, blockedTime, availabilityObj, bufferTime, duration) => {
            this.tempQuickSelectAvailablityObj = JSON.parse(JSON.stringify(availabilityObj));
            let range = await this.getMeetingSlots({
                date,
                availabilityObject: this.tempQuickSelectAvailablityObj,
                bufferTime, duration,
                blockedTime
            });
            // Ensure range is an Array
            if (!Array.isArray(range)) {
                range = [];
            }
            this.tempQuickSelectAvailablityObsj[date] = this.tempQuickSelectAvailablityObsj[date] || {};
            this.tempQuickSelectAvailablityObsj[date].availability = range;
            this.quickSelectAvailablityObj[date] = {
                ...this.tempQuickSelectAvailablityObj[date],
            };
            this.quickSelectAvailablityObj[date].availability = this.tempQuickSelectAvailablityObsj[date].availability;
            if (range.length < 3)
                await this.getNextQuickSlots(date, range, bufferTime, duration, blockedTime);
            let quickSlotsArray = [];
            if (this.quickSelectAvailablityObj) {
                Object.entries(this.quickSelectAvailablityObj)
                    .filter(([key]) => new Date(key) >= new Date(date))
                    .forEach(([key, value]) => {
                    if (value && (value === null || value === void 0 ? void 0 : value.availability)) {
                        value === null || value === void 0 ? void 0 : value.availability.forEach((item) => {
                            quickSlotsArray.push({
                                availability: item,
                                item: value
                            });
                        });
                    }
                });
            }
            return quickSlotsArray;
        };
    }
    getTimeZoneName() {
        const timezoneCode = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const date = new Date();
        const options = { timeZone: timezoneCode, timeZoneName: 'long' };
        const dateString = new Intl.DateTimeFormat('en', options).format(date);
        // Extract the timezone from the dateString
        const timeZoneName = dateString.split(',').slice(-1)[0];
        return timeZoneName;
    }
    getMinSlotsFromRange({ startTime, endTime, slotDuration = 30, selectedSlots = [], bufferDuration = 0, timeFormat = "12Hr" }) {
        const slots = []; // Array to hold all available slots
        let currentStartMinutes = Number(startTime.slice(0, 2)) * 60 + Number(startTime.slice(2));
        let endMinutesTotal = Number(endTime.slice(0, 2)) * 60 + Number(endTime.slice(2));
        if (endMinutesTotal === 1439)
            endMinutesTotal += 1;
        // Add buffer time if the availability starts immediately after a blocked time
        const prevSlot = selectedSlots.find(slot => Number(slot.endTime.slice(0, 2)) * 60 + Number(slot.endTime.slice(2)) === currentStartMinutes);
        if (prevSlot)
            currentStartMinutes += bufferDuration;
        // Keep generating slots until the end of the availability range
        while (currentStartMinutes + slotDuration <= endMinutesTotal) {
            let conflictSlot = null;
            // Iterate over each selected slot to find a conflict
            for (let i = 0; i < selectedSlots.length; i++) {
                const { startTime: start, endTime: end } = selectedSlots[i];
                const slotStart = Number(start.slice(0, 2)) * 60 + Number(start.slice(2));
                const slotEnd = Number(end.slice(0, 2)) * 60 + Number(end.slice(2));
                let currentEndMinutes = currentStartMinutes + slotDuration;
                // The current slot is within the selected slot or
                // The current slot starts before and ends after the start of the selected slot or
                // The current slot starts before the end of the selected slot but ends after
                if ((currentStartMinutes >= slotStart && currentEndMinutes <= slotEnd) ||
                    (currentStartMinutes < slotStart && currentEndMinutes > slotStart) ||
                    (currentStartMinutes < slotEnd && currentEndMinutes > slotEnd)) {
                    conflictSlot = selectedSlots[i];
                    break;
                }
            }
            // If there is no conflict, add the slot
            if (!conflictSlot) {
                slots.push(this.formatTime(currentStartMinutes, timeFormat));
            }
            else {
                // If a conflict arises, remove the last added slot if it is not possible to add the buffer duration to it without overlapping the selected slot
                if (slots.length &&
                    Number(conflictSlot.startTime.slice(0, 2)) * 60 +
                        Number(conflictSlot.startTime.slice(2)) <
                        Number(slots[slots.length - 1].slice(0, 2)) * 60 +
                            Number(slots[slots.length - 1].slice(3)) +
                            slotDuration +
                            bufferDuration) {
                    slots.pop();
                }
                // Skip to the end of the conflict slot and continue to the next iteration
                currentStartMinutes =
                    Number(conflictSlot.endTime.slice(0, 2)) * 60 +
                        Number(conflictSlot.endTime.slice(2)) +
                        bufferDuration;
                continue;
            }
            // Move to the next slot by adding the slot duration
            currentStartMinutes += slotDuration;
        }
        // Return all available slots
        return slots;
    }
    findLongestMeeting(meetings) {
        const meetingsWithDuration = meetings.map(meeting => ({
            ...meeting,
            startTimeInMinutes: parseInt(meeting.startTime.slice(0, 2)) * 60 + parseInt(meeting.startTime.slice(2)),
            endTimeInMinutes: parseInt(meeting.endTime.slice(0, 2)) * 60 + parseInt(meeting.endTime.slice(2))
        })).sort((a, b) => (b.endTimeInMinutes - b.startTimeInMinutes) - (a.endTimeInMinutes - a.startTimeInMinutes));
        const longestMeeting = meetingsWithDuration[0];
        const filteredMeetings = meetings.filter(meeting => {
            const startTimeInMinutes = parseInt(meeting.startTime.slice(0, 2)) * 60 + parseInt(meeting.startTime.slice(2));
            const endTimeInMinutes = parseInt(meeting.endTime.slice(0, 2)) * 60 + parseInt(meeting.endTime.slice(2));
            return ((startTimeInMinutes < longestMeeting.startTimeInMinutes && endTimeInMinutes <= longestMeeting.startTimeInMinutes) ||
                (startTimeInMinutes >= longestMeeting.endTimeInMinutes && endTimeInMinutes > longestMeeting.endTimeInMinutes));
        });
        return [...filteredMeetings, longestMeeting];
    }
    convertToISOString(timeStr, dateStr) {
        // Split time and modifier from the time string
        let [time, modifier] = timeStr.split(' ');
        // Further split hours and minutes from the time
        let [hours, minutes] = time.split(':');
        let hour = parseInt(hours);
        // Convert hours to 24 hour format
        if (modifier.toLowerCase() === "pm" && hour < 12) {
            hour += 12;
        }
        else if (modifier.toLowerCase() === "am" && hour === 12) {
            hour -= 12;
        }
        // Combine hours and minutes to get 24 hour format time
        let time24Hour = hour.toString().padStart(2, '0') + ':' + minutes;
        // Combine date and time
        const dateTimeStr = `${dateStr}T${time24Hour}:00`;
        // Create a date object from the datetime string
        const dateObj = new Date(dateTimeStr);
        function pad(n) {
            return n < 10 ? '0' + n : n;
        }
        // Manually construct the ISO string using local time components
        const localISOString = dateObj.getFullYear() + '-'
            + pad(dateObj.getMonth() + 1) + '-'
            + pad(dateObj.getDate()) + 'T'
            + pad(dateObj.getHours()) + ':'
            + pad(dateObj.getMinutes());
        return localISOString;
    }
    getCurrentDate() {
        const date = new Date();
        const year = date.getFullYear();
        // JavaScript's getMonth() starts at 0 (0 = January, 1 = February, etc.)
        // so we add 1 to get the correct month number
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    formatTime(minutes, timeFormat) {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        const paddedMinutes = String(mins).padStart(2, '0');
        if (timeFormat === '24Hr') {
            const paddedHours = String(hours).padStart(2, '0');
            return `${paddedHours}:${paddedMinutes}`;
        }
        else { // 12Hr format
            const period = hours >= 12 ? 'PM' : 'AM';
            const adjustedHours = hours % 12 || 12; // Convert 0 (midnight) to 12 and adjust other hours
            const paddedAdjustedHours = String(adjustedHours).padStart(2, '0');
            return `${paddedAdjustedHours}:${paddedMinutes} ${period}`;
        }
    }
    formatDate(date) {
        let month = '' + (date.getMonth() + 1), day = '' + date.getDate(), year = date.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        return [year, month, day].join('-');
    }
    toEpoch(time, date) {
        // Remove any whitespace or periods from the time string
        time = time.replace(/\s/g, "").replace(".", "");
        // If the time string contains "pm", convert to 24 hour format
        if (time.toLowerCase().includes("pm")) {
            let [hours, minutes] = time.toLowerCase().replace("pm", "").split(":");
            hours = parseInt(hours) + 12 === 24 ? '00' : parseInt(hours) + 12; // convert 12pm to 12, others to 13-23
            time = `${hours}:${minutes}`;
        }
        else if (time.toLowerCase().includes("am")) {
            time = time.toLowerCase().replace("am", "");
        }
        // Combine the date and time strings and convert to a Date object
        let dateTimeStr = `${date}T${time}:00`;
        let dateObj = new Date(dateTimeStr);
        // Convert the Date object to epoch time
        let epoch = dateObj.getTime();
        return epoch;
    }
}

var timerIcon = "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2217%22%20viewBox%3D%220%200%2016%2017%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M1%208.5C1%2010.3565%201.7375%2012.137%203.05025%2013.4497C4.36301%2014.7625%206.14348%2015.5%208%2015.5C9.85652%2015.5%2011.637%2014.7625%2012.9497%2013.4497C14.2625%2012.137%2015%2010.3565%2015%208.5C15%206.64348%2014.2625%204.86301%2012.9497%203.55025C11.637%202.2375%209.85652%201.5%208%201.5C6.14348%201.5%204.36301%202.2375%203.05025%203.55025C1.7375%204.86301%201%206.64348%201%208.5Z%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.27273%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8%208.50043V6.01074%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.27273%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8%208.5L11.1118%2011.6124%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.27273%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var calenderIcon = "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2217%22%20viewBox%3D%220%200%2016%2017%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_6620_62830%29%22%3E%3Cpath%20d%3D%22M14.0938%203.34375H1.90625C1.65761%203.34375%201.41915%203.44252%201.24334%203.61834C1.06752%203.79415%200.96875%204.03261%200.96875%204.28125V14.5938C0.96875%2014.8424%201.06752%2015.0808%201.24334%2015.2567C1.41915%2015.4325%201.65761%2015.5313%201.90625%2015.5313H14.0938C14.3424%2015.5313%2014.5808%2015.4325%2014.7567%2015.2567C14.9325%2015.0808%2015.0313%2014.8424%2015.0313%2014.5938V4.28125C15.0313%204.03261%2014.9325%203.79415%2014.7567%203.61834C14.5808%203.44252%2014.3424%203.34375%2014.0938%203.34375Z%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M0.96875%207.09375H15.0313%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.71875%204.75V1.46875%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.2812%204.75V1.46875%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.01563%209.90625C3.95346%209.90625%203.89385%209.88156%203.8499%209.8376C3.80594%209.79365%203.78125%209.73404%203.78125%209.67188C3.78125%209.60971%203.80594%209.5501%203.8499%209.50615C3.89385%209.46219%203.95346%209.4375%204.01563%209.4375%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M4.01562%209.90625C4.07779%209.90625%204.1374%209.88156%204.18135%209.8376C4.22531%209.79365%204.25%209.73404%204.25%209.67188C4.25%209.60971%204.22531%209.5501%204.18135%209.50615C4.1374%209.46219%204.07779%209.4375%204.01562%209.4375%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M4.01563%2013.1875C3.95346%2013.1875%203.89385%2013.1628%203.8499%2013.1189C3.80594%2013.0749%203.78125%2013.0153%203.78125%2012.9531C3.78125%2012.891%203.80594%2012.8314%203.8499%2012.7874C3.89385%2012.7434%203.95346%2012.7188%204.01563%2012.7188%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M4.01562%2013.1875C4.07779%2013.1875%204.1374%2013.1628%204.18135%2013.1189C4.22531%2013.0749%204.25%2013.0153%204.25%2012.9531C4.25%2012.891%204.22531%2012.8314%204.18135%2012.7874C4.1374%2012.7434%204.07779%2012.7188%204.01562%2012.7188%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M8%209.90625C7.93784%209.90625%207.87823%209.88156%207.83427%209.8376C7.79032%209.79365%207.76562%209.73404%207.76562%209.67188C7.76562%209.60971%207.79032%209.5501%207.83427%209.50615C7.87823%209.46219%207.93784%209.4375%208%209.4375%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M8%209.90625C8.06216%209.90625%208.12177%209.88156%208.16573%209.8376C8.20968%209.79365%208.23438%209.73404%208.23438%209.67188C8.23438%209.60971%208.20968%209.5501%208.16573%209.50615C8.12177%209.46219%208.06216%209.4375%208%209.4375%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M8%2013.1875C7.93784%2013.1875%207.87823%2013.1628%207.83427%2013.1189C7.79032%2013.0749%207.76562%2013.0153%207.76562%2012.9531C7.76562%2012.891%207.79032%2012.8314%207.83427%2012.7874C7.87823%2012.7434%207.93784%2012.7188%208%2012.7188%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M8%2013.1875C8.06216%2013.1875%208.12177%2013.1628%208.16573%2013.1189C8.20968%2013.0749%208.23438%2013.0153%208.23438%2012.9531C8.23438%2012.891%208.20968%2012.8314%208.16573%2012.7874C8.12177%2012.7434%208.06216%2012.7188%208%2012.7188%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M11.9844%209.90625C11.9222%209.90625%2011.8626%209.88156%2011.8186%209.8376C11.7747%209.79365%2011.75%209.73404%2011.75%209.67188C11.75%209.60971%2011.7747%209.5501%2011.8186%209.50615C11.8626%209.46219%2011.9222%209.4375%2011.9844%209.4375%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M11.9844%209.90625C12.0465%209.90625%2012.1061%209.88156%2012.1501%209.8376C12.1941%209.79365%2012.2188%209.73404%2012.2188%209.67188C12.2188%209.60971%2012.1941%209.5501%2012.1501%209.50615C12.1061%209.46219%2012.0465%209.4375%2011.9844%209.4375%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M11.9844%2013.1875C11.9222%2013.1875%2011.8626%2013.1628%2011.8186%2013.1189C11.7747%2013.0749%2011.75%2013.0153%2011.75%2012.9531C11.75%2012.891%2011.7747%2012.8314%2011.8186%2012.7874C11.8626%2012.7434%2011.9222%2012.7188%2011.9844%2012.7188%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M11.9844%2013.1875C12.0465%2013.1875%2012.1061%2013.1628%2012.1501%2013.1189C12.1941%2013.0749%2012.2188%2013.0153%2012.2188%2012.9531C12.2188%2012.891%2012.1941%2012.8314%2012.1501%2012.7874C12.1061%2012.7434%2012.0465%2012.7188%2011.9844%2012.7188%22%20stroke%3D%22%23525252%22%20stroke-width%3D%221.2%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_6620_62830%22%3E%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%20transform%3D%22translate%280%200.5%29%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var planetIcon = "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M16%208C16%206.41775%2015.5308%204.87103%2014.6518%203.55544C13.7727%202.23985%2012.5233%201.21447%2011.0615%200.608967C9.59966%200.00346629%207.99113%20-0.15496%206.43928%200.153721C4.88743%200.462403%203.46197%201.22433%202.34315%202.34315C1.22433%203.46197%200.462403%204.88743%200.153721%206.43928C-0.15496%207.99113%200.00346629%209.59966%200.608967%2011.0615C1.21447%2012.5233%202.23985%2013.7727%203.55544%2014.6518C4.87103%2015.5308%206.41775%2016%208%2016H8.08C10.18%2015.9982%2012.1934%2015.1632%2013.6783%2013.6783C15.1632%2012.1934%2015.9982%2010.18%2016%208.08V8ZM14.6667%208C14.6654%208.59255%2014.5847%209.18225%2014.4267%209.75333C14.415%209.79935%2014.3935%209.84228%2014.3635%209.87912C14.3336%209.91596%2014.296%209.94584%2014.2533%209.96667C14.1764%2010.0103%2014.0856%2010.0223%2014%2010C13.5871%209.82223%2013.235%209.52802%2012.9867%209.15333L11.5067%206.93334C11.3542%206.70545%2011.1479%206.51869%2010.906%206.38961C10.6642%206.26053%2010.3942%206.19311%2010.12%206.19334H9.83333C9.34711%206.19334%208.88079%206.00018%208.53697%205.65636C8.19316%205.31255%208%204.84623%208%204.36C8%203.87377%208.19316%203.40746%208.53697%203.06364C8.88079%202.71982%209.34711%202.52667%209.83333%202.52667H11.68C11.7492%202.52522%2011.8171%202.54628%2011.8733%202.58667C12.7355%203.20215%2013.4387%204.01424%2013.9244%204.95564C14.4102%205.89704%2014.6646%206.94066%2014.6667%208ZM1.45334%206.77334C1.46609%206.69623%201.50606%206.62626%201.566%206.57611C1.62593%206.52596%201.70186%206.49895%201.78%206.5H4.66667C4.97168%206.49603%205.27443%206.55294%205.55718%206.66741C5.83993%206.78189%206.09699%206.95162%206.31334%207.16667L7.06667%207.93333C7.48735%208.35423%207.73133%208.91997%207.74867%209.5148C7.76602%2010.1096%207.55544%2010.6886%207.16%2011.1333L6.25334%2012.1533C5.9821%2012.4581%205.83259%2012.852%205.83334%2013.26V13.8133C5.83387%2013.8692%205.82005%2013.9243%205.7932%2013.9733C5.76636%2014.0224%205.72738%2014.0637%205.68%2014.0933C5.63144%2014.1179%205.57777%2014.1308%205.52334%2014.1308C5.4689%2014.1308%205.41523%2014.1179%205.36667%2014.0933C4.17416%2013.5806%203.15727%2012.7309%202.44079%2011.6485C1.72432%2010.5661%201.33942%209.29805%201.33334%208C1.33232%207.58813%201.37252%207.1772%201.45334%206.77334Z%22%20fill%3D%22%23525252%22%2F%3E%3C%2Fsvg%3E";

var EmptySlotIcon$1 = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%20122.88%2099.53%22%20style%3D%22enable-background%3Anew%200%200%20122.88%2099.53%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.st0%7Bfill%3A%23393939%3B%7D%20.st1%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%23D8453E%3B%7D%3C%2Fstyle%3E%3Cg%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M73.11%2C0c6.73%2C0%2C13.16%2C1.34%2C19.03%2C3.77c6.09%2C2.52%2C11.57%2C6.22%2C16.16%2C10.81l0%2C0c4.58%2C4.58%2C8.28%2C10.06%2C10.8%2C16.17%20c2.43%2C5.87%2C3.77%2C12.3%2C3.77%2C19.02c0%2C6.73-1.34%2C13.16-3.77%2C19.03c-2.52%2C6.09-6.22%2C11.57-10.81%2C16.16l0%2C0%20c-4.58%2C4.58-10.06%2C8.28-16.17%2C10.8c-5.87%2C2.43-12.3%2C3.77-19.02%2C3.77c-6.73%2C0-13.16-1.34-19.03-3.77%20c-6.09-2.52-11.57-6.22-16.15-10.8l-0.01-0.01c-4.59-4.59-8.28-10.07-10.8-16.15c-0.78-1.89-1.45-3.83-2-5.82%20c1.04%2C0.1%2C2.1%2C0.15%2C3.17%2C0.15c2.03%2C0%2C4.01-0.18%2C5.94-0.53c0.32%2C0.96%2C0.67%2C1.91%2C1.05%2C2.84c2.07%2C5%2C5.11%2C9.5%2C8.89%2C13.28%20c3.78%2C3.78%2C8.29%2C6.82%2C13.28%2C8.89c4.81%2C1.99%2C10.1%2C3.1%2C15.66%2C3.1c5.56%2C0%2C10.84-1.1%2C15.66-3.1c5-2.07%2C9.5-5.11%2C13.28-8.89%20c3.78-3.78%2C6.82-8.29%2C8.89-13.28c1.99-4.81%2C3.1-10.1%2C3.1-15.66c0-5.56-1.1-10.84-3.1-15.66c-2.07-5-5.11-9.5-8.89-13.28%20c-3.78-3.78-8.29-6.82-13.28-8.89c-4.81-1.99-10.1-3.1-15.66-3.1c-5.56%2C0-10.84%2C1.1-15.66%2C3.1c-0.43%2C0.18-0.86%2C0.37-1.28%2C0.56%20c-1.64-2.58-3.62-4.92-5.89-6.95c1.24-0.64%2C2.51-1.23%2C3.8-1.77C59.96%2C1.34%2C66.38%2C0%2C73.11%2C0L73.11%2C0z%20M67.4%2C26.11%20c0-1.22%2C0.5-2.32%2C1.29-3.12c0.8-0.8%2C1.9-1.29%2C3.12-1.29s2.32%2C0.49%2C3.12%2C1.29c0.8%2C0.8%2C1.29%2C1.9%2C1.29%2C3.12v23.22l17.35%2C10.29%20c1.04%2C0.62%2C1.74%2C1.61%2C2.02%2C2.7c0.28%2C1.09%2C0.15%2C2.29-0.47%2C3.33l0%2C0.01l0%2C0c-0.62%2C1.04-1.61%2C1.74-2.7%2C2.02%20c-1.09%2C0.28-2.29%2C0.15-3.33-0.47l-0.01%2C0l0%2C0L69.67%2C55.69c-0.67-0.37-1.22-0.91-1.62-1.55c-0.41-0.67-0.65-1.46-0.65-2.3V26.11%20L67.4%2C26.11z%22%2F%3E%3Cpath%20class%3D%22st1%22%20d%3D%22M26.98%2C2.64c14.9%2C0%2C26.98%2C12.08%2C26.98%2C26.98c0%2C14.9-12.08%2C26.98-26.98%2C26.98C12.08%2C56.6%2C0%2C44.52%2C0%2C29.62%20C0%2C14.72%2C12.08%2C2.64%2C26.98%2C2.64L26.98%2C2.64z%20M32.26%2C19.83c1.21-1.23%2C3.17-1.23%2C4.39-0.01c1.21%2C1.22%2C1.22%2C3.2%2C0.01%2C4.43l-5.3%2C5.37%20l5.3%2C5.38c1.2%2C1.22%2C1.18%2C3.19-0.04%2C4.4c-1.22%2C1.21-3.17%2C1.21-4.37-0.01l-5.27-5.34l-5.28%2C5.35c-1.21%2C1.23-3.17%2C1.23-4.39%2C0.01%20c-1.21-1.22-1.22-3.2-0.01-4.43l5.3-5.37l-5.3-5.38c-1.2-1.22-1.18-3.19%2C0.04-4.4c1.22-1.21%2C3.17-1.21%2C4.37%2C0.01l5.27%2C5.34%20L32.26%2C19.83L32.26%2C19.83z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

exports.CometChatSchedulerBubble = class CometChatSchedulerBubble extends lit.LitElement {
    constructor() {
        var _a, _b;
        super(...arguments);
        this.goalCompletionText = uikitResources.localize("MEETING_SCHEDULED");
        this.avatarStyle = {
            height: "48px",
            width: "48px",
            backgroundColor: "grey",
            borderRadius: "50%",
            border: "none"
        };
        this.timeFormat = "12Hr";
        this.emptySlotIconURL = EmptySlotIcon$1;
        this.backButtonIconURL = backIcon;
        this.loadingIconURL = LoadingIcon;
        this.clockIconURL = timerIcon;
        this.calendarIconURL = calenderIcon;
        this.timezoneIconURL = planetIcon;
        this.schedulerBubbleStyle = {
            goalCompletionTextColor: "grey",
            goalCompletionTextFont: "500 15px Inter",
        };
        this.currentPage = 0;
        this.blockedTimes = [];
        this.availableMeetingDays = {};
        this.availabilityObject = {};
        this.dateAvailablity = {};
        this.compDimensions = {};
        this.selectedSlotState = {};
        this.timeSlotContainerHeight = {};
        this.SelectedSlot = {};
        this.isLoading = true;
        this.blockedCurrentTime = {};
        this.availableDaySlots = {};
        this.defaultButtonsStyle = {
            padding: "8px",
            boxSizing: "border-box",
            border: "1px solid #5353ff",
            borderRadius: "8px",
            height: "fit-content",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        };
        this.dateFormats = {
            date: "yyyy-MM-dd",
            time: "HHmm",
        };
        this.oldIcsFileData = {};
        this.interactiveData = (_b = (_a = this.schedulerMessage) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.interactiveData;
        this.allowSenderInteraction = false;
        this.currentDate = "";
        this.availableDefaultSlots = [];
        this.currentDateWithYear = "";
        this.slotAlreadyBooked = false;
        this.showError = false;
        this.timezoneText = uikitResources.localize("TIME_ZONE");
        this.schedulingInProgress = false;
        this.icsFileData = {};
        this.currentComp = {};
        this.buffer = 10;
        this.duration = 45;
        this.availableSlots = {};
        this.selectedDate = "";
        this.slotsArray = [];
        this.timezoneCode = "ist";
        this.minDate = "";
        this.maxDate = "";
        this.checkHasInteractionCompleted = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            let completed = false;
            let neededInteractionElement = ((_c = (_b = (_a = this.schedulerMessage) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.interactionGoal) === null || _c === void 0 ? void 0 : _c.elementIds) || [];
            let neededInteractionElementCondition = ((_f = (_e = (_d = this.schedulerMessage) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.interactionGoal) === null || _f === void 0 ? void 0 : _f.type) || "";
            let interactedElements = ((_h = (_g = this.schedulerMessage) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.interactions) || [];
            switch (neededInteractionElementCondition) {
                case uikitResources.CometChatUIKitConstants.goalType.anyOf:
                    completed = interactedElements.find((element) => neededInteractionElement.includes(element.getElementId()))
                        ? true
                        : false;
                    break;
                case uikitResources.CometChatUIKitConstants.goalType.anyAction:
                    completed = interactedElements.length > 0 ? true : false;
                    break;
                case uikitResources.CometChatUIKitConstants.goalType.allOf:
                    completed = neededInteractionElement.every((element) => interactedElements.find((interaction) => interaction.getElementId() === element))
                        ? true
                        : false;
                    break;
                case uikitResources.CometChatUIKitConstants.goalType.none:
                    completed = false;
                    break;
                default:
                    completed = false;
                    break;
            }
            return completed;
        };
        this.onDateSelected = (e) => {
            var _a, _b, _c, _d;
            this.showError = false;
            this.schedulingInProgress = false;
            this.slotAlreadyBooked = false;
            this.selectedDate = e === null || e === void 0 ? void 0 : e.detail;
            if (this.blockedCurrentTime) {
                this.icsFileData[(_a = this.selectedDate) === null || _a === void 0 ? void 0 : _a.date] = this.oldIcsFileData[(_b = this.selectedDate) === null || _b === void 0 ? void 0 : _b.date];
            }
            new SchedulerMessageUtils().getSlotsForADate(this.icsFileData, (_c = this.selectedDate) === null || _c === void 0 ? void 0 : _c.date, this.buffer, this.duration, this.timeFormat, (_d = this.interactiveData) === null || _d === void 0 ? void 0 : _d.availability, this.timezoneCode).then((date) => {
                this.availableDaySlots = date;
                this.goToNextPage();
            });
        };
        this.onSlotSelected = (e) => {
            var _a;
            this.showError = false;
            this.schedulingInProgress = false;
            this.slotAlreadyBooked = false;
            this.SelectedSlot = e.detail;
            if (((_a = Object.keys(e.detail)) === null || _a === void 0 ? void 0 : _a.length) && Object.keys(e.detail).length > 0) {
                this.goToNextPage();
            }
        };
        this.showMoreSlots = (number) => {
            this.previousPage = this.currentPage;
            this.currentPage = number;
            this.requestUpdate("currentPage");
        };
    }
    getHeaderView() {
        switch (this.currentPage) {
            case 0:
                return this.getInitialHeaderView();
            case 1:
            case 2:
            case 3:
                return this.getDateTimeHeaderView();
            default:
                return lit.nothing;
        }
    }
    getButtonView() {
        switch (this.currentPage) {
            case 0:
                return lit.html ` <div class="more-button">
       <cometchat-button  .disabled=${!this.allowSenderInteraction} .buttonStyle=${this.getButtonsStyle()} @cc-button-clicked="${() => { this.showMoreSlots(1); }}" .text=${uikitResources.localize("MORE_TIMES")}></cometchat-button>
      </div>`;
            case 3:
                return lit.html ` <div class="more-button">
        ${this.slotAlreadyBooked && !this.schedulingInProgress && !this.showError ? lit.html `        <span class="cc-meeting__slot-booked" style=${styleMap_js.styleMap(this.slotBookedStyle())}>${uikitResources.localize("MEETING_SLOT_BOOK")}</span>
` : lit.nothing}
         ${this.showError && !this.schedulingInProgress && !this.slotAlreadyBooked ? lit.html `
             <span class="cc-meeting__slot-error" style=${styleMap_js.styleMap(this.slotBookedStyle())}>${uikitResources.localize("SOMETHING_WRONG")}</span>
         ` : lit.nothing}
       <cometchat-button class="cc-scheduler-button__common" .disabled=${!this.allowSenderInteraction} .buttonStyle=${this.getButtonsStyle()} @cc-button-clicked="${() => { this.scheduleMeeting(); }}" .iconURL=${this.schedulingInProgress && !this.showError && !this.slotAlreadyBooked ? this.loadingIconURL || LoadingIcon : lit.nothing} .text=${this.getSlotButtonText()}></cometchat-button>

      </div>`;
            default:
                return lit.nothing;
        }
    }
    getSlotButtonText() {
        var _a, _b;
        let text = lit.nothing;
        if (!this.schedulingInProgress && !this.slotAlreadyBooked && !this.showError) {
            text = ((_b = (_a = this.interactiveData) === null || _a === void 0 ? void 0 : _a.scheduleElement) === null || _b === void 0 ? void 0 : _b.buttonText) || uikitResources.localize("SCHEDULE");
        }
        else if (this.slotAlreadyBooked) {
            text = uikitResources.localize("MEETING_BOOK_NEW_SLOT");
        }
        else if (this.showError) {
            text = uikitResources.localize("TRY_AGAIN");
        }
        else {
            text = lit.nothing;
        }
        return text;
    }
    getInitialHeaderView() {
        var _a, _b;
        return lit.html `  ${this.avatarUrl || ((_a = this.user) === null || _a === void 0 ? void 0 : _a.name) ? lit.html ` <cometchat-avatar class="avatar" .avatarStyle=${this.getAvatarStyle()} .name=${(_b = this.user) === null || _b === void 0 ? void 0 : _b.name} .image=${this.avatarUrl}>  </cometchat-avatar>` : lit.nothing}
     ${this.title ? lit.html ` <cometchat-label class="cc-initial_header-title" .labelStyle=${this.getTitleStyle()} .text=${this.title} ></cometchat-label>` : lit.nothing}`;
    }
    getDateTimeHeaderView() {
        var _a, _b;
        return lit.html ` <div class="cc-slot__list-item" style=${styleMap_js.styleMap(this.getHeaderStyle())}>
    <cometchat-button @cc-button-clicked=${() => this.goToPreviousPage(this.currentPage)} class="cc-slot__back-button" .buttonStyle=${this.getBackButtonStyle()} .iconURL=${this.backButtonIconURL || backIcon}> </cometchat-button>
    <cometchat-list-item .avatarStyle=${this.getAvatarStyle()} .hideSeparator=${true} .listItemStyle=${this.getListItemStyle()} .title=${this.title} .avatarName=${(_a = this.user) === null || _a === void 0 ? void 0 : _a.name} .avatarURL=${this.avatarUrl}>
    <div slot="subtitleView" style=${styleMap_js.styleMap(this.getSubtitleStyle())} class="subtitle_view">
      <cometchat-icon .URL=${this.clockIconURL || timerIcon} .iconStyle=${{ height: "16px", width: "16px", iconTint: ((_b = this.schedulerBubbleStyle) === null || _b === void 0 ? void 0 : _b.subtitleTextColor) || "grey" }}></cometchat-icon>
      ${this.duration + " " + "min"}
    </div>
    </cometchat-list-item>
    </div>`;
    }
    getConfirmPageHeaderView() {
        let headerStyle = {
            display: "flex",
            columnGap: "4px",
            width: "100%",
            alignItems: "center",
            marginBottom: "-8px"
        };
        return lit.html ` <div class="cc-slot__title-header" style=${styleMap_js.styleMap(headerStyle)}>
    <cometchat-button @cc-button-clicked=${() => this.goToPreviousPage(this.currentPage)} class="cc-slot__back-button" .buttonStyle=${this.getBackButtonStyle()} .iconURL=${this.backButtonIconURL || backIcon}> </cometchat-button>
   ${this.user ? lit.html ` <cometchat-list-item .avatarStyle=${this.getAvatarStyle()} .hideSeparator=${true} .listItemStyle=${this.getListItemStyle()} .title=${this.title}>
    </cometchat-list-item>` : lit.nothing}
    </div>`;
    }
    getContentView() {
        switch (this.currentPage) {
            case 1:
                return this.getDateContentView();
            case 2:
                return this.getTimeContentView();
            case 3:
                return this.getConfirmPageView();
            case 4:
                return this.getGoalCompletedView();
            default:
                return this.getInitialContentView();
        }
    }
    connectedCallback() {
        super.connectedCallback();
    }
    getCurrentTime() {
        const date = new Date();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}${minutes}`;
    }
    getNextDate(current) {
        let currentDate = new Date(current);
        currentDate.setDate(currentDate.getDate() + 1);
        const nextDate = currentDate.toISOString().split('T')[0];
        return nextDate;
    }
    timeToMinutes(timeStr) {
        let [hours, minutes] = timeStr.split(':');
        let modifier = minutes.substr(-2).toLowerCase();
        hours = parseInt(hours);
        minutes = parseInt(minutes);
        if (modifier === 'pm' && hours < 12) {
            hours += 12;
        }
        else if (modifier === 'am' && hours === 12) {
            hours -= 12;
        }
        return hours * 60 + minutes;
    }
    isSlotAvailable(availableSlots, selectedSlot) {
        // Convert selectedSlot to minutes
        const selectedSlotMinutes = this.timeToMinutes(selectedSlot);
        // Convert availableSlots to their equivalent minutes
        const availableSlotsMinutes = availableSlots.map(this.timeToMinutes);
        for (let i = 0; i < availableSlotsMinutes.length - 1; i++) {
            if (availableSlotsMinutes[i] <= selectedSlotMinutes && selectedSlotMinutes < availableSlotsMinutes[i + 1]) {
                return true;
            }
        }
        return false;
    }
    getQuickSlotDate() {
        const minDate = new Date(this.minDate);
        const maxDate = new Date(this.maxDate);
        const currentDate = new Date();
        if (currentDate >= minDate && currentDate <= maxDate) {
            return currentDate.toISOString().split("T")[0];
        }
        else {
            return this.minDate;
        }
    }
    isTimeInArray(timeStr, timeArray) {
        if (timeArray && timeArray.length > 0) {
            const [hours, minutes] = timeStr.split(':');
            return timeArray.some(time => {
                const [timeHours, timeMinutes] = time.split(':');
                return time === timeStr || timeHours === hours;
            });
        }
        else {
            return true;
        }
    }
    processEvents(events) {
        // Create a shallow copy of the events to avoid modifying the original events object
        const processedEvents = { ...events };
        // Loop over all dates in the events
        for (const date in processedEvents) {
            // Loop over all events of the date
            processedEvents[date].forEach((event) => {
                // Check if the event spans multiple days
                if (event.startDate !== event.endDate) {
                    // Loop over all the days the event spans
                    const startDate = new Date(event.startDate);
                    const endDate = new Date(event.endDate);
                    for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
                        const dateStr = d.toISOString().substr(0, 10);
                        // Prepare a copy of the event with adjusted start and end times
                        const adjustedEvent = { ...event, startDate: dateStr, endDate: dateStr };
                        // If the date is not the event's start date, set the start time to 0000
                        if (dateStr !== event.startDate) {
                            adjustedEvent.startTime = "0000";
                        }
                        // If the date is not the event's end date, set the end time to 2359
                        if (dateStr !== event.endDate) {
                            adjustedEvent.endTime = "2359";
                        }
                        // If the date is not already in the processedEvents, add it
                        if (!processedEvents[dateStr]) {
                            processedEvents[dateStr] = [];
                        }
                        // Add the adjusted event to the date
                        processedEvents[dateStr].push(adjustedEvent);
                        let updatedDate = new SchedulerMessageUtils().findLongestMeeting(processedEvents[dateStr]);
                        processedEvents[dateStr] = updatedDate;
                    }
                }
            });
        }
        return processedEvents;
    }
    fetchIcsData(checkAlreadySchedule) {
        var _a, _b, _c;
        if (!((_a = this.interactiveData) === null || _a === void 0 ? void 0 : _a.icsFileUrl)) {
            // Converted ICS to JSON
            // Restructure the JSON to make it more easy to assign to calendar dates
            this.icsFileData = {};
            let currentDate = new SchedulerMessageUtils().convertToATimeZone(this.getCurrentDateInMilliseconds(), this.timezoneCode, this.dateFormats.date, "fromMillis");
            let newMeeting = {
                endDate: currentDate,
                endTime: this.getCurrentTime(),
                startDate: currentDate,
                startTime: "0000",
            };
            let getInitialDate = new SchedulerMessageUtils().getCurrentDate();
            // If meetings exist for the current date, push the new meeting to them, otherwise initiate an array
            if (currentDate == getInitialDate) {
                if (this.icsFileData && this.icsFileData[currentDate]) {
                    this.icsFileData[currentDate].push(newMeeting);
                }
                else {
                    this.icsFileData[currentDate] = [newMeeting];
                }
                let actualData = new SchedulerMessageUtils().findLongestMeeting(this.icsFileData[currentDate]);
                // Find the longest meeting and update
                this.icsFileData[currentDate] = actualData;
            }
            if (this.interactiveData) {
                new SchedulerMessageUtils().getInitialAvailableDays({
                    availability: (_b = this.interactiveData) === null || _b === void 0 ? void 0 : _b.availability,
                    date: new SchedulerMessageUtils().convertToATimeZone(this.getCurrentDateInMilliseconds(this.getQuickSlotDate()), this.timezoneCode, this.dateFormats.date, "fromMillis"),
                    timeZoneCode: this.timezoneCode,
                    blockedTime: this.icsFileData,
                    bufferTime: this.buffer,
                    duration: this.duration,
                    quickSlotDate: this.getQuickSlotDate()
                }).then((slots) => {
                    var _a, _b, _c;
                    this.availabilityObject = slots === null || slots === void 0 ? void 0 : slots.availableSlots;
                    this.availableDefaultSlots = slots === null || slots === void 0 ? void 0 : slots.quickSlots;
                    if (checkAlreadySchedule) {
                        new SchedulerMessageUtils().getSlotsForADate(this.icsFileData, (_a = this.selectedDate) === null || _a === void 0 ? void 0 : _a.date, this.buffer, this.duration, this.timeFormat, (_b = this.interactiveData) === null || _b === void 0 ? void 0 : _b.availability, this.timezoneCode).then((availableSlots) => {
                            var _a;
                            this.slotsArray.push(availableSlots);
                            checkAlreadySchedule(!this.isTimeInArray((_a = this.SelectedSlot) === null || _a === void 0 ? void 0 : _a.availability, availableSlots === null || availableSlots === void 0 ? void 0 : availableSlots.availability));
                            // checkAlreadySchedule(!this.isTimeInArray(availableSlots?.availability, this.SelectedSlot?.availability))
                        });
                    }
                    else {
                        if (this.availableDefaultSlots && ((_c = this.availableDefaultSlots) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                            this.availableDefaultSlots.flatMap((slot) => {
                                var _a, _b;
                                new SchedulerMessageUtils().getSlotsForADate(this.icsFileData, (_a = slot === null || slot === void 0 ? void 0 : slot.item) === null || _a === void 0 ? void 0 : _a.date, this.buffer, this.duration, this.timeFormat, (_b = this.interactiveData) === null || _b === void 0 ? void 0 : _b.availability, this.timezoneCode).then((availableSlots) => {
                                    if (!Array.isArray(availableSlots)) {
                                        this.slotsArray.push(availableSlots);
                                    }
                                    this.isLoading = false;
                                    this.requestUpdate("isLoading");
                                }).catch((err) => {
                                    console.log(err);
                                    this.slotsArray = [];
                                    this.isLoading = false;
                                    this.requestUpdate("isLoading");
                                });
                            });
                        }
                        else {
                            this.slotsArray = [];
                            this.isLoading = false;
                            this.requestUpdate("false");
                            this.requestUpdate("availableDefaultSlots");
                        }
                    }
                });
            }
        }
        else {
            fetch((_c = this.interactiveData) === null || _c === void 0 ? void 0 : _c.icsFileUrl)
                .then((response) => {
                if (response.status === 200) {
                    return { response, status: response.status };
                }
                return { status: response.status };
            })
                .then(async (res) => {
                var _a, _b;
                // Converted ICS to JSON
                if (res.status === 200) {
                    let text = await res.response.text();
                    let jcalData = icsToJson(text);
                    // Restructure the JSON to make it more easy to assign to calendar dates
                    let finalJcalData = {};
                    jcalData.forEach((item, index) => {
                        let startDate = new SchedulerMessageUtils().convertToLocalTimeZone(new SchedulerMessageUtils().convertDate(item.startDate), item.tzid ? item.tzid : "utc", this.dateFormats.date);
                        let startTime = new SchedulerMessageUtils().convertToLocalTimeZone(new SchedulerMessageUtils().convertDate(item.startDate), item.tzid ? item.tzid : "utc", this.dateFormats.time);
                        let endDate = new SchedulerMessageUtils().convertToLocalTimeZone(new SchedulerMessageUtils().convertDate(item.endDate), item.tzid ? item.tzid : "utc", this.dateFormats.date);
                        let endTime = new SchedulerMessageUtils().convertToLocalTimeZone(new SchedulerMessageUtils().convertDate(item.endDate), item.tzid ? item.tzid : "utc", this.dateFormats.time);
                        let finalObject = {
                            ...item,
                            startDate,
                            startTime,
                            endDate,
                            endTime,
                        };
                        if (finalJcalData[startDate]) {
                            finalJcalData[startDate] = [
                                ...finalJcalData[startDate],
                                finalObject,
                            ];
                        }
                        else
                            finalJcalData[startDate] = [finalObject];
                    });
                    this.oldIcsFileData = finalJcalData;
                    this.icsFileData = this.processEvents(finalJcalData);
                    let currentDate = new SchedulerMessageUtils().convertToATimeZone(this.getCurrentDateInMilliseconds(this.getQuickSlotDate()), this.timezoneCode, this.dateFormats.date, "fromMillis");
                    let getInitialDate = new SchedulerMessageUtils().getCurrentDate();
                    // If meetings exist for the current date
                    if (currentDate == getInitialDate) {
                        // Check if there is already a booking up to or beyond the current time
                        if (this.icsFileData && this.icsFileData[currentDate]) {
                            // Find any meeting that spans the entire day but does not start at 0000
                            const fullDayMeetingIndex = this.icsFileData[currentDate].findIndex((meeting) => meeting.endTime === "2359" && meeting.startTime !== "0000");
                            // If such a meeting exists, adjust its start time
                            if (fullDayMeetingIndex > -1) {
                                this.icsFileData[currentDate][fullDayMeetingIndex].startTime = "0000";
                                this.blockedCurrentTime = this.icsFileData[currentDate][fullDayMeetingIndex];
                            }
                        }
                        const isAlreadyBooked = (_a = this.icsFileData[currentDate]) === null || _a === void 0 ? void 0 : _a.some((meeting) => meeting.endTime >= this.getCurrentTime());
                        if (!isAlreadyBooked) {
                            let newMeeting = {
                                endDate: currentDate,
                                endTime: this.getCurrentTime(),
                                startDate: currentDate,
                                startTime: "0000",
                            };
                            // Check if there is already meeting data for the current date
                            if (this.icsFileData[currentDate]) {
                                this.icsFileData[currentDate].push(newMeeting);
                            }
                            else {
                                this.icsFileData[currentDate] = [newMeeting];
                            }
                            let actualData = new SchedulerMessageUtils().findLongestMeeting(this.icsFileData[currentDate]);
                            // Find the longest meeting and update
                            this.icsFileData[currentDate] = actualData;
                            this.blockedCurrentTime = this.icsFileData[currentDate];
                        }
                    }
                }
                if (this.interactiveData) {
                    new SchedulerMessageUtils().getInitialAvailableDays({
                        availability: (_b = this.interactiveData) === null || _b === void 0 ? void 0 : _b.availability,
                        date: new SchedulerMessageUtils().convertToATimeZone(this.getCurrentDateInMilliseconds(this.getQuickSlotDate()), this.timezoneCode, this.dateFormats.date, "fromMillis"),
                        timeZoneCode: this.timezoneCode,
                        bufferTime: this.buffer,
                        duration: this.duration,
                        blockedTime: this.icsFileData,
                        quickSlotDate: this.getQuickSlotDate()
                    }).then((slots) => {
                        var _a, _b, _c;
                        this.availabilityObject = slots === null || slots === void 0 ? void 0 : slots.availableSlots;
                        this.availableDefaultSlots = slots === null || slots === void 0 ? void 0 : slots.quickSlots;
                        if (checkAlreadySchedule) {
                            new SchedulerMessageUtils().getSlotsForADate(this.icsFileData, (_a = this.selectedDate) === null || _a === void 0 ? void 0 : _a.date, this.buffer, this.duration, this.timeFormat, (_b = this.interactiveData) === null || _b === void 0 ? void 0 : _b.availability, this.timezoneCode).then((availableSlots) => {
                                var _a;
                                this.slotsArray.push(availableSlots);
                                let timeStr = (_a = this.SelectedSlot) === null || _a === void 0 ? void 0 : _a.availability;
                                // let [hours, minutes]: any = timeStr.split(':');
                                // const isSelectedSlotAvailable = availableSlots?.availability?.includes(timeStr) || availableSlots?.availability?.includes(hours);
                                checkAlreadySchedule(!this.isTimeInArray(timeStr, availableSlots === null || availableSlots === void 0 ? void 0 : availableSlots.availability));
                                // checkAlreadySchedule(!this.isSlotAvailable(availableSlots?.availability, this.SelectedSlot?.availability))
                            })
                                .catch((err) => {
                                console.log(err);
                                this.slotsArray = [];
                                this.isLoading = false;
                                this.requestUpdate("isLoading");
                            });
                        }
                        else {
                            if (this.availableDefaultSlots && ((_c = this.availableDefaultSlots) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                                this.availableDefaultSlots.flatMap((slot) => {
                                    var _a, _b;
                                    new SchedulerMessageUtils().getSlotsForADate(this.icsFileData, (_a = slot === null || slot === void 0 ? void 0 : slot.item) === null || _a === void 0 ? void 0 : _a.date, this.buffer, this.duration, this.timeFormat, (_b = this.interactiveData) === null || _b === void 0 ? void 0 : _b.availability, this.timezoneCode).then((availableSlots) => {
                                        if (!Array.isArray(availableSlots)) {
                                            this.slotsArray.push(availableSlots);
                                        }
                                        this.isLoading = false;
                                        this.requestUpdate("isLoading");
                                    });
                                });
                            }
                            else {
                                this.slotsArray = [];
                                this.isLoading = false;
                                this.requestUpdate("false");
                                this.requestUpdate("availableDefaultSlots");
                            }
                        }
                    });
                }
            })
                .catch((err) => {
                console.log("Error :: ", err);
            });
        }
    }
    getCurrentDateInMilliseconds(date) {
        const currentDate = date ? new Date(date) : new Date();
        return currentDate.getTime();
    }
    getFirstAvailableDay() {
    }
    getTodaysDateFormatted() {
        const today = new Date();
        const options = {
            weekday: 'short',
            day: '2-digit',
            year: '2-digit'
        };
        return today.toLocaleDateString('en-US', options).replace(/,/g, '');
    }
    getCurrentDateSlots(slots) {
        this.blockedTimes = slots["01/26/2024"];
        this.requestUpdate("blockedTimes");
    } // Helper function to pad numbers to two digits
    padTo2Digits(num) {
        return num.toString().padStart(2, '0');
    }
    // Function to format a date to YYYY-MM-DD
    formatDate() {
        let date = new Date();
        return [
            date.getFullYear(),
            this.padTo2Digits(date.getMonth() + 1),
            this.padTo2Digits(date.getDate()),
        ].join('-');
    }
    getTodaysDateInDDMMYY() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0
        const year = String(today.getFullYear()).substring(2); // Get last two digits of year
        return `${day}/${month}/${year}`;
    }
    firstUpdated(_changedProperties) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        try {
            if (this.schedulerMessage) {
                this.isLoading = true;
                if (!this.loggedInUser) {
                    chatSdkJavascript.CometChat.getLoggedinUser()
                        .then((user) => {
                        if (user)
                            this.loggedInUser = user;
                    })
                        .catch((error) => {
                        console.log(error);
                    });
                }
                this.interactiveData = (_a = this.schedulerMessage) === null || _a === void 0 ? void 0 : _a.getInteractiveData();
                this.currentDate = this.getTodaysDateInDDMMYY();
                this.currentDateWithYear = this.getTodaysDateFormatted();
                this.buffer = ((_b = this.interactiveData) === null || _b === void 0 ? void 0 : _b.bufferTime) || 0;
                this.duration = ((_c = this.interactiveData) === null || _c === void 0 ? void 0 : _c.duration) || 60;
                this.avatarUrl = ((_d = this.interactiveData) === null || _d === void 0 ? void 0 : _d.avatarUrl) || ((_e = this.schedulerMessage) === null || _e === void 0 ? void 0 : _e.getSender().getAvatar());
                this.timezoneCode = ((_f = this.interactiveData) === null || _f === void 0 ? void 0 : _f.timezoneCode) ? (_h = (_g = this.interactiveData) === null || _g === void 0 ? void 0 : _g.timezoneCode) === null || _h === void 0 ? void 0 : _h.trim() : "Asia/Kolkata";
                this.user = ((_j = this.schedulerMessage) === null || _j === void 0 ? void 0 : _j.getSender()) || {};
                this.minDate = new SchedulerMessageUtils().convertToATimeZone(this.getCurrentDateInMilliseconds((_k = this.interactiveData) === null || _k === void 0 ? void 0 : _k.dateRangeStart), this.timezoneCode, "yyyy-MM-dd", "fromMillis");
                this.maxDate = new SchedulerMessageUtils().convertToATimeZone(this.getCurrentDateInMilliseconds((_l = this.interactiveData) === null || _l === void 0 ? void 0 : _l.dateRangeEnd), this.timezoneCode, "yyyy-MM-dd", "fromMillis");
                this.title = (_p = (_m = this.title) !== null && _m !== void 0 ? _m : (_o = this.interactiveData) === null || _o === void 0 ? void 0 : _o.title) !== null && _p !== void 0 ? _p : uikitResources.localize("MEET_WITH") + " " + ((_q = this.schedulerMessage) === null || _q === void 0 ? void 0 : _q.getSender().getName());
                if (this.checkHasInteractionCompleted()) {
                    this.currentPage = 4;
                    this.requestUpdate("currentPage");
                }
                else {
                    this.fetchIcsData();
                }
                this.requestUpdate("interactiveData");
            }
        }
        catch (err) {
            console.log(err);
        }
    }
    // Example usage to get the current date
    getInitialContentView() {
        var _a, _b, _c;
        this.slotAlreadyBooked = false;
        this.showError = false;
        let firstThreeSlots = [];
        if (!this.isLoading && ((_a = this.availableDefaultSlots) === null || _a === void 0 ? void 0 : _a.length) && ((_b = this.availableDefaultSlots) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            firstThreeSlots = this.availableDefaultSlots.slice(0, 3);
        }
        else {
            firstThreeSlots = [];
        }
        return lit.html ` ${this.isLoading ? lit.html `<div class="cc-loading__view">
    <cometchat-icon .URL=${this.loadingIconURL || LoadingIcon} .iconStyle=${{ height: "24px", width: "24px", iconTint: ((_c = this.schedulerBubbleStyle) === null || _c === void 0 ? void 0 : _c.loadingIconTint) || "grey" }}></cometchat-icon>
    </div>` : lit.html `
    <div class="buttons">
    ${(firstThreeSlots === null || firstThreeSlots === void 0 ? void 0 : firstThreeSlots.length) && (firstThreeSlots === null || firstThreeSlots === void 0 ? void 0 : firstThreeSlots.length) > 0 ? firstThreeSlots.map(({ availability, item }) => {
            return lit.html `
      <cometchat-button class="cc-scheduler-button__common" .disabled=${!this.allowSenderInteraction} .buttonStyle=${this.getSelectSlotStyles()} @cc-button-clicked="${() => { this.onSlotClick({ availability, item }); }}"  .text=${this.getAvailableQuickSlot({ availability, item })}></cometchat-button>
      `;
        }) : lit.html `<div class="cc-empty__view">
        <cometchat-icon .URL=${this.emptySlotIconURL || EmptySlotIcon$1} .iconStyle=${this.emptySlotIconStyle()}></cometchat-icon>
    <cometchat-label .labelStyle=${this.emptySlotStyle()} .text=${uikitResources.localize("NO_TIME_SLOTS_AVAILABLE")}></cometchat-label>
    </div>`}
      </div>
        <span class="cc-meeting-bubble__time-format"  style=${styleMap_js.styleMap(this.getTimeZoneStyle())}>${this.duration}min meeting &bull;  ${new SchedulerMessageUtils().getTimeZoneName()}</span>`}`;
    }
    formatTime(timeString) {
        return timeString;
    }
    getAvailableQuickSlot(slot, showReverse = false) {
        var _a, _b, _c;
        let dayString = (_a = slot === null || slot === void 0 ? void 0 : slot.item) === null || _a === void 0 ? void 0 : _a.day;
        let dateString = '';
        if (typeof dayString === 'string') {
            dateString = `${dayString.charAt(0).toUpperCase() + dayString.slice(1)}`;
        }
        if (showReverse) {
            let dateTime = DateTime.fromFormat((_b = slot === null || slot === void 0 ? void 0 : slot.item) === null || _b === void 0 ? void 0 : _b.date, "yyyy-MM-dd");
            let date = `${this.formatTime(slot === null || slot === void 0 ? void 0 : slot.availability)}, ${dateTime.weekdayLong}, ${dateTime.toFormat("dd MMMM yyyy")}`;
            return date;
        }
        else {
            dateString = dateString.slice(0, 3);
            let date = `${dateString}, ${DateTime.fromFormat((_c = slot === null || slot === void 0 ? void 0 : slot.item) === null || _c === void 0 ? void 0 : _c.date, "yyyy-MM-dd").toFormat("MMM dd")} at  ${this.formatTime(slot === null || slot === void 0 ? void 0 : slot.availability)}`;
            return date;
        }
    }
    getDateContentView() {
        return lit.html `<cometchat-calendar timezoneText.=${this.timezoneText} .calendarStyle=${this.getdateSelectorStyle()} .maxDate=${this.maxDate} .minDate=${this.minDate}  @cc-date-selected="${this.onDateSelected}"></cometchat-calendar>`;
    }
    convertTimestampToDate(timestamp) {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2); // Months are 0-11, add one and format to 2
        const day = ("0" + date.getDate()).slice(-2); // Format to 2 digits
        return `${year}-${month}-${day}`;
    }
    getTimeContentView() {
        var _a, _b;
        return lit.html `<cometchat-time-slot .calendarIconURL=${this.calendarIconURL || calenderIcon} .availableSlots=${this.availableDaySlots}  .timezoneIconURL=${this.timezoneIconURL || planetIcon} .timeSlotStyle=${(_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.timeSlotSelectorStyle} .selectedDayDate=${this.selectedDate} .duration=${this.duration} .buffer=${this.buffer} .timezoneCode=${this.timezoneCode}  .availability=${(_b = this.interactiveData) === null || _b === void 0 ? void 0 : _b.availability} @cc-slot-selected=${(e) => { this.onSlotSelected(e); }} .blockedTime=${this.icsFileData}></cometchat-time-slot>`;
    }
    getConfirmPageView() {
        var _a, _b;
        return lit.html `<div class="cc-confirm-page__wrapper">
     <div class="cc-confirm-page__description cc-confirm-page__icon"  style=${styleMap_js.styleMap(this.getSummeryStyle())}>
      <cometchat-icon .URL=${this.calendarIconURL || calenderIcon} .iconStyle=${{ height: "16px", width: "16px", iconTint: ((_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.calendarIconTint) || "black" }}></cometchat-icon>
     ${this.getAvailableQuickSlot(this.SelectedSlot, true)}</div>
      <div class="cc-confirm-page__timezone cc-confirm-page__icon"  style=${styleMap_js.styleMap(this.getSummeryStyle())}>
       <cometchat-icon .URL=${this.timezoneIconURL || planetIcon} .iconStyle=${{ height: "16px", width: "16px", iconTint: ((_b = this.schedulerBubbleStyle) === null || _b === void 0 ? void 0 : _b.timezoneIconTint) || "black" }}></cometchat-icon>
      ${new SchedulerMessageUtils().getTimeZoneName()}
      </div>
    </div>`;
    }
    scheduleMeeting() {
        try {
            if (this.slotAlreadyBooked) {
                this.fetchIcsData();
                this.slotAlreadyBooked = false;
                this.showError = false;
                this.currentPage = 0;
                this.requestUpdate("slotAlreadyBooked");
                this.requestUpdate("showError");
                this.requestUpdate("currentPage");
            }
            else {
                this.schedulingInProgress = true;
                this.showError = false;
                this.requestUpdate("schedulingInProgress");
                this.requestUpdate("showError");
                this.fetchIcsData((bool) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    if (bool) {
                        this.schedulingInProgress = false;
                        this.slotAlreadyBooked = true;
                        this.showError = false;
                        this.previousPage = this.currentPage;
                        this.requestUpdate("slotAlreadyBooked");
                    }
                    else {
                        this.slotAlreadyBooked = false;
                        this.showError = false;
                        let element = (_a = this.interactiveData) === null || _a === void 0 ? void 0 : _a.scheduleElement;
                        let action = uikitResources.APIAction.fromJSON(element === null || element === void 0 ? void 0 : element.action);
                        action.setHeaders((_b = element === null || element === void 0 ? void 0 : element.action) === null || _b === void 0 ? void 0 : _b.headers);
                        action.setPayload((_c = element === null || element === void 0 ? void 0 : element.action) === null || _c === void 0 ? void 0 : _c.payload);
                        if (this.onScheduleClick) {
                            this.onScheduleClick(new SchedulerMessageUtils().convertToISOString((_d = this.SelectedSlot) === null || _d === void 0 ? void 0 : _d.availability, (_e = this.selectedDate) === null || _e === void 0 ? void 0 : _e.date), this.schedulerMessage);
                            chatSdkJavascript.CometChat.markAsInteracted((_f = this.schedulerMessage) === null || _f === void 0 ? void 0 : _f.getId(), element === null || element === void 0 ? void 0 : element.elementId);
                            this.previousPage = this.currentPage;
                            this.currentPage = 4;
                            this.schedulingInProgress = false;
                            this.slotAlreadyBooked = false;
                            this.requestUpdate("currentPage");
                        }
                        else {
                            InteractiveMessageUtils.actionHandler(action, {
                                elementId: element === null || element === void 0 ? void 0 : element.elementId,
                                data: {
                                    duration: this.duration,
                                    meetStartAt: new SchedulerMessageUtils().convertToISOString((_g = this.SelectedSlot) === null || _g === void 0 ? void 0 : _g.availability, (_h = this.selectedDate) === null || _h === void 0 ? void 0 : _h.date),
                                },
                                loggedInUser: this.loggedInUser,
                                message: this.schedulerMessage
                            })
                                .then((response) => {
                                var _a;
                                if (response) {
                                    chatSdkJavascript.CometChat.markAsInteracted((_a = this.schedulerMessage) === null || _a === void 0 ? void 0 : _a.getId(), element === null || element === void 0 ? void 0 : element.elementId);
                                    this.previousPage = this.currentPage;
                                    this.currentPage = 4;
                                    this.schedulingInProgress = false;
                                    this.slotAlreadyBooked = false;
                                    this.showError = false;
                                    this.requestUpdate("slotAlreadyBooked");
                                    this.requestUpdate("currentPage");
                                }
                                else {
                                    this.slotAlreadyBooked = false;
                                    this.showError = true;
                                    this.schedulingInProgress = false;
                                    this.requestUpdate("showError");
                                    this.requestUpdate("schedulingInProgress");
                                }
                            })
                                .catch((err) => {
                                console.log(err);
                                this.showError = true;
                                this.schedulingInProgress = false;
                                this.schedulingInProgress = false;
                                this.requestUpdate("schedulingInProgress");
                                this.requestUpdate("showError");
                            })
                                .finally(() => {
                            });
                        }
                    }
                });
            }
        }
        catch (err) {
            console.log(err);
        }
    }
    getGoalCompletedView() {
        var _a;
        return lit.html `<cometchat-quick-view
          .title=${this.title}
          .subtitle=${uikitResources.localize("MEETING_SCHEDULER")}
          .quickViewStyle=${this.getquickViewStyle()}

    ></cometchat-quick-view>
     <span style=${styleMap_js.styleMap(this.getGoalCompletionTextStyle())}
          >${((_a = this.interactiveData) === null || _a === void 0 ? void 0 : _a.goalCompletionText) || this.goalCompletionText}</span
        >
    `;
    }
    render() {
        var _a, _b, _c, _d;
        if (this.schedulerMessage) {
            if (this.loggedInUser) {
                let allowInteraction = (_a = this.schedulerMessage) === null || _a === void 0 ? void 0 : _a.getIsSenderInteractionAllowed(false);
                let isSender = !((_b = this.schedulerMessage) === null || _b === void 0 ? void 0 : _b.getSender()) || ((_c = this.schedulerMessage) === null || _c === void 0 ? void 0 : _c.getSender().getUid()) == ((_d = this.loggedInUser) === null || _d === void 0 ? void 0 : _d.getUid());
                this.allowSenderInteraction = allowInteraction ? true : !isSender;
            }
            else {
                this.allowSenderInteraction = true;
            }
            this.currentPage == 1 || this.currentPage == 3;
            return lit.html `
 <div class="cc-meeting-bubble__wrapper ${this.isLoading || this.availableDefaultSlots ? "cc-meeting-bubble__loading" : "cc-meeting-bubble__loaded"}"  style=${styleMap_js.styleMap(this.getWrapperStyle())}>
      ${this.interactiveData ? this.getHeaderView() : lit.nothing}
     ${this.currentPage < 4 ? lit.html ` <div class="divider"> <cometchat-divider .dividerStyle=${this.getDividerStyle()} class="divider"></cometchat-divider></div>` : lit.nothing}
     <div class="cc-bubble_content-view" style=${styleMap_js.styleMap(this.getContentWrapperStyle())}>
     ${this.interactiveData ? this.getContentView() : lit.nothing}
     </div>
     ${this.interactiveData ? this.getButtonView() : lit.nothing}
     </div>
    `;
        }
    }
    goToNextPage(page) {
        this.previousPage = this.currentPage;
        this.currentPage++;
        this.showError = false;
        this.schedulingInProgress = false;
        this.slotAlreadyBooked = false;
        this.requestUpdate("currentPage");
    }
    goToPreviousPage(page) {
        this.showError = false;
        this.schedulingInProgress = false;
        this.slotAlreadyBooked = false;
        // this.previousPage = this.currentPage;
        if (this.previousPage != undefined) {
            this.currentPage = this.previousPage;
            this.previousPage = undefined;
        }
        else {
            this.currentPage--;
        }
        this.requestUpdate("currentPage");
    }
    onSlotClick(slot) {
        this.showError = false;
        this.schedulingInProgress = false;
        this.slotAlreadyBooked = false;
        this.selectedDate = slot === null || slot === void 0 ? void 0 : slot.item;
        this.previousPage = this.currentPage;
        this.SelectedSlot = slot;
        // Handle slot selection
        this.currentPage = 3;
        this.requestUpdate("showError");
        this.requestUpdate("slotAlreadyBooked");
        this.requestUpdate("currentPage");
    }
    async makePutRequest(url, method, data, headers) {
        try {
            // Create a new Headers object
            const header = headers !== null && headers !== void 0 ? headers : {
                'Content-Type': 'application/json; charset=UTF-8',
                'loggedInUser': 'userId'
            };
            // Add additional headers if provided
            if (header) {
                Object.entries(header).forEach(([key, value]) => {
                    if (key && value) {
                        header.append(key.trim(), value.trim());
                    }
                });
            }
            // Set up the options for the fetch call
            const options = {
                method: 'PUT',
                headers: header,
                body: JSON.stringify(data), // Convert the data to a JSON string
            };
            // Perform the HTTP PUT call using fetch
            const response = await fetch(url, options);
            if (!response.ok) {
                // Check if the response status is not successful and throw an error
                throw new Error(`Request failed with status ${response.status}`);
            }
            // Convert the response to JSON (or handle as needed)
            const result = await response.json();
            // Return or process the result as required
            return result;
        }
        catch (error) {
            console.error('There was an error making the PUT request', error);
            // Handle errors as appropriate for your application
        }
    }
    // styles
    getAvatarStyle() {
        var _a;
        let defaultStyle = {
            borderRadius: "24px",
            width: "48px",
            height: "48px",
            border: "none",
            backgroundColor: "rgba(20, 20, 20, 0.69)",
            nameTextColor: "rgba(255, 255, 255)",
            backgroundSize: "cover",
            nameTextFont: "400 15px Inter,sans-serif",
        };
        return { ...defaultStyle, ...(_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.avatarStyle };
    }
    getTitleStyle() {
        var _a, _b;
        return {
            textFont: ((_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.titleTextFont) || "600 22px Inter,sans-serif",
            textColor: ((_b = this.schedulerBubbleStyle) === null || _b === void 0 ? void 0 : _b.titleTextColor) || "black"
        };
    }
    getSubtitleStyle() {
        var _a, _b;
        return {
            font: ((_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.subtitleTextFont) || "400 13px Inter,sans-serif",
            color: ((_b = this.schedulerBubbleStyle) === null || _b === void 0 ? void 0 : _b.subtitleTextColor) || "grey"
        };
    }
    slotBookedStyle() {
        var _a, _b;
        return {
            font: ((_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.errorTextFont) || "400 11px Inter,sans-serif",
            color: ((_b = this.schedulerBubbleStyle) === null || _b === void 0 ? void 0 : _b.errorTextColor) || "red"
        };
    }
    getSelectSlotStyles() {
        if (this.allowSenderInteraction) {
            return {
                buttonTextFont: this.schedulerBubbleStyle.suggestedTimeTextFont || "500 13px Inter,sans-serif",
                buttonTextColor: this.allowSenderInteraction ? this.schedulerBubbleStyle.suggestedTimeTextColor || "rgba(51, 153, 255)" : "grey",
                border: this.allowSenderInteraction ? this.schedulerBubbleStyle.suggestedTimeBorder || "1px solid rgba(51, 153, 255)" : "grey",
                borderRadius: this.schedulerBubbleStyle.suggestedTimeBorderRadius || "8px",
                background: this.schedulerBubbleStyle.suggestedTimeBackground || "white",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "5px 12px",
                minHeight: "32px"
            };
        }
        else {
            return {
                buttonTextFont: this.schedulerBubbleStyle.suggestedTimeDisabledTextFont || "400 15px Inter,sans-serif",
                buttonTextColor: this.schedulerBubbleStyle.suggestedTimeDisabledTextColor || "grey",
                border: this.schedulerBubbleStyle.suggestedTimeDisabledBorder || "grey",
                borderRadius: this.schedulerBubbleStyle.suggestedTimeDisabledBorderRadius || "8px",
                background: this.schedulerBubbleStyle.suggestedTimeDisabledBackground || "white",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "8px",
            };
        }
    }
    getBackButtonStyle() {
        var _a;
        return {
            height: "20px", width: "20px", iconHeight: "20px", iconWidth: "20px", buttonIconTint: ((_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.backButtonIconTint) || "#56a1f0", border: "none", background: "transparent"
        };
    }
    getTimeZoneStyle() {
        return {
            font: this.schedulerBubbleStyle.timezoneTextFont || "400 11px Inter,sans-serif",
            color: this.schedulerBubbleStyle.timezoneTextColor || "grey"
        };
    }
    getButtonsStyle() {
        var _a, _b, _c;
        let moreButtonStyle = {
            buttonTextFont: ((_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.moreButtonTextFont) || "400 13px Inter", buttonTextColor: this.allowSenderInteraction ? this.schedulerBubbleStyle.moreButtonTextColor || "rgba(51, 153, 255)" : "grey", border: this.schedulerBubbleStyle.moreButtonTextBorder || "none", borderRadius: this.schedulerBubbleStyle.moreButtonTextBorderRadius || "0", background: this.schedulerBubbleStyle.moreButtonTextBackground || "transparent", width: "100%", display: "flex", justifyContent: "center", minHeight: "22px"
        };
        if (!this.allowSenderInteraction) {
            moreButtonStyle = {
                buttonTextFont: ((_b = this.schedulerBubbleStyle) === null || _b === void 0 ? void 0 : _b.moreButtonDisabledTextFont) || "400 13px Inter", buttonTextColor: this.schedulerBubbleStyle.moreButtonDisabledTextColor || "grey", border: this.schedulerBubbleStyle.moreButtonDisabledTextBorder || "none", borderRadius: this.schedulerBubbleStyle.moreButtonDisabledTextBorderRadius || "0", background: this.schedulerBubbleStyle.moreButtonDisabledTextBackground || "transparent", width: "100%", display: "flex", justifyContent: "center", minHeight: "22px"
            };
        }
        let defaultScheduleButtonStyle = {
            iconHeight: "20px", iconWidth: "20px", buttonIconTint: "white",
            buttonTextFont: "400 15px Inter", buttonTextColor: "white", border: "none", borderRadius: "8px", background: "rgba(51, 153, 255)", width: "100%", display: "flex", justifyContent: "center", padding: "8px"
        };
        let configStyle = { ...(_c = this.schedulerBubbleStyle) === null || _c === void 0 ? void 0 : _c.scheduleButtonStyle, ...{ buttonIconTint: "white" } };
        return this.currentPage == 0 ? moreButtonStyle : { ...defaultScheduleButtonStyle, ...configStyle };
    }
    emptySlotStyle() {
        var _a, _b;
        return {
            textFont: ((_a = this.schedulerBubbleStyle.timeSlotSelectorStyle) === null || _a === void 0 ? void 0 : _a.emptySlotTextFont) || "400 15px Inter,sans-serif",
            textColor: ((_b = this.schedulerBubbleStyle.timeSlotSelectorStyle) === null || _b === void 0 ? void 0 : _b.emptySlotTextColor) || "grey"
        };
    }
    emptySlotIconStyle() {
        var _a;
        return {
            iconTint: ((_a = this.schedulerBubbleStyle.timeSlotSelectorStyle) === null || _a === void 0 ? void 0 : _a.emptySlotIconTint) || "grey",
            height: "24px",
            width: "24px"
        };
    }
    getDividerStyle() {
        var _a;
        return {
            height: "1px",
            width: "100%",
            background: ((_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.seperatorTint) || "#cccccc"
        };
    }
    getquickViewStyle() {
        var _a, _b;
        let defaultStyle = {
            background: ((_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.background) || "rgb(240 240 240)",
            height: "fit-content",
            width: "100%",
            titleFont: "600 13px Inter, sans-serif",
            titleColor: "grey",
            subtitleFont: "400 13px Inter, sans-serif",
            subtitleColor: "grey",
            closeIconTint: "black",
            leadingBarTint: "rgba(51, 153, 255)",
            leadingBarWidth: "8px",
            borderRadius: "8px",
        };
        return { ...defaultStyle, ...(_b = this.schedulerBubbleStyle) === null || _b === void 0 ? void 0 : _b.quickViewStyle };
    }
    getdateSelectorStyle() {
        var _a;
        let defaultStyle = {
            height: "fit-content",
            width: "100%",
            border: "none",
            borderRadius: "0",
            background: "transparent",
            dateTextFont: "400 13px Inter, sans-serif",
            dateTextColor: "#000",
            dayTextFont: "600 13.86px Inter, sans-serif",
            dayTextColor: "#000",
            monthYearTextFont: "700 13.86px Inter,sans-serif",
            monthYearTextColor: "#000",
            defaultDateTextBackground: 'transparent',
            disabledDateTextColor: 'grey',
            disabledDateTextFont: "400 13px Inter, sans-serif",
            disabledDateTextBackground: "transparent",
            titleTextFont: "400 15px Inter, sans-serif",
            titleTextColor: "black",
            timezoneTextFont: "400 13px Inter, sans-serif",
            timezoneTextColor: "black",
            arrowButtonTextColor: "black",
            arrowButtonTextFont: "400 15px Inter"
        };
        return { ...defaultStyle, ...(_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.dateSelectorStyle };
    }
    getContentWrapperStyle() {
        let padding = {
            padding: "16px"
        };
        if (this.currentPage == 2) {
            padding = {
                padding: "14px 16px 16px 16px"
            };
        }
        if (this.currentPage == 3) {
            padding = {
                padding: "16px 16px 12px 16px"
            };
        }
        if (this.currentPage == 4) {
            padding = {
                padding: "4px 12px"
            };
        }
        return {
            ...padding
        };
    }
    getHeaderStyle() {
        let padding = {
            padding: "10px 4px"
        };
        if (this.currentPage == 3) {
            padding = {
                padding: "16px 7px"
            };
        }
        return {
            ...padding
        };
    }
    getWrapperStyle() {
        var _a, _b, _c, _d, _e, _f, _g;
        let background = this.currentPage == 4 ? {
            background: ((_b = (_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.quickViewStyle) === null || _b === void 0 ? void 0 : _b.background) || "rgb(214 214 214)"
        } : {
            background: ((_c = this.schedulerBubbleStyle) === null || _c === void 0 ? void 0 : _c.background) || "rgb(240 240 240)"
        };
        return {
            height: ((_d = this.schedulerBubbleStyle) === null || _d === void 0 ? void 0 : _d.height) || "fit-content",
            width: ((_e = this.schedulerBubbleStyle) === null || _e === void 0 ? void 0 : _e.width) || "300px",
            border: ((_f = this.schedulerBubbleStyle) === null || _f === void 0 ? void 0 : _f.border) || "none",
            borderRadius: ((_g = this.schedulerBubbleStyle) === null || _g === void 0 ? void 0 : _g.borderRadius) || "8px",
            ...background,
        };
    }
    getGoalCompletionTextStyle() {
        return {
            font: this.schedulerBubbleStyle.goalCompletionTextFont || "400 15px Inter, sans-serifer",
            color: this.schedulerBubbleStyle.goalCompletionTextColor || "grey",
            display: "flex",
            paddingLeft: "4px",
            paddingTop: "8px"
        };
    }
    getSummeryStyle() {
        var _a, _b;
        return {
            font: ((_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.summaryTextFont) || "400 15px Inter, sans-serif",
            color: ((_b = this.schedulerBubbleStyle) === null || _b === void 0 ? void 0 : _b.summaryTextColor) || "black",
            textAlign: "left"
        };
    }
    getListItemStyle() {
        var _a;
        let defailtStyle = {
            height: "fit-content",
            width: "100%",
            background: "transparent",
            activeBackground: "transparent",
            borderRadius: "0",
            titleFont: "400 15px Inter, sans-serif",
            titleColor: "black",
            border: "none",
            separatorColor: "",
            hoverBackground: "transparent",
        };
        return { ...defailtStyle, ...(_a = this.schedulerBubbleStyle) === null || _a === void 0 ? void 0 : _a.listItemStyle };
    }
};
exports.CometChatSchedulerBubble.styles = lit.css `
    :host {
     box-sizing:border-box;
     margin:0;
    padding:0;
            text-align: center;
    }
    .cc-scheduler-button__common{
      width:100%;
      height:100%;
    }
    .cc-bubble_content-view{
      padding: 16px;
    }
    .cc-initial_header-title{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 16px 16px 16px;
    }
          .cc-empty__view{
      min-height: 120px;
    justify-content: center;
    align-items: center;
    display: flex;
    width:100%;
    flex-direction:column;
    gap:4px;
}
          .avatar {
          padding:16px 16px 10px 16px;
        width: fit-content;
        height: fit-content;
        margin: 0 auto;
      }
      cometchat-label {
        display:flex;
        justify-content:center;
        align-items:center;
      }
      .divider {
        width: 100%;
        display:block;
      }
      .subtitle_view{
        display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    padding-top:6px;
      }
      .buttons {
        display: flex;
        justify-content: center;
        gap: 12px;
        flex-direction: column;
        align-items: center;
        width: 100%;
       cometchat-button{
        width:100%;
        height:100%;
        }

      }
   .more-button{
     display: flex;
    justify-content: center;
    flex-direction: column-reverse;
    align-items: center;
    width: 100%;
    padding: 0px 16px 16px 16px;
    overflow: hidden;
    box-sizing:border-box;
    cometchat-button{
      width:100%;
    }
   }
         .cc-slot__list-item{
    display: flex;
    column-gap: 4px;
    width: 100%;
    padding: 10px 4px;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;

      }

    cometchat-list-item{
      width:100%;
    }
.cc-slot__title-header > .cc-slot__back-button{
  padding-top:0;
}
.cc-meeting-bubble__wrapper{
      height: fit-content;
    width: 300px;
    background: #efefef;
    box-sizing: border-box;
     border-radius:8px;
}
.cc-meeting-bubble__time-format{
  display:flex;
  padding:2px;
  padding-top:4px;

}
.cc-loading__view{
      min-height: 120px;
    justify-content: center;
    align-items: center;
    display: flex;
}
.cc-confirm-page__wrapper{
      flex-direction: column;
    display: flex;
    gap: 12px;
        align-items: flex-start;
}
.cc-confirm-page__icon{
    display: flex;
    gap: 6px;
    justify-content: center;
    align-items: flex-start;
}
.cc-meeting__slot-booked{
      display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    padding-top:2px;
}
.cc-meeting__slot-error{
      display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    padding-top:2px;
}
  `;
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatSchedulerBubble.prototype, "title", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatSchedulerBubble.prototype, "avatarUrl", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatSchedulerBubble.prototype, "goalCompletionText", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatSchedulerBubble.prototype, "avatarStyle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatSchedulerBubble.prototype, "onScheduleClick", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatSchedulerBubble.prototype, "timeFormat", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatSchedulerBubble.prototype, "loggedInUser", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatSchedulerBubble.prototype, "emptySlotIconURL", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatSchedulerBubble.prototype, "backButtonIconURL", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatSchedulerBubble.prototype, "loadingIconURL", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatSchedulerBubble.prototype, "clockIconURL", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatSchedulerBubble.prototype, "calendarIconURL", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatSchedulerBubble.prototype, "timezoneIconURL", void 0);
__decorate([
    decorators_js.property({ type: uikitResources.SchedulerMessage })
], exports.CometChatSchedulerBubble.prototype, "schedulerMessage", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatSchedulerBubble.prototype, "schedulerBubbleStyle", void 0);
exports.CometChatSchedulerBubble = __decorate([
    decorators_js.customElement('cometchat-scheduler-bubble')
], exports.CometChatSchedulerBubble);

var EmptySlotIcon = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_10446_6597%29%22%3E%3Cpath%20d%3D%22M20.997%2012.2497C21.0472%2010.4478%2020.5552%208.6724%2019.5847%207.1534C18.6142%205.63439%2017.2099%204.44181%2015.5537%203.73014C13.8976%203.01848%2012.0659%202.82052%2010.296%203.16192C8.526%203.50331%206.89934%204.36833%205.6267%205.64491C4.35406%206.9215%203.49408%208.55082%203.15815%2010.3218C2.82223%2012.0928%203.02585%2013.9239%203.74263%2015.5778C4.45942%2017.2318%205.65633%2018.6323%207.17834%2019.5982C8.70034%2020.564%2010.4773%2021.0505%2012.279%2020.9947%22%20stroke%3D%22%23A1A1A1%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M16%2019C16%2019.7956%2016.3161%2020.5587%2016.8787%2021.1213C17.4413%2021.6839%2018.2044%2022%2019%2022C19.7956%2022%2020.5587%2021.6839%2021.1213%2021.1213C21.6839%2020.5587%2022%2019.7956%2022%2019C22%2018.2044%2021.6839%2017.4413%2021.1213%2016.8787C20.5587%2016.3161%2019.7956%2016%2019%2016C18.2044%2016%2017.4413%2016.3161%2016.8787%2016.8787C16.3161%2017.4413%2016%2018.2044%2016%2019Z%22%20stroke%3D%22%23A1A1A1%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M17%2021L21%2017%22%20stroke%3D%22%23A1A1A1%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12%207V12L14%2014%22%20fill%3D%22%23A1A1A1%22%2F%3E%3Cpath%20d%3D%22M12%207V12L14%2014%22%20stroke%3D%22%23A1A1A1%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_10446_6597%22%3E%3Crect%20width%3D%2224%22%20height%3D%2224%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var TimeFormat;
(function (TimeFormat) {
    TimeFormat["12hr"] = "12hr";
    TimeFormat["24hr"] = "24hr";
})(TimeFormat || (TimeFormat = {}));
exports.CometChatTimeSlot = class CometChatTimeSlot extends lit.LitElement {
    constructor() {
        super();
        this.calendarIconURL = calenderIcon;
        this.timeSlotStyle = {};
        this.from = "";
        this.to = "";
        this.duration = 0;
        this.timeFormat = TimeFormat['12hr'];
        this.availableSlots = [];
        this.timezoneCode = "";
        this.meetingDateRangeStart = 0;
        this.meetingDateRangeEnd = 0;
        this.buffer = 30;
        this.selectedDayDate = {};
        this.timezoneIconURL = planetIcon;
        this.emptySlotIconURL = EmptySlotIcon;
        this.slots = {};
    }
    _selectSlot(slot) {
        // Handle slot selection logic here
        this.dispatchEvent(new CustomEvent('cc-slot-selected', {
            bubbles: true,
            composed: true,
            detail: { availability: slot, item: this.availableSlots }
        }));
        // You may want to dispatch a custom event or make an API call
    }
    connectedCallback() {
        var _a, _b;
        super.connectedCallback();
        if (this.availableSlots && ((_a = Object.keys(this.availableSlots)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.slots = this.availableSlots;
        }
        else {
            new SchedulerMessageUtils().getSlotsForADate(this.blockedTime, (_b = this.selectedDayDate) === null || _b === void 0 ? void 0 : _b.date, this.buffer, this.duration, this.timeFormat, this.availability, this.timezoneCode).then((slot) => {
                this.slots = slot;
                this.requestUpdate("slots");
            });
        }
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        let showSlot = this.slots && ((_a = this.slots) === null || _a === void 0 ? void 0 : _a.availability) && ((_c = (_b = this.slots) === null || _b === void 0 ? void 0 : _b.availability) === null || _c === void 0 ? void 0 : _c.length) > 0;
        return lit.html `
   <div class="cc-time-slot__wrapper" style=${styleMap_js.styleMap(this.getWrapperStyle())}>
            <div class="cc-time-slot__icon">
               <cometchat-icon .URL=${this.calendarIconURL} .iconStyle=${{ height: "16px", width: "16px", iconTint: ((_d = this.timeSlotStyle) === null || _d === void 0 ? void 0 : _d.calendarIconTint) || "grey" }}></cometchat-icon>
                     <div class="date" style=${styleMap_js.styleMap(this.getTitleStyle())}>${(_e = this.selectedDayDate) === null || _e === void 0 ? void 0 : _e.day}</div>

            </div>
      <div class="divider">
      <cometchat-divider .dividerStyle=${this.getDividerStyle()}></cometchat-divider>
      </div>
     ${showSlot ? lit.html ` <div class="subtitle"
     style=${styleMap_js.styleMap(this.getSubtitleStyle())}>${uikitResources.localize("SELECT_TIME")}</div>` : lit.nothing}
      <div div class= "slots" style=${styleMap_js.styleMap({ gridTemplateColumns: showSlot ? "repeat(3, 1fr)" : "100%" })}>
        ${showSlot ? (_f = this.slots) === null || _f === void 0 ? void 0 : _f.availability.map((slot) => lit.html `
            <div class="slot" style=${styleMap_js.styleMap(this.getSelectSlotStyles())} @click="${() => this._selectSlot(slot)}">
              ${slot}
            </div>
          `) : lit.html `<div class="cc-empty__view">
        <cometchat-icon .URL=${this.emptySlotIconURL} .iconStyle=${this.emptySlotIconStyle()}></cometchat-icon>
    <cometchat-label .labelStyle=${this.emptySlotStyle()} .text=${uikitResources.localize("MEETING_NO_SLOTS_AVAILABLE")}></cometchat-label>
    </div>`}
      </div>
       <span class="cc-time-slot_time-format"  style=${styleMap_js.styleMap({ font: ((_g = this.timeSlotStyle) === null || _g === void 0 ? void 0 : _g.timezoneTextFont) || "400 11px Inter", color: ((_h = this.timeSlotStyle) === null || _h === void 0 ? void 0 : _h.timezoneTextColor) || "black" })}>  <cometchat-icon .URL=${this.timezoneIconURL} .iconStyle=${{ height: "16px", width: "16px", iconTint: ((_j = this.timeSlotStyle) === null || _j === void 0 ? void 0 : _j.timezoneIconTint) || "black" }}></cometchat-icon>
      ${new SchedulerMessageUtils().getTimeZoneName()}
      </span>
   </div>
    `;
    }
    getTitleStyle() {
        var _a, _b;
        return {
            font: ((_a = this.timeSlotStyle) === null || _a === void 0 ? void 0 : _a.dateTextFont) || "400 15px Inter,sans-serif",
            color: ((_b = this.timeSlotStyle) === null || _b === void 0 ? void 0 : _b.dateTextColor) || "black"
        };
    }
    getSubtitleStyle() {
        var _a, _b;
        return {
            font: ((_a = this.timeSlotStyle) === null || _a === void 0 ? void 0 : _a.titleTextFont) || "400 17px Inter,sans-serif",
            color: ((_b = this.timeSlotStyle) === null || _b === void 0 ? void 0 : _b.titleTextColor) || "black"
        };
    }
    timezoneStyles() {
        var _a, _b;
        return {
            font: ((_a = this.timeSlotStyle) === null || _a === void 0 ? void 0 : _a.timezoneTextFont) || "400 11px Inter,sans-serif",
            color: ((_b = this.timeSlotStyle) === null || _b === void 0 ? void 0 : _b.timezoneTextColor) || "grey"
        };
    }
    emptySlotStyle() {
        var _a, _b;
        return {
            textFont: ((_a = this.timeSlotStyle) === null || _a === void 0 ? void 0 : _a.emptySlotTextFont) || "400 15px sans-serif,Inter",
            textColor: ((_b = this.timeSlotStyle) === null || _b === void 0 ? void 0 : _b.emptySlotTextColor) || "grey"
        };
    }
    emptySlotIconStyle() {
        var _a;
        return {
            iconTint: ((_a = this.timeSlotStyle) === null || _a === void 0 ? void 0 : _a.emptySlotIconTint) || "grey",
            height: "24px",
            width: "24px"
        };
    }
    getWrapperStyle() {
        var _a, _b, _c, _d, _e;
        return {
            height: ((_a = this.timeSlotStyle) === null || _a === void 0 ? void 0 : _a.height) || "fit-content",
            width: ((_b = this.timeSlotStyle) === null || _b === void 0 ? void 0 : _b.width) || "100%",
            border: ((_c = this.timeSlotStyle) === null || _c === void 0 ? void 0 : _c.border) || "none",
            borderRadius: ((_d = this.timeSlotStyle) === null || _d === void 0 ? void 0 : _d.borderRadius) || "8px",
            background: ((_e = this.timeSlotStyle) === null || _e === void 0 ? void 0 : _e.background) || "rgb(240 240 240)"
        };
    }
    getDividerStyle() {
        var _a;
        return {
            height: "1px",
            width: "100%",
            background: ((_a = this.timeSlotStyle) === null || _a === void 0 ? void 0 : _a.seperatorTint) || "#e0e0e0"
        };
    }
    getSelectSlotStyles() {
        var _a, _b, _c, _d, _e;
        return {
            font: ((_a = this.timeSlotStyle) === null || _a === void 0 ? void 0 : _a.slotTextFont) || "400 11px Inter,sans-serif",
            color: ((_b = this.timeSlotStyle) === null || _b === void 0 ? void 0 : _b.slotTextColor) || "grey",
            border: ((_c = this.timeSlotStyle) === null || _c === void 0 ? void 0 : _c.slotBorder) || "none",
            borderRadius: ((_d = this.timeSlotStyle) === null || _d === void 0 ? void 0 : _d.slotBorderRadius) || "8px",
            background: ((_e = this.timeSlotStyle) === null || _e === void 0 ? void 0 : _e.slotBackground) || "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px",
        };
    }
};
exports.CometChatTimeSlot.styles = lit.css `
    :host {
    box-sizing:border-box;
    }
       .cc-empty__view{
      min-height: 120px;
    justify-content: center;
    align-items: center;
    display: flex;
    width:100%;
    flex-direction:column;
    gap:4px;
}
.cc-time-slot__icon{
    display: flex;
    gap: 6px;
    justify-content: flex-start;
    align-items: center;
}
.cc-time-slot__wrapper{
  box-sizing: border-box;
    overflow: hidden;
}
       .date {
        text-align: left;
      }
      .divider {
        height: 1px;
        padding:14px 0;
      }
      .subtitle {
        text-align: left;
        font-weight: bold;
      }
  .cc-time-slot_time-format{
  display:flex;
  padding-top:18px;
  gap:6px;
  align-items:center;
  justify-content: flex-end;
   }
     .slots {
          display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 8px;
      padding-top: 14px;
      overflow-y: auto;
      }
      .slot {
      height: fit-content;
      box-sizing: border-box;
      padding: 10px;
      text-align: center;
      border: 1px solid #ccc;
      cursor: pointer;
      background-color: #f9f9f9;      }
      .cc-slot__list-item{
    display: flex;
    column-gap: 10px;
    width:100%;
    min-height: 30px;
    min-width: 85px;

      }
      .cc-slot__back-button{
        padding-top:8px;

}
      }



  `;
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatTimeSlot.prototype, "calendarIconURL", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatTimeSlot.prototype, "timeSlotStyle", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatTimeSlot.prototype, "from", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatTimeSlot.prototype, "to", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatTimeSlot.prototype, "duration", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatTimeSlot.prototype, "timeFormat", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatTimeSlot.prototype, "blockedTime", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatTimeSlot.prototype, "availability", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatTimeSlot.prototype, "availableSlots", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatTimeSlot.prototype, "timezoneCode", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatTimeSlot.prototype, "meetingDateRangeStart", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatTimeSlot.prototype, "meetingDateRangeEnd", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatTimeSlot.prototype, "buffer", void 0);
__decorate([
    decorators_js.property({ type: Function })
], exports.CometChatTimeSlot.prototype, "onSelection", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatTimeSlot.prototype, "selectedDayDate", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatTimeSlot.prototype, "timezoneIconURL", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatTimeSlot.prototype, "emptySlotIconURL", void 0);
exports.CometChatTimeSlot = __decorate([
    decorators_js.customElement('cometchat-time-slot')
], exports.CometChatTimeSlot);

class TimeSlotStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "";
        this.titleTextColor = "";
        this.dateTextFont = "";
        this.dateTextColor = "";
        this.slotTextFont = "";
        this.slotTextColor = "";
        this.emptySlotTextFont = "";
        this.emptySlotTextColor = "";
        this.slotBackground = "";
        this.slotBorder = "";
        this.slotBorderRadius = "";
        this.timezoneTextFont = "";
        this.timezoneTextColor = "";
        this.emptySlotIconTint = "";
        this.calendarIconTint = "";
        this.seperatorTint = "";
        this.timezoneIconTint = "";
        Object.assign(this, props);
    }
}

exports.CometChatCalendar = class CometChatCalendar extends lit.LitElement {
    constructor() {
        super();
        this.maxDate = "2023-10-05";
        this.minDate = "2023-05-05";
        this.timezoneIconURL = planetIcon;
        this.timezoneText = "Time Zone";
        this.calendarStyle = {
            height: "fit-content",
            width: "100%",
            border: "none",
            borderRadius: "0",
            background: "transparent",
            dateTextFont: "400 13px Inter, sans-serif",
            dateTextColor: "#000",
            dayTextFont: "600 13.86px Inter, sans-serif",
            dayTextColor: "#000",
            monthYearTextFont: "700 13.86px Inter,sans-serif",
            monthYearTextColor: "#000",
            defaultDateTextBackground: 'transparent',
            disabledDateTextColor: 'grey',
            disabledDateTextFont: "400 13px Inter, sans-serif",
            disabledDateTextBackground: "transparent",
            titleTextFont: "400 15px Inter, sans-serif",
            titleTextColor: "black",
            timezoneTextFont: "400 13px Inter, sans-serif",
            timezoneTextColor: "black",
            arrowButtonTextColor: "black",
            arrowButtonTextFont: "400 15px Inter"
        };
        this.currentDate = new Date();
        this.currentMonth = this.currentDate.getMonth();
        this.currentYear = this.currentDate.getFullYear();
        this.monthYear = "";
        this.startDay = 0;
        this.endDay = 0;
        this.datesElement = [];
        this.prevBtnDisabled = false;
        this.disableNextBtn = false;
        this.reRenderCount = 1;
        this.goToPreviousMonth = () => {
            if (this.isNextBtnDisabled()) {
                this.disableNextBtn = true;
            }
            else {
                this.disableNextBtn = false;
            }
            if (this.isPreviousBtnDisabled()) {
                this.prevBtnDisabled = true;
                return false;
            }
            this.currentMonth--;
            if (this.currentMonth < 0) {
                this.currentMonth = 11;
                this.currentYear--;
            }
            this.generateCalendar(this.currentMonth, this.currentYear);
        };
        this.goToNextMonth = () => {
            if (this.isPreviousBtnDisabled()) {
                this.prevBtnDisabled = true;
            }
            else {
                this.prevBtnDisabled = false;
            }
            if (this.isNextBtnDisabled()) {
                this.disableNextBtn = true;
                return false;
            }
            this.currentMonth++;
            if (this.currentMonth > 11) {
                this.currentMonth = 0;
                this.currentYear++;
            }
            this.generateCalendar(this.currentMonth, this.currentYear);
        };
        this.isPreviousBtnDisabled = () => {
            if (!this.minDate.length) {
                return false;
            }
            let minDate = new Date(this.minYear, this.minMonth);
            let currentDate = new Date(this.currentYear, this.currentMonth);
            if (currentDate <= minDate) {
                return true;
            }
            return false;
        };
        this.isNextBtnDisabled = () => {
            if (!this.maxDate.length) {
                return false;
            }
            let maxDate = new Date(this.maxYear, this.maxMonth);
            let currentMonth = this.currentMonth;
            let currentYear = this.currentYear;
            if (currentMonth > 11) {
                currentMonth = 0;
                ++currentYear;
            }
            let currentDate = new Date(currentYear, currentMonth);
            if (currentDate >= maxDate) {
                return true;
            }
            return false;
        };
        this.onDateClick = (event) => {
            this.currentSelectedDate = event === null || event === void 0 ? void 0 : event.target;
            this.currentSelectedDay = Number(this.currentSelectedDate.textContent);
            this.currentSelectedMonth = this.currentMonth;
            this.currentSelectedYear = this.currentYear;
            let date = this.formatDate(this.currentSelectedDay, this.currentSelectedMonth, this.currentSelectedYear);
            let day = this.formatDateToString(this.currentSelectedDay, this.currentSelectedMonth, this.currentSelectedYear);
            this.dispatchEvent(new CustomEvent('cc-date-selected', {
                bubbles: true,
                composed: true,
                detail: { date: date, day: day }
            }));
            this.reRenderCount++;
            this.requestUpdate("reRenderCount");
        };
    }
    requestUpdate(name, oldValue, options) {
        super.requestUpdate();
    }
    connectedCallback() {
        super.connectedCallback();
        [this.minYear, this.minMonth, this.minDay] = this.minDate.split("-").map((d) => Number(d));
        if ((this.minYear > this.currentYear) || (this.currentYear == this.minYear && this.minMonth > this.currentMonth)) {
            this.currentMonth = this.minMonth - 1;
            this.currentYear = this.minYear;
        }
        this.generateCalendar(this.currentMonth, this.currentYear);
        if (this.isPreviousBtnDisabled()) {
            this.prevBtnDisabled = true;
        }
        if (this.isNextBtnDisabled()) {
            this.disableNextBtn = true;
        }
    }
    generateCalendar(month, year) {
        this.month = month;
        this.year = year;
        this.monthYear = new Date(year, month).toLocaleString('default', { month: 'long' }) + ' ' + year;
        this.datesElement = [];
        const firstDayOfMonth = new Date(year, month, 1);
        const lastDayOfMonth = new Date(year, month + 1, 0);
        const startDay = firstDayOfMonth.getDay();
        const endDay = lastDayOfMonth.getDate();
        [this.maxYear, this.maxMonth, this.maxDay] = this.maxDate.split("-").map((d) => Number(d));
        [this.minYear, this.minMonth, this.minDay] = this.minDate.split("-").map((d) => Number(d));
        this.maxMonth = this.maxMonth - 1;
        this.minMonth = this.minMonth - 1;
        for (let i = 0; i < startDay; i++) {
            this.datesElement.push("");
        }
        for (let day = 1; day <= endDay; day++) {
            this.datesElement.push(day);
        }
        this.requestUpdate();
    }
    render() {
        var _a;
        let prevBtnClass = this.prevBtnDisabled ? `cc-calendar__prev disabled` : `cc-calendar__prev`;
        let nextBtnClass = this.disableNextBtn ? `cc-calendar__next disabled` : `cc-calendar__next`;
        return lit.html `
        <div class="cc-calendar" style= ${styleMap_js.styleMap(this.calendarStyles())}>
        <div class="cc-calendar__header-title"  style= ${styleMap_js.styleMap(this.titleStyles())}>${uikitResources.localize("SELECT_DAY")}</div>
            <div class="cc-calendar__header">
                <button type="button" style=${styleMap_js.styleMap(this.getArrowButtonStyle())} class=${prevBtnClass} ${this.prevBtnDisabled ? '@disabled' : ''}  @click=${this.goToPreviousMonth}>&lt;</button>
                <button type="button" class="cc-calendar__year-month" style=${styleMap_js.styleMap(this.monthYearStyles())}>${this.monthYear}</button>
                <button type="button" style=${styleMap_js.styleMap(this.getArrowButtonStyle())} class=${nextBtnClass} @click=${this.goToNextMonth}>&gt;</button>
            </div>
            <div class="cc-calendar__days">
                <div class="cc-calendar__days-day" style=${styleMap_js.styleMap(this.daysStyles())}>Sun</div>
                <div class="cc-calendar__days-day" style=${styleMap_js.styleMap(this.daysStyles())}>Mon</div>
                <div class="cc-calendar__days-day" style=${styleMap_js.styleMap(this.daysStyles())}>Tue</div>
                <div class="cc-calendar__days-day" style=${styleMap_js.styleMap(this.daysStyles())}>Wed</div>
                <div class="cc-calendar__days-day" style=${styleMap_js.styleMap(this.daysStyles())}>Thu</div>
                <div class="cc-calendar__days-day" style=${styleMap_js.styleMap(this.daysStyles())}>Fri</div>
                <div class="cc-calendar__days-day" style=${styleMap_js.styleMap(this.daysStyles())}>Sat</div>
            </div>
            <div class="cc-calendar__dates">
            ${this.reRenderCount > 0 ?
            this.datesElement.map((day) => {
                const isMinMonth = this.month === this.minMonth;
                const isMaxMonth = this.month === this.maxMonth;
                const isDisabled = (isMinMonth && day < this.minDay) || (isMaxMonth && day > this.maxDay);
                return lit.html `<div
                    class="cc-calendar__dates-date"
                    @click=${(e) => { this.onDateClick(e); }}
                    style=${styleMap_js.styleMap(this.dateStyles(day, this.month, this.year, isDisabled))}
                  >
                    ${"" + day}
                  </div>`;
            })
            : lit.nothing}
            </div>
                <span class="cc-calendar_time-format"  style=${styleMap_js.styleMap(this.timezoneStyles())}>
                     <cometchat-icon .URL=${this.timezoneIconURL} .iconStyle=${{ height: "16px", width: "16px", iconTint: ((_a = this.calendarStyle) === null || _a === void 0 ? void 0 : _a.timezoneTextColor) || "black" }}></cometchat-icon>
      ${new SchedulerMessageUtils().getTimeZoneName()}
      </span>
        </div>`;
    }
    formatDate(day, month, year) {
        // JS Date object months are 0-indexed, so we add one
        month += 1;
        // If the day or month is a single digit, prepend a 0
        if (day < 10)
            day = '0' + day;
        if (month < 10)
            month = '0' + month;
        // Concatenate the strings
        return `${year}-${month}-${day}`;
    }
    formatDateToString(day, month, year) {
        // Create a new Date object with the provided day, month, and year
        const date = new Date(year, month, day);
        // Format the date
        const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const weekday = dayNames[date.getDay()];
        const monthName = monthNames[date.getMonth()];
        let formattedDate = `${day} ${monthName} ${year}, ${weekday}`;
        return formattedDate;
    }
    monthYearStyles() {
        var _a, _b;
        return {
            font: (_a = this.calendarStyle) === null || _a === void 0 ? void 0 : _a.monthYearTextFont,
            color: (_b = this.calendarStyle) === null || _b === void 0 ? void 0 : _b.monthYearTextColor
        };
    }
    daysStyles() {
        var _a, _b;
        return {
            font: (_a = this.calendarStyle) === null || _a === void 0 ? void 0 : _a.dayTextFont,
            color: (_b = this.calendarStyle) === null || _b === void 0 ? void 0 : _b.dayTextColor
        };
    }
    titleStyles() {
        var _a, _b;
        return {
            font: (_a = this.calendarStyle) === null || _a === void 0 ? void 0 : _a.titleTextFont,
            color: (_b = this.calendarStyle) === null || _b === void 0 ? void 0 : _b.titleTextColor
        };
    }
    timezoneStyles() {
        var _a, _b;
        return {
            font: ((_a = this.calendarStyle) === null || _a === void 0 ? void 0 : _a.timezoneTextFont) || "400 11px Inter, sans-serif",
            color: ((_b = this.calendarStyle) === null || _b === void 0 ? void 0 : _b.timezoneTextColor) || "grey"
        };
    }
    timezoneTextStyles() {
        var _a, _b;
        return {
            font: ((_a = this.calendarStyle) === null || _a === void 0 ? void 0 : _a.timezoneTextFont) || "400 11px Inter, sans-serif",
            color: ((_b = this.calendarStyle) === null || _b === void 0 ? void 0 : _b.timezoneTextColor) || "grey"
        };
    }
    calendarStyles() {
        var _a, _b, _c, _d;
        return {
            height: (_a = this.calendarStyle) === null || _a === void 0 ? void 0 : _a.height,
            width: (_b = this.calendarStyle) === null || _b === void 0 ? void 0 : _b.width,
            borderRadius: (_c = this.calendarStyle) === null || _c === void 0 ? void 0 : _c.borderRadius,
            background: (_d = this.calendarStyle) === null || _d === void 0 ? void 0 : _d.background,
        };
    }
    dateStyles(day, month, year, disabled = false) {
        var _a, _b, _c, _d, _e, _f, _g;
        return {
            border: (_a = this.calendarStyle) === null || _a === void 0 ? void 0 : _a.border,
            margin: '1px',
            font: (_b = this.calendarStyle) === null || _b === void 0 ? void 0 : _b.dateTextFont,
            ...(disabled ? { pointerEvents: 'none' } : {}),
            ...(disabled ? { color: (_c = this.calendarStyle) === null || _c === void 0 ? void 0 : _c.disabledDateTextColor } : (day == this.currentSelectedDay && month == this.currentSelectedMonth && year == this.currentSelectedYear) ? { color: (_d = this.calendarStyle) === null || _d === void 0 ? void 0 : _d.dateTextColor } : { color: (_e = this.calendarStyle) === null || _e === void 0 ? void 0 : _e.dateTextColor }),
            ...(disabled ? { background: ((_f = this.calendarStyle) === null || _f === void 0 ? void 0 : _f.disabledDateTextBackground) || "transparent" } : { background: ((_g = this.calendarStyle) === null || _g === void 0 ? void 0 : _g.defaultDateTextBackground) || "transparent" })
        };
    }
    getArrowButtonStyle() {
        var _a, _b;
        return {
            font: ((_a = this.calendarStyle) === null || _a === void 0 ? void 0 : _a.arrowButtonTextFont) || "400 15px Inter",
            color: ((_b = this.calendarStyle) === null || _b === void 0 ? void 0 : _b.arrowButtonTextColor) || "black"
        };
    }
};
exports.CometChatCalendar.styles = [
    lit.css `
        .cc-calendar {
            margin: 0;
            box-sizing: border-box;
            overflow: hidden;
        }
        .cc-calendar__header-title{
                width: 100%;
               display: flex;
               padding-bottom: 17px;
        }
        .cc-calendar__header {
          display: flex;
    width: 96%;
    justify-content: space-between;
    margin: auto;
        }

        .cc-calendar__header > div {
            text-align: center;
        }

        .cc-calendar__prev,
        .cc-calendar__next,
        .cc-calendar__year-month {
            border: none;
            background:inherit;
            cursor: pointer;
        }

        .cc-calendar__prev.disabled,
        .cc-calendar__next.disabled {
            cursor: default;
            opacity: 0.5;

        }
        .cc-calendar-timezone-code{
  display: flex;
    gap: 6px;
    justify-content: center;
    align-items: center;
        }

        .cc-calendar__days {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
           padding: 18px 0px 16px 0px;
        }

        .cc-calendar__dates {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            gap: 8px;
        }

        .cc-calendar__dates-date {
            padding: 5px;
            cursor: pointer;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            position: relative;
            background: inherit;
        }
          .cc-calendar_time-format{
    padding-top: 22px;
    gap: 6px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
   }

        .cc-calendar__dates-date:hover {
            background: inherit;
        }
    `
];
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatCalendar.prototype, "maxDate", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatCalendar.prototype, "minDate", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatCalendar.prototype, "timezoneIconURL", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatCalendar.prototype, "timezoneText", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatCalendar.prototype, "calendarStyle", void 0);
exports.CometChatCalendar = __decorate([
    decorators_js.customElement('cometchat-calendar')
], exports.CometChatCalendar);

/**
 * LoaderStyle class represents the styles for popover. It extends BaseStyle.
 *
 * @property {string} boxShadow - boxshadow for popover.
 *  @extends {BaseStyle}
 */
class CalendarStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.dateTextFont = "400 12px Inter, sans-serif";
        this.dateTextColor = "grey";
        this.dayTextFont = "400 12px Inter";
        this.dayTextColor = "grey";
        this.monthYearTextFont = "700 13.86px Inter,sans-serif";
        this.monthYearTextColor = "#000";
        this.disabledDateTextFont = "400 12px Inter, sans-serif";
        /****added by Mathews ***/
        this.disabledDateTextBackground = '';
        this.defaultDateTextBackground = '';
        this.disabledDateTextColor = '';
        this.titleTextFont = "500 17px Inter, sans-serif";
        this.titleTextColor = "black";
        this.timezoneTextFont = "";
        this.timezoneTextColor = "";
        this.arrowButtonTextFont = "";
        this.arrowButtonTextColor = "";
        Object.assign(this, props);
    }
}

var EmptyIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%3F%3E%3Csvg%20version%3D%221.0%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100.000000pt%22%20height%3D%22100.000000pt%22%20viewBox%3D%220%200%20100.000000%20100.000000%22%20preserveAspectRatio%3D%22xMidYMid%20meet%22%3E%3Cg%20transform%3D%22translate%280.000000%2C100.000000%29%20scale%280.100000%2C-0.100000%29%22fill%3D%22%23000000%22%20stroke%3D%22none%22%3E%3Cpath%20d%3D%22M375%20847%20c-221%20-73%20-326%20-269%20-254%20-472%20l22%20-62%20-25%20-74%20c-14%20-41-23%20-80%20-21%20-86%206%20-17%2042%20-15%20138%206%2077%2017%2082%2017%20138%20-1%2072%20-22%20199%20-25%20216%20-46%207%209%2021%205%2030%20-5%2013%20-21%2016%20-79%2016%20-44%200%20-98%208%20-136%2019%20-58%2018%20-67%2019%20-123%206-89%20-21%20-88%20-23%20-65%2042%20l20%2058%20-26%2056%20c-52%20116%20-25%20240%2069%20327%2077%2071%20123%2087246%2087%20123%200%20169%20-16%20245%20-86%2064%20-59%2088%20-108%2094%20-199%205%20-68%208%20-75%2028%20-78%2036-5%2048%2038%2033%20118%20-22%20125%20-94%20215%20-218%20273%20-59%2028%20-79%2032%20-167%2034%20-63%202%20-115-2%20-140%20-10z%22%2F%3E%3Cpath%20d%3D%22M687%20313%20c-16%20-15%20-4%20-42%2038%20-83%20l45%20-44%20-45%20-46%20c-47%20-48%20-56%20-74-28%20-84%2011%20-5%2031%208%2064%2040%20l48%2047%2050%20-46%20c54%20-50%2061%20-53%2079%20-35%2018%2018%2015%2025-35%2079%20l-46%2050%2048%2049%20c41%2042%2046%2051%2035%2065%20-19%2023%20-30%2019%20-80%20-30%20l-46%20-45%20-4445%20c-41%2042%20-68%2054%20-83%2038z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var ErrorIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%3F%3E%3Csvg%20version%3D%221.0%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100.000000pt%22%20height%3D%22100.000000pt%22%20viewBox%3D%220%200%20100.000000%20100.000000%22%20preserveAspectRatio%3D%22xMidYMid%20meet%22%3E%3Cg%20transform%3D%22translate%280.000000%2C100.000000%29%20scale%280.100000%2C-0.100000%29%22fill%3D%22%23000000%22%20stroke%3D%22none%22%3E%3Cpath%20d%3D%22M375%20847%20c-221%20-73%20-326%20-269%20-254%20-472%20l22%20-62%20-25%20-74%20c-14%20-41-23%20-80%20-21%20-86%206%20-17%2042%20-15%20138%206%2077%2017%2082%2017%20138%20-1%2091%20-28%20257%20-20%20278%201312%2020%20-9%2052%20-29%2044%20-9%20-4%20-51%20-10%20-94%20-12%20-59%20-4%20-92%20-1%20-145%2015%20-63%2019%20-7220%20-128%207%20-88%20-21%20-87%20-23%20-64%2042%20l20%2058%20-26%2056%20c-52%20116%20-25%20240%2069%20327%207771%20123%2087%20246%2087%2087%200%20113%20-4%20152%20-22%20101%20-47%20188%20-160%20188%20-246%200%20-69%2036-102%2061%20-56%208%2016%208%2037%20-1%2083%20-24%20122%20-96%20212%20-218%20269%20-59%2028%20-79%2032%20-167%2034-63%202%20-115%20-2%20-140%20-10z%22%2F%3E%3Cpath%20d%3D%22M764%20347%20c-2%20-8%20-4%20-47%20-2%20-88%203%20-71%204%20-74%2028%20-74%2025%200%2025%201%2025%2085%20081%20-1%2085%20-23%2088%20-12%202%20-24%20-3%20-28%20-11z%22%2F%3E%3Cpath%20d%3D%22M764%2095%20c-4%20-9%200%20-23%208%20-31%2020%20-20%2050%20-7%2046%2020%20-4%2026%20-45%2035%20-54%2011z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

class AIBaseConfiguration {
    constructor(props) {
        this.loadingIconURL = LoadingIcon;
        this.errorIconURL = ErrorIcon;
        this.emptyIconURL = EmptyIcon;
        Object.assign(this, props);
    }
}

class AIBaseStyle extends BaseStyle {
    constructor(props) {
        super({});
        Object.assign(this, props);
    }
}

class AIConversationStarterConfiguration extends AIBaseConfiguration {
    constructor(props) {
        super({});
        Object.assign(this, props);
    }
}

class AIConversationStarterStyle extends AIBaseStyle {
    constructor(props) {
        super({});
        Object.assign(this, props);
    }
}

class AIConversationSummaryConfiguration extends AIBaseConfiguration {
    constructor(props) {
        super({});
        this.unreadMessageThreshold = 30;
        this.closeIconURL = closeIcon$1;
        Object.assign(this, props);
    }
}

class AIConversationSummaryStyle extends AIBaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "";
        this.titleTextColor = "";
        this.textFont = "";
        this.textColor = "";
        this.buttonTextColor = "";
        this.buttonTextFont = "";
        this.buttonBackground = "";
        this.closeIconTint = "";
        Object.assign(this, props);
    }
}

class AISmartRepliesConfiguration extends AIBaseConfiguration {
    constructor(props) {
        super({});
        this.backIconURL = backIcon;
        Object.assign(this, props);
    }
}

class AISmartRepliesStyle extends AIBaseStyle {
    constructor(props) {
        super({});
        this.textFont = "";
        this.textBorder = "";
        this.textBorderRadius = "";
        this.textColor = "";
        this.textBackground = "";
        this.buttonTextColor = "";
        this.buttonTextFont = "";
        this.buttonBackground = "";
        this.backIconTint = "";
        this.titleFont = "";
        this.titleColor = "";
        Object.assign(this, props);
    }
}

class AIOptionsStyle extends BaseStyle {
    constructor(props) {
        super({});
        Object.assign(this, props);
    }
}

class AIExtensionDataSource {
    enable() { }
}

class AIAssistBotStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.optionTitleFont = "";
        this.optionTitleColor = "";
        this.subtitleFont = "";
        this.subtitleColor = "";
        this.closeIconTint = "";
        this.backIconTint = "";
        this.sendIconTint = "";
        this.buttonTextColor = "";
        this.buttonTextFont = "";
        this.buttonBackground = "";
        Object.assign(this, props);
    }
}
class AITextMessageBubbleStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.textFont = "";
        this.textColor = "";
        Object.assign(this, props);
    }
}
class AIBotMessageBubbleStyle extends AITextMessageBubbleStyle {
    constructor(props) {
        super({});
        Object.assign(this, props);
    }
}
class AISenderMessageBubbleStyle extends AITextMessageBubbleStyle {
    constructor(props) {
        super({});
        Object.assign(this, props);
    }
}

class AIAssistBotConfiguration {
    constructor(props) {
        this.loadingIconURL = loadingIcon;
        this.errorIconURL = errorIcon;
        this.closeIconURL = closeIcon$1;
        this.sendIconURL = sendIcon;
        this.backIconURL = backIcon;
        this.emptyIconURL = EmptyIcon;
        Object.assign(this, props);
    }
}

const defaultStyle = new AIBaseStyle({
    height: "fit-content",
    width: "100%",
    border: "none",
    borderRadius: "0",
    background: "none",
    errorIconTint: "grey",
    emptyIconTint: "grey",
    loadingIconTint: "grey",
    emptyStateTextColor: "#323232",
    emptyStateTextFont: "400 14px inter",
    errorStateTextColor: "#323232",
    errorStateTextFont: "400 14px inter",
    loadingStateTextColor: "#323232",
    loadingStateTextFont: "400 14px inter",
});
exports.CometChatAICard = class CometChatAICard extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.state = uikitResources.States.loading;
        this.aiBaseStyle = defaultStyle;
        this.loadingIconURL = LoadingIcon;
        this.errorIconURL = ErrorIcon;
        this.emptyIconURL = EmptyIcon;
        this.loadingStateText = uikitResources.localize("LOADING");
        this.errorStateText = uikitResources.localize("SOMETHING_WRONG");
        this.emptyStateText = uikitResources.localize("NO_MESSAGES_FOUND");
        this.containerStyle = () => {
            const { height, width, border, borderRadius, background } = this.aiBaseStyle;
            return styleMap_js.styleMap({
                height: height || "fit-content",
                width: width || "100%",
                border: border || "none",
                borderRadius: borderRadius || "0",
                background: background || "none",
            });
        };
        this.iconStyle = (iconTint) => {
            return {
                buttonIconTint: iconTint || "grey",
                height: "24px",
                width: "24px",
                background: "transparent",
                border: "none",
                borderRadius: "0",
            };
        };
        this.labelStyle = (state) => {
            var _a, _b, _c, _d, _e, _f;
            switch (state) {
                case uikitResources.States.loading:
                    {
                        return new uikitElements.LabelStyle({
                            textColor: ((_a = this.aiBaseStyle) === null || _a === void 0 ? void 0 : _a.loadingStateTextColor) || "#323232",
                            textFont: ((_b = this.aiBaseStyle) === null || _b === void 0 ? void 0 : _b.loadingStateTextFont) || "400 14px inter",
                        });
                    }
                case uikitResources.States.error:
                    {
                        return new uikitElements.LabelStyle({
                            textColor: ((_c = this.aiBaseStyle) === null || _c === void 0 ? void 0 : _c.errorStateTextColor) || "#323232",
                            textFont: ((_d = this.aiBaseStyle) === null || _d === void 0 ? void 0 : _d.errorStateTextFont) || "400 14px inter",
                        });
                    }
                case uikitResources.States.empty: {
                    return new uikitElements.LabelStyle({
                        textColor: ((_e = this.aiBaseStyle) === null || _e === void 0 ? void 0 : _e.emptyStateTextColor) || "#323232",
                        textFont: ((_f = this.aiBaseStyle) === null || _f === void 0 ? void 0 : _f.emptyStateTextFont) || "400 14px inter",
                    });
                }
                default: {
                    return new uikitElements.LabelStyle({
                        textColor: "#323232",
                        textFont: "400 14px inter",
                    });
                }
            }
        };
    }
    render() {
        var _a, _b, _c;
        if (!this.loadingIconURL) {
            this.loadingIconURL = LoadingIcon;
        }
        if (!this.errorIconURL) {
            this.errorIconURL = ErrorIcon;
        }
        if (!this.emptyIconURL) {
            this.emptyIconURL = EmptyIcon;
        }
        return lit.html `
      <div class="cc__ai-card_container" style="${this.containerStyle()}">
        ${this.state === uikitResources.States.loading
            ? lit.html `
              <slot name="loadingView">
                <div class="cc__ai-card_state_wrapper">
                  <cometchat-button
                    iconURL="${this.loadingIconURL}"
                    buttonStyle="${JSON.stringify(this.iconStyle(((_a = this.aiBaseStyle) === null || _a === void 0 ? void 0 : _a.loadingIconTint) || ""))}"
                  ></cometchat-button>
                  <cometchat-label 
                  text=${this.loadingStateText} 
                  labelStyle=${JSON.stringify(this.labelStyle(this.state))}
                  />
                </div>
              </slot>
            `
            : lit.nothing}
        ${this.state === uikitResources.States.error
            ? lit.html `
              <slot name="errorView">
                <div class="cc__ai-card_state_wrapper">
                  <cometchat-button
                    iconURL="${this.errorIconURL}"
                    buttonStyle="${JSON.stringify(this.iconStyle(((_b = this.aiBaseStyle) === null || _b === void 0 ? void 0 : _b.errorIconTint) || ""))}"
                  ></cometchat-button>
                  <cometchat-label 
                  text=${this.errorStateText} 
                  labelStyle=${JSON.stringify(this.labelStyle(this.state))}
                  />
                </div>
              </slot>
            `
            : lit.nothing}
        ${this.state === uikitResources.States.empty
            ? lit.html `
              <slot name="emptyView">
                <div class="cc__ai-card_state_wrapper">
                  <cometchat-button
                    iconURL="${this.emptyIconURL}"
                    buttonStyle="${JSON.stringify(this.iconStyle(((_c = this.aiBaseStyle) === null || _c === void 0 ? void 0 : _c.emptyIconTint) || ""))}"
                  ></cometchat-button>
                  <cometchat-label 
                  text=${this.emptyStateText} 
                  labelStyle=${JSON.stringify(this.labelStyle(this.state))}
                  />
                </div>
              </slot>
            `
            : lit.nothing}
        ${this.state === uikitResources.States.loaded
            ? lit.html ` <slot name="loadedView"> </slot> `
            : lit.nothing}
      </div>
    `;
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has("state")) {
            this.requestUpdate();
        }
    }
};
exports.CometChatAICard.styles = [
    lit.css `
      .cc__ai-card_container {
        height: 100%;
        width: 100%;
      }

      .cc__ai-card_state_wrapper {
        display: flex;
        width: 100%;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        text-align: center;
      }
    `,
];
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "state", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatAICard.prototype, "aiBaseStyle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "loadingIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "errorIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "emptyIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "loadingStateText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "errorStateText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "emptyStateText", void 0);
exports.CometChatAICard = __decorate([
    decorators_js.customElement("cometchat-ai-card")
], exports.CometChatAICard);

class CometChatUIKitLoginListener {
    static setLoggedInUser(user) {
        this.loggedInUser = user;
    }
    static getLoggedInUser() {
        return this.loggedInUser;
    }
    static removeLoggedInUser() {
        this.loggedInUser = null;
    }
    static attachListener() {
        if (this.isAttached) {
            this.removeListener();
            this.isAttached = false;
            this.listenerID = ``;
        }
        this.listenerID = `CometChatLoginListener_${new Date().getTime()}`;
        chatSdkJavascript.CometChat.addLoginListener(this.listenerID, new chatSdkJavascript.CometChat.LoginListener({
            onLoggedIn: (user) => {
                this.setLoggedInUser(user);
            },
            onLoggedOut: () => {
                this.removeLoggedInUser();
            },
        }));
        this.isAttached = true;
    }
    static removeListener() {
        if (this.isAttached) {
            chatSdkJavascript.CometChat.removeLoginListener(this.listenerID);
            this.isAttached = false;
            this.listenerID = ``;
        }
    }
}
CometChatUIKitLoginListener.loggedInUser = null;
CometChatUIKitLoginListener.listenerID = ``;
CometChatUIKitLoginListener.isAttached = false;

/**
 * Abstract class that provides methods for formatting text in CometChat.
 */
class CometChatTextFormatter {
    constructor() {
        /**
         * A flag to start tracking once a specific keyboard event occurs.
         */
        this.startTracking = true;
        /**
         * The regex patterns to find specific text pattern in the user input text.
         */
        this.regexPatterns = [/(@\w+)/g];
        /**
         * The regex patterns to replace text formatting in the user input text.
         */
        this.regexToReplaceFormatting = [
            /<span class="hash"[^>]*>([^<]*)<span class="hash-margin-space">[^<]*<\/span><\/span> /g,
        ];
        /**
         * Mapping of CSS classes for styling the text.
         */
        this.cssClassMapping = ["custom-class"];
        /**
         * The character to track once typed in the text input field.
         */
        this.trackCharacter = "#";
        this.classes = [];
        /**
         * The user who is currently logged in.
         */
        this.loggedInUser = CometChatUIKitLoginListener.getLoggedInUser();
        this.textStyle = {
            formattedTextColor: "rgb(51, 153, 255)",
            formattedTextFont: "",
        };
        /**
         * Formats the text on keyboard key down.
         * @param {string|void} inputText - The text to format.
         */
        this.formatTextOnKeyUp = (inputText) => {
            if (!inputText) {
                const textToLeft = this.getPrecedingText(this.currentCaretPosition, this.currentRange);
                if (textToLeft) {
                    let updatedText = this.onRegexMatch(textToLeft);
                    this.addAtCaretPosition(updatedText, this.currentCaretPosition, this.currentRange);
                }
                return;
            }
        };
        this.debouncedFormatTextOnKeyUp = this.debounce(this.formatTextOnKeyUp, uikitResources.CometChatUtilityConstants.TextFormatter.KEY_UP_DEBOUNCE_TIME);
    }
    /**
     * Sets the current caret position and selection range.
     *
     * @param {Selection} currentCaretPosition - The current caret position.
     * @param {Range} currentRange - The current selection range.
     */
    setCaretPositionAndRange(currentCaretPosition, currentRange) {
        this.currentCaretPosition = currentCaretPosition;
        this.currentRange = currentRange === null || currentRange === void 0 ? void 0 : currentRange.cloneRange();
    }
    /**
     * Set css class to be applied on format spans
     */
    setClasses(classes) {
        this.classes = classes;
    }
    /**
     * Sets the regex patterns to match.
     * @param regexPatterns - Array of regex patterns.
     */
    setRegexPatterns(regexPatterns) {
        this.regexPatterns = regexPatterns;
    }
    /**
     * Gets the regex patterns.
     */
    getRegexPatterns() {
        return this.regexPatterns;
    }
    /**
     * Sets the regex patterns to replace formatting.
     * @param regexToReplaceFormatting - Array of regex patterns.
     */
    setRegexToReplaceFormatting(regexToReplaceFormatting) {
        this.regexToReplaceFormatting = regexToReplaceFormatting;
    }
    /**
     * Sets the tracking character.
     * @param trackCharacter - The character to track.
     */
    setTrackingCharacter(trackCharacter) {
        this.trackCharacter = trackCharacter;
    }
    /**
     * Sets the input element reference.
     * @param inputElementReference - The reference to the input element.
     */
    setInputElementReference(inputElementReference) {
        this.inputElementReference = inputElementReference;
    }
    /**
     * Sets the re-render function.
     * @param reRender - The function to call for re-rendering.
     */
    setReRender(reRender) {
        this.reRender = reRender;
    }
    /**
     * Retrieves the keydown callback function.
     * @returns {Function} The keydown callback function.
     */
    getKeyUpCallBack() {
        return this.keyUpCallBack;
    }
    /**
     * Sets the keydown callback function.
     * @param {Function} keyUpCallBack - The callback function for handling key down events.
     */
    setKeyUpCallBack(keyUpCallBack) {
        this.keyUpCallBack = keyUpCallBack;
    }
    /**
     * Retrieves the keydown callback function.
     * @returns {Function} The keydown callback function.
     */
    getKeyDownCallBack() {
        return this.keyDownCallBack;
    }
    /**
     * Sets the keydown callback function.
     * @param {Function} keyDownCallBack - The keydown callback function.
     */
    setKeyDownCallBack(keyDownCallBack) {
        this.keyDownCallBack = keyDownCallBack;
    }
    /**
     * Retrieves the currently logged in user.
     * @returns The currently logged user.
     */
    getLoggedInUser() {
        return this.loggedInUser;
    }
    /**
     * Sets the currently logged in user.
     * @param {CometChat.User} loggedInUser - The user to set as currently logged in.
     */
    setLoggedInUser(loggedInUser) {
        this.loggedInUser = loggedInUser;
    }
    /**
     * Sets the mapping of CSS classes.
     * @param cssClassesNames - Array of CSS class names.
     */
    setCssClassMapping(cssClassesNames) {
        this.cssClassMapping = cssClassesNames;
    }
    /**
     * Sets the CSS style.
     * @param {Object} styleObject - The CSS style object.
     * @param {string} styleObject.formattedTextColor - The color to use for formatted text.
     */
    setStyle(styleObject) {
        this.textStyle = styleObject;
    }
    getStyle() {
        return this.textStyle;
    }
    setId(id) {
        this.id = id;
    }
    getId() {
        return this.id;
    }
    cleanup() { }
    /**
     * If the input text is provided, it returns the formatted text. Otherwise, it edits the text using the current cursor position.
     * @param {string|null} inputText - The text to format.
     * @return {string|void} - The original or formatted input text, or void if editing was done based on cursor position.
     */
    getFormattedText(inputText, params) {
        if (!inputText) {
            return;
        }
        return this.onRegexMatch(inputText);
    }
    /**
     * Sets the message object.
     *
     * @param {CometChat.BaseMessage} messageObject - The message object to be set.
     */
    setMessage(messageObject) {
        this.messageObject = messageObject;
    }
    /**
     * Retrieves the message object.
     *
     * @returns {CometChat.BaseMessage} - The current message object.
     */
    getMessage() {
        return this.messageObject;
    }
    setMessageBubbleAlignment(messageBubbleAlignment) {
        this.messageBubbleAlignment = messageBubbleAlignment;
    }
    getMessageBubbleAlignment() {
        return this.messageBubbleAlignment;
    }
    setComposerConfig(user, group, composerId) {
        this.user = user;
        this.group = group;
        this.composerId = composerId;
    }
    getComposerConfig() {
        return { user: this.user, group: this.group, composerId: this.composerId };
    }
    /**
     * Retrieves the preceding text from the given caret position.
     * @param {Selection} currentCaretPosition - The current caret position.
     * @param {Range} currentRange - The current selection range.
     * @return {string|null} - The preceding text or null.
     */
    getPrecedingText(currentCaretPosition, currentRange) {
        var _a, _b;
        if (this.inputElementReference && currentRange) {
            const rangeCopy = currentRange.cloneRange();
            while (rangeCopy.startOffset > 0 &&
                ((_a = rangeCopy.startContainer.textContent) === null || _a === void 0 ? void 0 : _a.charAt(rangeCopy.startOffset - 1)) !== this.trackCharacter) {
                rangeCopy.setStart(rangeCopy.startContainer, rangeCopy.startOffset - 1);
                /** if the container is not text, it could be a span (already formatted)
                 *  So do not perform any action
                 * */
                if (!(rangeCopy.startContainer.nodeName === "#text")) {
                    return null;
                }
            }
            // Check the character immediately before the track character
            const charBeforeTrackChar = rangeCopy.startOffset > 1
                ? (_b = rangeCopy.startContainer.textContent) === null || _b === void 0 ? void 0 : _b.charAt(rangeCopy.startOffset - 2)
                : "";
            // If the character before the track character is not a space or doesn't exist, return null
            if (charBeforeTrackChar &&
                charBeforeTrackChar !== " " &&
                charBeforeTrackChar !== "\n") {
                return null;
            }
            if (rangeCopy.startOffset > 0 &&
                rangeCopy.startContainer.nodeName === "#text") {
                rangeCopy.setStart(rangeCopy.startContainer, rangeCopy.startOffset - 1);
                return rangeCopy.toString();
            }
        }
        return null;
    }
    /**
     * Returns true if previous character is previousCharacterToCheck or if there is just one character
     * @param {string} previousCharacterToCheck
     * @param {Range} currentRange
     * @returns  {boolean}
     */
    checkPreviousCharacterUsingRange(previousCharacterToCheck = " ", currentRange) {
        var _a;
        if (this.inputElementReference && currentRange) {
            const rangeCopy = currentRange.cloneRange();
            if (rangeCopy.startOffset === 1) {
                return true;
            }
            if (rangeCopy.startOffset > 0 &&
                ((_a = rangeCopy.startContainer.textContent) === null || _a === void 0 ? void 0 : _a.charAt(rangeCopy.startOffset - 2)) !== previousCharacterToCheck) {
                return false;
            }
            return true;
        }
        return false;
    }
    /**
     * Applies regex match on the input text and replaces matched instances.
     * @param {string|null} inputText - The text to apply regex match.
     * @return {string} - The replaced text.
     */
    onRegexMatch(inputText) {
        let replacedText = inputText !== null && inputText !== void 0 ? inputText : "";
        for (let i = 0; i < this.regexPatterns.length; i++) {
            let regexPattern = this.regexPatterns[i];
            if (inputText) {
                replacedText = inputText.replace(regexPattern, (match, capturedGroup) => {
                    var _a, _b, _c;
                    const span = document.createElement("span");
                    span.classList.add(this.cssClassMapping[0]);
                    span.setAttribute("contentEditable", "false");
                    span.style.color = (_b = (_a = this.textStyle) === null || _a === void 0 ? void 0 : _a.formattedTextColor) !== null && _b !== void 0 ? _b : "green";
                    span.style.font = (_c = this.textStyle) === null || _c === void 0 ? void 0 : _c.formattedTextFont;
                    span.textContent = match;
                    const zeroWidthSpace = document.createElement("span");
                    zeroWidthSpace.classList.add(this.cssClassMapping[0] + "-margin-space");
                    zeroWidthSpace.innerHTML = "\u200B";
                    span.appendChild(zeroWidthSpace);
                    return span.outerHTML + " ";
                });
            }
        }
        return replacedText;
    }
    /**
     * Debounce function.
     * @param {Function} func - The function to debounce.
     * @param {number} wait - The amount of delay before function invocation.
     * @return {Function} - The debounced function.
     */
    debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    /**
     * Handles 'keydown' events.
     * @param {KeyboardEvent} event - The keyboard event.
     */
    onKeyUp(event) {
        if (event.key == this.trackCharacter) {
            this.startTracking = true;
        }
        if (this.startTracking && event.key == " ") {
            this.debouncedFormatTextOnKeyUp();
        }
    }
    /**
     * Handles 'keydown' events.
     * @param {KeyboardEvent} event - The keyboard event.
     */
    onKeyDown(event) { }
    /**
     * Adds HTML at the current caret position.
     * @param {string} newHtml - The HTML to insert.
     * @param {Selection} currentCaretPosition - The current caret position.
     * @param {Range} currentRange - The current selection range.
     */
    addAtCaretPosition(newHtml, currentCaretPosition, currentRange) {
        var _a, _b, _c;
        if (this.inputElementReference && currentRange) {
            const selection = currentCaretPosition;
            let range = currentRange;
            range.collapse(true);
            range.setStart(range.startContainer, range.startOffset - 1);
            while (range.startOffset > 0 &&
                ((_a = range.startContainer.textContent) === null || _a === void 0 ? void 0 : _a.charAt(range.startOffset - 1)) !==
                    this.trackCharacter) {
                if (((_b = range.startContainer.textContent) === null || _b === void 0 ? void 0 : _b.charAt(range.startOffset - 1)) == " ") {
                    return;
                }
                range.setStart(range.startContainer, range.startOffset - 1);
            }
            if (range.startOffset > 0) {
                range.setStart(range.startContainer, range.startOffset - 1);
                range.deleteContents();
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = newHtml;
                const fragment = document.createDocumentFragment();
                Array.from(tempDiv.childNodes).forEach((node) => {
                    if (node instanceof Element &&
                        node.classList.contains(this.cssClassMapping[0])) {
                        this.registerEventListeners(node, node.classList);
                    }
                    fragment.appendChild(node);
                });
                range.insertNode(fragment);
                range.collapse(false);
                selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
                selection === null || selection === void 0 ? void 0 : selection.addRange(range);
            }
        }
        (_c = this.inputElementReference) === null || _c === void 0 ? void 0 : _c.focus();
    }
    /**
     * Returns the original unformatted text from the input text.
     * @param {string|null|undefined} inputText - The input text to get original text from.
     * @return {string} - The original text.
     */
    getOriginalText(inputText) {
        if (!inputText) {
            return "";
        }
        for (let i = 0; i < this.regexToReplaceFormatting.length; i++) {
            let regexPattern = this.regexToReplaceFormatting[i];
            if (inputText) {
                inputText = inputText.replace(regexPattern, "$1");
            }
        }
        return inputText;
    }
    /**
     * To inform formatter to stop keeping a track of characters
     */
    stopTracking() { }
    /**
     * To reset the formatter properties
     */
    reset() { }
    /**
     * This will be called by composer before sending the message. This can be used to set metadata, tags on message
     * @param {CometChat.BaseMessage} message
     * @return {CometChat.BaseMessage} - message with metadata added
     */
    formatMessageForSending(message) {
        return message;
    }
    /**
     * Registers event listeners on the given element.
     * @param {any} span - The HTML element to register event listeners.
     * @param {any} classList - The classList of the element.
     * @return {any} - The element with event listeners registered.
     */
    registerEventListeners(span, classList) {
        return span;
    }
}

/**
 * UserMentionStyle
 * @property {string} mentionTextFont - Default Font for mentions "@" text
 * @property {string} mentionsTextColor - Default Color for mentions "@" text
 * @property {string} mentionTextBackground - Default Background Color for mentions "@" text
 * @property {string} loggedInUserTextFont - Font for logged in user mentions
 * @property {string} loggedInUserTextColor - Color for logged in user mentions
 * @property {string} loggedInUserTextBackground - Background Color for logged in user mentions
 */
class UserMentionStyle {
    constructor(props) {
        this.mentionTextFont = "";
        this.mentionTextColor = "rgb(51, 153, 255)";
        this.mentionTextBackground = "";
        this.loggedInUserTextFont = "";
        this.loggedInUserTextColor = "rgb(51, 153, 255)";
        this.loggedInUserTextBackground = "";
        Object.assign(this, props);
    }
}

/**
 * Class that handles the text formatting for mentions in CometChat.
 * CometChatMentionsFormatter is a child class of CometChatTextFormatter.
 * It extends the functionality of text formatting to specifically handle user mentions
 * in the text, it keeps track of the mentions in the text, format them for display and
 * other functionalities.
 *
 * @extends {CometChatTextFormatter}
 */
class CometChatMentionsFormatter extends CometChatTextFormatter {
    constructor() {
        super();
        /**
         * List of users for mentions.
         */
        this.cometChatUserGroupMembers = [];
        /**
         * Mapping of CSS classes for mentions.
         */
        this.mentionsCssClassMapping = {};
        /**
         * Regular expression for validating search input.
         *
         * The search input is considered valid if it meets all of the following conditions:
         * - It starts with an "@" symbol.
         * - After the "@" symbol, it can optionally contain alphanumeric characters or periods.
         * - If there are spaces, they should not be immediately after the "@" symbol.
         * - After a space, it can optionally contain alphanumeric characters or periods.
         *
         * If the search input does not meet these conditions, the regular expression match will fail, indicating invalid input.
         *
         * @type {RegExp}
         * @private
         */
        this.invalidCharactersRegexForSearch = /^@(?! )[a-zA-Z0-9. ]*$/;
        /**
         * Count of mentions in the text.
         */
        this.mentionsCount = 0;
        /**
         * Map of mentions, linking user ids with their names.
         */
        this.mentionsMap = {};
        /**
         * Stores the formatting style for mentions.
         */
        this.mentionsStyle = {};
        this.composerMentionStyle = {};
        this.conversationMentionStyle = {};
        this.leftBubbleMentionStyle = {};
        this.rightBubbleMentionStyle = {};
        this.warningDisplayed = false;
        this.allowMultipleSpaces = true;
        this.mouseOverEventDispatched = false;
        this.regexPatterns = [/@(\w[\w\s]*)?(\b\s\w[\w\s]*)*/g];
        this.trackCharacter = "@";
        this.loggedInUser = CometChatUIKitLoginListener.getLoggedInUser();
    }
    /**
     * Observes changes in targetNode.
     *
     * @param {HTMLElement} targetNode - The HTML element to observe for changes.
     */
    observeChange(targetNode) {
        if (targetNode) {
            this.observer = new MutationObserver((mutations) => {
                var _a, _b;
                if (this.inputElementReference &&
                    ((_b = (_a = this.inputElementReference) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim()) === "") {
                    this.reset();
                    this.mentionsMap = {};
                    this.cssClassMapping = [];
                    return;
                }
                mutations.forEach((mutation) => {
                    mutation.removedNodes.forEach((node) => {
                        // Check if the node is an element node
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            let element = node; // Typecast to Element
                            if (element.tagName.toLowerCase() === "span" &&
                                element.classList.contains("mentions")) {
                                let mentionClass = Array.from(element.classList).find((cls) => cls.startsWith("mentions-"));
                                if (mentionClass) {
                                    let otherMentions = targetNode.querySelectorAll(`.${mentionClass}`);
                                    if (!otherMentions.length) {
                                        delete this.mentionsMap[mentionClass];
                                    }
                                    this.mentionsCount = Object.keys(this.mentionsMap).length;
                                    if (this.mentionsCount <
                                        uikitResources.CometChatUtilityConstants.MentionsTextFormatter
                                            .MENTIONS_LIMIT) {
                                        uikitResources.CometChatUIEvents.ccShowMentionsCountWarning.next({
                                            showWarning: false,
                                            id: this.getId(),
                                        });
                                        this.warningDisplayed = false;
                                    }
                                }
                            }
                        }
                    });
                });
            });
            let config = { childList: true, subtree: true };
            this.observer.observe(targetNode, config);
        }
    }
    /**
     * Retrieves the count of mentions.
     *
     * @returns {number} - The count of mentions.
     */
    getMentionsCount() {
        return this.mentionsCount;
    }
    /**
     * Sets the count of mentions.
     *
     * @param {number} mentionsCount - The count of mentions to be set.
     */
    setMentionsCount(mentionsCount) {
        this.mentionsCount = mentionsCount;
    }
    /**
     * Set Regex for Checking Invalid Characters in Search Term
     * @param pattern
     */
    setInvalidCharactersRegexForSearch(pattern) {
        this.invalidCharactersRegexForSearch = pattern;
    }
    /**
     * Sets the current caret position and selection range.
     *
     * @param {Selection} currentCaretPosition - The current caret position.
     * @param {Range} currentRange - The current selection range.
     */
    setCaretPositionAndRange(currentCaretPosition, currentRange) {
        this.currentCaretPosition = currentCaretPosition;
        this.currentRange = currentRange === null || currentRange === void 0 ? void 0 : currentRange.cloneRange();
    }
    /**
     * Sets the reference to the input element.
     *
     * @param {HTMLElement} inputElementReference - The reference to the input element.
     */
    setInputElementReference(inputElementReference) {
        this.inputElementReference = inputElementReference;
        if (!this.observer) {
            this.observeChange(inputElementReference);
        }
    }
    /**
     * Sets the regex pattern for matching text.
     *
     * @param {Array<RegExp>} regexPatterns - The array of regex patterns.
     */
    setRegexPattern(regexPatterns) {
        this.regexPatterns = regexPatterns;
    }
    /**
     * Retrieves the CometChatUserGroupMembers.
     *
     * @returns {Array<CometChatUserGroupMembers>} - The current CometChatUserGroupMembers.
     */
    getCometChatUserGroupMembers() {
        return this.cometChatUserGroupMembers;
    }
    /**
     * Sets the CometChatUserGroupMembers.
     *
     * @param {Array<CometChatUserGroupMembers>} CometChatUserGroupMembers - The CometChatUserGroupMembers to be set.
     */
    setCometChatUserGroupMembers(CometChatUserGroupMembers) {
        this.cometChatUserGroupMembers = [
            ...CometChatUserGroupMembers,
            ...this.cometChatUserGroupMembers,
        ];
    }
    resetCometChatUserGroupMembers() {
        this.cometChatUserGroupMembers = [];
    }
    /**
     * Sets the callback function for handling key down events.
     *
     * @param {Function} keyUpCallBack - The callback function for handling key up events.
     */
    setKeyUpCallBack(keyUpCallBack) {
        this.keyUpCallBack = this.debounce(keyUpCallBack, uikitResources.CometChatUtilityConstants.TextFormatter.KEY_UP_DEBOUNCE_TIME);
    }
    /**
     * Sets the keydown callback function.
     * @param {Function} keyDownCallBack - The keydown callback function.
     */
    setKeyDownCallBack(keyDownCallBack) {
        this.keyDownCallBack = this.debounce(keyDownCallBack, uikitResources.CometChatUtilityConstants.TextFormatter.KEY_UP_DEBOUNCE_TIME);
    }
    /**
     * Retrieves the mentions style.
     *
     * @returns {UserMentionStyle} - The current mentions style.
     */
    getTextStyle() {
        return this.mentionsStyle;
    }
    /**
     *
     * @param {UserMentionStyle} mentionsStyle - The mentions style to be set.
     */
    setMentionsTextStyle(mentionsStyle) {
        this.mentionsStyle = mentionsStyle;
    }
    /**
     * Sets the mentions style for conversation.
     *
     * @param {UserMentionStyle} mentionsStyle - The mentions style to be set.
     */
    setConversationMentionStyle(mentionsStyle) {
        this.conversationMentionStyle = mentionsStyle;
    }
    /**
     * Sets the mentions style for composer.
     *
     * @param {UserMentionStyle} mentionsStyle - The mentions style to be set.
     */
    setComposerMentionStyle(mentionsStyle) {
        this.composerMentionStyle = mentionsStyle;
    }
    /**
     * Sets the mentions style for left bubble.
     *
     * @param {UserMentionStyle} mentionsStyle - The mentions style to be set.
     */
    setLeftBubbleMentionStyle(mentionsStyle) {
        this.leftBubbleMentionStyle = mentionsStyle;
    }
    /**
     * Sets the mentions style for right bubble.
     *
     * @param {UserMentionStyle} mentionsStyle - The mentions style to be set.
     */
    setRightBubbleMentionStyle(mentionsStyle) {
        this.rightBubbleMentionStyle = mentionsStyle;
    }
    getAllowMultipleSpaces() {
        return this.allowMultipleSpaces;
    }
    setAllowMultipleSpaces(allowMultipleSpaces) {
        this.allowMultipleSpaces = allowMultipleSpaces;
    }
    cleanup() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
    /**
     * This will be called by composer before sending the message. This can be used to set metadata, tags on message
     * @param {CometChat.BaseMessage} message
     * @return {CometChat.BaseMessage} - message with metadata added
     */
    formatMessageForSending(message) {
        this.resetCometChatUserGroupMembers();
        return message;
    }
    reset() {
        this.mentionsCount = 0;
        this.stopTracking();
        if (this.warningDisplayed) {
            uikitResources.CometChatUIEvents.ccShowMentionsCountWarning.next({
                showWarning: false,
                id: this.getId(),
            });
        }
        this.warningDisplayed = false;
    }
    stopTracking() {
        this.keyUpCallBack("");
    }
    /**
     * Formats the input text if provided, otherwise edits the text at the cursor position.
     * @param {string|null} inputText - The input text to be formatted.
     * @returns {string|void} - The formatted input text, or void if inputText is not provided.
     */
    getFormattedText(inputText, params = {
        mentionsTargetElement: uikitResources.MentionsTargetElement.textinput,
    }) {
        if (!inputText) {
            this.setMentionsTextStyle(this.composerMentionStyle);
            const textToLeft = this.getPrecedingText(this.currentCaretPosition, this.currentRange);
            if (textToLeft) {
                let updatedText = this.onRegexMatch(textToLeft);
                this.addAtCaretPosition(updatedText, this.currentCaretPosition, this.currentRange);
            }
            this.keyUpCallBack("");
            return;
        }
        else {
            if (params.mentionsTargetElement == uikitResources.MentionsTargetElement.conversation) {
                this.setMentionsTextStyle(this.conversationMentionStyle);
            }
            else if (params.mentionsTargetElement == uikitResources.MentionsTargetElement.textbubble) {
                if (this.messageObject && this.messageObject.getMentionedUsers()) {
                    let mentionedUsers = this.messageObject.getMentionedUsers();
                    if (mentionedUsers && mentionedUsers.length) {
                        this.setCometChatUserGroupMembers(mentionedUsers);
                        var isUserSentMessage = this.messageBubbleAlignment === uikitResources.MessageBubbleAlignment.right;
                        if (isUserSentMessage) {
                            this.setMentionsTextStyle(this.rightBubbleMentionStyle);
                        }
                        else {
                            this.setMentionsTextStyle(this.leftBubbleMentionStyle);
                        }
                    }
                }
                else {
                    return inputText;
                }
            }
            else {
                this.setMentionsTextStyle(this.composerMentionStyle);
            }
            return this.addMentionsSpan(inputText);
        }
    }
    /**
     * This function adds the mention span to the input text.
     * @param {string} inputText - The input text where the span needs to be added.
     * @returns {string} - The modified input text.
     */
    addMentionsSpan(inputText) {
        var _a;
        if (this.cometChatUserGroupMembers) {
            let color;
            this.warningDisplayed = false;
            for (let i = 0; i < ((_a = this.cometChatUserGroupMembers) === null || _a === void 0 ? void 0 : _a.length); i++) {
                color = "";
                const userUid = this.cometChatUserGroupMembers[i].getUid();
                const userName = this.cometChatUserGroupMembers[i].getName();
                const regex = new RegExp(`<@uid:${userUid}>`, "g");
                const span = document.createElement("span");
                span.classList.add("mentions");
                for (let i = 0; i < this.classes.length; i++) {
                    span.classList.add(this.classes[i]);
                }
                span.classList.add("mentions-" + userUid);
                span.style.cursor = "pointer";
                span.setAttribute("contentEditable", "false");
                this.mentionsCssClassMapping["mentions-" + userUid] =
                    this.cometChatUserGroupMembers[i];
                const textSpan = document.createElement("span");
                color =
                    this.cometChatUserGroupMembers[i].getUid() ==
                        this.loggedInUser.getUid()
                        ? this.mentionsStyle.loggedInUserTextColor
                        : this.mentionsStyle.mentionTextColor;
                textSpan.style.color = color;
                textSpan.style.font =
                    this.cometChatUserGroupMembers[i].getUid() ==
                        this.loggedInUser.getUid()
                        ? this.mentionsStyle.loggedInUserTextFont
                        : this.mentionsStyle.mentionTextFont;
                textSpan.style.fontWeight =
                    this.cometChatUserGroupMembers[i].getUid() ==
                        this.loggedInUser.getUid()
                        ? "bold"
                        : "regular";
                textSpan.style.background =
                    this.cometChatUserGroupMembers[i].getUid() ==
                        this.loggedInUser.getUid()
                        ? this.mentionsStyle.loggedInUserTextBackground
                        : this.mentionsStyle.mentionTextBackground;
                textSpan.textContent = this.trackCharacter + userName;
                // const zeroWidthSpace = document.createElement("span");
                // zeroWidthSpace.classList.add("mentions-margin-space");
                // zeroWidthSpace.innerHTML = "\u200B";
                span.appendChild(textSpan);
                //span.appendChild(zeroWidthSpace);
                let count = 0;
                inputText = inputText.replace(regex, (match) => {
                    count++;
                    return span.outerHTML;
                });
                if (count) {
                    this.mentionsMap["mentions-" + userUid] = `<@uid:${userUid}>`;
                    this.mentionsCount = Object.keys(this.mentionsMap).length;
                    if (this.mentionsCount >=
                        uikitResources.CometChatUtilityConstants.MentionsTextFormatter.MENTIONS_LIMIT &&
                        !this.warningDisplayed) {
                        uikitResources.CometChatUIEvents.ccShowMentionsCountWarning.next({
                            showWarning: true,
                            id: this.getId(),
                        });
                        this.warningDisplayed = true;
                    }
                }
            }
        }
        return inputText;
    }
    /**
     * Registers event listeners for click, mouseover, mouseout on the element
     * @param {HTMLElement} element - The element on which the events need to be registered
     * @param {DOMTokenList} domTokenList - The classes to be added
     * @return {HTMLElement} - The element with the registered event listeners
     */
    registerEventListeners(element, domTokenList) {
        let classList = Array.from(domTokenList);
        for (let i = 0; i < classList.length; i++) {
            if (classList[i] in this.mentionsCssClassMapping) {
                element.addEventListener("click", (event) => {
                    var _a;
                    clearTimeout(this.timeoutID);
                    // this.dispatchCustomEvent(this.mentionsCssClassMapping[classList[i]], 'click');
                    uikitResources.CometChatUIEvents.ccMouseEvent.next({
                        body: {
                            CometChatUserGroupMembersObject: this.mentionsCssClassMapping[classList[i]],
                            message: (_a = this.messageObject) !== null && _a !== void 0 ? _a : null,
                            id: this.getId(),
                        },
                        event,
                        source: uikitResources.MouseEventSource.mentions,
                    });
                });
                element.addEventListener("mouseover", (event) => {
                    this.timeoutID = setTimeout(() => {
                        var _a;
                        this.mouseOverEventDispatched = true;
                        uikitResources.CometChatUIEvents.ccMouseEvent.next({
                            body: {
                                CometChatUserGroupMembersObject: this.mentionsCssClassMapping[classList[i]],
                                message: (_a = this.messageObject) !== null && _a !== void 0 ? _a : null,
                                id: this.getId(),
                            },
                            event,
                            source: uikitResources.MouseEventSource.mentions,
                        });
                    }, uikitResources.CometChatUtilityConstants.MentionsTextFormatter.MENTIONS_HOVER_TIMEOUT);
                });
                element.addEventListener("mouseout", (event) => {
                    var _a;
                    clearTimeout(this.timeoutID);
                    if (this.mouseOverEventDispatched) {
                        uikitResources.CometChatUIEvents.ccMouseEvent.next({
                            body: {
                                CometChatUserGroupMembersObject: this.mentionsCssClassMapping[classList[i]],
                                message: (_a = this.messageObject) !== null && _a !== void 0 ? _a : null,
                                id: this.getId(),
                            },
                            event,
                            source: uikitResources.MouseEventSource.mentions,
                        });
                        this.mouseOverEventDispatched = false;
                    }
                });
            }
        }
        return element;
    }
    /**
     * Replaces mentions which are span tags with corresponding user UIDs
     *
     * @param {string | null | undefined} inputText - The text in which the mentions need to be replaced
     * @return {string} - The text after replacing the mentions with uids
     */
    replaceMentionsSpanWithUid(inputText) {
        if (!inputText) {
            return "";
        }
        Object.keys(this.mentionsMap).forEach((spanId) => {
            const valueToReplace = this.mentionsMap[spanId];
            const spanRegex = new RegExp(
            //`<span\\s+class="mentions\\s+${spanId}"[^>]*>(.*?)\\u200B<\\/span><\\/span>`,
            `<span class="mentions ${spanId}" .*?>.*?<\/span><\/span>`, "g");
            inputText = inputText.replace(spanRegex, valueToReplace);
        });
        return inputText;
    }
    /**
     * Handles the keydown events, updating the mention state as necessary
     *
     * @param {KeyboardEvent} event - The keydown event
     */
    onKeyDown(event) {
        setTimeout((event) => {
            if (event.key === "Backspace") {
                return;
            }
            if (event.key === "Escape") {
                this.mentionsCount = 0;
                this.stopTracking();
                this.keyDownCallBack("");
                return;
            }
            let precedingText = "";
            precedingText = this.validateText(this.getPrecedingText(this.currentCaretPosition, this.currentRange));
            if (this.mentionsCount >=
                uikitResources.CometChatUtilityConstants.MentionsTextFormatter.MENTIONS_LIMIT) {
                if (!this.warningDisplayed) {
                    uikitResources.CometChatUIEvents.ccShowMentionsCountWarning.next({
                        showWarning: true,
                        id: this.getId(),
                    });
                    this.warningDisplayed = true;
                }
                return;
            }
            if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(event.key)) {
                return null;
            }
            this.keyDownCallBack(precedingText);
        }, 0, event);
    }
    /**
     * Validates the text input based on the invalidCharactersRegexForSearch regular expression.
     *
     * @param {string | null} text - The text to validate. If null, the function will return null.
     * @returns {string | null} - Returns the original text if valid, otherwise returns null.
     */
    validateText(text) {
        if (text && text.length) {
            if (!this.invalidCharactersRegexForSearch.test(text)) {
                return null;
            }
            if (!this.allowMultipleSpaces) {
                const hasMultipleSpaces = /(\s.*\s)/.test(text);
                if (hasMultipleSpaces) {
                    return null;
                }
            }
        }
        return text;
    }
    /**
     * Handles the keyup events, updating the mention state as necessary
     *
     * @param {KeyboardEvent} event - The keydown event
     */
    onKeyUp(event) {
        var _a, _b;
        if (event.key === "Escape") {
            this.mentionsCount = 0;
            this.stopTracking();
            /**
             * KeyUpCallBack and keyDownCallBack are the same for mentions to ensure there is just one debounced
             * callback
             */
            this.keyDownCallBack("");
            return;
        }
        let precedingText = "";
        precedingText = this.validateText(this.getPrecedingText(this.currentCaretPosition, this.currentRange));
        if (event.key == "Backspace") {
            if (this.inputElementReference &&
                ((_b = (_a = this.inputElementReference) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim()) === "") {
                this.reset();
                this.mentionsMap = {};
                this.cssClassMapping = [];
                return;
            }
        }
        if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(event.key) &&
            (precedingText === null || precedingText === void 0 ? void 0 : precedingText.includes(" "))) {
            if (precedingText === null || precedingText === void 0 ? void 0 : precedingText.includes(" ")) {
                return null;
            }
        }
        if (this.mentionsCount >=
            uikitResources.CometChatUtilityConstants.MentionsTextFormatter.MENTIONS_LIMIT) {
            return;
        }
        /**
         * KeyUpCallBack and keyDownCallBack are the same for mentions to ensure there is just one debounced
         * callback
         */
        this.keyDownCallBack(precedingText);
    }
    /**
     * Adds the given HTML at the caret position.
     *
     * @param {string} newHtml - The HTML to be added.
     * @param {any} currentCaretPosition - The current caret position
     * @param {any} currentRange - The current range
     * @returns {any}
     */
    addAtCaretPosition(newHtml, currentCaretPosition, currentRange) {
        var _a;
        if (this.inputElementReference && currentCaretPosition) {
            const selection = currentCaretPosition;
            let range = currentRange;
            range.collapse(true);
            // Move the range backward to find the '@' symbol
            while (range.startOffset > 0 &&
                ((_a = range.startContainer.textContent) === null || _a === void 0 ? void 0 : _a.charAt(range.startOffset - 1)) !== "@") {
                range.setStart(range.startContainer, range.startOffset - 1);
            }
            if (range.startOffset > 0) {
                // Delete the '@' symbol and the content from '@' sign to the cursor position
                range.setStart(range.startContainer, range.startOffset - 1);
                range.deleteContents();
                // Create a temporary div to hold the new HTML
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = newHtml;
                const fragment = document.createDocumentFragment();
                Array.from(tempDiv.childNodes).forEach((node) => {
                    if (node instanceof HTMLElement &&
                        node.classList.contains("mentions")) {
                        this.registerEventListeners(node, node.classList);
                    }
                    fragment.appendChild(node);
                });
                // Insert the DocumentFragment at the cursor position
                range.insertNode(fragment);
                range.collapse(false);
                // Update the selection with the modified range
                selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
                selection === null || selection === void 0 ? void 0 : selection.addRange(range);
                // let newRange = document.createRange();
                // let sel = window.getSelection();
                // if (lastNodeInFragment!) {
                //   newRange.setStart(
                //     lastNodeInFragment,
                //     lastNodeInFragment.childNodes.length
                //   );
                // }
                // newRange.collapse(true);
                // sel?.removeAllRanges();
                // sel?.addRange(newRange);
                this.inputElementReference.focus();
            }
        }
        this.inputElementReference.focus();
    }
    /**
     * Matches the regex with the given inputText and replaces the matched text with respective spans
     *
     * @param {string | null} inputText - The text in which the regex patterns needs to be matched
     * @return {string} - The text after replacing the matched text with spans
     */
    onRegexMatch(inputText) {
        let replacedText = inputText !== null && inputText !== void 0 ? inputText : "";
        this.warningDisplayed = false;
        for (let i = 0; i < this.regexPatterns.length; i++) {
            let regexPattern = this.regexPatterns[i];
            let cometChatUserGroupMember = this.cometChatUserGroupMembers
                ? this.cometChatUserGroupMembers[0]
                : null;
            let color;
            if (inputText &&
                (cometChatUserGroupMember === null || cometChatUserGroupMember === void 0 ? void 0 : cometChatUserGroupMember.getName()) &&
                (cometChatUserGroupMember === null || cometChatUserGroupMember === void 0 ? void 0 : cometChatUserGroupMember.getUid())) {
                replacedText = inputText.replace(regexPattern, (match, capturedGroup) => {
                    const alreadyMapped = this.mentionsMap[capturedGroup];
                    const span = document.createElement("span");
                    span.classList.add("mentions");
                    for (let i = 0; i < this.classes.length; i++) {
                        span.classList.add(this.classes[i]);
                    }
                    span.classList.add("mentions-" + cometChatUserGroupMember.getUid());
                    span.style.cursor = "pointer";
                    span.setAttribute("contentEditable", "false");
                    const textSpan = document.createElement("span");
                    color =
                        cometChatUserGroupMember.getUid() == this.loggedInUser.getUid()
                            ? this.mentionsStyle.loggedInUserTextColor
                            : this.mentionsStyle.mentionTextColor;
                    textSpan.style.color = color;
                    textSpan.style.font =
                        this.cometChatUserGroupMembers[i].getUid() ==
                            this.loggedInUser.getUid()
                            ? this.mentionsStyle.loggedInUserTextFont
                            : this.mentionsStyle.mentionTextFont;
                    textSpan.style.fontWeight =
                        cometChatUserGroupMember.getUid() == this.loggedInUser.getUid()
                            ? "bold"
                            : "regular";
                    textSpan.style.background =
                        this.cometChatUserGroupMembers[i].getUid() ==
                            this.loggedInUser.getUid()
                            ? this.mentionsStyle.loggedInUserTextBackground
                            : this.mentionsStyle.mentionTextBackground;
                    if (alreadyMapped) {
                        textSpan.textContent = capturedGroup;
                    }
                    else {
                        textSpan.textContent = "@" + cometChatUserGroupMember.getName();
                        this.mentionsMap["mentions-" + cometChatUserGroupMember.getUid()] = `<@uid:${cometChatUserGroupMember.getUid()}>`;
                        this.mentionsCssClassMapping["mentions-" + cometChatUserGroupMember.getUid()] = cometChatUserGroupMember;
                    }
                    this.mentionsCount = Object.keys(this.mentionsMap).length;
                    if (this.mentionsCount >=
                        uikitResources.CometChatUtilityConstants.MentionsTextFormatter
                            .MENTIONS_LIMIT &&
                        !this.warningDisplayed) {
                        uikitResources.CometChatUIEvents.ccShowMentionsCountWarning.next({
                            showWarning: true,
                            id: this.getId(),
                        });
                        this.warningDisplayed = true;
                    }
                    // const zeroWidthSpace = document.createElement("span");
                    // zeroWidthSpace.classList.add("mentions-margin-space");
                    // zeroWidthSpace.innerHTML = "\u200B";
                    span.appendChild(textSpan);
                    //span.appendChild(zeroWidthSpace);
                    return span.outerHTML + " ";
                });
            }
        }
        return replacedText;
    }
    /**
     * Retrieves the original text after replacing mentions span with UIDs
     *
     * @param {string | null | undefined} inputText - The input text to be formatted.
     * @returns {string} The original text after replacing mentions span with UIDs
     */
    getOriginalText(inputText) {
        return this.replaceMentionsSpanWithUid(inputText);
    }
}

class CometChatUrlsFormatter extends CometChatTextFormatter {
    constructor(regexPatterns) {
        super();
        this.textStyle = { formattedTextColor: "rgb(51, 153, 255)", formattedTextFont: "" };
        this.setRegexPatterns(regexPatterns);
    }
    onRegexMatch(inputText) {
        let replacedText = inputText !== null && inputText !== void 0 ? inputText : "";
        for (let i = 0; i < this.regexPatterns.length; i++) {
            let regexPattern = this.regexPatterns[i];
            if (inputText) {
                replacedText = inputText.replace(regexPattern, (match, capturedGroup) => {
                    var _a, _b, _c;
                    const span = document.createElement('span');
                    span.classList.add(this.cssClassMapping[0]);
                    span.setAttribute('contentEditable', 'false');
                    span.style.color = (_b = (_a = this.textStyle) === null || _a === void 0 ? void 0 : _a.formattedTextColor) !== null && _b !== void 0 ? _b : "rgb(51, 153, 255)";
                    span.style.font = (_c = this.textStyle) === null || _c === void 0 ? void 0 : _c.formattedTextFont;
                    span.textContent = capturedGroup;
                    span.dataset.captureGroup = capturedGroup;
                    span.style.cursor = 'pointer';
                    const zeroWidthSpace = document.createElement('span');
                    zeroWidthSpace.classList.add(this.cssClassMapping[0] + '-margin-space');
                    zeroWidthSpace.innerHTML = '\u200B';
                    span.appendChild(zeroWidthSpace);
                    return span.outerHTML + ' ';
                });
            }
        }
        return replacedText;
    }
    registerEventListeners(element, classList) {
        for (let i = 0; i < classList.length; i++) {
            if (this.cssClassMapping.includes(classList[i])) {
                element.addEventListener('click', () => {
                    // Get the URL from the data attribute
                    const url = element.dataset.captureGroup;
                    // If the URL exists, open it in a new tab
                    if (url) {
                        window.open(url, '_blank');
                    }
                });
            }
        }
        return element;
    }
}

/**
 * UrlFormatterStyle
 * @property {string} rightAlignedLinkColor - Color for mentions in sent/right aligned messages
 * @property {string} leftAlignedLinkColor - Color for mentions in received/left aligned messages
 * @property {string} rightAlignedLinkFont - Font for mentions in sent/right aligned messages
 * @property {string} leftAlignedLinkFont - Font for mentions in received/left aligned messages
 */
class UrlFormatterStyle {
    constructor(props) {
        this.rightAlignedLinkColor = "#FFF500";
        this.leftAlignedLinkColor = "rgba(51, 153, 255)";
        this.rightAlignedLinkFont = "";
        this.leftAlignedLinkFont = "";
        Object.assign(this, props);
    }
}

const getSliderItemStyle = (style = {}, emojiId, selectedReaction) => {
    const isAll = emojiId === 'all';
    const sliderItemStyle = {
        background: emojiId === selectedReaction ? ((style === null || style === void 0 ? void 0 : style.activeEmojiBackground) || "rgba(212, 213, 215, 0.58)") : "transparent",
    };
    if (isAll) {
        sliderItemStyle['padding'] = '4px 6px';
    }
    return sliderItemStyle;
};
const getContainerStyle = (style = {}) => {
    const containerStyle = {
        height: (style === null || style === void 0 ? void 0 : style.height) || "300px",
        width: (style === null || style === void 0 ? void 0 : style.width) || "320px",
        borderRadius: (style === null || style === void 0 ? void 0 : style.borderRadius) || "12px",
        background: (style === null || style === void 0 ? void 0 : style.background) || "#ffffff",
        border: (style === null || style === void 0 ? void 0 : style.border) || "none",
        padding: "4px",
        display: "flex",
        flexDirection: "column"
    };
    return containerStyle;
};
const getSheetStyle = (state) => {
    return {
        justifyContent: state !== uikitResources.States.loaded ? "center" : "flex-start",
    };
};
const getLoaderStyle$1 = (style = {}) => {
    const loaderStyle = {
        height: "24px",
        width: "24px",
        iconTint: (style === null || style === void 0 ? void 0 : style.loadingIconTint) || "grey"
    };
    return loaderStyle;
};
const getErrorStyle$1 = (style = {}) => {
    const errorStyle = {
        height: "24px",
        width: "24px",
        iconTint: (style === null || style === void 0 ? void 0 : style.errorIconTint) || "grey"
    };
    return errorStyle;
};

class ReactionListStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.sliderEmojiFont = "";
        this.sliderEmojiCountFont = "";
        this.sliderEmojiCountColor = "";
        this.activeEmojiBackground = "";
        this.loadingIconTint = "";
        this.errorIconTint = "";
        this.tailViewFont = "";
        this.subtitleTextFont = "";
        this.subtitleTextColor = "";
        this.dividerTint = "";
        this.width = "";
        this.height = "";
        Object.assign(this, props);
    }
}

exports.CometChatReactionList = class CometChatReactionList extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.reactionListStyle = {
            height: "300px",
            width: "320px",
            borderRadius: "12px",
            activeEmojiBackground: "rgba(212, 213, 215, 0.58)",
            background: "#ffffff",
            border: "none",
            errorIconTint: "#81848a",
            loadingIconTint: "#81848a",
            sliderEmojiCountFont: "400 15px Inter",
            sliderEmojiFont: "400 15px Inter",
            subtitleTextColor: "#81848a",
            subtitleTextFont: "400 13px Inter",
            tailViewFont: "400 13px Inter",
        };
        this.loadingIconURL = LoadingIcon;
        this.errorIconURL = ErrorIcon$1;
        this.avatarStyle = {
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            nameTextFont: "600 15px Inter, sans-serif",
            nameTextColor: "rgb(20, 20, 20)",
        };
        this.listItemStyle = {
            activeBackground: "#ffffff",
            hoverBackground: "#ffffff",
            titleFont: "600 15px Inter, sans-serif",
            titleColor: "black",
        };
        this.messageReactions = [];
        this.selectedReaction = "all";
        this.requestBuilderMap = {};
        this.reactionList = {};
        this.state = uikitResources.States.loading;
        this.allText = uikitResources.localize("ALL");
        this.currentUIList = [];
        this.subtitleText = uikitResources.localize("CLICK_TO_REMOVE");
        this.youText = uikitResources.localize("YOU");
        this.limit = uikitResources.CometChatUIKitConstants.requestBuilderLimits.reactionListLimit;
        this.loggedInUser = CometChatUIKitLoginListener.getLoggedInUser();
        this.messageUpdated = true;
        this.isInteracting = false;
        this.removedReactionsIds = [];
        this.isFirstRender = true;
        /**
         * Returns the error state of the reaction list.
         * @returns {TemplateResult} The error state template.
         */
        this.getErrorState = () => {
            return lit.html `
      <cometchat-icon
        .URL=${this.errorIconURL}
        iconStyle=${JSON.stringify(getErrorStyle$1(this.reactionListStyle))}
      ></cometchat-icon>
    `;
        };
        /**
         * Returns the loading state of the reaction list.
         * @returns {TemplateResult} The loading state template.
         */
        this.getLoadingState = () => {
            return lit.html `
      <cometchat-loader
        iconURL=${this.loadingIconURL}
        loaderStyle=${JSON.stringify(getLoaderStyle$1(this.reactionListStyle))}
      ></cometchat-loader>
    `;
        };
        /**
         * Renders the reactions slider with reaction items.
         * @returns {React.ReactNode} The rendered reactions slider.
         */
        this.showReactionsSlider = () => {
            const reactionsObject = [
                {
                    id: "all",
                    reaction: this.allText,
                    count: this.getTotalReactionCount(),
                },
            ];
            this.messageReactions.forEach((reaction) => {
                reactionsObject.push({
                    id: reaction.getReaction(),
                    reaction: reaction.getReaction(),
                    count: reaction.getCount(),
                });
            });
            return reactionsObject.map((reactionObject) => {
                var _a, _b, _c, _d, _e;
                return lit.html `
        <div
          class="cc-reaction__list__slider__item"
          style=${styleMap_js.styleMap(getSliderItemStyle(this.reactionListStyle, reactionObject.id, this.selectedReaction))}
          @click=${() => {
                    this.selectedReaction = reactionObject.id;
                    this.requestUpdate("selectedReaction");
                }}
        >
          <div
            class="cc-reaction__list__slider__item__reaction"
            style=${styleMap_js.styleMap({
                    font: reactionObject.id === "all"
                        ? (_a = this.reactionListStyle) === null || _a === void 0 ? void 0 : _a.sliderEmojiCountFont
                        : ((_b = this.reactionListStyle) === null || _b === void 0 ? void 0 : _b.sliderEmojiFont) || "400 15px Inter",
                    color: reactionObject.id === "all"
                        ? (_c = this.reactionListStyle) === null || _c === void 0 ? void 0 : _c.sliderEmojiCountColor
                        : "#000000",
                })}
          >
            ${reactionObject.reaction}
          </div>
          <div
            class="cc-reaction__list__slider__item__count"
            style=${styleMap_js.styleMap({
                    font: ((_d = this.reactionListStyle) === null || _d === void 0 ? void 0 : _d.sliderEmojiCountFont) ||
                        "400 15px Inter",
                    color: ((_e = this.reactionListStyle) === null || _e === void 0 ? void 0 : _e.sliderEmojiCountColor) || "#81848a",
                })}
          >
            ${reactionObject.count}
          </div>
        </div>
      `;
            });
        };
        /**
         * Connects the observer to the parent element and triggers the necessary actions based on intersection.
         */
        this.connectObserver = () => {
            const parentElement = this.parentElement;
            if (parentElement) {
                this.observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            this.isInteracting = true;
                            if (this.messageUpdated) {
                                this.isFirstRender = true;
                            }
                            this.showReactionsIfNeeded();
                        }
                        else {
                            this.isInteracting = false;
                        }
                    });
                });
                this.observer.observe(parentElement);
            }
        };
        /**
         * Checks if reactions need to be shown and displays them if necessary.
         * @returns {Promise<void>} A promise that resolves when reactions are shown.
         */
        this.showReactionsIfNeeded = async () => {
            if (this.messageUpdated && this.isInteracting && this.isFirstRender) {
                this.resetComponent();
                this.messageUpdated = false;
                this.checkReaction();
                this.isFirstRender = false;
                await this.showReactions();
            }
        };
        /**
         * Resets the component to its initial state.
         */
        this.resetComponent = () => {
            this.messageReactions = [];
            this.selectedReaction = "all";
            this.requestBuilderMap = {};
            this.reactionList = {};
            this.state = uikitResources.States.loading;
            this.isInteracting = false;
            this.removedReactionsIds = [];
            this.isFirstRender = true;
        };
        /**
         * Calculates the total count of reactions for the message.
         * @returns The total count of reactions.
         */
        this.getTotalReactionCount = () => {
            let totalReactionCount = 0;
            this.messageReactions.forEach((reaction) => {
                totalReactionCount += reaction.count;
            });
            return totalReactionCount;
        };
        /**
         * Shows the list of reactions.
         * @returns {Promise<void>} A promise that resolves when the reaction list is displayed.
         */
        this.showReactions = async () => {
            const requestBuilder = this.getRequestBuilder(this.selectedReaction);
            const list = await this.getReactionList(requestBuilder, this.selectedReaction);
            this.currentUIList = list;
            this.requestUpdate("currentUIList");
        };
        /**
         * Returns the request builder for a specific reaction.
         * If the request builder for the given reaction already exists, it returns the existing one.
         * Otherwise, it creates a new request builder and sets the necessary properties.
         *
         * @param reaction - The reaction for which the request builder is needed.
         * @returns The request builder for the given reaction.
         */
        this.getRequestBuilder = (reaction) => {
            var _a;
            let requestBuilder;
            if (this.requestBuilderMap[reaction]) {
                return this.requestBuilderMap[reaction];
            }
            if (this.reactionsRequestBuilder) {
                requestBuilder = this.reactionsRequestBuilder;
            }
            else {
                requestBuilder = new chatSdkJavascript.CometChat.ReactionsRequestBuilder().setLimit(this.limit);
            }
            requestBuilder.setMessageId((_a = this.messageObject) === null || _a === void 0 ? void 0 : _a.getId());
            if (reaction !== "all") {
                requestBuilder.setReaction(reaction);
            }
            const request = requestBuilder.build();
            this.requestBuilderMap[reaction] = request;
            return request;
        };
        /**
         * Retrieves the reaction list based on the provided request builder and reaction.
         * @param requestBuilder The request builder for fetching reactions.
         * @param reaction The reaction for which the list is to be retrieved.
         * @returns The reaction list.
         */
        this.getReactionList = async (requestBuilder, reaction) => {
            this.state = uikitResources.States.loading;
            this.requestUpdate("state");
            if (this.reactionList[reaction]) {
                this.state = uikitResources.States.loaded;
                this.requestUpdate("state");
                let list = this.reactionList[reaction];
                return list;
            }
            try {
                const list = await requestBuilder.fetchNext();
                this.state = uikitResources.States.loaded;
                this.reactionList[reaction] = list;
                this.requestUpdate("state");
                return list;
            }
            catch (error) {
                this.state = uikitResources.States.error;
                this.requestUpdate("state");
                return [];
            }
        };
        /**
         * Returns the UI elements for the reaction list.
         * Filters out removed reactions and maps the remaining reactions to HTML elements.
         * @returns {HTMLElement[]} An array of HTML elements representing the reaction list UI.
         */
        this.getUI = () => {
            let list = this.currentUIList;
            list = list.filter((reaction) => {
                return !this.removedReactionsIds.includes(reaction.getReactionId());
            });
            return list.map((reaction) => {
                var _a, _b, _c, _d, _e;
                const isMe = ((_a = this.loggedInUser) === null || _a === void 0 ? void 0 : _a.getUid()) === ((_b = reaction === null || reaction === void 0 ? void 0 : reaction.getReactedBy()) === null || _b === void 0 ? void 0 : _b.getUid());
                return lit.html `
        <div class="cc-reaction__list__sheet__list-item_container">
          <cometchat-list-item
            title=${isMe ? this.youText : (_c = reaction === null || reaction === void 0 ? void 0 : reaction.getReactedBy()) === null || _c === void 0 ? void 0 : _c.getName()}
            .hideSeparator=${false}
            avatarURL=${(_d = reaction === null || reaction === void 0 ? void 0 : reaction.getReactedBy()) === null || _d === void 0 ? void 0 : _d.getAvatar()}
            avatarName=${(_e = reaction === null || reaction === void 0 ? void 0 : reaction.getReactedBy()) === null || _e === void 0 ? void 0 : _e.getName()}
            listItemStyle=${JSON.stringify(this.listItemStyle)}
            avatarStyle=${JSON.stringify(this.avatarStyle)}
            @cc-listitem-clicked=${() => {
                    if (this.reactionItemClicked) {
                        this.reactionItemClicked(reaction, this.messageObject);
                        if (this.isMyReaction(reaction)) {
                            this.removedReactionsIds.push(reaction.getReactionId());
                            this.updateMessageToRemoveReactionLocally(reaction);
                        }
                    }
                }}
          >
            ${isMe
                    ? lit.html `
                  <div slot="subtitleView">
                    <div
                      style=${styleMap_js.styleMap({
                        font: this.reactionListStyle.subtitleTextFont ||
                            "400 13px Inter",
                        color: this.reactionListStyle.subtitleTextColor || "#81848a",
                    })}
                    >
                      ${this.subtitleText}
                    </div>
                  </div>
                `
                    : lit.nothing}
            <div slot="tailView">
              <div
                style=${styleMap_js.styleMap({
                    font: this.reactionListStyle.tailViewFont || "400 13px Inter",
                })}
              >
                ${reaction === null || reaction === void 0 ? void 0 : reaction.getReaction()}
              </div>
            </div>
          </cometchat-list-item>
        </div>
      `;
            });
        };
        /**
         * Checks if the reaction is made by the logged-in user.
         * @param reaction - The reaction to check.
         * @returns True if the reaction is made by the logged-in user, false otherwise.
         */
        this.isMyReaction = (reaction) => {
            var _a, _b;
            return ((_a = this.loggedInUser) === null || _a === void 0 ? void 0 : _a.getUid()) === ((_b = reaction === null || reaction === void 0 ? void 0 : reaction.getReactedBy()) === null || _b === void 0 ? void 0 : _b.getUid());
        };
        /**
         * Updates the message to remove a reaction locally.
         * @param reaction - The reaction to be removed.
         */
        this.updateMessageToRemoveReactionLocally = (reaction) => {
            const message = this.messageObject;
            let changedSelectedReaction = false;
            if (message) {
                const reactions = message.getReactions();
                const index = reactions.findIndex((r) => r.getReaction() === reaction.getReaction());
                if (index !== -1) {
                    const reactionCount = reactions[index].getCount();
                    if (reactionCount === 1) {
                        reactions.splice(index, 1);
                        this.selectedReaction = "all";
                        changedSelectedReaction = true;
                    }
                    else {
                        reactions[index].setCount(reactions[index].getCount() - 1);
                    }
                    message.setReactions(reactions);
                    this.messageObject = message;
                    this.checkReaction();
                    if (changedSelectedReaction) {
                        this.requestUpdate("selectedReaction");
                    }
                    else {
                        this.requestUpdate("messageObject");
                    }
                }
            }
        };
        /**
         * Callback function to close the reaction list.
         */
        this.closeCallBack = () => {
            var _a;
            const parentElement = (_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
            if (parentElement && (parentElement === null || parentElement === void 0 ? void 0 : parentElement.closeContentView)) {
                parentElement === null || parentElement === void 0 ? void 0 : parentElement.closeContentView();
                this.isInteracting = false;
            }
        };
        /**
         * Checks if the parent element has a closeContentView function.
         * @returns The closeContentView function if it exists, otherwise undefined.
         */
        this.hasCloseCallBack = () => {
            var _a;
            const parentElement = (_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
            return parentElement && (parentElement === null || parentElement === void 0 ? void 0 : parentElement.closeContentView);
        };
        /**
         * Retrieves the reaction count based on the specified emoji.
         *
         * @param emoji - The emoji to search for.
         * @returns The reaction count for the specified emoji.
         */
        this.getReactionCountBasedOnEmoji = (emoji) => {
            const reaction = this.messageReactions.find((reaction) => reaction.getReaction() === emoji);
            return reaction;
        };
        /**
         * Performs a scroll check to determine if the user has scrolled to the bottom of the element.
         * If the user has scrolled to the bottom, it triggers the fetchNext() method.
         *
         * @param e - The scroll event object.
         */
        this.performScrollCheck = (e) => {
            const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
            if (bottom) {
                this.fetchNext();
            }
        };
        /**
         * Fetches the next set of reaction items and updates the reaction list.
         * If the reaction list for the selected reaction is empty, it returns early.
         * Otherwise, it fetches the next set of items using the request builder,
         * appends them to the existing reaction list, updates the current UI list,
         * and triggers a request update.
         * @returns {Promise<void>} A promise that resolves when the fetch and update process is complete.
         */
        this.fetchNext = async () => {
            try {
                const requestBuilder = this.getRequestBuilder(this.selectedReaction);
                if (this.reactionList[this.selectedReaction].length === 0) {
                    return;
                }
                else {
                    const newList = await requestBuilder.fetchNext();
                    this.reactionList[this.selectedReaction] = [
                        ...this.reactionList[this.selectedReaction],
                        ...newList,
                    ];
                    this.currentUIList = this.reactionList[this.selectedReaction];
                    this.requestUpdate("currentUIList");
                }
            }
            catch (error) {
                console.log(error);
            }
        };
    }
    /**
     * Checks the reactions for the message object and assigns them to the messageReactions property.
     */
    checkReaction() {
        var _a;
        try {
            this.messageReactions = ((_a = this.messageObject) === null || _a === void 0 ? void 0 : _a.getReactions()) || [];
        }
        catch (error) {
            console.log(error);
        }
    }
    render() {
        var _a;
        return lit.html `
      <div
        class="cc-reaction__list"
        style=${styleMap_js.styleMap(getContainerStyle(this.reactionListStyle))}
      >
        <div class="cc-reaction__list__slider">
          ${((_a = this.messageReactions) === null || _a === void 0 ? void 0 : _a.length) > 0
            ? this.showReactionsSlider()
            : lit.nothing}
        </div>

        <div
          class="cc-reaction__list__sheet"
          style=${styleMap_js.styleMap(getSheetStyle(this.state))}
          @scroll=${this.performScrollCheck}
        >
          ${this.state === uikitResources.States.loading ? this.getLoadingState() : lit.nothing}
          ${this.state === uikitResources.States.error ? this.getErrorState() : lit.nothing}
          ${this.state === uikitResources.States.loaded ? this.getUI() : lit.nothing}
        </div>
      </div>
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.connectObserver();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.observer) {
            this.observer.disconnect();
            this.resetComponent();
        }
    }
    updated(changedProperties) {
        if (changedProperties.has("selectedReaction") ||
            changedProperties.has("messageObject")) {
            if (changedProperties.has("messageObject")) {
                this.messageUpdated = true;
            }
            this.showReactionsIfNeeded();
            if (changedProperties.has("selectedReaction")) {
                this.checkReaction();
                this.showReactions().then(() => {
                    this.requestUpdate("currentUIList");
                });
            }
        }
    }
};
exports.CometChatReactionList.styles = [
    lit.css `
      * {
        box-sizing: border-box;
      }

      .cc-reaction__list__slider {
        width: 100%;
        height: 44px;
        min-height: 44px;
        padding: 4px 4px 0px 12px;
        display: flex;
        overflow-x: scroll;
        gap: 13px;
        white-space: nowrap;
        align-items: center;
      }

      .cc-reaction__list__slider::-webkit-scrollbar {
        display: none;
      }

      .cc-reaction__list__slider__item {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        height: fit-content;
        padding: 2px 6px;
        border-radius: 12px;
        cursor: pointer;
      }

      .cc-reaction__list__slider__item__reaction {
        font-size: 15px;
        font-weight: 400;
        font-family: Inter;
      }

      .cc-reaction__list__sheet {
        width: 100%;
        flex: 1;
        overflow-y: scroll;
        padding: 8px;
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 1px;
      }

      .cc-reaction__list__sheet__list-item_container {
        width: 100%;
        box-sizing: border-box;
      }
    `,
];
__decorate([
    decorators_js.property({ type: chatSdkJavascript.CometChat.BaseMessage })
], exports.CometChatReactionList.prototype, "messageObject", void 0);
__decorate([
    decorators_js.property({ type: ReactionListStyle })
], exports.CometChatReactionList.prototype, "reactionListStyle", void 0);
__decorate([
    decorators_js.property({ type: chatSdkJavascript.CometChat.ReactionsRequestBuilder })
], exports.CometChatReactionList.prototype, "reactionsRequestBuilder", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatReactionList.prototype, "loadingIconURL", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatReactionList.prototype, "errorIconURL", void 0);
__decorate([
    decorators_js.property({ type: uikitElements.AvatarStyle })
], exports.CometChatReactionList.prototype, "avatarStyle", void 0);
__decorate([
    decorators_js.property({ type: uikitElements.ListItemStyle })
], exports.CometChatReactionList.prototype, "listItemStyle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatReactionList.prototype, "reactionItemClicked", void 0);
exports.CometChatReactionList = __decorate([
    decorators_js.customElement("cometchat-reaction-list")
], exports.CometChatReactionList);

const getLoaderStyle = (style = {}) => {
    const loaderStyle = {
        height: "24px",
        width: "24px",
        iconTint: (style === null || style === void 0 ? void 0 : style.loadingIconTint) || "grey"
    };
    return loaderStyle;
};
const getErrorStyle = (style = {}) => {
    const errorStyle = {
        height: "24px",
        width: "24px",
        iconTint: (style === null || style === void 0 ? void 0 : style.errorIconTint) || "grey"
    };
    return errorStyle;
};
const getReactedTextStyle = (style = {}) => {
    return {
        font: style.reactedTextFont || "400 14px Inter",
        color: style.reactedTextColor || "grey",
    };
};

exports.CometChatReactionInfo = class CometChatReactionInfo extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.loadingIconURL = LoadingIcon;
        this.errorIconURL = ErrorIcon$1;
        this.reactionInfoStyle = {
            height: "fit-content",
            width: "fit-content",
            borderRadius: "12px",
            background: "#ffffff",
            border: "1px solid #ebebeb",
            namesFont: "400 14px Inter",
            reactionFontSize: "24px",
            namesColor: "white",
            errorIconTint: "#81848a",
            loadingIconTint: "#81848a",
            reactedTextColor: "#81848a",
            reactedTextFont: "400 14px Inter, sans-serif",
        };
        this.reactionNames = [];
        this.totalReactions = 0;
        this.state = uikitResources.States.loading;
        this.reactedText = uikitResources.localize("REACTED");
        this.andText = uikitResources.localize("AND");
        this.othersText = uikitResources.localize("OTHERS");
        this.youText = uikitResources.localize("YOU");
        this.limit = uikitResources.CometChatUIKitConstants.requestBuilderLimits.reactionInfoLimit;
        this.loggedInUser = CometChatUIKitLoginListener.getLoggedInUser();
        this.isInteracting = false;
        this.hasMessageUpdated = false;
        this.observer = null;
        /**
         * Returns the error state view for the reaction info.
         * @returns {TemplateResult} The error state view.
         */
        this.getErrorStateView = () => {
            return lit.html `
      <cometchat-icon
        .URL=${this.errorIconURL}
        iconStyle=${JSON.stringify(getErrorStyle(this.reactionInfoStyle))}
      ></cometchat-icon>
    `;
        };
        /**
         * Returns the loading state view.
         * @returns {TemplateResult} The loading state view.
         */
        this.getLoadingStateView = () => {
            return lit.html `
      <cometchat-loader
        iconURL=${this.loadingIconURL}
        loaderStyle=${JSON.stringify(getLoaderStyle(this.reactionInfoStyle))}
      ></cometchat-loader>
    `;
        };
        /**
         * Returns the loaded state view for the CometChatReactionInfo component.
         *
         * @returns {TemplateResult} The loaded state view HTML template.
         */
        this.getLoadedStateView = () => {
            var _a;
            const pendingCount = this.totalReactions - this.reactionNames.length;
            return lit.html `
      <div class="cc-reaction__info__reaction">
        <span class="cc-reaction__info__reaction__emoji"
        style=${styleMap_js.styleMap(this.getEmojiStyle(this.reactionInfoStyle))}
          >${this.reaction}</span
        >
      </div>
      <div class="cc-reaction__info__list"
      style=${styleMap_js.styleMap(this.getNameStyle(this.reactionInfoStyle))}
      >
        ${(_a = this.reactionNames) === null || _a === void 0 ? void 0 : _a.join(", ")}
        ${this.totalReactions > this.reactionNames.length
                ? ` ${this.andText} ${pendingCount} ${this.othersText}`
                : lit.nothing}
          <span
          style=${styleMap_js.styleMap(getReactedTextStyle(this.reactionInfoStyle))}
          >
          ${this.reactedText}
          </span>

      </div>
    `;
        };
        /**
         * Retrieves the total count of a specific reaction for the message.
         * @returns The total count of the specific reaction. Returns 0 if the reaction is not found.
         */
        this.getTotalReactionCount = () => {
            const messageReactions = this.messageObject.getReactions();
            const reactionObj = messageReactions.find((reaction) => {
                return reaction.getReaction() === this.reaction;
            });
            if (reactionObj) {
                return reactionObj.getCount();
            }
            return 0;
        };
        /**
         * Returns the style object for the name in the reaction info.
         * @param style - The style object containing font and color properties.
         * @returns The style object for the name.
         */
        this.getNameStyle = (style) => {
            return {
                font: style.namesFont || "400 14px Inter",
                color: style.namesColor || "white",
            };
        };
        /**
         * Returns the style object for the emoji.
         * @param style - The style object containing the reaction font size.
         * @returns The style object with the specified font size.
         */
        this.getEmojiStyle = (style) => {
            return {
                fontSize: style.reactionFontSize || "24px",
            };
        };
        /**
         * Returns the container style for the reaction info.
         * @param style - The style object containing the height, width, borderRadius, background, and border properties.
         * @returns The container style object.
         */
        this.getContainerStyle = (style) => {
            return {
                height: style.height,
                width: style.width,
                borderRadius: style.borderRadius,
                background: style.background,
                border: style.border,
            };
        };
    }
    render() {
        return lit.html `
      <div
        class="cc-reaction__info"
        style=${styleMap_js.styleMap(this.getContainerStyle(this.reactionInfoStyle))}
      >
        ${this.state === uikitResources.States.loading ? this.getLoadingStateView() : lit.nothing}
        ${this.state === uikitResources.States.error ? this.getErrorStateView() : lit.nothing}
        ${this.state === uikitResources.States.loaded ? this.getLoadedStateView() : lit.nothing}
      </div>
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.checkVisibilityOfElement();
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has("messageObject")) {
            this.resetElements();
            this.hasMessageUpdated = true;
            this.fetchReactionsOnInteraction();
        }
    }
    /**
     * Resets the elements of the CometChatReactionInfo class.
     */
    resetElements() {
        this.reactionNames = [];
        this.totalReactions = 0;
    }
    /**
     * Checks the visibility of the element using IntersectionObserver.
     * If the element is intersecting with the viewport, sets isInteracting to true and fetches reactions on interaction.
     */
    checkVisibilityOfElement() {
        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.isInteracting = true;
                    this.totalReactions = this.getTotalReactionCount();
                    this.fetchReactionsOnInteraction();
                }
            });
        });
        this.observer.observe(this);
    }
    /**
     * Called when the custom element is disconnected from the document's DOM.
     * It is a lifecycle method that is automatically invoked by the browser.
     * This method is responsible for cleaning up any resources or event listeners
     * that were set up in the connectedCallback method.
     */
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.observer) {
            this.observer.disconnect();
        }
    }
    /**
     * Fetches reactions on interaction.
     * If there is a message update and the component is currently interacting,
     * it resets the message update flag, sets the interacting flag to false,
     * clears the reaction names array, and fetches reactions.
     * If the component is only interacting, it checks the state.
     * If the state is error or loading, it clears the reaction names array and fetches reactions.
     * Finally, it sets the interacting flag to false.
     */
    fetchReactionsOnInteraction() {
        if (this.isInteracting && this.hasMessageUpdated) {
            this.hasMessageUpdated = false;
            this.isInteracting = false;
            this.reactionNames = [];
            this.fetchReactions();
        }
        else if (this.isInteracting) {
            if (this.state === uikitResources.States.error || this.state === uikitResources.States.loading) {
                this.reactionNames = [];
                this.fetchReactions();
            }
            this.isInteracting = false;
        }
    }
    /**
     * Fetches reactions for the message.
     * If the reaction names are already present, it updates the component with the existing names.
     * Otherwise, it fetches the reactions using the provided builder and updates the component with the fetched reaction names.
     * @returns {Promise<void>} A promise that resolves once the reactions are fetched and the component is updated.
     */
    async fetchReactions() {
        var _a;
        if (this.reactionNames.length > 0) {
            this.requestUpdate("reactionNames");
            return;
        }
        this.state = uikitResources.States.loading;
        this.requestUpdate("state");
        let builder;
        if (this.reactionsRequestBuilder) {
            builder = this.reactionsRequestBuilder;
        }
        else {
            builder = new chatSdkJavascript.CometChat.ReactionsRequestBuilder()
                .setLimit(this.limit);
        }
        builder = builder
            .setMessageId((_a = this.messageObject) === null || _a === void 0 ? void 0 : _a.getId())
            .setReaction(this.reaction)
            .build();
        try {
            const reactionList = await builder.fetchNext();
            const reactionNames = [];
            reactionList.forEach((reaction) => {
                var _a, _b, _c;
                if (((_a = reaction === null || reaction === void 0 ? void 0 : reaction.reactedBy) === null || _a === void 0 ? void 0 : _a.uid) === ((_b = this.loggedInUser) === null || _b === void 0 ? void 0 : _b.getUid())) {
                    reactionNames.unshift(this.youText);
                }
                else {
                    reactionNames.push((_c = reaction === null || reaction === void 0 ? void 0 : reaction.reactedBy) === null || _c === void 0 ? void 0 : _c.name);
                }
            });
            this.reactionNames = reactionNames;
            this.state = uikitResources.States.loaded;
            this.requestUpdate("reactionNames");
        }
        catch (error) {
            this.state = uikitResources.States.error;
            console.log("error", error);
        }
    }
};
exports.CometChatReactionInfo.styles = [
    lit.css `
      * {
        box-sizing: border-box;
      }

      .cc-reaction__info {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 8px;
        padding: 8px;
        box-sizing: border-box;
      }

      .cc-reaction__info__reaction {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .cc-reaction__info__reaction__emoji {
        font-size: 24px;
      }

      .cc-reaction__info__list {
        flex: 1;
        width: 100%;
        color: rgb(138, 138, 138);
        overflow: auto;
        justify-content: center;
        text-align: center;
      }
    `,
];
__decorate([
    decorators_js.property({ type: chatSdkJavascript.CometChat.BaseMessage })
], exports.CometChatReactionInfo.prototype, "messageObject", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatReactionInfo.prototype, "reaction", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatReactionInfo.prototype, "loadingIconURL", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatReactionInfo.prototype, "errorIconURL", void 0);
__decorate([
    decorators_js.property({ type: chatSdkJavascript.CometChat.ReactionsRequestBuilder })
], exports.CometChatReactionInfo.prototype, "reactionsRequestBuilder", void 0);
__decorate([
    decorators_js.property({ type: ReactionInfoStyle })
], exports.CometChatReactionInfo.prototype, "reactionInfoStyle", void 0);
exports.CometChatReactionInfo = __decorate([
    decorators_js.customElement("cometchat-reaction-info")
], exports.CometChatReactionInfo);

exports.AIAssistBotConfiguration = AIAssistBotConfiguration;
exports.AIAssistBotStyle = AIAssistBotStyle;
exports.AIBaseConfiguration = AIBaseConfiguration;
exports.AIBaseStyle = AIBaseStyle;
exports.AIBotMessageBubbleStyle = AIBotMessageBubbleStyle;
exports.AIConversationStarterConfiguration = AIConversationStarterConfiguration;
exports.AIConversationStarterStyle = AIConversationStarterStyle;
exports.AIConversationSummaryConfiguration = AIConversationSummaryConfiguration;
exports.AIConversationSummaryStyle = AIConversationSummaryStyle;
exports.AIExtensionDataSource = AIExtensionDataSource;
exports.AIOptionsStyle = AIOptionsStyle;
exports.AISenderMessageBubbleStyle = AISenderMessageBubbleStyle;
exports.AISmartRepliesConfiguration = AISmartRepliesConfiguration;
exports.AISmartRepliesStyle = AISmartRepliesStyle;
exports.AddMembersConfiguration = AddMembersConfiguration;
exports.AddMembersStyle = AddMembersStyle;
exports.BannedMembersConfiguration = BannedMembersConfiguration;
exports.BannedMembersStyle = BannedMembersStyle;
exports.BaseStyle = BaseStyle;
exports.CalendarStyle = CalendarStyle;
exports.CallButtonsConfiguration = CallButtonsConfiguration;
exports.CallButtonsStyle = CallButtonsStyle;
exports.CallLogDetailsConfiguration = CallLogDetailsConfiguration;
exports.CallLogDetailsStyle = CallLogDetailsStyle;
exports.CallLogHistoryConfiguration = CallLogHistoryConfiguration;
exports.CallLogHistoryStyle = CallLogHistoryStyle;
exports.CallLogParticipantsConfiguration = CallLogParticipantsConfiguration;
exports.CallLogParticipantsStyle = CallLogParticipantsStyle;
exports.CallLogRecordingsConfiguration = CallLogRecordingsConfiguration;
exports.CallLogRecordingsStyle = CallLogRecordingsStyle;
exports.CallLogsConfiguration = CallLogsConfiguration;
exports.CallLogsStyle = CallLogsStyle;
exports.CallScreenConfiguration = CallScreenConfiguration;
exports.CallingDetailsUtils = CallingDetailsUtils;
exports.CardBubbleStyle = CardBubbleStyle;
exports.CollaborativeDocumentConfiguration = CollaborativeDocumentConfiguration;
exports.CollaborativeDocumentConstants = CollaborativeDocumentConstants;
exports.CollaborativeDocumentStyle = CollaborativeDocumentStyle;
exports.CollaborativeWhiteboardConfiguration = CollaborativeWhiteboardConfiguration;
exports.CollaborativeWhiteboardConstants = CollaborativeWhiteboardConstants;
exports.CollaborativeWhiteboardStyle = CollaborativeWhiteboardStyle;
exports.CometChatMentionsFormatter = CometChatMentionsFormatter;
exports.CometChatSoundManager = CometChatSoundManager;
exports.CometChatTextFormatter = CometChatTextFormatter;
exports.CometChatUIKitCalls = CometChatUIKitCalls;
exports.CometChatUIKitHelper = CometChatUIKitHelper;
exports.CometChatUIKitLoginListener = CometChatUIKitLoginListener;
exports.CometChatUIKitSharedSettings = CometChatUIKitSharedSettings;
exports.CometChatUIKitUtility = CometChatUIKitUtility;
exports.CometChatUrlsFormatter = CometChatUrlsFormatter;
exports.ContactsConfiguration = ContactsConfiguration;
exports.ContactsStyle = ContactsStyle;
exports.ConversationUtils = ConversationUtils;
exports.ConversationsConfiguration = ConversationsConfiguration;
exports.ConversationsStyle = ConversationsStyle;
exports.CreateGroupConfiguration = CreateGroupConfiguration;
exports.CreatePollStyle = CreatePollStyle;
exports.DetailsConfiguration = DetailsConfiguration;
exports.DetailsStyle = DetailsStyle;
exports.DetailsUtils = DetailsUtils;
exports.ExtensionsDataSource = ExtensionsDataSource;
exports.ExtensionsId = ExtensionsId;
exports.FormBubbleStyle = FormBubbleStyle;
exports.GroupMemberUtils = GroupMemberUtils;
exports.GroupMembersConfiguration = GroupMembersConfiguration;
exports.GroupMembersStyle = GroupMembersStyle;
exports.GroupsConfiguration = GroupsConfiguration;
exports.GroupsStyle = GroupsStyle;
exports.ImageModerationConfiguration = ImageModerationConfiguration;
exports.ImageModerationConstants = ImageModerationConstants;
exports.ImageModerationStyle = ImageModerationStyle;
exports.IncomingCallStyle = IncomingCallStyle;
exports.InteractiveMessageUtils = InteractiveMessageUtils;
exports.JoinGroupConfiguration = JoinGroupConfiguration;
exports.LinkPreviewConstants = LinkPreviewConstants;
exports.LinkPreviewStyle = LinkPreviewStyle;
exports.ListStyle = ListStyle;
exports.MessageBubbleConfiguration = MessageBubbleConfiguration;
exports.MessageComposerConfiguration = MessageComposerConfiguration;
exports.MessageComposerStyle = MessageComposerStyle;
exports.MessageHeaderConfiguration = MessageHeaderConfiguration;
exports.MessageHeaderStyle = MessageHeaderStyle;
exports.MessageInformationConfiguration = MessageInformationConfiguration;
exports.MessageInformationStyle = MessageInformationStyle;
exports.MessageListConfiguration = MessageListConfiguration;
exports.MessageListStyle = MessageListStyle;
exports.MessageReceiptUtils = MessageReceiptUtils;
exports.MessageTranslationConfiguration = MessageTranslationConfiguration;
exports.MessageTranslationConstants = MessageTranslationConstants;
exports.MessageTranslationStyle = MessageTranslationStyle;
exports.MessagesConfiguration = MessagesConfiguration;
exports.MessagesStyle = MessagesStyle;
exports.OptionsStyle = OptionsStyle;
exports.OutgoingCallConfiguration = OutgoingCallConfiguration;
exports.OutgoingCallStyle = OutgoingCallStyle;
exports.PollsBubbleStyle = PollsBubbleStyle;
exports.PollsConstants = PollsConstants;
exports.ReactionInfoConfiguration = ReactionInfoConfiguration;
exports.ReactionInfoStyle = ReactionInfoStyle;
exports.ReactionListConfiguration = ReactionListConfiguration;
exports.ReactionListStyle = ReactionListStyle;
exports.ReactionsConfiguration = ReactionsConfiguration;
exports.ReactionsStyle = ReactionsStyle;
exports.SchedulerBubbleStyle = SchedulerBubbleStyle;
exports.SchedulerMessageUtils = SchedulerMessageUtils;
exports.SmartRepliesConfiguration = SmartRepliesConfiguration;
exports.SmartRepliesConstants = SmartRepliesConstants;
exports.SmartRepliesStyle = SmartRepliesStyle;
exports.StickersConfiguration = StickersConfiguration;
exports.StickersConstants = StickersConstants;
exports.StickersStyle = StickersStyle;
exports.StorageUtils = StorageUtils;
exports.TabItemStyle = TabItemStyle;
exports.ThreadedMessagesConfiguration = ThreadedMessagesConfiguration;
exports.ThreadedMessagesStyle = ThreadedMessagesStyle;
exports.ThumbnailGenerationConstants = ThumbnailGenerationConstants;
exports.TimeSlotStyle = TimeSlotStyle;
exports.TransferOwnershipConfiguration = TransferOwnershipConfiguration;
exports.TransferOwnershipStyle = TransferOwnershipStyle;
exports.UIKitSettings = UIKitSettings;
exports.UIKitSettingsBuilder = UIKitSettingsBuilder;
exports.UrlFormatterStyle = UrlFormatterStyle;
exports.UserMemberWrapperConfiguration = UserMemberWrapperConfiguration;
exports.UserMentionStyle = UserMentionStyle;
exports.UsersConfiguration = UsersConfiguration;
exports.UsersStyle = UsersStyle;
exports.WithDetailsStyle = WithDetailsStyle;
exports.WithMessagesStyle = WithMessagesStyle;
